webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/rLzrh8/%3F1709061805485&title=The%20Sex%20Coach&summary=A%20twisted%20modern%20love%20story.After%20ending%20a%20long%20and%20difficult%20conventional%20marriage%2C%20middle-aged%20Sarah%20craves%20challenge%14and%20fun.%20But%20who%20is%20she%3F%20Is%20she%20desirable%3F%20A%20plunge%20into%20online%20dating%20quickly%20finds%20Sarah%20entangled%20with%20the%20evasive%20and%20compellin&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/rLzrh8/%3F1709061805485",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=A%20twisted%20modern%20love%20story.After%20ending%20a%20long%20and%20difficult%20conventional%20marriage%2C%20middle-aged%20Sarah%20craves%20challenge%14and%20fun.%20But%20who%20is%20%0Dhttps://textcafe.co/books/rLzrh8/%3F1709061805485&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/rLzrh8/%3F1709061805485&posttype=link&caption=A%20twisted%20modern%20love%20story.After%20ending%20a%20long%20and%20difficult%20conventional%20marriage%2C%20middle-aged%20Sarah%20craves%20challenge%14and%20fun.%20But%20who%20is%20she%3F%20Is%20she%20desirable%3F%20A%20plunge%20into%20online%20dating%20quickly%20finds%20Sarah%20entangled%20with%20the%20evasive%20and%20compellin",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/rLzrh8/%3F1709061805485&description=A%20twisted%20modern%20love%20story.After%20ending%20a%20long%20and%20difficult%20conventional%20marriage%2C%20middle-aged%20Sarah%20craves%20challenge%14and%20fun.%20But%20who%20is%20she%3F%20Is%20she%20desirable%3F%20A%20plunge%20into%20online%20dating%20quickly%20finds%20Sarah%20entangled%20with%20the%20evasive%20and%20compellin&media=https://textcafe.co/books/rLzrh8/tc-custom/FC-9781643780085.jpg?1685204506029",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon UK',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.co.uk/s?k=9781398433403&i=stripbooks&linkCode=qs',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781398433403').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/rLzrh8/tc-custom/FC-9781643780085.jpg?1685204506029?1709061805485',
        alt: 'The Sex Coach'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "nav", "text/ch001", "text/ch002", "text/ch003", "text/ch004", "text/Section0001", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/rLzrh8/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_text_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_text_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_text_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_text_title_page__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_text_title_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_text_title_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_nav__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_text_ch001__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_text_ch001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_text_ch001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_text_ch002__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_text_ch002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_text_ch002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_text_ch003__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_text_ch003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_text_ch003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_text_ch004__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_text_ch004___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_text_ch004__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_text_Section0001__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_text_Section0001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_text_Section0001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_text_ch005__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_text_ch005___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_text_ch005__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_text_Section0002__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_text_Section0002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_text_Section0002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_text_ch006__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_text_ch006___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_text_ch006__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_text_Section0003__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_text_Section0003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_text_Section0003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_last__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_last__);
/*jshint esversion: 6 */



















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/nav",
    "name": "nav",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_nav___default.a
  }, {
    "path": "/text/ch001",
    "name": "text/ch001",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_text_ch001___default.a
  }, {
    "path": "/text/ch002",
    "name": "text/ch002",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_text_ch002___default.a
  }, {
    "path": "/text/ch003",
    "name": "text/ch003",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_text_ch003___default.a
  }, {
    "path": "/text/ch004",
    "name": "text/ch004",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_text_ch004___default.a
  }, {
    "path": "/text/Section0001",
    "name": "text/Section0001",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_text_Section0001___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_16__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rLzrh8/tc-custom/FC-9781643780085.jpg?1685204506029?1709061805485",
      "alt": "This image is the cover for the book The Sex Coach"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Sex Coach\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A twisted modern love story. After ending a long and difficult conventional marriage, middle-aged Sarah craves challenge—and fun. But who is she? Is she desirable? A plunge into online dating quickly finds Sarah entangled with the evasive and compelling Rick. Their online chat transcripts relive and anticipate not only their own trysts but her experiences with other lovers. Pushing her sexual boundaries, Rick advises and encourages Sarah to report back in detail. He assures Sarah this is therapeutic, dubbing himself as her ‘sex coach’. Against these secret sexual exploits, Sarah shares the lonely reality of day-to-day survival as a single older woman, coping with the fraught dynamics of family and friends. But what is Rick’s agenda? Is he capable of helping Sarah make good choices? What is he coaching her towards? Immersive, stimulating and engaging, The Sex Coach is more than an exciting insight into the precarious and intriguing world of online dating.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jane McLeod\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jane McLeod was born in 1960 in Auckland, New Zealand, where she has lived most of her life. The inspiration for The Sex Coach came from various conversations about separation with other women, all of whom described a difficult adjustment for family and friends, and some had experienced a period of sexual exploration and freedom. This is Jane’s first novel.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Sex Coach")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#acknowledgment"
    }
  }, [_vm._v("Acknowledgment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#part-one"
    }
  }, [_vm._v("Part One")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#sunday-27-may-2018"
    }
  }, [_vm._v("Sunday, 27 May 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#tuesday-29-may-2018"
    }
  }, [_vm._v("Tuesday, 29 May 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-30-may-2018"
    }
  }, [_vm._v("Wednesday, 30 May 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-1-june-2018"
    }
  }, [_vm._v("Friday, 1 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-2-june-2018"
    }
  }, [_vm._v("Saturday, 2 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#sunday-3-june-2018"
    }
  }, [_vm._v("Sunday, 3 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-4-june-2018"
    }
  }, [_vm._v("Monday, 4 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#tuesday-5-june-2018"
    }
  }, [_vm._v("Tuesday, 5 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-6-june-2018"
    }
  }, [_vm._v("Wednesday, 6 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-7-june-2018"
    }
  }, [_vm._v("Thursday, 7 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-8-june-2018"
    }
  }, [_vm._v("Friday, 8 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-9-june-2018"
    }
  }, [_vm._v("Saturday, 9 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#sunday-10-june-2018"
    }
  }, [_vm._v("Sunday, 10 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-11-june-2018"
    }
  }, [_vm._v("Monday, 11 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#tuesday-12-june-2018"
    }
  }, [_vm._v("Tuesday, 12 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-13-june-2018"
    }
  }, [_vm._v("Wednesday, 13 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-14-june-2018"
    }
  }, [_vm._v("Thursday, 14 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-15-june-2018"
    }
  }, [_vm._v("Friday, 15 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-16-june-2018"
    }
  }, [_vm._v("Saturday, 16 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#sunday-17-june-2018"
    }
  }, [_vm._v("Sunday, 17 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-18-june-2018"
    }
  }, [_vm._v("Monday, 18 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#tuesday-19-june-2018"
    }
  }, [_vm._v("Tuesday, 19 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-20-june-2018"
    }
  }, [_vm._v("Wednesday, 20 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-21-june-2018"
    }
  }, [_vm._v("Thursday, 21 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-22-june-2018"
    }
  }, [_vm._v("Friday, 22 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-23-june-2018"
    }
  }, [_vm._v("Saturday, 23 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#sunday-24-june-2018"
    }
  }, [_vm._v("Sunday, 24 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-25-june-2018"
    }
  }, [_vm._v("Monday, 25 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#tuesday-26-june-2018"
    }
  }, [_vm._v("Tuesday, 26 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-27-june-2018"
    }
  }, [_vm._v("Wednesday, 27 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-28-june-2018"
    }
  }, [_vm._v("Thursday, 28 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-29-june-2018"
    }
  }, [_vm._v("Friday, 29 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-30-june-2018"
    }
  }, [_vm._v("Saturday, 30 June 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#sunday-1-july-2018"
    }
  }, [_vm._v("Sunday, 1 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-2-july-2018"
    }
  }, [_vm._v("Monday, 2 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#tuesday-3-july-2018"
    }
  }, [_vm._v("Tuesday, 3 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-4-july-2018"
    }
  }, [_vm._v("Wednesday, 4 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-5-july-2018"
    }
  }, [_vm._v("Thursday, 5 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-6-july-2018"
    }
  }, [_vm._v("Friday, 6 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-7-july-2018"
    }
  }, [_vm._v("Saturday, 7 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#sunday-8-july-2018"
    }
  }, [_vm._v("Sunday, 8 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-9-july-2018"
    }
  }, [_vm._v("Monday, 9 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#tuesday-10-july-2018"
    }
  }, [_vm._v("Tuesday, 10 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-11-july-2018"
    }
  }, [_vm._v("Wednesday, 11 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-12-july-2018"
    }
  }, [_vm._v("Thursday, 12 July 2018")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#part-two",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0002#wednesday-18-july-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wednesday, 18 July 2018")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#part-three",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#monday-23-july-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monday, 23 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#tuesday-24-july-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuesday, 24 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#wednesday-25-july-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wednesday, 25 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#thursday-26-july-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thursday, 26 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#friday-27-july-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friday, 27 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#saturday-28-july-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saturday, 28 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#sunday-29-july-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday, 29 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#monday-30-july-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monday, 30 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#tuesday-31-july-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuesday, 31 July 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#wednesday-1-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wednesday, 1 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#thursday-2-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thursday, 2 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#friday-3-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friday, 3 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#saturday-4-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saturday, 4 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#sunday-5-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday, 5 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#monday-6-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monday, 6 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#tuesday-7-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuesday, 7 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#wednesday-8-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wednesday, 8 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#thursday-9-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thursday, 9 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#friday-10-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friday, 10 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#saturday-11-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saturday, 11 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#sunday-12-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday, 12 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#monday-13-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monday, 13 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#tuesday-14-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuesday, 14 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#wednesday-15-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wednesday, 15 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#thursday-16-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thursday, 16 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#friday-17-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friday, 17 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#sunday-19-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday, 19 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#monday-20-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monday, 20 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#tuesday-21-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuesday, 21 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#wednesday-22-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wednesday, 22 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#thursday-23-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thursday, 23 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#friday-24-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friday, 24 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#saturday-25-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saturday, 25 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#sunday-26-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday, 26 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-87"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#monday-27-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monday, 27 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#tuesday-28-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuesday, 28 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#wednesday-29-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wednesday, 29 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#thursday-30-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thursday, 30 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-91"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#friday-31-august-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friday, 31 August 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-92"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#saturday-1-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saturday, 1 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-93"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#sunday-2-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday, 2 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-94"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#monday-3-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monday, 3 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-95"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#tuesday-4-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuesday, 4 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-96"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#wednesday-5-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wednesday, 5 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-97"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#thursday-6-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thursday, 6 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-98"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#saturday-8-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saturday, 8 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-99"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#sunday-9-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday, 9 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-100"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#monday-10-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monday, 10 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-101"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#tuesday-11-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuesday, 11 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-102"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#wednesday-12-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wednesday, 12 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-103"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#thursday-13-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thursday, 13 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-104"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#friday-14-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friday, 14 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-105"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#saturday-15-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saturday, 15 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-106"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#sunday-16-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday, 16 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-107"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#monday-17-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monday, 17 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-108"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#tuesday-18-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuesday, 18 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-109"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#wednesday-19-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wednesday, 19 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-110"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#thursday-20-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thursday, 20 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-111"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#friday-21-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friday, 21 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-112"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#saturday-22-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saturday, 22 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-113"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#sunday-23-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday, 23 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-114"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#monday-24-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monday, 24 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-115"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#tuesday-25-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuesday, 25 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-116"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#wednesday-26-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wednesday, 26 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-117"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#thursday-27-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thursday, 27 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-118"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#friday-28-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friday, 28 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-119"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#saturday-29-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saturday, 29 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-120"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#sunday-30-september-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday, 30 September 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-121"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#monday-1-october-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monday, 1 October 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-122"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#tuesday-2-october-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuesday, 2 October 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-123"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#wednesday-3-october-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wednesday, 3 October 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-124"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#thursday-4-october-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thursday, 4 October 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-125"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#friday-5-october-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friday, 5 October 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-126"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#saturday-6-october-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saturday, 6 October 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-127"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#sunday-7-october-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday, 7 October 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-128"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#monday-8-october-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monday, 8 October 2018")])])])])])])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Jane McLeod was born in 1960 in Auckland, New Zealand, where she has lived most of her life. The inspiration for "), _c('em', [_vm._v("The Sex Coach")]), _vm._v(" came from various conversations about separation with other women, all of whom described a difficult adjustment for family and friends, and some had experienced a period of sexual exploration and freedom. This is Jane’s first novel.")])])])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "copyright-information"
    }
  }, [_c('h1', [_vm._v("Copyright Information ©")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Jane McLeod (2020)")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("The right of Jane McLeod to be identified as author of this work has been asserted by the author in accordance with section 77 and 78 of the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("This is a work of fiction. Names, characters, businesses, places, events, locales, and incidents are either the products of the author’s imagination or used in a fictitious manner. Any resemblance to actual persons, living or dead, or actual events is purely coincidental.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("A CIP catalogue record for this title is available from the British Library.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("ISBN 9781787108028 (Paperback)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("ISBN 9781398433403 (ePub e-book)")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("www.austinmacauley.com")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("First Published (2020)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Austin Macauley Publishers Ltd")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("25 Canada Square")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Canary Wharf")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("London")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("E14 5LQ")])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgment"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', [_vm._v("To my long-suffering book club buddies, thank you for swallowing your judgement. Your open-mouthed horror provided more encouragement than helpful comments could.")])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "part-one"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-top": "170px"
    }
  }, [_vm._v("Part One")])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "part-one"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "sunday-27-may-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Sunday, 27 May 2018")]), _vm._v(" "), _c('p', [_vm._v("9:14 A.M. Rick: Good morning Sarah. Thanks for the match.")]), _vm._v(" "), _c('p', [_vm._v("9:17 A.M. Sarah: Morning Rick. Your profile is funny. I hope Tinder has treated you well?")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("11:13 A.M. Rick: People now seem to think Tinder is a dating site. Glad you enjoyed it, very tongue in…")]), _vm._v(" "), _c('p', [_vm._v("11:14 A.M. Sarah: Oh? and what is it then?")]), _vm._v(" "), _c('p', [_vm._v("11:16 A.M. Rick: It’s a site where women present themselves to men. What did you find funny about my profile?")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("12:54 P.M. Sarah: Is that so – why not a site where men present themselves to women? And so, your profile – you’re a good kisser, good looking, vain. I thought honest, deluded or funny. I hope funny.")]), _vm._v(" "), _c('p', [_vm._v("12:57 P.M. Rick: Honest and funny. Should have been... Great kisser")]), _vm._v(" "), _c('p', [_vm._v("12:58 P.M. Sarah: Subjective but I do like a good kiss. A great kiss can only be better.")]), _vm._v(" "), _c('p', [_vm._v("1:01 P.M. Rick: Proof is in the tasting")]), _vm._v(" "), _c('p', [_vm._v("1:02 P.M. Sarah: True")]), _vm._v(" "), _c('p', [_vm._v("1:03 P.M. Rick: Tell me something about yourself – what sort of work do you do? Where did you grow up? How did you lose your virginity?")]), _vm._v(" "), _c('p', [_vm._v("1:04 P.M. Sarah: Oh haha – easy tiger! I’ve awarded myself a year off paid work after exiting a long marriage. I have a commitment to a local group most weekday mornings for an hour or so making school lunches, but otherwise getting to grips with being single, friends, family, keeping fit. What else… I grew up here, I have two adult children (adult in theory anyway) – I’m off to see my daughter who lives in London shortly, and my son lives locally. I’ll save the virginity story for now thanks!")]), _vm._v(" "), _c('p', [_vm._v("1:06 P.M. Rick: So we match and you leave the country. For how long? When do you leave?")]), _vm._v(" "), _c('p', [_vm._v("1:06 P.M. Sarah: I know! I’m away for three weeks, leaving Wednesday night")]), _vm._v(" "), _c('p', [_vm._v("1:07 P.M. Rick: So we have a small window of opportunity")]), _vm._v(" "), _c('p', [_vm._v("1:07 P.M. Sarah: We do. I like honest and funny, so if it’s not too forward to suggest it, buy me a drink tonight?")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("2:49 P.M. Rick: You are a reflection of today’s woman, but if you get me drunk you will have to take me home!!!")]), _vm._v(" "), _c('p', [_vm._v("2:59 P.M. Sarah: You’d be lucky")]), _vm._v(" "), _c('p', [_vm._v("3:01 P.M. Rick: Actually, you would be 😮")]), _vm._v(" "), _c('p', [_vm._v("3:04 P.M. Sarah: Ah. Now that is funny! I read that part of your profile correctly. I can’t talk now, I’m at the movies with my son x")]), _vm._v(" "), _c('p', [_vm._v("3:09 P.M. Rick: Has Tinder treated you well?")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("5:50 P.M. Sarah: I’ll tell you my Tinder tales in person, but short story is I went on Tinder in early January this year and was inundated and rather intimidated. I met a couple of men and turned the feed off, until now.")]), _vm._v(" "), _c('p', [_vm._v("5:51 P.M. Rick: Tell me more later. Pillow talk? How was the film?")]), _vm._v(" "), _c('p', [_vm._v("5:52 P.M. Sarah: Presumptive! The movie was great thanks. It’s a bit of a tradition.")]), _vm._v(" "), _c('p', [_vm._v("5:57 P.M. Rick: Going to the movies with your son?")]), _vm._v(" "), _c('p', [_vm._v("6:02 P.M. Sarah: Yes, he buys me tickets for gifts. It’s a treat to have dedicated time with him.")]), _vm._v(" "), _c('p', [_vm._v("6:05 P.M. Rick: They are a gift in small doses")]), _vm._v(" "), _c('p', [_vm._v("6:06 P.M. Sarah: Yes, that’s so true. I got very tired of sharing a house with him this year, so I’m thrilled he’s gone flatting. I had no privacy, no space. I only separated in September last year (my decision) and there’s been a considerable amount of judging going on from the kids – so I’m not overly keen for the boy to see me messaging on Tinder!")]), _vm._v(" "), _c('p', [_vm._v("6:09 P.M. Rick: Completely understand – so you couldn’t entertain? Doesn’t he know you are on Tinder?")]), _vm._v(" "), _c('p', [_vm._v("6:12 P.M. Sarah: That’s correct, but of course entertainment wasn’t the only reason. I went on Tinder for the usual reasons I suspect – to test the market, determine if I was attractive at all, and to get experience meeting new men, and most importantly learning how to not become too attached. The supply appeared plentiful, and I have kept up with the two I met initially, and you are the result of my having gone on again now. My son knew in January and was appalled. I’m sure he’d be more understanding now but I’m not keen to test it before I go away!")]), _vm._v(" "), _c('p', [_vm._v("6:16 P.M. Rick: Of course, but at some point, they have to realise you are a hotblooded woman who has needs")]), _vm._v(" "), _c('p', [_vm._v("6:18 P.M. Sarah: And you know that how? But yes, they do, timing is everything.")]), _vm._v(" "), _c('p', [_vm._v("6:19 P.M. Rick: You are also very direct and modest")]), _vm._v(" "), _c('p', [_vm._v("6:19 P.M. Sarah: Indeed, true again")]), _vm._v(" "), _c('p', [_vm._v("6:25 P.M. Rick: I wouldn’t have you travelling across town so I’ll meet you at your local. I can occasionally be a gentleman! Sounds like we can have fun")]), _vm._v(" "), _c('p', [_vm._v("6:36 P.M. Sarah: I just need to eat something first or lord knows what will happen. I’ll have toast.")]), _vm._v(" "), _c('p', [_vm._v("6:36 P.M. Rick: Don’t eat lol 😮")]), _vm._v(" "), _c('p', [_vm._v("6:39 P.M. Sarah: Looking forward to meeting you")]), _vm._v(" "), _c('p', [_vm._v("6:43 P.M. Rick: As I am Sarah. Will you wear a skirt?")]), _vm._v(" "), _c('p', [_vm._v("6:43 P.M. Sarah: No, black skinny pants. Will you?")]), _vm._v(" "), _c('p', [_vm._v("6:46 P.M. Rick: Lol. Not on the first meet")]), _vm._v(" "), _c('p', [_vm._v("6:46 P.M. Sarah: Phew")]), _vm._v(" "), _c('p', [_vm._v("6:55 P.M. Rick: You won’t be disappointed. I am worth it x")]), _c('br'), _vm._v(" "), _c('p', [_c('em', [_vm._v("I rush home from the movie for toast and to get ready for the meet, wondering why I’m bothering. He was the most ordinary looking of the four men I matched with following a lonely Saturday evening with Netflix and a glass or two of wine. A slightly disturbing but very funny profile and only one photo of him sitting at a café, showing just his face. It’s a nice face, friendly and smiling, kind eyes. (It doesn’t take long on a dating site to work out that everyone wants to see a full-length photo and he failed on that front!) He’s older than me – 58 to my 56 – a first for me on Tinder. So, all things considered, not particularly promising.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("I quickly developed rules for men on my Tinder feed in January – only one picture and no bio is a definite no; as is too young or too old, or too far away; I look for a smile, nice eyes, and not too many boats or cars or motorbikes or fish – what is it with men and fish! I now include some new criteria – I’m not overly keen on young children or grandchildren because it puts the man at a different life stage to me. If I’m to connect with him, the first few messages need to demonstrate that he is articulate and funny. I’m not looking for a relationship, so my own bio rather blandly says – along with other details of course – I’m looking for fun and adventure. I won’t swipe on anyone who specifically says they are looking for a long-term relationship.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("I arrive to find him waiting outside my local bar. It’s early, but the bar is closing! It’s wet, cold and miserable, and I suggest we walk to another bar nearby. They will serve just one drink before closing at 8:30.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("I’m usually regarded as socially able – a good talker and listener, always with a wry response – but this man puts me off balance. He asks searching questions I can’t – or don’t want to – answer, he makes fun of me, criticises my views, sits just a couple of inches too far away to touch, and does everything except make me feel comfortable. I think he’s either a challenge or he’s an idiot. It’s still very entertaining, and I’m bored with the men I’ve been seeing, so the jury’s out for the time being.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("A third bar and a second drink and it’s nearly 9:45 P.M. We walk back to our cars, his hands in his pockets, he hasn’t touched me once. My car has been locked up in the secure carpark at the first bar, so I reluctantly ask if he would drive me home. It doesn’t really feel risky, and I had been thinking he’s not interested in me anyway. In the driveway I ask if I’m going to be the recipient of one of the “great” kisses. He looks at me, assessing, slowly unbuckles his seatbelt, reaches across, and with one hand behind my neck and the other on my waist pulls me across the handbrake into a long, extremely sexual kiss. And then another and another. Well. I guess he was interested in me after all!")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Quite some time later, maybe half an hour, I bid him goodnight, get out of the car and walk upstairs, not looking back. His car doesn’t drive away immediately, and I know he’s watching me walk up the stairs, waiting for a signal perhaps? He doesn’t get one.")])]), _vm._v(" "), _c('p', [_vm._v("10:22 P.M. Sarah: You are worth it. Thank you for the drink, and driving me home xxx")]), _vm._v(" "), _c('p', [_vm._v("10:24 P.M. Rick: As you are. I can still feel you on my lips 💋")]), _vm._v(" "), _c('p', [_vm._v("10:25 P.M. Sarah: Oh, me too x")]), _vm._v(" "), _c('p', [_vm._v("10:29 P.M. Rick: Thank you for a delicious evening Sarah")]), _vm._v(" "), _c('p', [_vm._v("10:31 P.M. Sarah: It pays to be forward occasionally x")]), _vm._v(" "), _c('p', [_vm._v("10:34 P.M. Rick: I totally agree, and to embrace the opportunity to meet new people. Unfortunate about your car, or not. Probably wouldn’t have tasted your kisses if it had been available")]), _vm._v(" "), _c('p', [_vm._v("10:42 P.M. Sarah: Maybe. I think I might have exercised further forwardness before that happened, and the car will be fine until morning")]), _vm._v(" "), _c('p', [_vm._v("10:44 P.M. Rick: Did you not trust me or yourself that you didn’t invite me in for coffee?")]), _vm._v(" "), _c('p', [_vm._v("10:44 P.M. Sarah: Until I was walking up the stairs, I thought you actually wanted to go home. I would have enjoyed coffee, and I’m free Tuesday evening if you would be interested in reconvening?")]), _vm._v(" "), _c('p', [_vm._v("10:48 P.M. Rick: I look forward to that Sarah. In answer to your thoughts, coffee would have also been enjoyable. Going home was not on my mind.")]), _vm._v(" "), _c('p', [_vm._v("10:49 P.M. Sarah: Oh. My apologies.")]), _vm._v(" "), _c('p', [_vm._v("10:50 P.M. Rick: Don’t be sorry Sarah. I obviously did not give the right signals! Your kisses are passionate and hungry. Quite a combination.")]), _vm._v(" "), _c('p', [_vm._v("11:00 P.M. Sarah: Why thank you! Yours lived up to your marketing also x")]), _vm._v(" "), _c('p', [_vm._v("11:00 P.M. Rick: Sleep well Sarah x")]), _vm._v(" "), _c('p', [_vm._v("11:00 P.M. Sarah: I probably won’t now, but thanks anyway")]), _vm._v(" "), _c('p', [_vm._v("11:01 P.M. Rick: And why is that? Thinking of how we would have been sexually?")]), _vm._v(" "), _c('p', [_vm._v("11:03 P.M. Sarah: I guess, yes")]), _vm._v(" "), _c('p', [_vm._v("11:04 P.M. Rick: You know how it would have been. Both demanding of each other. Isn’t that how you could have seen us together?")]), _vm._v(" "), _c('p', [_vm._v("11:06 P.M. Sarah: Of course, yes")]), _vm._v(" "), _c('p', [_vm._v("11:07 P.M. Rick: I’m certain we would have ripped each other’s clothes off as the door closed")]), _vm._v(" "), _c('p', [_vm._v("11:07 P.M. Sarah: I’m sure that’s true too!")]), _vm._v(" "), _c('p', [_vm._v("11:09 P.M. Rick: Not even make it to the bedroom. Damn. Now I am wide awake 😮")]), _vm._v(" "), _c('p', [_vm._v("11:11 P.M. Sarah: Nite Rick x")]), _vm._v(" "), _c('p', [_vm._v("11:12 P.M. Rick: Nite Sarah x")]), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Monday, 28 May 2018")])]), _vm._v(" "), _c('p', [_vm._v("9:47 A.M. Rick: Good morning Sarah. I trust you slept well and encountered no problems retrieving your vehicle? x")]), _vm._v(" "), _c('p', [_vm._v("9:50 A.M. Sarah: Morning Rick, no problems thank you. I slept reasonably well, and hope you did too? x")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("10:15 A.M. Rick: That’s good, I slept well eventually x")]), _vm._v(" "), _c('p', [_vm._v("10:17 A.M. Sarah: It took a while to clear the mind")]), _vm._v(" "), _c('p', [_vm._v("10:54 A.M. Rick: Of the possibilities")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("11:44 A.M. Sarah: Yes x")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("8:15 P.M. Sarah: So tomorrow evening the possibilities are endless – I could feed you and ply you with alcohol at my place, or we could meet out somewhere – what’s your preference? And I would be interested in seeing how another kiss goes x")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("8:59 P.M. Rick: Are you offering gourmet toast? I do like the way your mind works. I also see no reason not to see if the kisses are once again passionate and hungry x")]), _vm._v(" "), _c('p', [_vm._v("9:03 P.M. Sarah: Yes, maybe gourmet toast – I’ll organise food, and see you around 7.30? And I’m sure they will be xxx")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("9:25 P.M. Rick: The thought of my fingers in your hair as I kiss your hot lips and exposed neck. Would that be of interest to you Sarah? x")]), _vm._v(" "), _c('p', [_vm._v("9:35 P.M. Sarah: You know it would. I like a hands-on approach x")]), _vm._v(" "), _c('p', [_vm._v("9:45 P.M. Rick: Hands all over you no doubt. Are you passive or aggressive? x")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("9:46 P.M. Sarah: That would be correct. And I don’t really know. As I explained on Sunday, I’m relatively inexperienced, just getting used to a single life. We’ll see x")]), _vm._v(" "), _c('p', [_vm._v("9:53 P.M. Rick: What can I bring over Sarah? x")]), _vm._v(" "), _c('p', [_vm._v("9:57 P.M. Sarah: Just a bottle of whatever you fancy Rick. It won’t be a fancy meal, but the company will make up for it x")]), _vm._v(" "), _c('p', [_vm._v("10:04 P.M. Rick: Oh, I have no doubt. What time do you fly on Wednesday??? x")]), _vm._v(" "), _c('p', [_vm._v("10:05 P.M. Sarah: 10 P.M.")]), _vm._v(" "), _c('p', [_vm._v("10:07 P.M. Rick: You will have plenty of time to recover 😮😮")]), _vm._v(" "), _c('p', [_vm._v("10:08 P.M. Sarah: You think I’ll need recovery time?")]), _vm._v(" "), _c('p', [_vm._v("10:12 P.M. Rick: Don’t you Sarah? My kisses can be exhausting x")]), _vm._v(" "), _c('p', [_vm._v("10:14 P.M. Sarah: I’m sure you are right – but how will you recover? x")]), _vm._v(" "), _c('p', [_vm._v("10:16 P.M. Rick: I have amazing powers of recovery x")]), _vm._v(" "), _c('p', [_vm._v("10:18 P.M. Sarah: I’d better get some sleep now in anticipation x")]), _vm._v(" "), _c('p', [_vm._v("10:21 P.M. Rick: Have I virtually exhausted you? lol x")]), _vm._v(" "), _c('p', [_vm._v("10:22 P.M. Sarah: Should I be afraid? I’m not.")]), _vm._v(" "), _c('p', [_vm._v("10:24 P.M. Rick: Of course, not Sarah. Unless that’s part of the role play? x")]), _vm._v(" "), _c('p', [_vm._v("10:25 P.M. Sarah: No role play. I’m looking forward to it x")]), _vm._v(" "), _c('p', [_vm._v("10:26 P.M. Rick: Do I unsettle you lover? x")]), _vm._v(" "), _c('p', [_vm._v("10:27 P.M. Sarah: Maybe you do, a little...you’re different")]), _vm._v(" "), _c('p', [_vm._v("10:28 P.M. Rick: Sweet dreams x")]), _vm._v(" "), _c('p', [_vm._v("10:28 P.M. Sarah: x")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "tuesday-29-may-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Tuesday, 29 May 2018")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Not being one to dress for a man’s preferences, I’m surprised I want to please this man – he does unsettle me, no maybe about it. I have no experience with a man like this and don’t at all understand what I’m dealing with. I’m curious, and up for a challenge – that’s why I’m on Tinder, right?")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("I know Rick likes a skirt or dress but I don’t own many for this season, so I choose an old but sexy dress. Formal black, slightly sparkly, short, and fitted with an almost transparent top, a black bra and matching G-string, diamond earrings, dark red toenails, bare legs and feet. I never paint my fingernails, nor do I wear lipstick. I think I look sufficiently delicious – apart from the bare feet. Completely overdressed for a Tuesday night, but I like some contradiction and surprise.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Dinner is a bit more complex than gourmet toast – it’s an old favourite – not particularly pretty but very nice, and one I’ve served countless times to friends. It’s ready and keeping warm by 7:15 P.M., the lights are low, the table set, candles ready to be lit, clean sheets…")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("A knock on the door, and I’m greeted with a hug and that kiss. I’m not sure if it’s me or him, I suspect the combination. The wine is opened, and I’m instructed not to pour until it has had a chance to breathe – bossy. I decant the wine and we sit on the couch, side by side. Conversation is easy and relaxed, I’m not put on the spot as I was on Sunday night, and we sip our Pinot Noir very slowly. We head to the kitchen to cook some beans to go with the chicken, and while they cook, he pulls me into a long kiss in the kitchen, his hands around my body, in my cropped hair.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("We eat around 9, at one end of my long dining table, a cluster of candles now lit. We are oddly formal, polite, excellent table manners. Towards the end of the meal he takes my hands in an intimate but easy way, and we continue to chat. A candle splutters and drips wax on the table surface – I rush to fix the mess, blowing out the candles as I do so since we are about to leave the room, returning to the lounge to finish the wine. We are still drinking very slowly. Rick has great restraint, control, I suspect in everything he does.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Now sitting close, one leg over his, his hands find their way under my dress to my waist, around my bottom, running the length of my legs, around my neck, head and face. Mine are over his chest and shoulders, one hand on his neck and face when we kiss. Pulling back I say, “You’re pretty cute Rick.” By the look on his face, cute is clearly not a word often – or ever – applied to him.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Clothes are shed in the half light of the bedroom with little ceremony and he positions and moves me to suit him, pushing in deep, twisting my body. I like this. It’s exciting having a man take complete control of how I experience sex. We experiment with many different positions, he’s always assertive, confident, obviously ridiculously experienced. He particularly likes being on his knees between my legs, holding my legs open wide by the ankles, alternating between pushing into me with his cock and, lifting me higher, with his tongue. I’m not objecting. This is new and fun. We stop occasionally for breath, chat, kisses, my body wrapped around his. At 2 A.M. Rick dresses and heads home for an early start tomorrow. Three hours have passed in my bed.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("During the evening, I discovered Rick is particularly interested in the other men in my life and my sexual relationships. I’ve never been asked with such real interest to share details of my sex life with a current sex partner. In the aftermath of my marriage I consider myself to now be an open person, and we freely discuss my sexual experiences, touching on my unsatisfactory sexual relationship with my ex and the two men I see currently.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("These two men could not be more different. I met them both in early January, also online. One is a kind and loving man, sole caregiver to young children, working a full-time job. He understands and appreciates my situation, having been in a similar type of relationship himself. He treats me with respect and sexually goes as slow as he thinks I need. He has shown me the pleasure of slow lovemaking but it’s become clear he is in love with me. He has, in the last few weeks, retreated to deal with that since he doesn’t feel “emotionally available” for a new relationship yet, and I’m certainly in no place for that.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("The other is an intellectual man who challenges me by questioning my lifestyle and my sexual preferences. He believes I need to explore more in every aspect of my life, especially sexually but also vocationally. I enjoy his company, and we have a lot of fun drinking, live music, dinners out, but I do not enjoy being directed about how to live.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("At some stage earlier in the evening I tell Rick that he has more dimensions than I thought he would have from his profile and from our first meeting on Sunday. I have now found some further dimensions to Rick that I had not expected!")])])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "wednesday-30-may-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Wednesday, 30 May 2018")]), _vm._v(" "), _c('p', [_vm._v("2:26 A.M. Sarah: Delicious cutie x")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("8:13 A.M. Rick: Good morning Sweet Cheeks. Trust you slept well!!! It was a battle to drag myself up. Thank you for a lovely dinner and a wonderful evening xxx")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("8:17 A.M. Sarah: I had such a nice time with you too. You have many more dimensions than I expected xxx")]), _vm._v(" "), _c('p', [_vm._v("8:39 A.M. Rick: I hope it doesn’t catch up with you later or possibly that would be a good thing – you can sleep on your flight x")]), _vm._v(" "), _c('p', [_vm._v("8:43 A.M. Sarah: I can’t stop smirking this morning x")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("9:59 A.M. Rick: The cat that got the cream!!!")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("11:07 A.M. Rick: I can still feel you around me mmm x")]), _vm._v(" "), _c('p', [_vm._v("11:15 A.M. Sarah: Close and tight xxx")]), _vm._v(" "), _c('p', [_vm._v("11:27 A.M. Rick: Two words that perfectly describe our passion last evening. Just adds another dimension xxx")]), _vm._v(" "), _c('p', [_vm._v("11:28 A.M. Sarah: I noticed that dimension last night. Clearly on the positive side of the dimension ledger x")]), _vm._v(" "), _c('p', [_vm._v("11:29 A.M. Rick: I would like to know the negative side of said ledger x")]), _vm._v(" "), _c('p', [_vm._v("11:30 A.M. Sarah: I can’t think of any right now x")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("1:10 P.M. Rick: How is your last-minute panic packing progressing? What time will your son be over tonight to collect you? x")]), _vm._v(" "), _c('p', [_vm._v("1:15 P.M. Sarah: I’m completely organised, having lunch with my parents, then have a friend coming for tea until 3 P.M. I expect my son to turn up around 5.30. I’ll buy him dinner as a bribe to take me to the airport x")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("3:10 P.M. Rick: Did my ink shock you? x")]), _vm._v(" "), _c('p', [_vm._v("3:13 P.M. Sarah: The fact that you had any? No. I don’t have any aversion, each to their own. I’d like to know more about the one that says “look at my cock”. I like it x")]), _vm._v(" "), _c('p', [_vm._v("3:15 P.M. Rick: My God! Have you researched the meaning??? x")]), _vm._v(" "), _c('p', [_vm._v("3:16 P.M. Sarah: It was obvious x")]), _vm._v(" "), _c('p', [_vm._v("3:27 P.M. Rick: Are you packed and waiting for your son?")]), _vm._v(" "), _c('p', [_vm._v("3:28 P.M. Sarah: No, I’m just having a rest before he arrives")]), _vm._v(" "), _c('p', [_vm._v("3:30 P.M. Rick: Recuperating from last night!!!")]), _vm._v(" "), _c('p', [_vm._v("3:30 P.M. Sarah: Yes x")]), _vm._v(" "), _c('p', [_vm._v("3:30 P.M. Rick: You should have asked me to stop if it was too much x")]), _vm._v(" "), _c('p', [_vm._v("3:31 P.M. Sarah: Never! I just didn’t realise how late it was")]), _vm._v(" "), _c('p', [_vm._v("3:32 P.M. Rick: We could have gone all night")]), _vm._v(" "), _c('p', [_vm._v("3:33 P.M. Sarah: I could have. It was so good x")]), _vm._v(" "), _c('p', [_vm._v("3:35 P.M. Rick: We certainly couldn’t get enough of each other")]), _vm._v(" "), _c('p', [_vm._v("3:36 P.M. Sarah: Very true. I do love just lying and chatting too. You’re pretty good company, Rick x")]), _vm._v(" "), _c('p', [_vm._v("3:38 P.M. Rick: As are you. So multi-dimensional, not to mention cute x")]), _vm._v(" "), _c('p', [_vm._v("3:39 P.M. Sarah: Me? You definitely are all of that x")]), _vm._v(" "), _c('p', [_vm._v("3:40 P.M. Rick: You most definitely are. We both can’t be cute, so I will have to go with Sweet Cheeks for you x")]), _vm._v(" "), _c('p', [_vm._v("3:41 P.M. Sarah: Fair enough Cutie Pie x")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("6:28 P.M. Rick: Hello again Sweet Cheeks. Enjoying dinner with your son? x")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("7:06 P.M. Sarah: Yes, we’re on the way to the airport now. I’ll miss you – we haven’t really got started x")]), _vm._v(" "), _c('p', [_vm._v("7:07 P.M. Rick: I would have ravished you before your flight. Had you board full of my cum x")]), _vm._v(" "), _c('p', [_vm._v("7:11 P.M. Sarah: I would have loved that – I still have that feeling from last night")]), _vm._v(" "), _c('p', [_vm._v("7:12 P.M. Rick: If it was too much you should have told me to stop or rest")]), _vm._v(" "), _c('p', [_vm._v("7:15 P.M. Sarah: I didn’t want you to stop or rest – I loved it all x")]), _vm._v(" "), _c('p', [_vm._v("7:16 P.M. Rick: I was worried it was too much x")]), _vm._v(" "), _c('p', [_vm._v("7:17 P.M. Sarah: There was a bit of urgency last night. Please don’t worry. I’m fine and happy x")]), _vm._v(" "), _c('p', [_vm._v("7:17 P.M. Rick: Happy and content x")]), _vm._v(" "), _c('p', [_vm._v("7:18 P.M. Sarah: Yes, babe x")]), _vm._v(" "), _c('p', [_vm._v("7:19 P.M. Rick: You may have noticed I am very sexual x")]), _vm._v(" "), _c('p', [_vm._v("7:20 P.M. Sarah: I did observe that Rick")]), _vm._v(" "), _c('p', [_vm._v("7:21 P.M. Rick: As you are. You have deep passion x")]), _vm._v(" "), _c('p', [_vm._v("7:22 P.M. Sarah: Really? I’ve been told I have passion before – it’s a new thing for me, but I feel it strongly. I’m settled in airside for a long wait… I should tell you I’m a bit of an extra virgin. You may have noticed? I was with the same man for so long in a relationship where sex wasn’t the key, and then I’ve had a few experiences since, but nothing compared to your lifetime of sexual adventure. I had no passion or intimacy in my married life, so this is very new for me – too much information? x")]), _vm._v(" "), _c('p', [_vm._v("7:29 P.M. Rick: Not at all lover. You can tell me anything. It’s hard to believe a woman with such passion could stand to be locked in a relationship with no passion or intimacy! You briefly mentioned last night bad sex with your ex? x")]), _vm._v(" "), _c('p', [_vm._v("7:30 P.M. Sarah: Yes. I don’t talk too much about it, but it wasn’t a good situation for many years. In many ways abusive.")]), _vm._v(" "), _c('p', [_vm._v("7:32 P.M. Rick: I don’t judge babe. How did you manage? x")]), _vm._v(" "), _c('p', [_vm._v("7:39 P.M. Sarah: Not too well actually. When it turned from just bad sex into sex that I felt I couldn’t refuse without criticism and complaint, I just couldn’t cope and had to leave. Before that I tolerated it, got it over as quick as possible")]), _vm._v(" "), _c('p', [_vm._v("7:40 P.M. Rick: I can appreciate that. I may be very sexual, but I wouldn’t force myself on you unless we are role playing x")]), _vm._v(" "), _c('p', [_vm._v("7:40 P.M. Sarah: I know Rick")]), _vm._v(" "), _c('p', [_vm._v("7:40 P.M. Rick: Explain more about extra virgin")]), _vm._v(" "), _c('p', [_vm._v("7:42 P.M. Sarah: A virgin in good sexual experiences but have had a lot of sex. We never had a spectacular sex life, nor an intimate relationship in other ways. We certainly never had extended sexual encounters.")]), _vm._v(" "), _c('p', [_vm._v("7:44 P.M. Rick: You love sex Sarah! Did you have an open relationship?")]), _vm._v(" "), _c('p', [_vm._v("7:46 P.M. Sarah: Oh Rick, that’s funnier than you could imagine. We had anything but actually, and yes, I do love sex now. I came out of a very young, short marriage straight into the next, with no gap in between to work out what I wanted – or even what I liked – and just got trapped in so many ways. This is the first time I’ve been single since I was 17.")]), _vm._v(" "), _c('p', [_vm._v("7:47 P.M. Rick: Now you have finally opened Pandora’s box! x")]), _vm._v(" "), _c('p', [_vm._v("7:48 P.M. Sarah: Literally yes. Can you imagine the frustration knowing I had the need in me but with no outlet?")]), _vm._v(" "), _c('p', [_vm._v("7:50 P.M. Rick: Totally, it must seem insane in retrospect. What was your coping mechanism babe? x")]), _vm._v(" "), _c('p', [_vm._v("7:51 P.M. Sarah: If you mean sexual satisfaction, I need a glass of wine for that (which I have). I had to DIY. A depressing option. So other coping mechanisms? I’m fully aware my behaviour towards ex was not exemplary, and I relied heavily on my children, particularly my daughter, for emotional support, and as a consequence I became very self-sufficient. Far too self-sufficient. I believe I became hard and cold in that relationship, so it’s a complete delight to know that wasn’t the real me.")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("8:11 P.M. Rick: You are very far from hard and cold babe x")]), _vm._v(" "), _c('p', [_vm._v("8:11 P.M. Sarah: Thank you, I know I’m not now. That’s the tragedy and the triumph. I’ll never be that person again.")]), _vm._v(" "), _c('p', [_vm._v("8:14 P.M. Rick: Good for you Sarah. You are an independent woman 💋")]), _vm._v(" "), _c('p', [_vm._v("8:17 P.M. Sarah: 💋 thanks. I could use one of those great kisses right now – would it be unreasonable to ask you to buy a ticket to anywhere so you could get airside to supply one or two? I can’t believe I have to wait three weeks for another xxx")]), _vm._v(" "), _c('p', [_vm._v("8:49 P.M. Rick: Put on a show for the other passengers? 😮")]), _vm._v(" "), _c('p', [_vm._v("8:49 P.M. Sarah: I wouldn’t care x")]), _vm._v(" "), _c('p', [_vm._v("8:50 P.M. Rick: Would we wear masks?")]), _vm._v(" "), _c('p', [_vm._v("8:50 P.M. Sarah: You can wear whatever you like so long as that lovely mouth is exposed")]), _vm._v(" "), _c('p', [_vm._v("8:51 P.M. Rick: You animal! xxx")]), _vm._v(" "), _c('p', [_vm._v("8:51 P.M. Sarah: You love it")]), _vm._v(" "), _c('p', [_vm._v("8:51 P.M. Rick: Damn right I do x")]), _vm._v(" "), _c('p', [_vm._v("8:52 P.M. Sarah: Don’t go finding anyone better in my absence now x")]), _vm._v(" "), _c('p', [_vm._v("8:52 P.M. Rick: I am not a predator!")]), _vm._v(" "), _c('p', [_vm._v("8:53 P.M. Sarah: I do know that. Too cute to be a predator xxx")]), _vm._v(" "), _c('p', [_vm._v("8:54 P.M. Rick: Why thank you, gorgeous damsel xxx")]), _vm._v(" "), _c('p', [_vm._v("8:59 P.M. Sarah: You’re such a nice man. I’m so pleased to have met you x")]), _vm._v(" "), _c('p', [_vm._v("9:02 P.M. Rick: Likewise, Sarah x")]), _vm._v(" "), _c('p', [_vm._v("9:12 P.M. Sarah: I had a car chat with my son on the way to the airport about Tinder, new men, the possibility of new experiences. I’m trying to get to a more adult relationship with him, normalise how he sees me – as a woman, not just mum. I want them to know I’m trying to learn how to not fall into another relationship, and I’m learning to be single.")]), _vm._v(" "), _c('p', [_vm._v("9:14 P.M. Rick: It’s difficult for kids to let go. It’s good you have this out in the open x")]), _vm._v(" "), _c('p', [_vm._v("9:16 P.M. Sarah: It’s an ongoing struggle but I’m prepared to be persistent! My daughter rolls her eyes when I mention men – as if I’m competing or showing off, or even making it up, which of course is ridiculous")]), _vm._v(" "), _c('p', [_vm._v("9:22 P.M. Rick: Of course. They seem to think sex stops after kids x")]), _vm._v(" "), _c('p', [_vm._v("9:25 P.M. Sarah: Or in fact never happened. My two did observe a fairly poor example of normal with their parents to be fair, so thinking about me not just as happy and free, but as a woman, is hard. I fully appreciate it from their point of view, but I won’t pretend any longer. They are good kids and they love me so hopefully it’s just going to take a little time x")]), _vm._v(" "), _c('p', [_vm._v("9:27 P.M. Rick: That’s all you can ask for from your children. They are both independent and live out of home so it should get easier x")]), _vm._v(" "), _c('p', [_vm._v("9:28 P.M. Sarah: Yes, I’m sure that’s right. It’s been an odd experience having to skulk like a teenager round my kids’ sensitivities!")]), _vm._v(" "), _c('p', [_vm._v("9:30 P.M. Rick: It’s borne out of concern for your well being")]), _vm._v(" "), _c('p', [_vm._v("9:32 P.M. Sarah: Or just bewilderment that their mum likes men!")]), _vm._v(" "), _c('p', [_vm._v("9:36 P.M. Rick: Haha yes. It could be that you like women, would that be more acceptable?")]), _vm._v(" "), _c('p', [_vm._v("9:37 P.M. Sarah: I doubt it! And for the record I don’t, but it’s been suggested before.")]), _vm._v(" "), _c('p', [_vm._v("9:40 P.M. Rick: By whom?")]), _vm._v(" "), _c('p', [_vm._v("9:40 P.M. Sarah: My ex, his friends – why else would I leave?")]), _vm._v(" "), _c('p', [_vm._v("9:42 P.M. Rick: Now that is hilarious")]), _vm._v(" "), _c('p', [_vm._v("9:42 P.M. Sarah: The only reasonable explanation, other than that I have gone mad of course. I could chat away all night Rick. Shame about the flight – I’ll be boarding soon.")]), _vm._v(" "), _c('p', [_vm._v("9:43 P.M. Rick: I can vouch for your sexuality x")]), _vm._v(" "), _c('p', [_vm._v("9:44 P.M. Sarah: If I’m asked for a reference I’ll get in touch. Not that I need an excuse to touch you x")]), _vm._v(" "), _c('p', [_vm._v("9:45 P.M. Rick: All over x")]), _vm._v(" "), _c('p', [_vm._v("9:45 P.M. Sarah: Yes x")]), _vm._v(" "), _c('p', [_vm._v("9:46 P.M. Rick: With every part of you x")]), _vm._v(" "), _c('p', [_vm._v("9:46 P.M. Sarah: I think you know I like being a limpet x")]), _vm._v(" "), _c('p', [_vm._v("9:47 P.M. Rick: Mmm yes, I enjoyed your body over me, around me x")]), _vm._v(" "), _c('p', [_vm._v("9:51 P.M. Sarah: Thanks for keeping me company Rick. I really enjoy it but I’ll sign out now to board. Keep in touch Cutie Pie x")]), _vm._v(" "), _c('p', [_vm._v("9:52 P.M. Rick: Cutie Pie! Have a safe relaxing flight Sweet Cheeks. I will keep in touch xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "friday-1-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Friday, 1 June 2018")]), _vm._v(" "), _c('p', [_vm._v("6:59 P.M. Rick: Good morning Sarah. You arrived safely? How is the London lodging? x")]), _vm._v(" "), _c('p', [_vm._v("7:00 P.M. Sarah: Hi Rick, and yes thanks – it’s great to be here. My Airbnb room is good, the host seems friendly, and it’s fabulous to see the child. I’ve had a relatively normal sleep and am looking forward to coffee. I doubt my daughter has discerning taste on the coffee front – she drinks some disgusting concoction like a caramel macchiato from Starbucks – living like a local! Thinking of you quite a bit if I’m honest xxx")]), _vm._v(" "), _c('p', [_vm._v("9:53 P.M. Sarah: So just back from a 14,000-step walk (not an exaggeration) through the local park to a cute little “village” for my coffee – not as hearty as I like it but not bad, and the scones were fabulous as you might expect! x")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "saturday-2-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Saturday, 2 June 2018")]), _vm._v(" "), _c('p', [_vm._v("1:28 A.M. Rick: I’ve just had a huge walk too – to see the Vivid Sydney light display. Really spectacular, an amazing experience. How is your adventure? Still catching up with your daughter on all the gossip? x")]), _vm._v(" "), _c('p', [_vm._v("1:30 A.M. Sarah: I forgot you were going to Sydney! x")]), _vm._v(" "), _c('p', [_vm._v("1:32 A.M. Rick: It was pillow talk in the afterglow x")]), _vm._v(" "), _c('p', [_vm._v("1:32 A.M. Sarah: Mmm stop it x")]), _vm._v(" "), _c('p', [_vm._v("1:34 A.M. Rick: 💋💋")]), _vm._v(" "), _c('p', [_vm._v("11:45 P.M. Sarah: No gossip to catch up on – two or three times a week we each go for a walk on the other side of the world and talk, my morning, her evening. I have been aware since I separated from her father that there was some sorting out of roles to deal with. I know I’ve said it to you before, but I admit I’m a very different person to the one she grew up with – so much more open and relaxed, keen for new adventures, flexible, happy.")]), _vm._v(" "), _c('p', [_vm._v("She’s still not sure about the “new me”, and I find that very challenging. Neither of us really factored in how much I would change so I suspect she’s mourning the old mum, the old family life – regardless of how bad it was, it’s what she grew up with and is all she knows. I can’t open up about my new life at all – not just men or potential new relationships, but how I fund my lifestyle, where I live, who I associate with – without judgment. It’s nowhere near sorted, but we had a frank chat today, tears and all, so onward and upward. Nothing is simple is it? xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "sunday-3-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Sunday, 3 June 2018")]), _vm._v(" "), _c('p', [_vm._v("12:05 A.M. Rick: Well it’s good you are dealing with it, sometimes it’s just better to tell stuff like it is. She’s an adult after all.")]), _vm._v(" "), _c('p', [_vm._v("12:09 A.M. Sarah: She is, and I completely agree to telling it like it is, but it’s not easy! Would love to chat but I’d better go – we are on a mission x")]), _vm._v(" "), _c('p', [_vm._v("12:14 A.M. Rick: Of course, lover. Enjoy your day in the big city x")]), _vm._v(" "), _c('p', [_vm._v("12:14 A.M. Sarah: I like that. Lover. 💋")]), _vm._v(" "), _c('p', [_vm._v("12:15 A.M. Rick: Still thinking about your lips 💋")]), _vm._v(" "), _c('p', [_vm._v("12:16 A.M. Sarah: Oh, me too – haven’t had nearly enough of that xxx")]), _vm._v(" "), _c('p', [_vm._v("12:16 A.M. Rick: You naughty girl x")]), _vm._v(" "), _c('p', [_vm._v("12:17 A.M. Sarah: Really? You are the same x")]), _vm._v(" "), _c('p', [_vm._v("12:26 A.M. Rick: I am teasing you. Totally naughty, as you know I am. I get highly aroused thinking about the great sex we had x")]), _vm._v(" "), _c('p', [_vm._v("1:35 A.M. Sarah: Haaa yes it most certainly was babe xxx")]), _vm._v(" "), _c('p', [_vm._v("1:43 A.M. Rick: Apologies if that was too much information 😮😮")]), _vm._v(" "), _c('p', [_vm._v("1:45 A.M. Sarah: Absolutely not x")]), _vm._v(" "), _c('p', [_vm._v("8:40 A.M. Sarah: On the too much information theme, I love knowing you enjoyed it as much as I did – the extra virgin in me doesn’t have the experience to know for sure. Have a great day Rick xxx")]), _vm._v(" "), _c('p', [_vm._v("5:23 P.M. Rick: Good morning Sarah. You are awake quite early? Still getting your sleep pattern sorted? x")]), _vm._v(" "), _c('p', [_vm._v("5:25 P.M. Sarah: No, I had a terrible sleep following a meal which didn’t suit me. Lamb. We also walked a very long way yesterday, so a combination of factors designed to inhibit good sleep.")]), _vm._v(" "), _c('p', [_vm._v("5:26 P.M. Rick: Oh no! The dreaded kebab? comfort food for the drinking masses in London!")]), _vm._v(" "), _c('p', [_vm._v("5:28 P.M. Sarah: Correct, and I know, really not my thing. My daughter has terrible taste in food. I’ll have to take over picking eateries, I think.")]), _vm._v(" "), _c('p', [_vm._v("5:29 P.M. Rick: I have got to say I enjoyed myself immensely in your bed, it gave me great pleasure, giving and receiving x")]), _vm._v(" "), _c('p', [_vm._v("5:31 P.M. Sarah: I am delighted to know that cutie. Truly. I’m still in bed, eating toast, and will stay here for an hour or so then we are off to Kew Gardens x")]), _vm._v(" "), _c('p', [_vm._v("5:36 P.M. Rick: They should be awesome due to the mini heatwave. Have you been before? x")]), _vm._v(" "), _c('p', [_vm._v("5:37 P.M. Sarah: No, I haven’t, so I’m very keen. We need to make a schedule of things to see and do so we fit everything in x")]), _vm._v(" "), _c('p', [_vm._v("5:40 P.M. Rick: That’s true, you also need some quiet time so that you don’t go overboard and hit the wall x")]), _vm._v(" "), _c('p', [_vm._v("5:44 P.M. Sarah: She was so rude to me yesterday I actually wondered why I’d bothered. Kids eh?")]), _vm._v(" "), _c('p', [_vm._v("5:44 P.M. Rick: Did you address it with her?")]), _vm._v(" "), _c('p', [_vm._v("5:44 P.M. Sarah: I certainly did, and it’s partially sorted")]), _vm._v(" "), _c('p', [_vm._v("5:45 P.M. Rick: Excellent, it is only manners and she should appreciate the effort you have put in. Is she aware you have travelled to London to fix these issues?")]), _vm._v(" "), _c('p', [_vm._v("5:45 P.M. Sarah: Yes, she is. As you know, the problems arose as a consequence of the separation. She was fully aware before she left that things weren’t good between me and her father, and I had discussed the possibility of separation with her. She understood, of course, but no-one can really anticipate the wider ramifications of a decision like that. Well I certainly didn’t. We have had extensive unsatisfactory discussions, by phone and when she returned home for Christmas. That was a very frustrating trip for me because she has so many friends here that I hardly got an audience, and that’s why I jumped at the chance to have this trip when she said she was uncommitted for a few weeks now.")]), _vm._v(" "), _c('p', [_vm._v("Also, I met her boyfriend last night over the dodgy kebab. Having me meet him has been a cause of stress for her. They have had an interesting relationship – he has some personality traits similar to her father which concerns me enormously. According to his mother he has always been an angry boy, now an angry 23-year-old man. He hasn’t treated my child very well over the past year they have been together, but because of her father, she’s familiar with this sort of behaviour and tolerates it when anyone else would walk away. I’ll be walking if it happens to me again! Anyway, dinner went well, and I behaved myself x")]), _vm._v(" "), _c('p', [_vm._v("5:47 P.M. Rick: You’re right – it’s impossible to fully appreciate how a breakup will affect others, and every family is different. And that’s horrible for your daughter. She’s going to have to extract herself from that sooner or later. But you behaved yourself! Incredible x")]), _vm._v(" "), _c('p', [_vm._v("5:47 P.M. Sarah: The boyfriend issue is another reason I’m here. And yes, I kept my clothes on and everything x")]), _vm._v(" "), _c('p', [_vm._v("5:48 P.M. Rick: Lol. You also kept them on the first time we met x")]), _vm._v(" "), _c('p', [_vm._v("5:49 P.M. Sarah: Also, true. I’ll confess now that I had told myself I would keep them on before we met, and I needed to test my ability to stick to it. Sorry about that xxx")]), _vm._v(" "), _c('p', [_vm._v("5:50 P.M. Rick: That’s so funny! I didn’t think I’d read it that wrong – I did consider throwing you onto the backseat x")]), _vm._v(" "), _c('p', [_vm._v("5:51 P.M. Sarah: That probably would have worked. If you had said shall I come upstairs my resolve would have been seriously tested. Poor self-control in the face of cuteness x")]), _vm._v(" "), _c('p', [_vm._v("5:52 P.M. Rick: Cutie Pie x")]), _vm._v(" "), _c('p', [_vm._v("5:53 P.M. Sarah: Indeed xxx")]), _vm._v(" "), _c('p', [_vm._v("5:54 P.M. Rick: As you are. I hope I’m not holding you up Sweet Cheeks? x")]), _vm._v(" "), _c('p', [_vm._v("5:58 P.M. Sarah: No nothing pressing here. It’s only 7 A.M. You go if you need to. I’m just enjoying my new pen pal x")]), _vm._v(" "), _c('p', [_vm._v("5:58 P.M. Rick: I am crossing Sydney harbour on the ferry for another 10 mins. I’m travelling alone, so am available for you too. The lone wolf 🐺 x")]), _vm._v(" "), _c('p', [_vm._v("6:01 P.M. Sarah: It’s nice sometimes isn’t it – but I would have come! You wouldn’t have seen the lights of Vivid Sydney then, or perhaps just what is visible from a hotel room? Having said that, I’ve demonstrated self-control once. I can do it again x")]), _vm._v(" "), _c('p', [_vm._v("6:05 P.M. Rick: I don’t think so Sarah. The need and desire will be too great x")]), _vm._v(" "), _c('p', [_vm._v("6:06 P.M. Sarah: We’ll have to test that theory. Happy to fail x")]), _vm._v(" "), _c('p', [_vm._v("6:16 P.M. Rick: And you know I will test you over and over, don’t you lover x")]), _vm._v(" "), _c('p', [_vm._v("6:17 P.M. Sarah: I do and I expect to fail, over and over xxx")]), _vm._v(" "), _c('p', [_vm._v("6:19 P.M. Rick: Are you aroused lover? xxx")]), _vm._v(" "), _c('p', [_vm._v("6:20 P.M. Sarah: I most definitely am. I know you are xxx")]), _vm._v(" "), _c('p', [_vm._v("6:28 P.M. Rick: Totally. Why wouldn’t I be? remembering those hungry, passionate kisses, your touch xxx")]), _vm._v(" "), _c('p', [_vm._v("6:29 P.M. Sarah: Aww thanks xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "monday-4-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Monday, 4 June 2018")]), _vm._v(" "), _c('p', [_vm._v("7:53 A.M. Sarah: I’d love a kiss and a cuddle right now Rick, but with a step count of 22,274 today I’m not sure my hips are up to much more than that! Lucky, I have a couple of weeks to recover xxx")]), _vm._v(" "), _c('p', [_vm._v("8:11 A.M. Rick: Good morning lover. A kiss and cuddle would be delicious, and you would soon forget any aches in your hips xxx")]), _vm._v(" "), _c('p', [_vm._v("8:12 A.M. Sarah: Yum, yes please x")]), _vm._v(" "), _c('p', [_vm._v("8:16 A.M. Rick: If we could have measured activity levels in your bed it would have been off the chart xxx")]), _vm._v(" "), _c('p', [_vm._v("8:17 A.M. Sarah: Haha yes, I don’t tend bring my phone to bed! x")]), _vm._v(" "), _c('p', [_vm._v("8:19 A.M. Rick: The vibrations can be somewhat stimulating. Are you imagining just lying together or moving your delicious hips? x")]), _vm._v(" "), _c('p', [_vm._v("8:20 A.M. Sarah: Either would be welcome therapy x")]), _vm._v(" "), _c('p', [_vm._v("8:21 A.M. Rick: For the mind and body x")]), _vm._v(" "), _c('p', [_vm._v("8:21 A.M. Sarah: Yes. Absolutely. I loved Kew gardens – just stunning and a beautiful day too – 27 degrees x")]), _vm._v(" "), _c('p', [_vm._v("8:23 A.M. Rick: I trust you used sun block x")]), _vm._v(" "), _c('p', [_vm._v("8:23 A.M. Sarah: I did")]), _vm._v(" "), _c('p', [_vm._v("8:24 A.M. Rick: So you can be a good girl!")]), _vm._v(" "), _c('p', [_vm._v("8:25 A.M. Sarah: So, it seems. Doesn’t happen often according to my daughter")]), _vm._v(" "), _c('p', [_vm._v("8:26 A.M. Rick: I have seen both sides of you. It’s your bad side that won the day for me x")]), _vm._v(" "), _c('p', [_vm._v("8:26 A.M. Sarah: Bad? I thought that was the good side xxx")]), _vm._v(" "), _c('p', [_vm._v("8:27 A.M. Rick: It’s a fine line lover xxx")]), _vm._v(" "), _c('p', [_vm._v("8:28 A.M. Rick: Do you regret inviting me into your bed Sarah? X")]), _vm._v(" "), _c('p', [_vm._v("8:28 A.M. Sarah: No, I don’t at all. I had nothing to lose, everything to gain xxx")]), _vm._v(" "), _c('p', [_vm._v("8:29 A.M. Rick: That’s good to hear. Would you have changed anything? x")]), _vm._v(" "), _c('p', [_vm._v("8:31 A.M. Sarah: I enjoyed it enormously so probably not – you?")]), _vm._v(" "), _c('p', [_vm._v("8:33 A.M. Rick: I most certainly did too, I did consider serving you up on the dining room table. Put you on your back and devour you with my mouth. Possibly test you with a drop of wax on your nipple x")]), _vm._v(" "), _c('p', [_vm._v("8:35 A.M. Sarah: That’s evil!")]), _vm._v(" "), _c('p', [_vm._v("8:36 A.M. Rick: When you read the wax message did your hips move involuntarily?")]), _vm._v(" "), _c('p', [_vm._v("8:37 A.M. Sarah: They are moving all the time")]), _vm._v(" "), _c('p', [_vm._v("8:37 A.M. Rick: As they did when you envisioned yourself on the table")]), _vm._v(" "), _c('p', [_vm._v("8:38 A.M. Sarah: You’re bad xxx")]), _vm._v(" "), _c('p', [_vm._v("8:38 A.M. Rick: Yes, we are xxx")]), _vm._v(" "), _c('p', [_vm._v("8:40 A.M. Sarah: How often does the gentleman appear?")]), _vm._v(" "), _c('p', [_vm._v("8:42 A.M. Rick: He is present all the time, it’s when the bad boy appears that will be the unexpected x")]), _vm._v(" "), _c('p', [_vm._v("8:43 A.M. Sarah: Careful with me. Extra virgin remember x")]), _vm._v(" "), _c('p', [_vm._v("8:45 A.M. Rick: You know I listened to you lover as I plunged deep into you. You asked me to stop when I went too deep and I did x")]), _vm._v(" "), _c('p', [_vm._v("8:46 A.M. Sarah: You did babe x")]), _vm._v(" "), _c('p', [_vm._v("8:47 A.M. Rick: Remember that fine line between pleasure and pain mmm")]), _vm._v(" "), _c('p', [_vm._v("8:47 A.M. Sarah: Oh, I certainly do xxx")]), _vm._v(" "), _c('p', [_vm._v("8:49 A.M. Rick: How you missed it when I took it away x")]), _vm._v(" "), _c('p', [_vm._v("9:04 A.M. Rick: It is a workday in Australia and I need to jump in the shower...close your eyes 👀 hahaha xxx")]), _vm._v(" "), _c('p', [_vm._v("9:07 A.M. Sarah: Ok sweet, eyes shut. I need to sleep – completely exhausted. Think of me today xxx")]), _vm._v(" "), _c('p', [_vm._v("9:17 A.M. Rick: Oh, I will. Goodnight lover xxx")]), _vm._v(" "), _c('p', [_vm._v("9:17 A.M. Sarah: xxx")]), _vm._v(" "), _c('p', [_vm._v("5:59 P.M. Sarah: Hello Cutie Pie. I’m still watching tv in bed. Netflix. I live a fiction life x")]), _vm._v(" "), _c('p', [_vm._v("6:04 P.M. Rick: Good morning sleepyhead. Escapism is good x")]), _vm._v(" "), _c('p', [_vm._v("6:06 P.M. Sarah: I think so. I’ve always read a lot of fiction, not so much in the last year or so – the stress in my life has rather consumed my mind. I never know who was acting in a movie – I completely believe the characters!")]), _vm._v(" "), _c('p', [_vm._v("6:09 P.M. Rick: Mmm. Interesting. Lie on the couch and let’s talk about this hahaha x")]), _vm._v(" "), _c('p', [_vm._v("6:10 P.M. Sarah: You just want me horizontal x")]), _vm._v(" "), _c('p', [_vm._v("6:15 P.M. Rick: You naughty girl – it never crossed my mind! Although I am much more creative that just horizontal x")]), _vm._v(" "), _c('p', [_vm._v("6:16 P.M. Sarah: I’m sure you are x")]), _vm._v(" "), _c('p', [_vm._v("6:26 P.M. Rick: What’s on the cards today?")]), _vm._v(" "), _c('p', [_vm._v("6:29 P.M. Sarah: I’m being given the tour of the child’s life and various things in the city, then she has a social event to attend tonight so I’ll have a quiet moment later")]), _vm._v(" "), _c('p', [_vm._v("6:30 P.M. Rick: That sounds fun. Will you go on the pick up at the local pub? 👅👅😮😮")]), _vm._v(" "), _c('p', [_vm._v("6:31 P.M. Sarah: Not sure I’m in the mood for a man x")]), _vm._v(" "), _c('p', [_vm._v("6:32 P.M. Rick: You cougar! Would you tell me if you did? x")]), _vm._v(" "), _c('p', [_vm._v("6:32 P.M. Sarah: You know I only go on Tinder when I’m exceptionally bored – I’ve probably been active a total of ten days in my single life. Would I tell you? If you really wanted me to – would you be interested? I’ve never had anyone to tell before! x")]), _vm._v(" "), _c('p', [_vm._v("6:32 P.M. Rick: I’d be very interested babe x")]), _vm._v(" "), _c('p', [_vm._v("6:34 P.M. Sarah: You know about my recent exploits but what about you? How many do you have on the go?")]), _vm._v(" "), _c('p', [_vm._v("6:35 P.M. Rick: So you just use Tinder to satisfy your basic needs. I have a full harem on the go… NOT")]), _vm._v(" "), _c('p', [_vm._v("6:36 P.M. Sarah: I use it to alleviate boredom and if it turns into more – and it always seems to – then that’s good too. I like people and I like chatting, and – as you observed – I like sex x")]), _vm._v(" "), _c('p', [_vm._v("6:37 P.M. Rick: Why wouldn’t it turn into more? You are very desirable x")]), _vm._v(" "), _c('p', [_vm._v("6:38 P.M. Sarah: So funny to think of myself like that. I’m having a lot of these moments lately, and I’ve had to adjust my self-image rather drastically x")]), _vm._v(" "), _c('p', [_vm._v("6:38 P.M. Rick: You breathe sex woman! You’re insatiable x")]), _vm._v(" "), _c('p', [_vm._v("6:38 P.M. Sarah: Haha we’ll see about that x")]), _vm._v(" "), _c('p', [_vm._v("6:39 P.M. Rick: I will put you to the test lover x")]), _vm._v(" "), _c('p', [_vm._v("6:40 P.M. Sarah: I’ve worked that out xxx")]), _vm._v(" "), _c('p', [_vm._v("6:41 P.M. Rick: I know your hand is between your legs x")]), _vm._v(" "), _c('p', [_vm._v("6:41 P.M. Sarah: Stop that x")]), _vm._v(" "), _c('p', [_vm._v("6:42 P.M. Rick: Haha. Caught you x")]), _vm._v(" "), _c('p', [_vm._v("6:43 P.M. Sarah: You have made me actually laugh now. No idea what my host thinks is going on in here x")]), _vm._v(" "), _c('p', [_vm._v("6:44 P.M. Sarah: Shouldn’t you be out being busy and important?")]), _vm._v(" "), _c('p', [_vm._v("6:47 P.M. Rick: I enjoy playing with you lover. Will you cum thinking of me? xxx")]), _vm._v(" "), _c('p', [_vm._v("6:48 P.M. Sarah: Probably, yes, as I lie in bed x")]), _vm._v(" "), _c('p', [_vm._v("6:49 P.M. Rick: Mmm. I would lick your fingers")]), _vm._v(" "), _c('p', [_vm._v("6:49 P.M. Sarah: Or lick elsewhere")]), _vm._v(" "), _c('p', [_vm._v("6:50 P.M. Rick: Only if you hold my head there until you explode mmm")]), _vm._v(" "), _c('p', [_vm._v("6:56 P.M. Sarah: I’d better get up, shower, and find me a real coffee xxx")]), _vm._v(" "), _c('p', [_vm._v("6:58 P.M. Rick: Not a real man!!! xxx")]), _vm._v(" "), _c('p', [_vm._v("6:59 P.M. Sarah: Do I need another real man? x")]), _vm._v(" "), _c('p', [_vm._v("7:06 P.M. Rick: Not yet, still life left in me x")]), _vm._v(" "), _c('p', [_vm._v("7:13 P.M. Sarah: I noticed that babe x")]), _vm._v(" "), _c('p', [_vm._v("9:12 P.M. Rick: Did you find good coffee?")]), _vm._v(" "), _c('p', [_vm._v("9:13 P.M. Sarah: Yes, I now have a favourite cafe here in the hood. My regular tipple is a piccolo which is a cortado here")]), _vm._v(" "), _c('p', [_vm._v("9:26 P.M. Rick: You are the fussy one!")]), _vm._v(" "), _c('p', [_vm._v("10:07 P.M. Sarah: You have no idea. I have been left in the capable hands of the British museum while the child goes to the gym. I’m being enlightened.")]), _vm._v(" "), _c('p', [_vm._v("10:31 P.M. Rick: That’s now twice in a week!")]), _vm._v(" "), _c('p', [_vm._v("10:31 P.M. Sarah: Twice enlightened?")]), _vm._v(" "), _c('p', [_vm._v("10:32 P.M. Rick: You are having some Brit culture put in you 😂😂")]), _vm._v(" "), _c('p', [_vm._v("10:33 P.M. Sarah: Haha that’s inappropriate in these hallowed halls xxx")]), _vm._v(" "), _c('p', [_vm._v("10:35 P.M. Rick: Totally. There again we are both rebels xxx")]), _vm._v(" "), _c('p', [_vm._v("10:35 P.M. Sarah: What if someone is reading over my shoulder!")]), _vm._v(" "), _c('p', [_vm._v("10:35 P.M. Rick: It would make their day!!!")]), _vm._v(" "), _c('p', [_vm._v("10:35 P.M. Sarah: You’re not playing fair! I’m not meant to snigger my way round x")]), _vm._v(" "), _c('p', [_vm._v("10:37 P.M. Rick: Apologies for my abhorrent behaviour. What are you wearing – a summer dress?")]), _vm._v(" "), _c('p', [_vm._v("10:38 P.M. Sarah: Jeans – it’s cooler today. I wore a summer dress yesterday. My favourite clothing.")]), _vm._v(" "), _c('p', [_vm._v("10:39 P.M. Rick: Mmm. As it is mine, although I fear for completely different reasons x")]), _vm._v(" "), _c('p', [_vm._v("10:40 P.M. Sarah: I suspect so. Tell me why summer dresses are your favourite?")]), _vm._v(" "), _c('p', [_vm._v("10:48 P.M. Rick: Easy access, perfect for flashing 😮😮😮")]), _vm._v(" "), _c('p', [_vm._v("10:49 P.M. Sarah: I like you to have easy access too, not sure about the flashing")]), _vm._v(" "), _c('p', [_vm._v("10:49 P.M. Rick: At any time, we both have the need to ravish each other")]), _vm._v(" "), _c('p', [_vm._v("10:50 P.M. Sarah: It feels nice worn with skimpy undergarments also. I like the feel of a breeze")]), _vm._v(" "), _c('p', [_vm._v("10:50 P.M. Rick: Who mentioned anything about undergarments? I will have you take them off and hand them to me")]), _vm._v(" "), _c('p', [_vm._v("10:51 P.M. Sarah: What if the wind blows?")]), _vm._v(" "), _c('p', [_vm._v("10:53 P.M. Rick: Then you will be modest and try to hold the dress down. Until I tell you to let it go.")]), _vm._v(" "), _c('p', [_vm._v("10:53 P.M. Sarah: You’re bossy! x")]), _vm._v(" "), _c('p', [_vm._v("10:54 P.M. Rick: We know this. I will push your boundaries lover, if you allow it x")]), _vm._v(" "), _c('p', [_vm._v("11:27 P.M. Sarah: Easy tiger x")]), _vm._v(" "), _c('p', [_vm._v("11:28 P.M. Rick: You are the tiger. I am the wolf x")]), _vm._v(" "), _c('p', [_vm._v("11:29 P.M. Sarah: Just got lost getting to the street corner appointed")]), _vm._v(" "), _c('p', [_vm._v("11:32 P.M. Rick: I won’t even go there, lover xxx")]), _vm._v(" "), _c('p', [_vm._v("11:35 P.M. Sarah: I look like I hang out on street corners, do I?")]), _vm._v(" "), _c('p', [_vm._v("11:36 P.M. Rick: I would make you stand on a street corner mmm. It’s a game we could play.")]), _vm._v(" "), _c('p', [_vm._v("11:39 P.M. Sarah: Hmmm I’ve never met anyone quite like you before sweetheart x")]), _vm._v(" "), _c('p', [_vm._v("11:40 P.M. Rick: Does it scare you? xxx")]), _vm._v(" "), _c('p', [_vm._v("11:40 P.M. Sarah: It’s just new, so no, not yet anyway. You know my motto – open mind, open heart")]), _vm._v(" "), _c('p', [_vm._v("11:42 P.M. Rick: Add open legs to that x")]), _vm._v(" "), _c('p', [_vm._v("11:49 P.M. Sarah: Lol yes ok. Lunch with the child and her boyfriend – marvellous – mushy twenty something handholding x")]), _vm._v(" "), _c('p', [_vm._v("11:49 P.M. Rick: Puppy love x")]), _vm._v(" "), _c('p', [_vm._v("11:50 P.M. Sarah: I know. It would do her good to see me in a clinch with a man x")]), _vm._v(" "), _c('p', [_vm._v("11:51 P.M. Rick: Tell her about your last liaison")]), _vm._v(" "), _c('p', [_vm._v("11:52 P.M. Sarah: I could never. She thinks as a mother I should have the sense not to indulge in such activities, let alone talk about them – to her at least. Of course, it’s ok that I know details of her sex life I’d rather not know, it’s hardly an even playing field. We have a rather one-sided conversation on that topic. I know she is torn between wanting to know and being somehow disgusted. She could be feeling disloyal, or frustrated herself, or she could be horrified at the thought of old people sex! I actually have no comprehension and it frustrates me enormously.")]), _vm._v(" "), _c('p', [_vm._v("11:55 P.M. Rick: It’s complicated and probably confusing to her too. Disloyal to her father?")]), _vm._v(" "), _c('p', [_vm._v("11:55 P.M. Sarah: I guess so, but that’s stupid because he has a new woman. I’m being sensible – actively learning how to be single, and actively learning how to not enter a new relationship until I’m ready.")]), _vm._v(" "), _c('p', [_vm._v("11:56 P.M. Rick: She should be happy for you")]), _vm._v(" "), _c('p', [_vm._v("11:56 P.M. Sarah: I know")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "tuesday-5-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Tuesday, 5 June 2018")]), _vm._v(" "), _c('p', [_vm._v("12:49 A.M. Rick: Are you also chatting to your other lovers? x")]), _vm._v(" "), _c('p', [_vm._v("12:55 A.M. Sarah: Haha no. To be continued...it’s getting late for you?")]), _vm._v(" "), _c('p', [_vm._v("12:55 A.M. Rick: The next thrilling episode")]), _vm._v(" "), _c('p', [_vm._v("12:58 A.M. Sarah: I can stop being thrilling if you’d rather? Tell me if I’m boring you!")]), _vm._v(" "), _c('p', [_vm._v("1:00 A.M. Rick: You do thrill me lover x")]), _vm._v(" "), _c('p', [_vm._v("1:00 A.M. Sarah: So, on the other men, I think I might have said I’d reached a bit of a hiatus? What that means is I’m frustrated or bored with people I’ve seen recently and need a fresh start, which is where you come in.")]), _vm._v(" "), _c('p', [_vm._v("1:05 A.M. Rick: Mmm I certainly did x")]), _vm._v(" "), _c('p', [_vm._v("1:06 A.M. Sarah: From what you’ve said you have no one else at the moment?")]), _vm._v(" "), _c('p', [_vm._v("1:06 A.M. Rick: That’s correct.")]), _vm._v(" "), _c('p', [_vm._v("1:08 A.M. Sarah: Ok, just good to know where you stand. I’ve had a difficult time with one man recently. I told you before that he’s very keen, in love even, but with his other commitments he doesn’t have much time for me, so he’s torn and I’m frustrated! Being away is making me realise how it just can’t work given our different life stages.")]), _vm._v(" "), _c('p', [_vm._v("1:09 A.M. Rick: One of your lovers?")]), _vm._v(" "), _c('p', [_vm._v("1:10 A.M. Sarah: Yes, but I don’t want more than one at a time.")]), _vm._v(" "), _c('p', [_vm._v("1:11 A.M. Rick: Let’s keep an open mind about that! X")]), _vm._v(" "), _c('p', [_vm._v("1:36 A.M. Sarah: I totally do have an open mind about that – I can’t commit to not wanting a relationship, but still expect exclusive. It’s just my personal preference for the moment. Sleep tight, see you tomorrow xxx")]), _vm._v(" "), _c('p', [_vm._v("1:36 A.M. Rick: Yes, sleep time, goodnight lover xxx")]), _vm._v(" "), _c('p', [_vm._v("8:01 A.M. Rick: Good morning Sweet Cheeks x")]), _vm._v(" "), _c('p', [_vm._v("8:01 A.M. Sarah: Hey sweetheart, sleep well? You wake up early too x")]), _vm._v(" "), _c('p', [_vm._v("8:03 A.M. Rick: I did thank you. It’s my body clock and doesn’t really matter which country I am in. There is also another reason. It’s a male thing x")]), _vm._v(" "), _c('p', [_vm._v("8:04 A.M. Sarah: And what fixes that?")]), _vm._v(" "), _c('p', [_vm._v("8:05 A.M. Rick: A vivid imagination")]), _vm._v(" "), _c('p', [_vm._v("8:05 A.M. Sarah: I hope I feature?")]), _vm._v(" "), _c('p', [_vm._v("8:06 A.M. Rick: Actually, you do. Is that a turn on for you lover? xxx")]), _vm._v(" "), _c('p', [_vm._v("8:08 A.M. Sarah: Absolutely is! xxx")]), _vm._v(" "), _c('p', [_vm._v("8:10 A.M. Rick: At the moment I have you on top riding me hard mmm")]), _vm._v(" "), _c('p', [_vm._v("8:11 A.M. Sarah: Sounds delish – I’m sure I could do that xxx")]), _vm._v(" "), _c('p', [_vm._v("8:12 A.M. Rick: Oh, from past experience you do it rather well except there is a variance this morning. Reverse cowgirl.")]), _vm._v(" "), _c('p', [_vm._v("8:15 A.M. Sarah: You prefer that?")]), _vm._v(" "), _c('p', [_vm._v("8:16 A.M. Rick: It does give us both a great view and allows me access to you as you ride me")]), _vm._v(" "), _c('p', [_vm._v("8:18 A.M. Sarah: Either way works for me – I do like access to your mouth x")]), _vm._v(" "), _c('p', [_vm._v("8:18 A.M. Rick: Would that be with your mouth?")]), _vm._v(" "), _c('p', [_vm._v("8:19 A.M. Sarah: Generally, yes")]), _vm._v(" "), _c('p', [_vm._v("8:19 A.M. Rick: You don’t seem to be an oral person, as in oral sex. Have you had a bad experience?")]), _vm._v(" "), _c('p', [_vm._v("8:21 A.M. Sarah: I have, years ago, but I’ve dealt with that now and am just inexperienced. With my ex I had got to a point where I refused oral sex (giving or receiving) – and I say this in complete honesty – as a way of exercising control over him. Getting my own back for other relationship crimes. I’m not proud of it. He was a very controlling man. And remember I’ve only been in bed with you once!")]), _vm._v(" "), _c('p', [_vm._v("8:23 A.M. Rick: That’s fair enough lover. I am generally an anywhere and everywhere type of person.")]), _vm._v(" "), _c('p', [_vm._v("8:24 A.M. Sarah: As I say I’m just inexperienced. If you’d done brief encounters, a few minutes each, twice a week for several years you might feel similar. I’m very familiar with not being noticed sexually, so that’s new and intoxicating!")]), _vm._v(" "), _c('p', [_vm._v("8:27 A.M. Rick: Do you regret taking me to your bed lover?")]), _vm._v(" "), _c('p', [_vm._v("8:27 A.M. Sarah: You’ve asked that before, and I definitely don’t regret anything. Should I? I enjoyed your company and your body, and hope to again xxx")]), _vm._v(" "), _c('p', [_vm._v("8:29 A.M. Rick: Excellent. So, in one night with me you had a year of otherwise historical sex lol x")]), _vm._v(" "), _c('p', [_vm._v("8:30 A.M. Sarah: Correct. I’m catching up babe and loving it. I don’t think I have time to catch up completely! Would have to violate my one at a time rule x")]), _vm._v(" "), _c('p', [_vm._v("8:34 A.M. Rick: Your moral upbringing showing through")]), _vm._v(" "), _c('p', [_vm._v("8:34 A.M. Sarah: Sort of, yes. My childhood was traditional, I was sheltered from anything to do with sex, and I never broached difficult subjects with my parents. Having said that, I’ve always lived outside my family’s morals (in my head at least) and was attracted to bad lads as a youth. I scared myself so much that I ended up with the person who represented an overreaction to that. He was a difficult man, but at the time I saw safety, loyalty and security. I thought that was what I needed. Turns out…")]), _vm._v(" "), _c('p', [_vm._v("8:38 A.M. Rick: There is a naughty side to you Sarah xxx")]), _vm._v(" "), _c('p', [_vm._v("8:39 A.M. Sarah: There is. It has been kept away for a long time")]), _vm._v(" "), _c('p', [_vm._v("8:41 A.M. Rick: Now it’s time to release the Kraken!")]), _vm._v(" "), _c('p', [_vm._v("8:43 A.M. Sarah: Maybe so. It’s been building as I’ve said before x")]), _vm._v(" "), _c('p', [_vm._v("8:46 A.M. Rick: The time is right for you to take control and enjoy yourself. As I took you in your bed, you didn’t let yourself go fully. Why is that?")]), _vm._v(" "), _c('p', [_vm._v("8:48 A.M. Sarah: Yes, that’s true. I find it hard to let go.")]), _vm._v(" "), _c('p', [_vm._v("8:49 A.M. Rick: Why though lover? x")]), _vm._v(" "), _c('p', [_vm._v("8:51 A.M. Sarah: Difficult to answer, but I’d say there’s a feeling I don’t deserve the time spent on me and have consequent performance anxieties. Sexually insecure, unworthy. I’m sure these are common issues for women.")]), _vm._v(" "), _c('p', [_vm._v("8:53 A.M. Rick: You have no need to question your sexuality or performance lover. Do you feel you have missed out? x")]), _vm._v(" "), _c('p', [_vm._v("8:56 A.M. Sarah: Haha of course I do – I have! A lifetime.")]), _vm._v(" "), _c('p', [_vm._v("8:57 A.M. Rick: Depends lover on what you feel you have missed out on and if you are willing to explore")]), _vm._v(" "), _c('p', [_vm._v("9:02 A.M. Sarah: I am, that’s how I met you. I’m trying to be kinder to myself too – I know if I go too fast it won’t end well for me. That’s what I was trying to say before – easy tiger. I will get there.")]), _vm._v(" "), _c('p', [_vm._v("9:03 A.M. Rick: Of that I am 100000% sure")]), _vm._v(" "), _c('p', [_vm._v("9:03 A.M. Sarah: Thank you. This is a pretty heavy chat, especially when you haven’t even got out of bed! Hope you’re not put off by it x")]), _vm._v(" "), _c('p', [_vm._v("9:06 A.M. Rick: Not at all lover. It’s who you are and you shouldn’t accept anything less of yourself x")]), _vm._v(" "), _c('p', [_vm._v("9:07 A.M. Sarah: You’re very kind. Thank you for not judging x")]), _vm._v(" "), _c('p', [_vm._v("9:08 A.M. Rick: Who am I to judge you? x")]), _vm._v(" "), _c('p', [_vm._v("9:08 A.M. Sarah: People do")]), _vm._v(" "), _c('p', [_vm._v("9:10 A.M. Rick: Narrow minded people")]), _vm._v(" "), _c('p', [_vm._v("9:10 A.M. Sarah: Indeed x")]), _vm._v(" "), _c('p', [_vm._v("9:14 A.M. Rick: Tell me one of your wildest fantasies that you would like to happen")]), _vm._v(" "), _c('p', [_vm._v("9:15 A.M. Sarah: Another challenge! I haven’t dared have fantasies xxx")]), _vm._v(" "), _c('p', [_vm._v("9:18 A.M. Rick: It’s giving you an opportunity to be open with yourself x")]), _vm._v(" "), _c('p', [_vm._v("9:20 A.M. Sarah: I know, and it is good for me to be challenged like this x")]), _vm._v(" "), _c('p', [_vm._v("9:26 A.M. Sarah: Only 18,000 steps round the monopoly board today")]), _vm._v(" "), _c('p', [_vm._v("9:27 A.M. Rick: Used up all that pent-up sexuality?")]), _vm._v(" "), _c('p', [_vm._v("9:27 A.M. Sarah: Lol no. I’m always ready!")]), _vm._v(" "), _c('p', [_vm._v("9:28 A.M. Rick: Mmm let me taste")]), _vm._v(" "), _c('p', [_vm._v("9:28 A.M. Sarah: Wish you could")]), _vm._v(" "), _c('p', [_vm._v("9:29 A.M. Rick: Are you aching lover")]), _vm._v(" "), _c('p', [_vm._v("9:31 A.M. Sarah: Yes. Are you?")]), _vm._v(" "), _c('p', [_vm._v("9:31 A.M. Rick: Totally")]), _vm._v(" "), _c('p', [_vm._v("9:32 A.M. Sarah: Two more weeks of this and you’ll have to pick me up from the airport and whisk me to the nearest bedroom!")]), _vm._v(" "), _c('p', [_vm._v("9:35 A.M. Rick: I like that idea, you naughty girl. I do enjoy the intimacy of kissing you lover, your passion xxx")]), _vm._v(" "), _c('p', [_vm._v("9:48 A.M. Sarah: Ah don’t! Hey, I need to sleep – thanks for today sweetheart xxx")]), _vm._v(" "), _c('p', [_vm._v("9:50 A.M. Rick: It’s my pleasure lover. Sweet dreams xxx")]), _vm._v(" "), _c('p', [_vm._v("3:25 P.M. Rick: Hello lover xxx")]), _vm._v(" "), _c('p', [_vm._v("3:25 P.M. Sarah: Hello babe x")]), _vm._v(" "), _c('p', [_vm._v("4:42 P.M. Sarah: I’m hungry. Pizza, toast and coffee. Breaking more rules – no food in your room allowed!")]), _vm._v(" "), _c('p', [_vm._v("4:43 P.M. Rick: Yummy. An early morning feast. You rebel, but I think they are referring to smelly Chinese or Indian, not toast!")]), _vm._v(" "), _c('p', [_vm._v("4:44 P.M. Sarah: I don’t think so actually, the host is a fussy little Italian chap and is worried about crumbs in the bed. Having said that I do generally assume rules don’t apply to me lol.")]), _vm._v(" "), _c('p', [_vm._v("4:45 P.M. Rick: Well. Lamb!!!")]), _vm._v(" "), _c('p', [_vm._v("4:45 P.M. Sarah: What??? The dodgy lamb wasn’t consumed in my bedroom, but cheap fatty meat is definitely one thing I’m too old for!")]), _vm._v(" "), _c('p', [_vm._v("4:54 P.M. Rick: You are never too old for anything lover. Just out of practice x")]), _vm._v(" "), _c('p', [_vm._v("4:55 P.M. Sarah: Too old for dodgy kebabs – that’s the only thing I’m too old for that I can think of. I have reverted to the age I was when I entered the last relationship, so I’m only 22 x")]), _vm._v(" "), _c('p', [_vm._v("4:57 P.M. Rick: Which makes me only 24 x")]), _vm._v(" "), _c('p', [_vm._v("4:58 P.M. Sarah: Fantastic. You are the first man older than me in 34 years. Assuming you put your correct age on Tinder? Correct name?")]), _vm._v(" "), _c('p', [_vm._v("5:43 P.M. Rick: Of course, I have, what reason would you change them for? Have you? x")]), _vm._v(" "), _c('p', [_vm._v("5:45 P.M. Sarah: All correct from me, but I’ve met women who have lied about their age. You must be heading home today?")]), _vm._v(" "), _c('p', [_vm._v("6:16 P.M. Rick: I’m working in the airport lounge, ready to fly this evening")]), _vm._v(" "), _c('p', [_vm._v("6:17 P.M. Sarah: No rest for the wicked x")]), _vm._v(" "), _c('p', [_vm._v("6:31 P.M. Rick: Talking about wicked... What are your plans for today? x")]), _vm._v(" "), _c('p', [_vm._v("6:34 P.M. Sarah: Lol today is based around dinner at a restaurant near Tower Bridge with a friend of my daughter’s. I think I’ll be babysat by another British cultural attraction while she goes to the gym, then I’ll follow the leader. I swear she’ll have me on a leash by the end of this journey so I don’t get lost! x")]), _vm._v(" "), _c('p', [_vm._v("6:42 P.M. Rick: Exactly why are you there??? x")]), _vm._v(" "), _c('p', [_vm._v("6:47 P.M. Sarah: It’s fun being the child x")]), _vm._v(" "), _c('p', [_vm._v("7:02 P.M. Rick: Only if you wear the school girl outfits 😮😮")]), _vm._v(" "), _c('p', [_vm._v("7:02 P.M. Sarah: I am of course, just for you. This is the revenge of the mother. Officially I’m here to witness her life and I’m such an awesome mother that anything else is a bonus 🙂")]), _vm._v(" "), _c('p', [_vm._v("7:11 P.M. Rick: For whose benefit?")]), _vm._v(" "), _c('p', [_vm._v("7:12 P.M. Sarah: Both, but mainly hers")]), _vm._v(" "), _c('p', [_vm._v("7:44 P.M. Rick: The things we do for our children!")]), _vm._v(" "), _c('p', [_vm._v("7:48 P.M. Sarah: I know babe. Selfless. Having my cortado with her now.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "wednesday-6-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Wednesday, 6 June 2018")]), _vm._v(" "), _c('p', [_vm._v("6:59 A.M. Sarah: Morning cutie x")]), _vm._v(" "), _c('p', [_vm._v("7:07 A.M. Sarah: Busy day in the big city. A highlight was Borough Market where we had incredible gnocchi. We’re worn out and grumpy waiting for the train now. Hope your trip home was uneventful, and I featured again in this morning’s happy thoughts xxx")]), _vm._v(" "), _c('p', [_vm._v("8:41 A.M. Rick: Good morning lover. My plane was delayed but I’m home and was definitely thinking of you this morning x")]), _vm._v(" "), _c('p', [_vm._v("9:41 A.M. Rick: Have you orgasmed since you have been there lover? X")]), _vm._v(" "), _c('p', [_vm._v("3:27 P.M. Sarah: That’s a funny message to wake up to! As it happens, I have. We’re off to France this afternoon for three nights x")]), _vm._v(" "), _c('p', [_vm._v("3:41 P.M. Rick: Going to buy pastries and drink coffee? It’s so convenient and well-priced to travel from the UK x")]), _vm._v(" "), _c('p', [_vm._v("3:43 P.M. Sarah: My body needs a break from all this walking. Yesterday we didn’t go so far but I need a day to just chill, and some hands on my aching muscles would be very welcome – like to volunteer? x")]), _vm._v(" "), _c('p', [_vm._v("4:10 P.M. Rick: How will that help? I will exhaust you x")]), _vm._v(" "), _c('p', [_vm._v("4:11 P.M. Sarah: It’s not walking x")]), _vm._v(" "), _c('p', [_vm._v("4:44 P.M. Rick: That’s true unless I make you do all the work x")]), _vm._v(" "), _c('p', [_vm._v("4:45 P.M. Sarah: It’s a massage man, and you’d never do that! x")]), _vm._v(" "), _c('p', [_vm._v("4:45 P.M. Rick: Never say never x")]), _vm._v(" "), _c('p', [_vm._v("4:48 P.M. Sarah: It’s bizarre having this long intensely personal conversation with you – we only just met! x")]), _vm._v(" "), _c('p', [_vm._v("4:49 P.M. Rick: We can talk about the weather if you’d rather? I hear it’s raining men")]), _vm._v(" "), _c('p', [_vm._v("4:55 P.M. Sarah: That’s true. Who would have thought!")]), _vm._v(" "), _c('p', [_vm._v("4:56 P.M. Rick: Most of them are drips")]), _vm._v(" "), _c('p', [_vm._v("4:57 P.M. Sarah: They all make puddles")]), _vm._v(" "), _c('p', [_vm._v("4:57 P.M. Rick: That’s naughty!")]), _vm._v(" "), _c('p', [_vm._v("7:59 P.M. Sarah: A summer dress day – it should get to 24 👗")]), _vm._v(" "), _c('p', [_vm._v("10:19 P.M. Rick: Hello lover. So, in a dress, don’t give me ideas mmm")]), _vm._v(" "), _c('p', [_vm._v("10:24 P.M. Sarah: A short one xxx")]), _vm._v(" "), _c('p', [_vm._v("10:25 P.M. Sarah: Wrap around")]), _vm._v(" "), _c('p', [_vm._v("10:25 P.M. Sarah: Yellow")]), _vm._v(" "), _c('p', [_vm._v("10:25 P.M. Rick: Damn. Such easy access x")]), _vm._v(" "), _c('p', [_vm._v("10:25 P.M. Sarah: Yes, there is. You wouldn’t last long x")]), _vm._v(" "), _c('p', [_vm._v("10:27 P.M. Rick: I think it should be the other way around")]), _vm._v(" "), _c('p', [_vm._v("10:28 P.M. Sarah: No, I’m irresistible in this one x")]), _vm._v(" "), _c('p', [_vm._v("10:32 P.M. Rick: Off with the dress!")]), _vm._v(" "), _c('p', [_vm._v("10:33 P.M. Sarah: Haha that would be perfect xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "thursday-7-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Thursday, 7 June 2018")]), _vm._v(" "), _c('p', [_vm._v("8:09 A.M. Sarah: Good morning Rick. Hope you had good sleep? Having some power struggles here, including who gets the sofa bed (surely not me?) and very different views on what personal information to share and what not. I expect I’ll be accepting an altered, more distant, relationship in the near future. A shame if that happens x")]), _vm._v(" "), _c('p', [_vm._v("8:29 A.M. Rick: Good morning lover. You are in Paris? The decision all depends on who is paying. And personal information relating to your love life or finances!!! xxx")]), _vm._v(" "), _c('p', [_vm._v("8:34 A.M. Sarah: Yes, gay Paris. And I’m paying. Any personal information really – she shares and I listen, which isn’t how it used to be. I don’t want to give her details of last Tuesday night of course, but I do “date” and men talk to me all the time! I’m used to a very close friendship with this one so it makes me feel a bit sad xxx")]), _vm._v(" "), _c('p', [_vm._v("9:51 A.M. Rick: They can be frustrating at times; all you need to do is sit her down and lay it out as to who is the child here. Possibly she is just being over protective. You might just need to tell her that you appreciate the concern but she shouldn’t worry xxx")]), _vm._v(" "), _c('p', [_vm._v("4:23 P.M. Sarah: Girls can be cruel and yes, that’s a good plan, I’ll try that approach today. My error has been to include her in my life dramas for years and now my life just doesn’t match what she historically knows. It will be fine I’m sure xxx")]), _vm._v(" "), _c('p', [_vm._v("4:27 P.M. Rick: What’s on the agenda today? x")]), _vm._v(" "), _c('p', [_vm._v("4:59 P.M. Sarah: We are thinking a couple of galleries, a food market, and see what we find. Nothing in particular lined up as “must see” attractions x")]), _vm._v(" "), _c('p', [_vm._v("10:21 P.M. Rick: Are you on the move again lover? x")]), _vm._v(" "), _c('p', [_vm._v("10:23 P.M. Sarah: We’ve been out for coffee and pastry of course and shopped for lunch things at the local market. The weather is nicer than we thought it would be, so another summer dress day xxx")]), _vm._v(" "), _c('p', [_vm._v("10:26 P.M. Rick: Weekend looks much better here too ☀")]), _vm._v(" "), _c('p', [_vm._v("10:26 P.M. Sarah: You want to talk about the weather now?")]), _vm._v(" "), _c('p', [_vm._v("10:26 P.M. Rick: Will you wear underwear?")]), _vm._v(" "), _c('p', [_vm._v("10:26 P.M. Sarah: There he is! That’s better, and I should. I don’t want my daughter to get a further correct impression xxx")]), _vm._v(" "), _c('p', [_vm._v("10:27 P.M. Rick: He’s always there! Be daring lover xxx")]), _vm._v(" "), _c('p', [_vm._v("10:28 P.M. Sarah: Tempted. I need breeze x")]), _vm._v(" "), _c('p', [_vm._v("10:29 P.M. Rick: Pick up a French lover babe")]), _vm._v(" "), _c('p', [_vm._v("10:30 P.M. Sarah: That would really put the cat among the pigeons")]), _vm._v(" "), _c('p', [_vm._v("10:30 P.M. Rick: You have needs!")]), _vm._v(" "), _c('p', [_vm._v("10:30 P.M. Sarah: She knows almost nothing about my single life, but still thinks I’m so badly behaved! And I certainly do have needs x")]), _vm._v(" "), _c('p', [_vm._v("10:31 P.M. Rick: Why does she think you’re badly behaved? x")]), _vm._v(" "), _c('p', [_vm._v("10:32 P.M. Sarah: I can’t mention a man without an eye roll or worse, so standards are basically unachievable. I don’t actually share much of course but knowing anything is too much for her at this stage. I’m only her mother. Not a woman as previously noted.")]), _vm._v(" "), _c('p', [_vm._v("10:33 P.M. Rick: Just tell her you need and enjoy cock!")]), _vm._v(" "), _c('p', [_vm._v("10:33 P.M. Sarah: Too funny! I should. I couldn’t tell her I’d been “ravished” by you on the second date, for example.")]), _vm._v(" "), _c('p', [_vm._v("10:34 P.M. Rick: Why not tell her if she asks? xxx")]), _vm._v(" "), _c('p', [_vm._v("10:35 P.M. Sarah: She asks who I’m chatting to (you) then tells me not to tell her anything! She opens the subject then shuts it down. I can’t win. But that’s an excellent idea. Sounds strange but I think she might be jealous of my apparent newfound sexual freedom since her own relationship isn’t so great. I’m sorry to say I actively discouraged her from being loose with her body when she was young, and most definitely wasn’t a good role model in that way!")]), _vm._v(" "), _c('p', [_vm._v("10:38 P.M. Rick: It will stop her asking lol")]), _vm._v(" "), _c('p', [_vm._v("10:39 P.M. Sarah: True, but she can also see I’m different – happy – and that’s the other side of the problem. We will work it out eventually.")]), _vm._v(" "), _c('p', [_vm._v("10:40 P.M. Rick: What does she expect? You to be timid and meek? x")]), _vm._v(" "), _c('p', [_vm._v("10:40 P.M. Sarah: Yes. And not interested in men. Going to walk along the river soon – catch me a man x")]), _vm._v(" "), _c('p', [_vm._v("10:42 P.M. Rick: I dare you lover. Tell me the details xxx")]), _vm._v(" "), _c('p', [_vm._v("10:43 P.M. Sarah: Trust me there’ll be none of that on this camp x")]), _vm._v(" "), _c('p', [_vm._v("10:44 P.M. Rick: Tell the child you need the flat for a couple of hours")]), _vm._v(" "), _c('p', [_vm._v("10:44 P.M. Sarah: Too funny. I’ve done that to my son before when he was living with me in January, in the early Tinder days. I had an assignation arranged and had to ask him to be at his girlfriend’s house for the evening. To say it wasn’t received very well is a slight understatement, but what’s a girl to do? I think we’d both prefer him to be absent to avoid witnessing a naked man heading down the hall in the night xxx")]), _vm._v(" "), _c('p', [_vm._v("10:45 P.M. Rick: He’d be traumatised for life! Would you find yourself a Frenchman today, lover?")]), _vm._v(" "), _c('p', [_vm._v("10:45 P.M. Sarah: I wouldn’t do that to her. She seriously couldn’t cope and I’d lose a child.")]), _vm._v(" "), _c('p', [_vm._v("10:46 P.M. Rick: If she wasn’t there, would you?")]), _vm._v(" "), _c('p', [_vm._v("10:46 P.M. Sarah: Yes, if I could find one who’d have me")]), _vm._v(" "), _c('p', [_vm._v("10:46 P.M. Rick: Good for you, and that would hardly be a problem. I would watch you xxx")]), _vm._v(" "), _c('p', [_vm._v("10:47 P.M. Sarah: Is that so…off again, so nighty night xxx")]), _vm._v(" "), _c('p', [_vm._v("10:47 P.M. Rick: Enjoy lover xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "friday-8-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Friday, 8 June 2018")]), _vm._v(" "), _c('p', [_vm._v("5:05 A.M. Sarah: Lovely very long walk from the 8th arr. along the Seine and back – warm and sunny and we are back to friendly relations after some thinly disguised bribery in the clothing shops along the way. Possibly a better idea than your suggestion which has kept me privately smirking all day. Musée d’Orsay was very cool, first time for both of us xxx")]), _vm._v(" "), _c('p', [_vm._v("7:57 A.M. Rick: Good morning, gorgeous. So, a better day was had by all. How are those lovely legs standing up to all the walking? xxx")]), _vm._v(" "), _c('p', [_vm._v("7:58 A.M. Sarah: A much better day, but we must have done another trillion steps today – I’ll either come home shorter or legless. And French men definitely pay more attention than English ones x")]), _vm._v(" "), _c('p', [_vm._v("8:04 A.M. Rick: Hopefully not legless – I want to feel them wrapped around me, pulling me in deeper xxx")]), _vm._v(" "), _c('p', [_vm._v("8:04 A.M. Sarah: Ah yes, good, I’m looking forward to that too x")]), _vm._v(" "), _c('p', [_vm._v("8:05 A.M. Rick: I know you are naughty girl xxx")]), _vm._v(" "), _c('p', [_vm._v("8:06 A.M. Rick: Did the Froggies hit on you? xxx")]), _vm._v(" "), _c('p', [_vm._v("8:07 A.M. Sarah: Just with their eyes!")]), _vm._v(" "), _c('p', [_vm._v("8:08 A.M. Rick: Did you flirt, you temptress???")]), _vm._v(" "), _c('p', [_vm._v("8:09 A.M. Sarah: Limited opportunities of course but I would have under normal circumstances. Am I a flirt? x")]), _vm._v(" "), _c('p', [_vm._v("8:09 A.M. Rick: You know you are. You enjoy attention xxx")]), _vm._v(" "), _c('p', [_vm._v("8:10 A.M. Sarah: Yes, I do enjoy attention, can’t get enough actually. A terrible failing x")]), _vm._v(" "), _c('p', [_vm._v("8:11 A.M. Rick: No, it’s not. You are a hotblooded sexual female. I think it’s every woman’s need to be desired in one way or another xxx")]), _vm._v(" "), _c('p', [_vm._v("8:28 A.M. Sarah: Three weeks abstinence was always going to be hard, even without you in the background – I’m practicing being a nun x")]), _vm._v(" "), _c('p', [_vm._v("8:54 A.M. Rick: What a waste! Go for your life xxx")]), _vm._v(" "), _c('p', [_vm._v("8:55 A.M. Sarah: Only two weeks to go. I can do it. I need sleep – have a great day, talk tomorrow, sweetie xxx")]), _vm._v(" "), _c('p', [_vm._v("8:59 A.M. Rick: Sleep well naughty girl xxx")]), _vm._v(" "), _c('p', [_vm._v("9:00 A.M. Sarah: xxx")]), _vm._v(" "), _c('p', [_vm._v("9:04 A.M. Rick: Will you cum for me tonight lover? xxx")]), _vm._v(" "), _c('p', [_vm._v("9:05 A.M. Sarah: I’d love to but aching legs rather than aching elsewhere tonight. Will you?")]), _vm._v(" "), _c('p', [_vm._v("9:05 A.M. Rick: Oh yes, of course!!! And did you get the bed?")]), _vm._v(" "), _c('p', [_vm._v("9:06 A.M. Sarah: Yes, I did. It wasn’t pretty, but I just took it. Seniority won. She was so angry about it but I withstood and she’s recovered now lol x")]), _vm._v(" "), _c('p', [_vm._v("9:08 A.M. Rick: Good for you xxx")]), _vm._v(" "), _c('p', [_vm._v("9:08 A.M. Sarah: I want your kiss x")]), _vm._v(" "), _c('p', [_vm._v("9:08 A.M. Rick: All over xxx")]), _vm._v(" "), _c('p', [_vm._v("9:41 P.M. Rick: Good morning lover. Did you sleep well? What whirlwind activities are on the cards today? xxx")]), _vm._v(" "), _c('p', [_vm._v("9:47 P.M. Sarah: Good morning to you too, cutie. Just a bit of shopping and eating today. And yes, very well, thanks xxx")]), _vm._v(" "), _c('p', [_vm._v("10:17 P.M. Rick: That’s good. So now the power struggle is over! Is it a separate bedroom? x")]), _vm._v(" "), _c('p', [_vm._v("10:29 P.M. Sarah: Yes, thank goodness!")]), _vm._v(" "), _c('p', [_vm._v("10:30 P.M. Rick: Did you open your legs wide last night and cum for me, lover? x")]), _vm._v(" "), _c('p', [_vm._v("10:37 P.M. Sarah: Haha having lunch with the child. Talk soon x")]), _vm._v(" "), _c('p', [_vm._v("10:37 P.M. Rick: Lol. Are you shy?")]), _vm._v(" "), _c('p', [_vm._v("10:38 P.M. Sarah: I’m being told off! But the answer is sadly no. I was otherwise rooted by the day. And am I shy? Yes. When do you leave for Melbourne?")]), _vm._v(" "), _c('p', [_vm._v("11:27 P.M. Rick: Monday until Thursday.")]), _vm._v(" "), _c('p', [_vm._v("11:34 P.M. Sarah: So, how’s the weather? Improved?")]), _vm._v(" "), _c('p', [_vm._v("11:35 P.M. Rick: Yes. Should be fine for the weekend")]), _vm._v(" "), _c('p', [_vm._v("11:35 P.M. Sarah: Got some naked sunbathing planned?")]), _vm._v(" "), _c('p', [_vm._v("11:36 P.M. Rick: Lol. You want pics? 😮")]), _vm._v(" "), _c('p', [_vm._v("11:36 P.M. Sarah: Haha I’m too much of a good girl for that but I do love being naked x")]), _vm._v(" "), _c('p', [_vm._v("11:37 P.M. Rick: I noticed lover")]), _vm._v(" "), _c('p', [_vm._v("11:37 P.M. Sarah: You did? I thought I kept my clothes on for a long time. Hours x")]), _vm._v(" "), _c('p', [_vm._v("11:38 P.M. Rick: Well that sexy dress was around your waist on the couch")]), _vm._v(" "), _c('p', [_vm._v("11:38 P.M. Sarah: Was it?")]), _vm._v(" "), _c('p', [_vm._v("11:38 P.M. Rick: Lol. You know it was, and I’m not complaining lover. You know I was considering taking you over the table")]), _vm._v(" "), _c('p', [_vm._v("11:42 P.M. Sarah: More accurately your hands were up my dress rather than me exposing myself, and you did mention the table, but as a first time I’m not sure how that would have gone! x")]), _vm._v(" "), _c('p', [_vm._v("11:43 P.M. Rick: You would have presented yourself to me x")]), _vm._v(" "), _c('p', [_vm._v("11:43 P.M. Sarah: How would I have done that?")]), _vm._v(" "), _c('p', [_vm._v("11:44 P.M. Rick: Lifted your dress up or left your knickers around your ankles")]), _vm._v(" "), _c('p', [_vm._v("11:44 P.M. Sarah: I see. I liked what we did x")]), _vm._v(" "), _c('p', [_vm._v("11:45 P.M. Rick: So, did I x")]), _vm._v(" "), _c('p', [_vm._v("11:47 P.M. Sarah: I could do it again. Repeatedly. Not just in my mind x")]), _vm._v(" "), _c('p', [_vm._v("11:47 P.M. Rick: Do you play it over?")]), _vm._v(" "), _c('p', [_vm._v("11:48 P.M. Sarah: Of course! Don’t you?")]), _vm._v(" "), _c('p', [_vm._v("11:48 P.M. Rick: Yes, often. What is your highlight?")]), _vm._v(" "), _c('p', [_vm._v("11:50 P.M. Sarah: That’s tricky – it was all great – but I really love that feeling of complete relaxation afterwards, lying close feeling comfortable. You know I also like your tongue in me, and you filling me, your hands everywhere xxx")]), _vm._v(" "), _c('p', [_vm._v("11:53 P.M. Rick: Tasting you as my tongue and lips push inside you x")]), _vm._v(" "), _c('p', [_vm._v("11:53 P.M. Sarah: Yes, I love it. Your highlight?")]), _vm._v(" "), _c('p', [_vm._v("11:54 P.M. Rick: What you mentioned, and having you on top riding me and knowing you are full of me")]), _vm._v(" "), _c('p', [_vm._v("11:55 P.M. Sarah: Yes, that too. I love feeling full inside x")]), _vm._v(" "), _c('p', [_vm._v("11:56 P.M. Rick: You don’t enjoy giving oral?")]), _vm._v(" "), _c('p', [_vm._v("11:56 P.M. Sarah: You’ve asked that before, and the answer is I don’t have much experience if I’m completely honest, but yes, sure. Willing and able. Need practice if you want to be a test subject? x")]), _vm._v(" "), _c('p', [_vm._v("11:59 P.M. Rick: You know I am hard, don’t you? x")]), _vm._v(" "), _c('p', [_vm._v("11:59 P.M. Sarah: I do. I’m sure you know I’m ready for you now too")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "saturday-9-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Saturday, 9 June 2018")]), _vm._v(" "), _c('p', [_vm._v("12:02 A.M. Rick: I would push myself deep into you")]), _vm._v(" "), _c('p', [_vm._v("12:03 A.M. Sarah: And I’d pull you closer with my legs wrapped round you")]), _vm._v(" "), _c('p', [_vm._v("12:06 A.M. Rick: I would prefer to hold your legs spread by your ankles and have you guide my cock into you. We must have been having sex for nearly three hours that night x")]), _vm._v(" "), _c('p', [_vm._v("12:10 A.M. Sarah: I’d say that’s about right – I felt it for days after, in a very good way. I want to feel your mouth x")]), _vm._v(" "), _c('p', [_vm._v("12:12 A.M. Rick: Where lover? x")]), _vm._v(" "), _c('p', [_vm._v("12:12 A.M. Sarah: Start on mine then see what happens x")]), _vm._v(" "), _c('p', [_vm._v("12:13 A.M. Sarah: You need to sleep babe?")]), _vm._v(" "), _c('p', [_vm._v("12:13 A.M. Rick: Yes. It’s that time x")]), _vm._v(" "), _c('p', [_vm._v("12:14 A.M. Sarah: Ok. I enjoy my moments with you xxx")]), _vm._v(" "), _c('p', [_vm._v("12:16 A.M. Rick: Same for me lover xxx")]), _vm._v(" "), _c('p', [_vm._v("12:17 A.M. Sarah: You should see how tired my poor legs are – I have them crossed, up against the wall behind the bed as I chat to you")]), _vm._v(" "), _c('p', [_vm._v("12:21 A.M. Rick: That is just cruel. Open them wide")]), _vm._v(" "), _c('p', [_vm._v("12:22 A.M. Sarah: Lol no. Good night Cutie Pie xxx")]), _vm._v(" "), _c('p', [_vm._v("12:28 A.M. Rick: Good night Sweet Cheeks xxx")]), _vm._v(" "), _c('p', [_vm._v("6:52 A.M. Sarah: Hello again sweetheart. I’ve been on a pub crawl – good for the child relationship x")]), _vm._v(" "), _c('p', [_vm._v("11:11 A.M. Rick: Hello lover. I trust you had a great day exploring the city xxx")]), _vm._v(" "), _c('p', [_vm._v("5:06 P.M. Sarah: We are having a great time, bonding, enjoying the sights x")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "sunday-10-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Sunday, 10 June 2018")]), _vm._v(" "), _c('p', [_vm._v("8:35 A.M. Sarah: Good morning Rick. Just got back to my room in London after a fabulous Indian dinner at a trendy new hotspot near the train from Paris. Full marks to the child for thinking ahead! How are things with you? x")]), _vm._v(" "), _c('p', [_vm._v("8:35 A.M. Rick: Good morning lover. I’m at the airport, fly later today. How was the weekend?")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "monday-11-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Monday, 11 June 2018")]), _vm._v(" "), _c('p', [_vm._v("7:42 A.M. Sarah: It’s been good – it was a long day yesterday getting back to London, and it’s another lovely day here today. I met the boyfriend’s mother over a pub lunch and had a walk with the child later. Now I’m alone with a glass of wine in my room – illicit glass of wine – the guy really doesn’t want me to enjoy myself. I’m off to sleep soon, so travel well xxx")]), _vm._v(" "), _c('p', [_vm._v("10:30 A.M. Rick: Will chat later from Melbourne. Goodnight and sleep well lover xxx")]), _vm._v(" "), _c('p', [_vm._v("10:31 A.M. Sarah: You’re too cute 💋")]), _vm._v(" "), _c('p', [_vm._v("9:14 P.M. Rick: Pretty damn cute yourself 💋")]), _vm._v(" "), _c('p', [_vm._v("9:14 P.M. Sarah: Aww thanks. I’m on the bus to Brixton – I have no idea why but will go with the flow! xxx")]), _vm._v(" "), _c('p', [_vm._v("11:27 P.M. Rick: Are you going to the scene of the riots? x")]), _vm._v(" "), _c('p', [_vm._v("11:29 P.M. Sarah: Getting some more culture in me you think? x")]), _vm._v(" "), _c('p', [_vm._v("11:29 P.M. Rick: Lol. I will put a lot more in you, lover x")]), _vm._v(" "), _c('p', [_vm._v("11:30 P.M. Sarah: Now please! x")]), _vm._v(" "), _c('p', [_vm._v("11:31 P.M. Rick: It wouldn’t be appreciated by your daughter to see her mother ravished in public")]), _vm._v(" "), _c('p', [_vm._v("11:31 P.M. Sarah: She can get off the bus and leave me with you x")]), _vm._v(" "), _c('p', [_vm._v("11:34 P.M. Rick: Or we could be discreet")]), _vm._v(" "), _c('p', [_vm._v("11:35 P.M. Sarah: I’d need to remove my clothes surely?")]), _vm._v(" "), _c('p', [_vm._v("11:36 P.M. Rick: Stop teasing now. I’m sure you would have accessible clothes. I would move your underwear to one side and push into you. Have you sit on my lap as the bus bounces along x!")]), _vm._v(" "), _c('p', [_vm._v("11:40 P.M. Sarah: It is quite bouncy – we might need to go further than Brixton 💋")]), _vm._v(" "), _c('p', [_vm._v("11:43 P.M. Rick: Damn woman! You are horny today 💋")]), _vm._v(" "), _c('p', [_vm._v("11:44 P.M. Sarah: I am as it happens. Maybe there’s something wrong with me? x")]), _vm._v(" "), _c('p', [_vm._v("11:45 P.M. Rick: Nothing that I can’t take care of")]), _vm._v(" "), _c('p', [_vm._v("11:45 P.M. Sarah: Oh, I do know that babe x")]), _vm._v(" "), _c('p', [_vm._v("11:46 P.M. Rick: Are you sitting next to your daughter?")]), _vm._v(" "), _c('p', [_vm._v("11:46 P.M. Sarah: Yes. I’m skulking like a teenager with my mum. It makes me laugh – of course she knows I’m talking to you.")]), _vm._v(" "), _c('p', [_vm._v("11:48 P.M. Rick: We could disappear onto the back seat")]), _vm._v(" "), _c('p', [_vm._v("11:49 P.M. Sarah: Well that would be classic teen – my life is pretty teen x")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "tuesday-12-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Tuesday, 12 June 2018")]), _vm._v(" "), _c('p', [_vm._v("12:00 A.M. Rick: I’m lying here in bed thinking about having you over me x")]), _vm._v(" "), _c('p', [_vm._v("12:01 A.M. Sarah: How over you?")]), _vm._v(" "), _c('p', [_vm._v("12:02 A.M. Rick: Either – facing me or reverse cowgirl")]), _vm._v(" "), _c('p', [_vm._v("12:02 A.M. Sarah: Delicious. You prefer reverse?")]), _vm._v(" "), _c('p', [_vm._v("12:03 A.M. Rick: Do you?")]), _vm._v(" "), _c('p', [_vm._v("12:03 A.M. Sarah: With you I have no preference. I like being with you, and love to watch your face but either would be great x")]), _vm._v(" "), _c('p', [_vm._v("12:04 A.M. Rick: It would give me access to all of you")]), _vm._v(" "), _c('p', [_vm._v("12:09 A.M. Sarah: I don’t mind which way round but I totally fancy that NOW")]), _vm._v(" "), _c('p', [_vm._v("12:09 A.M. Rick: Mmm. You are demanding!")]), _vm._v(" "), _c('p', [_vm._v("12:10 A.M. Sarah: Haha yes maybe. You appear to have quite a capacity too x")]), _vm._v(" "), _c('p', [_vm._v("12:11 A.M. Rick: Oh lover. I am very demanding and take what I want x")]), _vm._v(" "), _c('p', [_vm._v("12:12 A.M. Sarah: What if I can’t keep up?")]), _vm._v(" "), _c('p', [_vm._v("12:15 A.M. Rick: Then I train you")]), _vm._v(" "), _c('p', [_vm._v("12:15 A.M. Sarah: I’m open to that x")]), _vm._v(" "), _c('p', [_vm._v("12:19 A.M. Rick: Have you had many men?")]), _vm._v(" "), _c('p', [_vm._v("12:20 A.M. Sarah: How could I? I’ve had two husbands spanning almost 40 years and have never cheated. The first was from 17 to 22, then the second immediately after, so from 22-55. I’m now free to choose for the first time since I was 17 – it’s terrifyingly liberating. As you know I have had a few sexual experiences post separation, but I’ve slowed my progress to go at my pace, given my history. There appear to be lots of men available so there’s no mad rush.")]), _vm._v(" "), _c('p', [_vm._v("12:24 A.M. Rick: How did they work out for you lover?")]), _vm._v(" "), _c('p', [_vm._v("12:25 A.M. Sarah: The first was a teacher, now a friend. I met him when the kids were at primary school and we became very close friends, meeting for a walk or coffee when we could – I was unhappy even then – and when I was in the throes of deciding how to extract myself from my relationship he spent a lot of time just chatting to me about it. That sex experience was extremely good for me – eye opening – it got me naked and exposed to extended sex sessions and allowed me an outlet for the passion I didn’t know I had, and of course intimacy. We stopped after a couple of months for the sake of our friendship. It’s best this way.")]), _vm._v(" "), _c('p', [_vm._v("12:27 A.M. Rick: You should have carried on with him")]), _vm._v(" "), _c('p', [_vm._v("12:28 A.M. Sarah: No, I wasn’t sufficiently stable at the time and it got a bit messy. Then I’ve told you about the two I’ve had ongoing this year. One I like mentally who challenges me; and the other is very loving and sweet but I can’t see how it could work long term.")]), _vm._v(" "), _c('p', [_vm._v("12:29 A.M. Rick: How does the first one not take you to bed when he sees you now?")]), _vm._v(" "), _c('p', [_vm._v("12:30 A.M. Sarah: He has self-control, as I suspect you do. I do see him quite often for a glass of wine or a coffee, and we’re pretty comfortable with the mini frisson in the background. We have talked about it and agreed the terms of the friendship! Otherwise, there’s no one I’m keen on, other than you.")]), _vm._v(" "), _c('p', [_vm._v("12:32 A.M. Rick: You do enjoy the sex the other two offer, and I know you need to satisfy that lust")]), _vm._v(" "), _c('p', [_vm._v("12:34 A.M. Sarah: Well I don’t want to further mess with the brain of the loving one, and the challenging one is, well, challenging. For the moment at least I need to factor in my past.")]), _vm._v(" "), _c('p', [_vm._v("12:36 A.M. Rick: I am not interested in your past, just your mind and body")]), _vm._v(" "), _c('p', [_vm._v("12:37 A.M. Sarah: Good. But you do at least appreciate my situation?")]), _vm._v(" "), _c('p', [_vm._v("12:40 A.M. Rick: We live for the moment, lover")]), _vm._v(" "), _c('p', [_vm._v("12:40 A.M. Sarah: I’m learning that babe x")]), _vm._v(" "), _c('p', [_vm._v("12:41 A.M. Rick: Is that not enough, lover?")]), _vm._v(" "), _c('p', [_vm._v("12:42 A.M. Sarah: Yes, it is. Just not familiar. I have nothing to lose, everything to gain from the people around me now, including you.")]), _vm._v(" "), _c('p', [_vm._v("12:43 A.M. Rick: We seem to be sexually compatible")]), _vm._v(" "), _c('p', [_vm._v("12:43 A.M. Sarah: We do rather, and very attracted")]), _vm._v(" "), _c('p', [_vm._v("12:44 A.M. Rick: Totally. Quite animal in some ways.")]), _vm._v(" "), _c('p', [_vm._v("12:45 A.M. Sarah: Yes, I agree")]), _vm._v(" "), _c('p', [_vm._v("12:46 A.M. Rick: Insatiable. I am always aroused when we chat.")]), _vm._v(" "), _c('p', [_vm._v("12:50 A.M. Sarah: Me too. I think I may have to curb my forward and open ways!")]), _vm._v(" "), _c('p', [_vm._v("12:52 A.M. Rick: Why do that? You know that’s your style, lover. So direct, so honest. It’s very attractive.")]), _vm._v(" "), _c('p', [_vm._v("12:52 A.M. Sarah: I don’t want to give the wrong impression, although I’ve spent my life pretending to be a good girl x")]), _vm._v(" "), _c('p', [_vm._v("12:55 A.M. Rick: You are definitely not a good girl, lover. You have repressed that sexuality and need. Have you only just discovered your sexuality?")]), _vm._v(" "), _c('p', [_vm._v("12:57 A.M. Sarah: I knew it was there but thought I could ignore it, but – obviously tangled up with all sorts of other relationship problems – the frustration became too hard to bear")]), _vm._v(" "), _c('p', [_vm._v("12:57 A.M. Rick: How was the sex prior to this state?")]), _vm._v(" "), _c('p', [_vm._v("12:59 A.M. Sarah: For some years I wasn’t at all physically attracted to my ex, so the sex was terrible for me. I didn’t want him touching me, but I needed to be touched, needed sex, and had no other option. It was very confusing.")]), _vm._v(" "), _c('p', [_vm._v("12:59 A.M. Rick: You went through the motions")]), _vm._v(" "), _c('p', [_vm._v("1:00 A.M. Sarah: Yes, with an ever-increasing unfulfilled urge. I’ll admit one thing that made me decide to make the move was the attention of other men – my ex’s friends, work colleagues – and it felt nice being noticed. It’s a weird thing to say, but having mentally moved on made me more attractive to other men, and more open to a bit of a flirt when the opportunity arose.")]), _vm._v(" "), _c('p', [_vm._v("1:04 A.M. Rick: I understand that – an awakening. You did what every other woman does and just lay there. Are my questions too direct, lover?")]), _vm._v(" "), _c('p', [_vm._v("1:04 A.M. Sarah: That’s right, I didn’t make much of an effort. I know it’s a two-way street and I wasn’t kind in other ways. And your questions are direct, but answering them clarifies my thoughts.")]), _vm._v(" "), _c('p', [_vm._v("I’m fairly direct myself, and if I can’t or don’t want to answer, I won’t! It’s like having emotional and sexual therapy in one session xxx")]), _vm._v(" "), _c('p', [_vm._v("1:09 A.M. Rick: I never thought of it that way!")]), _vm._v(" "), _c('p', [_vm._v("1:10 A.M. Sarah: Its only that way because I need to learn and understand myself, and your questions make me think. I’m not reliving it because I’m attracted to you, and focused on that.")]), _vm._v(" "), _c('p', [_vm._v("1:13 A.M. Rick: Mental and sexual stimulation")]), _vm._v(" "), _c('p', [_vm._v("1:13 A.M. Sarah: Yes. And you are very entertaining x")]), _vm._v(" "), _c('p', [_vm._v("1:14 A.M. Rick: Just hilarious xxx")]), _vm._v(" "), _c('p', [_vm._v("1:14 A.M. Sarah: It was funny lying on top of you afterwards")]), _vm._v(" "), _c('p', [_vm._v("1:15 A.M. Rick: Mmm that was delicious. Funny in what way?")]), _vm._v(" "), _c('p', [_vm._v("1:15 A.M. Sarah: I thought you might be unable to breathe")]), _vm._v(" "), _c('p', [_vm._v("1:17 A.M. Rick: But you weigh next to nothing! I could pick you up and carry you around on my cock!")]), _vm._v(" "), _c('p', [_vm._v("1:18 A.M. Sarah: Haha x")]), _vm._v(" "), _c('p', [_vm._v("1:19 A.M. Rick: Now that image is going to be with you all day")]), _vm._v(" "), _c('p', [_vm._v("1:19 A.M. Sarah: Yes, it is. Happy thought for the day xxx")]), _vm._v(" "), _c('p', [_vm._v("1:20 A.M. Sarah: Bed time for you? Or are you still hard?")]), _vm._v(" "), _c('p', [_vm._v("1:22 A.M. Rick: Bed time soon babe, and of course I am still hard! Only a dead man wouldn’t be at the thought of you with your arms around my neck bouncing on my cock!")]), _vm._v(" "), _c('p', [_vm._v("1:23 A.M. Sarah: Yes, that’s a good thought to go to bed with. No wonder you wake up with a man problem every day. It was a fun morning in Brixton, bus trip aside x")]), _vm._v(" "), _c('p', [_vm._v("1:26 A.M. Rick: Did you see many white faces?")]), _vm._v(" "), _c('p', [_vm._v("1:26 A.M. Sarah: A few but not many. It was interesting. I’m living not too far from there in an area which is very mixed racially, downmarket but quiet, with a few dodgy characters around. Brixton is downright dodgy and crazy busy.")]), _vm._v(" "), _c('p', [_vm._v("1:28 A.M. Rick: All of London is dodgy")]), _vm._v(" "), _c('p', [_vm._v("1:29 A.M. Sarah: And dirty, and the people are rude – no one catches your eye")]), _vm._v(" "), _c('p', [_vm._v("1:40 A.M. Rick: They don’t want trouble")]), _vm._v(" "), _c('p', [_vm._v("1:41 A.M. Sarah: And I’m trouble? x")]), _vm._v(" "), _c('p', [_vm._v("1:41 A.M. Rick: Big little trouble x")]), _vm._v(" "), _c('p', [_vm._v("1:42 A.M. Sarah: I’ve been called trouble before! x")]), _vm._v(" "), _c('p', [_vm._v("1:43 A.M. Rick: I’m going to put my head down, lover")]), _vm._v(" "), _c('p', [_vm._v("1:44 A.M. Sarah: Ok sweetheart. Good night xxx")]), _vm._v(" "), _c('p', [_vm._v("1:44 A.M. Rick: Enjoy the rest of your day x")]), _vm._v(" "), _c('p', [_vm._v("1:44 A.M. Sarah: x")]), _vm._v(" "), _c('p', [_vm._v("7:55 A.M. Sarah: Go back to sleep. Oh sorry. The man problem, it’s that time isn’t it? x")]), _vm._v(" "), _c('p', [_vm._v("8:18 A.M. Rick: Lol. I have that problem now, yes. I know you wouldn’t be complaining as you moved back on it as we spooned.")]), _vm._v(" "), _c('p', [_vm._v("8:21 A.M. Sarah: Haha, yes, I love it. Bit early in the morning isn’t it? x")]), _vm._v(" "), _c('p', [_vm._v("8:22 A.M. Rick: It’s never too early x")]), _vm._v(" "), _c('p', [_vm._v("8:23 A.M. Sarah: Ahh no indeed")]), _vm._v(" "), _c('p', [_vm._v("8:24 A.M. Rick: Are you in your room?")]), _vm._v(" "), _c('p', [_vm._v("8:24 A.M. Sarah: Yes sweetheart")]), _vm._v(" "), _c('p', [_vm._v("8:25 A.M. Rick: Don’t want to get you too excited")]), _vm._v(" "), _c('p', [_vm._v("8:26 A.M. Sarah: I’m always keen babe. Do you know, the meal I made you was the first time I’ve cooked for a man, post separation? I don’t know what you did to qualify!")]), _vm._v(" "), _c('p', [_vm._v("8:28 A.M. Rick: You needed to feed me as you had an inkling of the marathon session that was to follow x")]), _vm._v(" "), _c('p', [_vm._v("8:29 A.M. Sarah: Maybe that was it, or maybe I felt sorry for you working then having to come over and fix me x")]), _vm._v(" "), _c('p', [_vm._v("8:29 A.M. Rick: Mmm fix you x")]), _vm._v(" "), _c('p', [_vm._v("8:30 A.M. Sarah: You did. Man’s work is never done. It must be tough x")]), _vm._v(" "), _c('p', [_vm._v("8:32 A.M. Rick: But damn enjoyable. I enjoyed every minute of our sexscapade")]), _vm._v(" "), _c('p', [_vm._v("8:36 A.M. Sarah: Me too. I think cooking was prolonging the tension")]), _vm._v(" "), _c('p', [_vm._v("8:37 A.M. Rick: You put so much effort into the meal I only thought it good manners to eat that first before you")]), _vm._v(" "), _c('p', [_vm._v("8:38 A.M. Sarah: How polite. I do enjoy the anticipation.")]), _vm._v(" "), _c('p', [_vm._v("8:39 A.M. Rick: There will be very little of that next time")]), _vm._v(" "), _c('p', [_vm._v("8:40 A.M. Sarah: Oh? Not taking me to dinner then?")]), _vm._v(" "), _c('p', [_vm._v("8:40 A.M. Rick: You are dinner and dessert. Wear clothes you no longer want so I can rip them off. Or be naked as you answer the door.")]), _vm._v(" "), _c('p', [_vm._v("8:44 A.M. Sarah: Omg there you go again")]), _vm._v(" "), _c('p', [_vm._v("8:44 A.M. Rick: I gave you two options lol")]), _vm._v(" "), _c('p', [_vm._v("8:44 A.M. Sarah: Two male fantasies to choose from!")]), _vm._v(" "), _c('p', [_vm._v("8:45 A.M. Rick: Did it make you clench? And your hips move?")]), _vm._v(" "), _c('p', [_vm._v("8:45 A.M. Sarah: Of course. I’m back Thursday next week. Pick a time. I’ll consider the options and surprise you x")]), _vm._v(" "), _c('p', [_vm._v("8:48 A.M. Rick: Are your fingers exploring, lover?")]), _vm._v(" "), _c('p', [_vm._v("8:49 A.M. Sarah: I did that earlier today")]), _vm._v(" "), _c('p', [_vm._v("8:49 A.M. Rick: Did you explode?")]), _vm._v(" "), _c('p', [_vm._v("8:51 A.M. Sarah: You might have gathered masturbation isn’t my favourite sport, but yes, I did x")]), _vm._v(" "), _c('p', [_vm._v("8:52 A.M. Rick: And you only use your fingers? or have you introduced objects?")]), _vm._v(" "), _c('p', [_vm._v("8:52 A.M. Sarah: Rick.")]), _vm._v(" "), _c('p', [_vm._v("8:53 A.M. Rick: Answer the question Sarah")]), _vm._v(" "), _c('p', [_vm._v("8:53 A.M. Sarah: No objects")]), _vm._v(" "), _c('p', [_vm._v("8:54 A.M. Rick: Then we will explore that. Have you never looked at an object and wondered?")]), _vm._v(" "), _c('p', [_vm._v("8:55 A.M. Sarah: No. Should I have?")]), _vm._v(" "), _c('p', [_vm._v("8:55 A.M. Rick: Yes lover")]), _vm._v(" "), _c('p', [_vm._v("8:56 A.M. Sarah: Ok well we’ll see. Give me time.")]), _vm._v(" "), _c('p', [_vm._v("8:56 A.M. Rick: Your ex wasn’t sexually adventurous?")]), _vm._v(" "), _c('p', [_vm._v("8:57 A.M. Sarah: Not at all. There was nothing sexual or flirty about him, so I’ve led a dull life sexually. In fairness, we were both young and repressed, so a terrible combination, and we never got past that to explore.")]), _vm._v(" "), _c('p', [_vm._v("8:57 A.M. Rick: I apologise if my questions shock you, lover")]), _vm._v(" "), _c('p', [_vm._v("8:58 A.M. Sarah: They do")]), _vm._v(" "), _c('p', [_vm._v("8:58 A.M. Rick: Have you never owned a vibrator?")]), _vm._v(" "), _c('p', [_vm._v("9:02 A.M. Rick: Answer the question lover. Are you shy or embarrassed?")]), _vm._v(" "), _c('p', [_vm._v("9:02 A.M. Sarah: Both")]), _vm._v(" "), _c('p', [_vm._v("9:04 A.M. Rick: If you look around the room is there anything that you could use?")]), _vm._v(" "), _c('p', [_vm._v("9:05 A.M. Sarah: Unless it was in my luggage it’s not here! Maybe move on from this one for now x")]), _vm._v(" "), _c('p', [_vm._v("9:07 A.M. Rick: Lol. Blushing lover x")]), _vm._v(" "), _c('p', [_vm._v("9:07 A.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("9:07 A.M. Rick: But mildly excited? Pick up a hard, firm cucumber tomorrow. One with girth 😮😮")]), _vm._v(" "), _c('p', [_vm._v("9:09 A.M. Sarah: Maybe loosely curious. And no!")]), _vm._v(" "), _c('p', [_vm._v("9:10 A.M. Rick: You know you will go and look now wondering how it would feel")]), _vm._v(" "), _c('p', [_vm._v("9:11 A.M. Sarah: I’m going to Edinburgh tomorrow night, so maybe another night xxx")]), _vm._v(" "), _c('p', [_vm._v("9:12 A.M. Rick: I have piqued your interest xxx")]), _vm._v(" "), _c('p', [_vm._v("9:12 A.M. Sarah: I don’t think I’ve ever had a vaginal orgasm. More TMI?")]), _vm._v(" "), _c('p', [_vm._v("9:13 A.M. Rick: Never TMI. How about an anal orgasm?")]), _vm._v(" "), _c('p', [_vm._v("9:13 A.M. Sarah: No!")]), _vm._v(" "), _c('p', [_vm._v("9:14 A.M. Rick: Lol. I can just picture the shock on your face as you read that")]), _vm._v(" "), _c('p', [_vm._v("9:14 A.M. Sarah: Play nice")]), _vm._v(" "), _c('p', [_vm._v("9:15 A.M. Rick: Oh, I do lover. Have you tried anal sex?")]), _vm._v(" "), _c('p', [_vm._v("9:16 A.M. Sarah: Dabbled but not really")]), _vm._v(" "), _c('p', [_vm._v("9:17 A.M. Rick: It’s not for everyone")]), _vm._v(" "), _c('p', [_vm._v("9:17 A.M. Sarah: You like it?")]), _vm._v(" "), _c('p', [_vm._v("9:21 A.M. Rick: It’s a weapon in my armoury. My vast array of talents lol")]), _vm._v(" "), _c('p', [_vm._v("9:22 A.M. Sarah: Your arsenal. Looking forward to seeing you xxx")]), _vm._v(" "), _c('p', [_vm._v("9:23 A.M. Rick: Ditto lover. Those hungry passionate kisses 💋")]), _vm._v(" "), _c('p', [_vm._v("9:37 A.M. Sarah: Yes please, but bed time for me xxx")]), _vm._v(" "), _c('p', [_vm._v("9:51 A.M. Rick: Sweet dreams lover xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "wednesday-13-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Wednesday, 13 June 2018")]), _vm._v(" "), _c('p', [_vm._v("12:42 A.M. Rick: Hello Sweet Cheeks x")]), _vm._v(" "), _c('p', [_vm._v("12:46 A.M. Sarah: Hello Cutie Pie. I’m getting ready to leave London for Edinburgh this evening. How was your day? Do you get lonely travelling alone?")]), _vm._v(" "), _c('p', [_vm._v("12:56 A.M. Rick: Not at all. I enjoy my own company, and travelling alone I get to please myself.")]), _vm._v(" "), _c('p', [_vm._v("12:57 A.M. Sarah: You’re lucky. Most people get lonely. I’m generally self-sufficient but am missing my people a bit now. The time difference is tricky. And I can’t believe I’m getting back on a plane in a week.")]), _vm._v(" "), _c('p', [_vm._v("12:59 A.M. Rick: It’s flown by so quickly")]), _vm._v(" "), _c('p', [_vm._v("1:00 A.M. Sarah: It has. I’ve been fairly busy here until the last few days, so haven’t thought much about it. Are you in bed yet?")]), _vm._v(" "), _c('p', [_vm._v("1:12 A.M. Rick: Yes. Just showered and slipped between the sheets")]), _vm._v(" "), _c('p', [_vm._v("1:12 A.M. Sarah: Delicious. I could do with a cuddle x")]), _vm._v(" "), _c('p', [_vm._v("1:12 A.M. Rick: Have a virtual hug from me lover xxx")]), _vm._v(" "), _c('p', [_vm._v("1:13 A.M. Sarah: Thanks. It helps, but oddly not quite as satisfying as the real thing! x")]), _vm._v(" "), _c('p', [_vm._v("1:13 A.M. Rick: Goodnight babe xxx")]), _vm._v(" "), _c('p', [_vm._v("1:42 A.M. Sarah: See you in the morning xxx")]), _vm._v(" "), _c('p', [_vm._v("7:55 A.M. Sarah: Morning Cutie Pie xxx")]), _vm._v(" "), _c('p', [_vm._v("8:08 A.M. Rick: Hello Sweet Cheeks xxx")]), _vm._v(" "), _c('p', [_vm._v("8:13 A.M. Sarah: I have been thinking about you – you are so foreign to me. It’s refreshing, I like it – but am I too green for you? Hope not x")]), _vm._v(" "), _c('p', [_vm._v("8:24 A.M. Rick: Green as in the cucumber lol x")]), _vm._v(" "), _c('p', [_vm._v("8:27 A.M. Sarah: I’ll take that as “you’re cute enough”! Not going to let it go, are you? x")]), _vm._v(" "), _c('p', [_vm._v("8:30 A.M. Rick: You know it intrigues and excites you. Do you find the act a little taboo lover? xxx")]), _vm._v(" "), _c('p', [_vm._v("8:36 A.M. Sarah: You want me in your bed right now! x")]), _vm._v(" "), _c('p', [_vm._v("8:37 A.M. Rick: We would make such a mess of this bed lover x")]), _vm._v(" "), _c('p', [_vm._v("8:48 A.M. Sarah: Taboo? Like most people my age sex was taboo in my childhood so, although it may have taken a while, I’ve come a long way! There’s still long way to go on this sex education journey, but I know I’m attracted to you on a few levels, and yes, I would relish that mess x")]), _vm._v(" "), _c('p', [_vm._v("8:58 A.M. Rick: My cuteness being the main one xxx")]), _vm._v(" "), _c('p', [_vm._v("8:58 A.M. Sarah: Keeping you cute keeps me sane. I’d probably run a mile if I allowed the other Rick to take over x")]), _vm._v(" "), _c('p', [_vm._v("8:59 A.M. Rick: I am glad I can help Sweet Cheeks 💋")]), _vm._v(" "), _c('p', [_vm._v("8:59 A.M. Sarah: You are helping babe. I went away at the wrong time. We needed a lot more time in the flesh x")]), _vm._v(" "), _c('p', [_vm._v("9:21 A.M. Rick: You are a naughty girl today. I like that xxx")]), _vm._v(" "), _c('p', [_vm._v("9:22 A.M. Sarah: I noticed! I’m going to try to sleep – wish me luck! Have a fab day babe 💋💋")]), _vm._v(" "), _c('p', [_vm._v("10:46 P.M. Sarah: Hello sweetheart. What was for dinner tonight?")]), _vm._v(" "), _c('p', [_vm._v("10:48 P.M. Rick: A corporate event. I ate far too much and regret it now.")]), _vm._v(" "), _c('p', [_vm._v("10:49 P.M. Sarah: Especially if you don’t need the energy later")]), _vm._v(" "), _c('p', [_vm._v("10:52 P.M. Rick: Exactly. You would burn it off me x")]), _vm._v(" "), _c('p', [_vm._v("10:53 P.M. Sarah: I would. A special diet")]), _vm._v(" "), _c('p', [_vm._v("10:54 P.M. Rick: Mmm. Naughty girl again! Is it a turn on sending sexual messages to me as you walk with your daughter? x")]), _vm._v(" "), _c('p', [_vm._v("10:57 P.M. Sarah: Absolutely yes! It does make me feel like a teenager but I had a breakthrough with her on this subject yesterday. Very happy about it xxx")]), _vm._v(" "), _c('p', [_vm._v("10:57 P.M. Rick: Tell me babe")]), _vm._v(" "), _c('p', [_vm._v("11:01 P.M. Sarah: She flats with a good friend (male) who suggested she might need to get over her disapproval so we had a chat about it over dinner last night and followed that up with a talk about her own sex life this morning which I think she needed to get out. We wouldn’t have had that talk if we hadn’t sorted out the other. It feels kind of like we can both be adults now, or that we are heading that way. Hope so xxx")]), _vm._v(" "), _c('p', [_vm._v("11:03 P.M. Rick: Good for you, although you didn’t need her approval")]), _vm._v(" "), _c('p', [_vm._v("11:03 P.M. Sarah: I know, but I value my relationship with her and this issue was putting it under pressure. We have always been open with each other so this feels like progress. I’ll never share all the details!")]), _vm._v(" "), _c('p', [_vm._v("11:05 P.M. Rick: That’s a good plan! Anyone would be jealous.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "thursday-14-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Thursday, 14 June 2018")]), _vm._v(" "), _c('p', [_vm._v("12:48 A.M. Rick: I do enjoy taunting and teasing you, lover x")]), _vm._v(" "), _c('p', [_vm._v("12:49 A.M. Sarah: I had noticed. I can see you are not commonly known as cute. Would that be correct?")]), _vm._v(" "), _c('p', [_vm._v("12:51 A.M. Rick: It is a new descriptive lol")]), _vm._v(" "), _c('p', [_vm._v("12:52 A.M. Sarah: You think I might have settled on that too soon? Or do you like it? Or perhaps have you mellowed into cuteness with age...")]), _vm._v(" "), _c('p', [_vm._v("12:58 A.M. Rick: It seems to fit in some respects. Although I think you know there is another side of me.")]), _vm._v(" "), _c('p', [_vm._v("12:59 A.M. Sarah: I am aware of that, but I do also think you are cute. A compliment x")]), _vm._v(" "), _c('p', [_vm._v("1:00 A.M. Rick: You know I can also rip your clothes off and take you. But that’s also cute lol.")]), _vm._v(" "), _c('p', [_vm._v("1:01 A.M. Sarah: That will be CUTE")]), _vm._v(" "), _c('p', [_vm._v("1:02 A.M. Rick: My hand under your dress as we sit at the bar")]), _vm._v(" "), _c('p', [_vm._v("1:03 A.M. Sarah: Also, CUTE")]), _vm._v(" "), _c('p', [_vm._v("1:03 A.M. Rick: Stripping you and have you walk along the beach")]), _vm._v(" "), _c('p', [_vm._v("1:03 A.M. Sarah: Not cute")]), _vm._v(" "), _c('p', [_vm._v("1:05 A.M. Rick: Why is that lover?")]), _vm._v(" "), _c('p', [_vm._v("1:05 A.M. Sarah: Unless you happen to own a private beach? I’m reasonably sure I wouldn’t be comfortable with public nakedness")]), _vm._v(" "), _c('p', [_vm._v("1:06 A.M. Rick: Now that you mention it. NO lol.")]), _vm._v(" "), _c('p', [_vm._v("1:07 A.M. Sarah: What? You don’t own a private beach?")]), _vm._v(" "), _c('p', [_vm._v("1:08 A.M. Rick: No. Sorry 😮")]), _vm._v(" "), _c('p', [_vm._v("1:08 A.M. Sarah: Been nice knowing you! That was a key implied criterion in my Tinder profile.")]), _vm._v(" "), _c('p', [_vm._v("1:10 A.M. Rick: Materialistic girl seeks more?")]), _vm._v(" "), _c('p', [_vm._v("1:11 A.M. Sarah: If I ever was materialistic, I’m not now if it’s any comfort to you x")]), _vm._v(" "), _c('p', [_vm._v("1:13 A.M. Rick: That’s good to know x")]), _vm._v(" "), _c('p', [_vm._v("1:14 A.M. Sarah: But a private island would be desirable nonetheless 😮. A warm one.")]), _vm._v(" "), _c('p', [_vm._v("1:17 A.M. Rick: I am a fun in the sun type of guy")]), _vm._v(" "), _c('p', [_vm._v("1:18 A.M. Sarah: Need I ask what sort of fun?")]), _vm._v(" "), _c('p', [_vm._v("1:19 A.M. Rick: You want me to be naughty, don’t you lover?")]), _vm._v(" "), _c('p', [_vm._v("1:19 A.M. Sarah: I have no shame left")]), _vm._v(" "), _c('p', [_vm._v("1:19 A.M. Rick: Why is that?")]), _vm._v(" "), _c('p', [_vm._v("1:20 A.M. Sarah: You’ve weaselled into my brain and turned it inside out. My confessor – you know far more than you should!")]), _vm._v(" "), _c('p', [_vm._v("1:21 A.M. Rick: Only what you have told me")]), _vm._v(" "), _c('p', [_vm._v("1:23 A.M. Sarah: Of course, I’ve just let my guard down so that’s probably good. And you’re cute so it’s ok x")]), _vm._v(" "), _c('p', [_vm._v("1:24 A.M. Rick: Did you want the night of lovemaking to happen?")]), _vm._v(" "), _c('p', [_vm._v("1:25 A.M. Sarah: I did")]), _vm._v(" "), _c('p', [_vm._v("1:26 A.M. Rick: Was it me or a need?")]), _vm._v(" "), _c('p', [_vm._v("1:26 A.M. Sarah: You")]), _vm._v(" "), _c('p', [_vm._v("1:27 A.M. Sarah: And for you? Me or a need?")]), _vm._v(" "), _c('p', [_vm._v("1:27 A.M. Rick: You, lover")]), _vm._v(" "), _c('p', [_vm._v("1:30 A.M. Sarah: I’ll be on a train to a little village out of the city in about half an hour. Staying two nights with a woman I met recently on another trip.")]), _vm._v(" "), _c('p', [_vm._v("1:30 A.M. Rick: How many times have you cum for me whilst you have been away, lover?")]), _vm._v(" "), _c('p', [_vm._v("1:31 A.M. Sarah: Oh, there he is...maybe three")]), _vm._v(" "), _c('p', [_vm._v("1:31 A.M. Rick: He is always there! Only three?")]), _vm._v(" "), _c('p', [_vm._v("1:31 A.M. Sarah: Think so. Not enough?")]), _vm._v(" "), _c('p', [_vm._v("1:33 A.M. Rick: Definitely not!")]), _vm._v(" "), _c('p', [_vm._v("1:33 A.M. Sarah: See above for reasons babe. Long way above. And sharing a bed so not much chance for a couple more days")]), _vm._v(" "), _c('p', [_vm._v("1:37 A.M. Rick: Damn. That will definitely inhibit any play")]), _vm._v(" "), _c('p', [_vm._v("1:37 A.M. Sarah: Can’t imagine that going down too well with the child, although I’m pretty good at silent, tragically enough. Ex used to roll straight off and in one movement pick up his book or whatever and be back to what he was doing before. No afterglow, nothing. Not even naked.")]), _vm._v(" "), _c('p', [_vm._v("1:40 A.M. Rick: That is so sad. So, it was over in minutes?")]), _vm._v(" "), _c('p', [_vm._v("1:40 A.M. Sarah: Yes. It’s sickening to think back")]), _vm._v(" "), _c('p', [_vm._v("1:42 A.M. Rick: What did you think about our night? Did you wish I would stop?")]), _vm._v(" "), _c('p', [_vm._v("1:42 A.M. Sarah: No! I want that. I have great capacity x")]), _vm._v(" "), _c('p', [_vm._v("1:43 A.M. Rick: You do, and you needed it")]), _vm._v(" "), _c('p', [_vm._v("1:44 A.M. Sarah: I also still need it")]), _vm._v(" "), _c('p', [_vm._v("1:44 A.M. Rick: Would you like to try a 3sum?")]), _vm._v(" "), _c('p', [_vm._v("1:44 A.M. Sarah: I’m a long way from that")]), _vm._v(" "), _c('p', [_vm._v("1:45 A.M. Rick: Why not? All that attention")]), _vm._v(" "), _c('p', [_vm._v("1:45 A.M. Sarah: No, really not keen. I want to focus on a single man who I connect with for now.")]), _vm._v(" "), _c('p', [_vm._v("1:46 A.M. Rick: So I am not the first to suggest it!")]), _vm._v(" "), _c('p', [_vm._v("1:46 A.M. Sarah: No, you are not")]), _vm._v(" "), _c('p', [_vm._v("1:47 A.M. Rick: One of the other two?")]), _vm._v(" "), _c('p', [_vm._v("1:47 A.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("1:51 A.M. Rick: Is he also a good lover?")]), _vm._v(" "), _c('p', [_vm._v("1:51 A.M. Sarah: He’s too full of suggestions of how I could change for my current mental state. I’m sure his heart is in the right place but I haven’t been ready for that – and I think I’m the best person to decide my future directions!")]), _vm._v(" "), _c('p', [_vm._v("1:57 A.M. Rick: How many times did you have sex?")]), _vm._v(" "), _c('p', [_vm._v("1:57 A.M. Sarah: I’d say 6 or 7")]), _vm._v(" "), _c('p', [_vm._v("1:58 A.M. Rick: So, he obviously gave you something")]), _vm._v(" "), _c('p', [_vm._v("2:00 A.M. Sarah: Well I liked him in other ways – interesting and smart")]), _vm._v(" "), _c('p', [_vm._v("2:01 A.M. Rick: Did you cum for him?")]), _vm._v(" "), _c('p', [_vm._v("2:01 A.M. Sarah: Maybe once, but not generally")]), _vm._v(" "), _c('p', [_vm._v("2:02 A.M. Rick: Did he have you outside of the bedroom?")]), _vm._v(" "), _c('p', [_vm._v("2:03 A.M. Sarah: Generally, in the bedroom, but once on the lawn under the stars. Delicious. Why?")]), _vm._v(" "), _c('p', [_vm._v("2:06 A.M. Rick: I am somewhat kinky that way")]), _vm._v(" "), _c('p', [_vm._v("2:08 A.M. Sarah: Kinky? You mean you like to have sex elsewhere? Where would you choose in my house? I’m not bored by a bed but not committed to it. I like to be comfortable though!")]), _vm._v(" "), _c('p', [_vm._v("2:10 A.M. Rick: I’d tie you over the dining room table")]), _vm._v(" "), _c('p', [_vm._v("2:11 A.M. Sarah: Tie me?")]), _vm._v(" "), _c('p', [_vm._v("2:12 A.M. Rick: Mmm. Restrained.")]), _vm._v(" "), _c('p', [_vm._v("2:12 A.M. Sarah: Down boy. I’m a newbie.")]), _vm._v(" "), _c('p', [_vm._v("2:16 A.M. Rick: Lol. Was the anal sex with him?")]), _vm._v(" "), _c('p', [_vm._v("2:16 A.M. Sarah: No!")]), _vm._v(" "), _c('p', [_vm._v("2:18 A.M. Sarah: But he was keen for that too. It never transpired for whatever reason. I’m serious Cutie Pie. Take it slow with me xxx")]), _vm._v(" "), _c('p', [_vm._v("2:38 A.M. Sarah: Sleep for you now? Sleep tight xxx")]), _vm._v(" "), _c('p', [_vm._v("2:38 A.M. Rick: Yes lover. Good night xxx")]), _vm._v(" "), _c('p', [_vm._v("9:20 A.M. Rick: Good morning Sarah x")]), _vm._v(" "), _c('p', [_vm._v("9:20 A.M. Sarah: Good morning sweetheart x")]), _vm._v(" "), _c('p', [_vm._v("9:23 A.M. Sarah: Answer please – will you take it easy with me?")]), _vm._v(" "), _c('p', [_vm._v("9:34 A.M. Rick: Do you feel I went easy on you during our first sexcapade?")]), _vm._v(" "), _c('p', [_vm._v("9:34 A.M. Sarah: No, but I didn’t ask you to. You thought you had gone too far I recall? I trust you not to push me too hard.")]), _vm._v(" "), _c('p', [_vm._v("9:43 A.M. Rick: It’s all mutual consent Sweet Cheeks x")]), _vm._v(" "), _c('p', [_vm._v("9:43 A.M. Sarah: Ok that’s all I want to hear, thank you. I’m not sharing a bed thank god. Just a room x")]), _vm._v(" "), _c('p', [_vm._v("9:46 A.M. Rick: Who with?")]), _vm._v(" "), _c('p', [_vm._v("9:46 A.M. Sarah: Haha – my child of course! Be nice if you could beam yourself into bed with me xxx")]), _vm._v(" "), _c('p', [_vm._v("9:48 A.M. Rick: Not sure she would appreciate watching her mother perform!!! 😮😮")]), _vm._v(" "), _c('p', [_vm._v("9:49 A.M. Sarah: You’d have to just cuddle me. Maybe a kiss xxx")]), _vm._v(" "), _c('p', [_vm._v("9:51 A.M. Rick: Could we stop there?")]), _vm._v(" "), _c('p', [_vm._v("9:51 A.M. Sarah: Highly unlikely")]), _vm._v(" "), _c('p', [_vm._v("9:53 A.M. Rick: First my mouth would explode")]), _vm._v(" "), _c('p', [_vm._v("9:53 A.M. Sarah: Oh? On mine?")]), _vm._v(" "), _c('p', [_vm._v("9:56 A.M. Rick: Both. Do you enjoy 69?")]), _vm._v(" "), _c('p', [_vm._v("9:56 A.M. Sarah: Yes, I do")]), _vm._v(" "), _c('p', [_vm._v("9:58 A.M. Rick: So you can multitask")]), _vm._v(" "), _c('p', [_vm._v("9:59 A.M. Sarah: I’m a woman!")]), _vm._v(" "), _c('p', [_vm._v("10:01 A.M. Rick: Use your mouth on me and move yourself on my probing tongue at the same time x")]), _vm._v(" "), _c('p', [_vm._v("10:02 A.M. Sarah: I can do that sweet pea")]), _vm._v(" "), _c('p', [_vm._v("10:03 A.M. Rick: I have no doubt")]), _vm._v(" "), _c('p', [_vm._v("10:05 A.M. Sarah: I’m so tired babe – excuse me to sleep?")]), _vm._v(" "), _c('p', [_vm._v("10:05 A.M. Rick: Of course, lover. Sweet dreams x")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "friday-15-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Friday, 15 June 2018")]), _vm._v(" "), _c('p', [_vm._v("9:08 A.M. Rick: Good morning lover x")]), _vm._v(" "), _c('p', [_vm._v("9:15 A.M. Sarah: Good morning babe. Such a blustery day here – you almost lost me off a cliff! How’s things back home? x")]), _vm._v(" "), _c('p', [_vm._v("10:01 A.M. Rick: It’s pretty close to the weekend, and at the moment it’s blue sky but rather chilly. So, a windy day in Scotland? x")]), _vm._v(" "), _c('p', [_vm._v("10:33 A.M. Sarah: I’d call it a howling gale actually, and no skimpy clothing to be seen. You’d hate it! x")]), _vm._v(" "), _c('p', [_vm._v("10:36 A.M. Rick: Damn woman! You make me sound like a dirty old man x")]), _vm._v(" "), _c('p', [_vm._v("10:37 A.M. Sarah: Sorry but that’s funny x")]), _vm._v(" "), _c('p', [_vm._v("10:37 A.M. Rick: Well it’s true!!! 😮😮😮")]), _vm._v(" "), _c('p', [_vm._v("10:37 A.M. Sarah: You’re a dirty old man? My favourite x")]), _vm._v(" "), _c('p', [_vm._v("10:38 A.M. Rick: Possibly xxx")]), _vm._v(" "), _c('p', [_vm._v("10:38 A.M. Sarah: Time will tell – I’m not old so you can’t be yet surely? Just dirty. Got to sleep now. Night Cutie Pie xxx")]), _vm._v(" "), _c('p', [_vm._v("10:53 A.M. Rick: Sweet dreams Sweet Cheeks xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "saturday-16-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Saturday, 16 June 2018")]), _vm._v(" "), _c('p', [_vm._v("8:56 A.M. Rick: Good morning lover. How was your day? x")]), _vm._v(" "), _c('p', [_vm._v("8:59 A.M. Sarah: Hello babe. Great, apart from a terrifying spiral staircase up a monument in Edinburgh! I’m back in London now and having a few drinks out. Missed you today x")]), _vm._v(" "), _c('p', [_vm._v("10:25 A.M. Sarah: Are you there, delicious man? what are you up to?")]), _vm._v(" "), _c('p', [_vm._v("10:38 A.M. Rick: Delicious as in eat me? mmm")]), _vm._v(" "), _c('p', [_vm._v("10:38 A.M. Sarah: Yes, if you would like that")]), _vm._v(" "), _c('p', [_vm._v("10:39 A.M. Rick: Eat you would be my pleasure x")]), _vm._v(" "), _c('p', [_vm._v("10:40 A.M. Sarah: Excellent, and you know I’m looking forward to that. Goodnight babe xxx")]), _vm._v(" "), _c('p', [_vm._v("10:40 A.M. Rick: Goodnight lover, sweet dreams xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "sunday-17-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Sunday, 17 June 2018")]), _vm._v(" "), _c('p', [_vm._v("7:12 A.M. Sarah: Last minute tourist activities – we had an AWESOME day clambering up and around St Paul’s cathedral with my very diligent tour leader. We got right to the top – more terrifying spiral staircases xxx")]), _vm._v(" "), _c('p', [_vm._v("8:59 A.M. Rick: Hello lover, you really are exploring the sights of London x")]), _vm._v(" "), _c('p', [_vm._v("10:14 A.M. Sarah: The cathedral was an incredible experience. If one were to flick back through this conversation it appears, I talk too much! Hope you find it sweet and lovable rather than annoying! xxx")]), _vm._v(" "), _c('p', [_vm._v("1:56 P.M. Rick: Not at all annoying, after all you are a woman!!! And I like that you enjoy sharing your trip with me. Not every day you get to explore new places and have new experiences")]), _vm._v(" "), _c('p', [_vm._v("2:15 P.M. Sarah: Yes, that’s part of it, plus you’re new and fun x")]), _vm._v(" "), _c('p', [_vm._v("2:16 P.M. Rick: Are you thinking about how I will feel inside you again?")]), _vm._v(" "), _c('p', [_vm._v("2:16 P.M. Sarah: I often do")]), _vm._v(" "), _c('p', [_vm._v("2:17 P.M. Rick: Oh really?")]), _vm._v(" "), _c('p', [_vm._v("2:17 P.M. Sarah: Don’t you?")]), _vm._v(" "), _c('p', [_vm._v("2:18 P.M. Rick: Oh yes")]), _vm._v(" "), _c('p', [_vm._v("2:19 P.M. Sarah: You’ve asked me a few times if I regret that night – have I said anything that makes you think I didn’t want it?")]), _vm._v(" "), _c('p', [_vm._v("2:20 P.M. Rick: Not at all. I know you actually needed it x")]), _vm._v(" "), _c('p', [_vm._v("2:21 P.M. Sarah: Really? I mean I did but...you make me think I should have held out longer?")]), _vm._v(" "), _c('p', [_vm._v("2:23 P.M. Rick: Why would you deny yourself? Go with your feelings and needs.")]), _vm._v(" "), _c('p', [_vm._v("2:24 P.M. Sarah: I hope you don’t think I’m promiscuous, or that it would have happened whoever you were")]), _vm._v(" "), _c('p', [_vm._v("2:24 P.M. Rick: Lol. I don’t lover xxx")]), _vm._v(" "), _c('p', [_vm._v("2:24 P.M. Sarah: xxx")]), _vm._v(" "), _c('p', [_vm._v("2:25 P.M. Rick: I knew the first time we met you wanted me x")]), _vm._v(" "), _c('p', [_vm._v("2:26 P.M. Sarah: Did you just!")]), _vm._v(" "), _c('p', [_vm._v("2:26 P.M. Rick: Yes. I could smell the sex on you x")]), _vm._v(" "), _c('p', [_vm._v("2:26 P.M. Sarah: Oh, you could not!")]), _vm._v(" "), _c('p', [_vm._v("2:27 P.M. Rick: Oh yes, I could")]), _vm._v(" "), _c('p', [_vm._v("2:27 P.M. Sarah: What does that even mean???")]), _vm._v(" "), _c('p', [_vm._v("2:28 P.M. Rick: Your excitement emanating from between your legs")]), _vm._v(" "), _c('p', [_vm._v("2:28 P.M. Sarah: No way! You kept yourself so distant!")]), _vm._v(" "), _c('p', [_vm._v("2:30 P.M. Rick: Did you orgasm that first night? Lying in bed?")]), _vm._v(" "), _c('p', [_vm._v("2:31 P.M. Sarah: I was definitely frustrated")]), _vm._v(" "), _c('p', [_vm._v("2:31 P.M. Rick: That means you did!")]), _vm._v(" "), _c('p', [_vm._v("2:32 P.M. Sarah: You didn’t touch me at all until in your car – did you want to?")]), _vm._v(" "), _c('p', [_vm._v("2:32 P.M. Rick: Of course. Did you want me to explore you in your local bars?")]), _vm._v(" "), _c('p', [_vm._v("2:33 P.M. Sarah: No, I just find it interesting how much self-control you exercised")]), _vm._v(" "), _c('p', [_vm._v("2:34 P.M. Sarah: I wanted to touch you")]), _vm._v(" "), _c('p', [_vm._v("2:34 P.M. Rick: Undo my zip and hold me")]), _vm._v(" "), _c('p', [_vm._v("2:35 P.M. Sarah: Nooo believe it or but there are other bits")]), _vm._v(" "), _c('p', [_vm._v("2:36 P.M. Rick: Seriously!!!")]), _vm._v(" "), _c('p', [_vm._v("2:37 P.M. Sarah: I thought you really did want to go home too")]), _vm._v(" "), _c('p', [_vm._v("2:37 P.M. Rick: I will have to read Cosmo")]), _vm._v(" "), _c('p', [_vm._v("2:38 P.M. Sarah: No babe. I doubt you need instructions.")]), _vm._v(" "), _c('p', [_vm._v("2:39 P.M. Rick: Did you meet your other lover on the Monday night?")]), _vm._v(" "), _c('p', [_vm._v("2:40 P.M. Sarah: No! Two in a week is bad behaviour but two in two days is just bad")]), _vm._v(" "), _c('p', [_vm._v("2:42 P.M. Rick: Or maybe you’re just a hotblooded woman")]), _vm._v(" "), _c('p', [_vm._v("2:42 P.M. Sarah: I hadn’t seen anyone for I think about ten days before you. A fine line I’m not ready to cross.")]), _vm._v(" "), _c('p', [_vm._v("2:43 P.M. Rick: Saving yourself for the chosen one 😮😮😮")]), _vm._v(" "), _c('p', [_vm._v("2:44 P.M. Sarah: That’s hardly fair either! Just trying to keep some self-respect x")]), _vm._v(" "), _c('p', [_vm._v("2:44 P.M. Rick: I know you are not a loose woman x")]), _vm._v(" "), _c('p', [_vm._v("2:45 P.M. Sarah: Many women of my acquaintance would be appalled that we had sex after knowing each other two days. I’m not appalled of course. Nothing to lose.")]), _vm._v(" "), _c('p', [_vm._v("2:46 P.M. Rick: Also, single women?")]), _vm._v(" "), _c('p', [_vm._v("2:46 P.M. Sarah: Both, but yes, a couple of single women")]), _vm._v(" "), _c('p', [_vm._v("2:47 P.M. Rick: Then they are selfish")]), _vm._v(" "), _c('p', [_vm._v("2:47 P.M. Sarah: Silly really – afraid. They think men are using them, or are the only ones getting anything out of a sexual interaction.")]), _vm._v(" "), _c('p', [_vm._v("2:48 P.M. Rick: It’s a two-way street. What’s the point of sitting and complaining!")]), _vm._v(" "), _c('p', [_vm._v("2:49 P.M. Sarah: I agree. I have no idea who was using who on our fateful night x")]), _vm._v(" "), _c('p', [_vm._v("2:49 P.M. Rick: Did you feel used and abused?")]), _vm._v(" "), _c('p', [_vm._v("2:50 P.M. Sarah: Not at all. Did you? xxx")]), _vm._v(" "), _c('p', [_vm._v("2:50 P.M. Rick: Not at all lover. And you can use me again.")]), _vm._v(" "), _c('p', [_vm._v("2:51 P.M. Sarah: That’s a generous offer Cutie x")]), _vm._v(" "), _c('p', [_vm._v("2:51 P.M. Rick: My pleasure x")]), _vm._v(" "), _c('p', [_vm._v("2:52 P.M. Sarah: I do enjoy these little chats with you xxx")]), _vm._v(" "), _c('p', [_vm._v("2:52 P.M. Rick: As do I xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "monday-18-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Monday, 18 June 2018")]), _vm._v(" "), _c('p', [_vm._v("6:40 A.M. Rick: Good morning Sweet Cheeks. Did you have another enjoyable day!!! Xxx")]), _vm._v(" "), _c('p', [_vm._v("7:44 A.M. Sarah: Good morning to you too Cutie Pie xxx")]), _vm._v(" "), _c('p', [_vm._v("7:49 A.M. Sarah: Yes, a good day but I’m tired of people! High tea in the full English tradition was immediately followed by dinner with others, so too much food and company. I’m looking forward to my little room. I’m messaging too much! I’m sorry xxx")]), _vm._v(" "), _c('p', [_vm._v("8:36 A.M. Rick: You are a message chatterbox!!!")]), _vm._v(" "), _c('p', [_vm._v("8:37 A.M. Sarah: So, it seems. I’m not like this in person if that helps. Seriously tell me to stop if you can’t stand it")]), _vm._v(" "), _c('p', [_vm._v("8:56 A.M. Rick: Lol. I enjoy your travel blog and the naughty bits in between xxx")]), _vm._v(" "), _c('p', [_vm._v("8:58 A.M. Sarah: Don’t encourage me – I would have been significantly less restrained had I known you longer before I left x")]), _vm._v(" "), _c('p', [_vm._v("8:58 A.M. Rick: You do enjoy being a coy shy girl don’t you 😮😮")]), _vm._v(" "), _c('p', [_vm._v("8:59 A.M. Sarah: Do I?")]), _vm._v(" "), _c('p', [_vm._v("9:00 A.M. Rick: Sometimes you are, not all the time. So, did you feel like royalty at high tea? x")]), _vm._v(" "), _c('p', [_vm._v("9:01 A.M. Sarah: No, but it was very sweet. We even wore frocks x")]), _vm._v(" "), _c('p', [_vm._v("9:04 A.M. Rick: Lol. Frock!!! I didn’t think that term was used anymore x")]), _vm._v(" "), _c('p', [_vm._v("9:05 A.M. Sarah: Apparently it is. I wore one I bought in Paris. It has excellent access with a single cord x")]), _vm._v(" "), _c('p', [_vm._v("9:07 A.M. Rick: Did you wear underwear?")]), _vm._v(" "), _c('p', [_vm._v("9:08 A.M. Sarah: Yes. Nice underwear of course. I’m a good girl x")]), _vm._v(" "), _c('p', [_vm._v("9:11 A.M. Rick: We know that’s not true! Perhaps occasionally good? We’ll have to change that xxx")]), _vm._v(" "), _c('p', [_vm._v("9:11 A.M. Sarah: You’re exceptionally good at the undressing game. I did notice that. And I wish you luck – I really do – I’ll be a delightful challenge for you 💋")]), _vm._v(" "), _c('p', [_vm._v("10:08 A.M. Rick: What’s the plan for tomorrow? More sights to behold? Or reflection time with your daughter? xxx")]), _vm._v(" "), _c('p', [_vm._v("10:10 A.M. Sarah: A stately home, but that’s the last activity. Maybe a walk and a nice dinner. I’m ready to come home, craving some unallocated time, and you. Hope you’re behaving yourself sitting there in your office?")]), _vm._v(" "), _c('p', [_vm._v("10:17 A.M. Rick: Define behave myself!!! If you mean having sexual thoughts about you, I would have to say no.")]), _vm._v(" "), _c('p', [_vm._v("10:18 A.M. Sarah: Well that’s good. I was hoping I was helping. I will leave you to those happy thoughts – I need to sleep Cutie Pie. You’re getting to the end of this episode of the message marathon. Talk tomorrow xxx")]), _vm._v(" "), _c('p', [_vm._v("10:21 A.M. Rick: Sweet dreams lover. Think of me spooning you xxx")]), _vm._v(" "), _c('p', [_vm._v("10:22 A.M. Sarah: I am already xxx")]), _vm._v(" "), _c('p', [_vm._v("10:22 A.M. Rick: Naughty but delicious xxx")]), _vm._v(" "), _c('p', [_vm._v("10:23 A.M. Sarah: Oh yeah x")]), _vm._v(" "), _c('p', [_vm._v("10:28 A.M. Rick: You know I am hard don’t you x")]), _vm._v(" "), _c('p', [_vm._v("10:29 A.M. Sarah: Yes. Sorry babe! I’m suffering too if that helps xxx")]), _vm._v(" "), _c('p', [_vm._v("10:32 A.M. Rick: Oh, it’s not suffering. I enjoy the feeling, thinking of your body, your kiss 💋💋")]), _vm._v(" "), _c('p', [_vm._v("4:27 P.M. Sarah: So, do I but I also enjoy not having the pang occasionally! And good morning, sweet pea. What’s for dinner? Is your food bag preparing it as we speak? Do you also have a cleaning bag? xxx")]), _vm._v(" "), _c('p', [_vm._v("8:24 P.M. Rick: Lol. Yes. Me 😮😮")]), _vm._v(" "), _c('p', [_vm._v("8:25 P.M. Sarah: Funny 🙂 I’m walking with the child now and will wait to be told which way and when to jump next...")]), _vm._v(" "), _c('p', [_vm._v("10:07 P.M. Rick: By your daughter or by me?")]), _vm._v(" "), _c('p', [_vm._v("10:08 P.M. Sarah: Well my daughter for now x")]), _vm._v(" "), _c('p', [_vm._v("10:09 P.M. Rick: You know I will tell you to get on your hands and knees. I will hold your hips, as I stroke inside you x")]), _vm._v(" "), _c('p', [_vm._v("10:12 P.M. Sarah: Hardly a challenge! Don’t taunt me xxx")]), _vm._v(" "), _c('p', [_vm._v("10:13 P.M. Rick: Slowly at first")]), _vm._v(" "), _c('p', [_vm._v("10:14 P.M. Sarah: Aaaaah no!")]), _vm._v(" "), _c('p', [_vm._v("10:14 P.M. Rick: Teasing. Just the head of my cock.")]), _vm._v(" "), _c('p', [_vm._v("10:15 P.M. Sarah: You are cruel")]), _vm._v(" "), _c('p', [_vm._v("10:16 P.M. Rick: Pushing your lips open over and over")]), _vm._v(" "), _c('p', [_vm._v("10:17 P.M. Sarah: Like I said. Cruel. Precisely when are you planning on doing this? xxx")]), _vm._v(" "), _c('p', [_vm._v("10:19 P.M. Rick: To be confirmed")]), _vm._v(" "), _c('p', [_vm._v("10:19 P.M. Sarah: Haha that’s just mean!")]), _vm._v(" "), _c('p', [_vm._v("10:20 P.M. Rick: Totally mean")]), _vm._v(" "), _c('p', [_vm._v("10:20 P.M. Sarah: When do you leave for Melbourne? Is it next Monday? I’m planning on sleeping the whole way home to be ready x")]), _vm._v(" "), _c('p', [_vm._v("10:22 P.M. Rick: Yes, for the week")]), _vm._v(" "), _c('p', [_vm._v("10:22 P.M. Sarah: TERRIBLE planning")]), _vm._v(" "), _c('p', [_vm._v("10:22 P.M. Rick: Do you want to feel me deep, lover?")]), _vm._v(" "), _c('p', [_vm._v("10:23 P.M. Sarah: Yes, and shallow, but I’d settle for anything at the moment. You’ve been such unexpectedly good company on this trip xxx")]), _vm._v(" "), _c('p', [_vm._v("10:27 P.M. Rick: It’s been my pleasure babe x")]), _vm._v(" "), _c('p', [_vm._v("10:27 P.M. Sarah: I’m glad. Do you do this to all the girls in your harem?")]), _vm._v(" "), _c('p', [_vm._v("10:29 P.M. Rick: Lol. What happens at home stays at home?")]), _vm._v(" "), _c('p', [_vm._v("10:29 P.M. Sarah: Oh, I’ll take that as a yes!")]), _vm._v(" "), _c('p', [_vm._v("10:30 P.M. Rick: We both have other playmates, don’t we?")]), _vm._v(" "), _c('p', [_vm._v("10:30 P.M. Sarah: I don’t know! You have said there was no one else before, so…")]), _vm._v(" "), _c('p', [_vm._v("10:34 P.M. Rick: I don’t mind you having other lovers babe")]), _vm._v(" "), _c('p', [_vm._v("10:35 P.M. Sarah: I know you don’t. It’s just not really in my psyche. I’m too new in the market, so to speak. I just had a tricky conversation with the loving one this morning where I had to explain that I need to be seeing other men to avoid getting trapped in a relationship with him. He’s not happy about it.")]), _vm._v(" "), _c('p', [_vm._v("10:37 P.M. Rick: Lol. You have two on the go. Lol. Sorry three!")]), _vm._v(" "), _c('p', [_vm._v("10:37 P.M. Sarah: I’m trying not to – I’ve almost come to the end of the road with one, and am heading the other off to the friend zone, and then there’s you")]), _vm._v(" "), _c('p', [_vm._v("10:39 P.M. Rick: Don’t get defensive lover! x")]), _vm._v(" "), _c('p', [_vm._v("10:39 P.M. Sarah: I’m just clarifying. It’s a phase not a lifestyle, I hope!")]), _vm._v(" "), _c('p', [_vm._v("10:41 P.M. Rick: Mmm. You never know.")]), _vm._v(" "), _c('p', [_vm._v("10:41 P.M. Sarah: True. May be a long phase, depends how fun it is, but I do know for now that I want you, all over me please x")]), _vm._v(" "), _c('p', [_vm._v("10:45 P.M. Rick: You want me to cum all over you babe? x")]), _vm._v(" "), _c('p', [_vm._v("10:45 P.M. Sarah: No! Hands and mouth all over me please x")]), _vm._v(" "), _c('p', [_vm._v("10:46 P.M. Rick: Do you like the taste? xxx")]), _vm._v(" "), _c('p', [_vm._v("10:46 P.M. Sarah: Interesting question – in the past it’s sort of disgusted me, for what I can only say are historic reasons. No simple answers here!")]), _vm._v(" "), _c('p', [_vm._v("10:50 P.M. Rick: That’s all I needed to know lover. Is that why you didn’t take me into your mouth?")]), _vm._v(" "), _c('p', [_vm._v("10:51 P.M. Sarah: Not at all. I’ll happily do that – just didn’t come about that night x")]), _vm._v(" "), _c('p', [_vm._v("10:52 P.M. Rick: Are you clenching as we chat?")]), _vm._v(" "), _c('p', [_vm._v("10:53 P.M. Sarah: I’m aching for just nearness at the moment")]), _vm._v(" "), _c('p', [_vm._v("10:54 P.M. Rick: You know it won’t stop there")]), _vm._v(" "), _c('p', [_vm._v("10:55 P.M. Sarah: I do know that, but that’s what I need now. I doubt it would ever stop there with us. Are you aching too?")]), _vm._v(" "), _c('p', [_vm._v("10:57 P.M. Rick: You know I am")]), _vm._v(" "), _c('p', [_vm._v("10:58 P.M. Sarah: We are a good fit")]), _vm._v(" "), _c('p', [_vm._v("11:00 P.M. Rick: You do fit nice and tight around me")]), _vm._v(" "), _c('p', [_vm._v("11:01 P.M. Sarah: I loved being draped around your body. And you feel good filling me inside.")]), _vm._v(" "), _c('p', [_vm._v("11:03 P.M. Rick: You naughty girl")]), _vm._v(" "), _c('p', [_vm._v("11:03 P.M. Sarah: Nice girl")]), _vm._v(" "), _c('p', [_vm._v("11:04 P.M. Rick: Naughty but nice")]), _vm._v(" "), _c('p', [_vm._v("11:04 P.M. Sarah: I can go with that")]), _vm._v(" "), _c('p', [_vm._v("11:05 P.M. Sarah: A couple of those kisses would be nice")]), _vm._v(" "), _c('p', [_vm._v("11:07 P.M. Rick: xxx")]), _vm._v(" "), _c('p', [_vm._v("11:19 P.M. Sarah: I’m off to Hampton court palace to visit Henry VIII, so we’re waiting for the train. Summer dress on a beautiful day x")]), _vm._v(" "), _c('p', [_vm._v("11:21 P.M. Rick: Knickers?")]), _vm._v(" "), _c('p', [_vm._v("11:22 P.M. Sarah: Haha do you want to know what they look like or if there are any?")]), _vm._v(" "), _c('p', [_vm._v("11:24 P.M. Rick: Both")]), _vm._v(" "), _c('p', [_vm._v("11:25 P.M. Sarah: You’re hilarious. Cream lacy g")]), _vm._v(" "), _c('p', [_vm._v("11:25 P.M. Rick: Mmm")]), _vm._v(" "), _c('p', [_vm._v("11:26 P.M. Sarah: You are lucky to have met this version of me. The old one wasn’t very fun. Bedtime for you Cutie? xxx")]), _vm._v(" "), _c('p', [_vm._v("11:26 P.M. Rick: Yes lover, enjoy your day xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "tuesday-19-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Tuesday, 19 June 2018")]), _vm._v(" "), _c('p', [_vm._v("6:41 A.M. Rick: Good morning lover xxx")]), _vm._v(" "), _c('p', [_vm._v("6:43 A.M. Sarah: You dreamt of me I hope Cutie Pie? Woke up with a smile? I’ve had the feeling all day, especially lying on the grass under an apple tree in Henry’s orchard, feeling the breeze – my favourite x")]), _vm._v(" "), _c('p', [_vm._v("6:45 A.M. Rick: Oh yes lover, I dreamt of you xxx")]), _vm._v(" "), _c('p', [_vm._v("7:58 A.M. Sarah: I feel tomorrow I’ll be saying goodbye to my child forever. It’s so oddly emotional x")]), _vm._v(" "), _c('p', [_vm._v("8:00 A.M. Rick: Why would you feel that way? x")]), _vm._v(" "), _c('p', [_vm._v("8:03 A.M. Sarah: I guess I’ve never spent such a long time in solitary confinement with her before and we are now both adults, and friends. She’s clearly living her life here and I’m clearly not. I’m leaving in a good space with her so I’m not unhappy, just emotional. I didn’t feel like that when she left last year.")]), _vm._v(" "), _c('p', [_vm._v("8:11 A.M. Rick: Stepping back can be a positive lover x")]), _vm._v(" "), _c('p', [_vm._v("8:12 A.M. Sarah: Thanks Rick, just what I needed to hear. You are right and I completely agree. I do need to step back from her life to allow myself to live my own x")]), _vm._v(" "), _c('p', [_vm._v("8:13 A.M. Rick: It sounds like this trip set boundaries for both of you xxx")]), _vm._v(" "), _c('p', [_vm._v("8:14 A.M. Sarah: That helps with tomorrow, and yes that was my plan. We both knew we needed to sort things out, just the two of us, and there have been a few very hard conversations along the way but we’re good for the moment.")]), _vm._v(" "), _c('p', [_vm._v("8:18 A.M. Rick: It also sets the boundaries on financial independence x")]), _vm._v(" "), _c('p', [_vm._v("8:19 A.M. Sarah: That’s so true")]), _vm._v(" "), _c('p', [_vm._v("8:19 A.M. Rick: She is her own woman now or so she believes")]), _vm._v(" "), _c('p', [_vm._v("8:20 A.M. Sarah: I’ve been surprised by that too. I’ve paid for a few things but definitely not everything. We’ve had a few chats about finances, and she understands I can no longer fund her, or even be a financial backstop.")]), _vm._v(" "), _c('p', [_vm._v("8:22 A.M. Rick: Well done you x")]), _vm._v(" "), _c('p', [_vm._v("8:22 A.M. Sarah: Thanks. She loves me, $ or not. It’s a nice feeling x")]), _vm._v(" "), _c('p', [_vm._v("8:33 A.M. Rick: Of course, she does x")]), _vm._v(" "), _c('p', [_vm._v("8:34 A.M. Sarah: I pretend to have that confidence but in reality, I’m quite insecure – it would be my worst nightmare to lose a child in any way, especially through my faulty parenting")]), _vm._v(" "), _c('p', [_vm._v("8:43 A.M. Rick: Stop with that nonsense!")]), _vm._v(" "), _c('p', [_vm._v("8:43 A.M. Sarah: Haha thanks. Right again. Emotional drivel. Give me a good shake.")]), _vm._v(" "), _c('p', [_vm._v("8:47 A.M. Rick: A good poke")]), _vm._v(" "), _c('p', [_vm._v("8:48 A.M. Sarah: That’ll do it lol. Poke anywhere in particular?")]), _vm._v(" "), _c('p', [_vm._v("8:48 A.M. Rick: With a blunt stick? lol")]), _vm._v(" "), _c('p', [_vm._v("8:49 A.M. Sarah: Your personal blunt stick I hope")]), _vm._v(" "), _c('p', [_vm._v("8:50 A.M. Rick: Cucumber!")]), _vm._v(" "), _c('p', [_vm._v("8:50 A.M. Sarah: I hate cucumber. And banana.")]), _vm._v(" "), _c('p', [_vm._v("8:51 A.M. Rick: Lol. That’s to eat.")]), _vm._v(" "), _c('p', [_vm._v("8:51 A.M. Sarah: And smell. I’m very fussy about objects, not just my coffee.")]), _vm._v(" "), _c('p', [_vm._v("8:54 A.M. Rick: It’s not as though you have a wealth of experience!")]), _vm._v(" "), _c('p', [_vm._v("9:04 A.M. Sarah: What was I doing in your bed overnight? Hope it was good x")]), _vm._v(" "), _c('p', [_vm._v("9:08 A.M. Rick: Riding me like a stallion x")]), _vm._v(" "), _c('p', [_vm._v("9:10 A.M. Sarah: Again? Nice xxx")]), _vm._v(" "), _c('p', [_vm._v("9:10 A.M. Rick: Then it was my turn")]), _vm._v(" "), _c('p', [_vm._v("9:11 A.M. Sarah: Mmm nice I’ll take as much of that as you have babe x")]), _vm._v(" "), _c('p', [_vm._v("9:22 A.M. Rick: That’s a bold statement x")]), _vm._v(" "), _c('p', [_vm._v("9:22 A.M. Sarah: I can be a little bit bold – it’s how we met x")]), _vm._v(" "), _c('p', [_vm._v("9:23 A.M. Rick: We will put that to the test")]), _vm._v(" "), _c('p', [_vm._v("9:24 A.M. Sarah: I know you will!")]), _vm._v(" "), _c('p', [_vm._v("9:29 A.M. Rick: Still aching? x")]), _vm._v(" "), _c('p', [_vm._v("9:29 A.M. Sarah: Yes. You?")]), _vm._v(" "), _c('p', [_vm._v("9:30 A.M. Rick: What do you think?")]), _vm._v(" "), _c('p', [_vm._v("9:30 A.M. Sarah: Yes, of course. That breeze in the orchard today was delicious. I thought of you.")]), _vm._v(" "), _c('p', [_vm._v("9:31 A.M. Rick: Up your frock")]), _vm._v(" "), _c('p', [_vm._v("9:32 A.M. Sarah: Lying on my back in the grass, knees bent. Soft and warm and up my frock, dappled light.")]), _vm._v(" "), _c('p', [_vm._v("9:35 A.M. Rick: Mmm. Did you have to clench? Roll over and move your hips? x")]), _vm._v(" "), _c('p', [_vm._v("9:35 A.M. Sarah: Yes, just like the thought does now x")]), _vm._v(" "), _c('p', [_vm._v("9:36 A.M. Rick: I would have had my hand under your frock")]), _vm._v(" "), _c('p', [_vm._v("9:37 A.M. Sarah: I would have removed my knickers to accommodate that")]), _vm._v(" "), _c('p', [_vm._v("9:39 A.M. Rick: No. I would have had you move them to one side allowing me to play between your lips x")]), _vm._v(" "), _c('p', [_vm._v("9:39 A.M. Sarah: That works too. Mmm yum, while you kiss me.")]), _vm._v(" "), _c('p', [_vm._v("9:40 A.M. Rick: Trying not to be obvious but also not caring. The hungry kisses. I can’t get enough of those.")]), _vm._v(" "), _c('p', [_vm._v("9:42 A.M. Sarah: Always hungry. Those innocent looks are deceptive. Maybe not so cute now? x")]), _vm._v(" "), _c('p', [_vm._v("9:54 A.M. Rick: Of course, I am! xxx")]), _vm._v(" "), _c('p', [_vm._v("9:55 A.M. Sarah: I think so xxx")]), _vm._v(" "), _c('p', [_vm._v("9:56 A.M. Sarah: Warm night here – I’m going to sleep naked. Tuck in behind? x")]), _vm._v(" "), _c('p', [_vm._v("10:00 A.M. Rick: Is that an invite?")]), _vm._v(" "), _c('p', [_vm._v("10:00 A.M. Sarah: Yes. I don’t want to go but should leave you to work and get to sleep. Goodnight babe. Enjoyed you today. Keep the orchard in mind while you work xxx")]), _vm._v(" "), _c('p', [_vm._v("10:05 A.M. Rick: I’d be behind you in a second if I could. Sweet dreams, lover xxx")]), _vm._v(" "), _c('p', [_vm._v("10:32 P.M. Sarah: Hello x")]), _vm._v(" "), _c('p', [_vm._v("10:33 P.M. Rick: Hello lover x")]), _vm._v(" "), _c('p', [_vm._v("10:34 P.M. Sarah: Busy day?")]), _vm._v(" "), _c('p', [_vm._v("10:34 P.M. Rick: Yes, down country for the day")]), _vm._v(" "), _c('p', [_vm._v("10:38 P.M. Sarah: I’ve never had a job requiring travel, too busy managing the careers of the men in my life… If you live alone it’s nice to break up the solitude.")]), _vm._v(" "), _c('p', [_vm._v("10:44 P.M. Rick: I know exactly what you mean, but solitude isn’t a problem to lone wolves.")]), _vm._v(" "), _c('p', [_vm._v("10:45 P.M. Sarah: Are you actually a lone wolf? You appear to have quite liked my company?")]), _vm._v(" "), _c('p', [_vm._v("10:45 P.M. Rick: Totally. Always have been. Chatting to you is different.")]), _vm._v(" "), _c('p', [_vm._v("10:46 P.M. Sarah: Can’t have made for easy relationships? Or maybe they liked you not being fully present?")]), _vm._v(" "), _c('p', [_vm._v("10:50 P.M. Rick: Never thought of that! It could be the case.")]), _vm._v(" "), _c('p', [_vm._v("10:50 P.M. Sarah: I wouldn’t consider myself a real loner, but have led a self-sufficient life, and I consider myself more of a loner than others in my family. I like my space. Does that make me a she-wolf?")]), _vm._v(" "), _c('p', [_vm._v("10:51 P.M. Rick: Who likes to mate")]), _vm._v(" "), _c('p', [_vm._v("10:52 P.M. Sarah: With lone wolves?")]), _vm._v(" "), _c('p', [_vm._v("10:52 P.M. Rick: Good answer, lover. I’m just heading to bed babe x")]), _vm._v(" "), _c('p', [_vm._v("11:02 P.M. Sarah: Want me to go?")]), _vm._v(" "), _c('p', [_vm._v("11:02 P.M. Rick: No, its ok lover. I may doze off x")]), _vm._v(" "), _c('p', [_vm._v("11:03 P.M. Sarah: Do you sleep naked?")]), _vm._v(" "), _c('p', [_vm._v("11:04 P.M. Rick: All the time")]), _vm._v(" "), _c('p', [_vm._v("11:04 P.M. Sarah: Me too unless I’m very cold. Love feeling skin on skin, body heat.")]), _vm._v(" "), _c('p', [_vm._v("11:07 P.M. Rick: Internal and external")]), _vm._v(" "), _c('p', [_vm._v("11:07 P.M. Sarah: Of course, babe. I love it. Sleep well Cutie xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "wednesday-20-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Wednesday, 20 June 2018")]), _vm._v(" "), _c('p', [_vm._v("7:27 A.M. Rick: Good morning lover xxx")]), _vm._v(" "), _c('p', [_vm._v("7:27 A.M. Sarah: Good morning sweetheart xxx")]), _vm._v(" "), _c('p', [_vm._v("7:28 A.M. Sarah: I’m at the gate and just changed into exercise gear for the longest flight, and so bored already. I was dropped here an hour or so earlier than necessary. My daughter and a friend are heading away for a few days and need to catch a train. Pretty tough saying goodbye actually!")]), _vm._v(" "), _c('p', [_vm._v("7:29 A.M. Rick: Well good for you babe. You’ve done what you came to do. How long is the wait?")]), _vm._v(" "), _c('p', [_vm._v("7:29 A.M. Sarah: Almost another hour, and don’t you dare! I can’t spend all those hours feeling the ache xxx")]), _vm._v(" "), _c('p', [_vm._v("7:31 A.M. Rick: Lol. How did you know?")]), _vm._v(" "), _c('p', [_vm._v("7:32 A.M. Sarah: I have experience with you now babe. Let me know when I land in KL when we can meet. I am being asked for other social things and need to plan. Keen to prioritise you. Have a good day chicky 💋")]), _vm._v(" "), _c('p', [_vm._v("8:44 A.M. Rick: Safe flight lover. Chat to you in 10 or so hours xxx")]), _vm._v(" "), _c('p', [_vm._v("9:56 P.M. Sarah: Hello, sweet. Just landed xxx")]), _vm._v(" "), _c('p', [_vm._v("9:57 P.M. Rick: Hello lover. Good flight? xxx")]), _vm._v(" "), _c('p', [_vm._v("9:58 P.M. Sarah: Yes thanks. I had an extra leg room seat – makes for a much more comfortable journey. Just behind the people who pay double xxx")]), _vm._v(" "), _c('p', [_vm._v("9:59 P.M. Rick: The perfect location. How long is the lay over?")]), _vm._v(" "), _c('p', [_vm._v("10:00 P.M. Sarah: Almost six hours. I’ve bought an extortionately expensive mocha and will be heading off for a walk around the airport soon. What are you up to?")]), _vm._v(" "), _c('p', [_vm._v("10:00 P.M. Rick: Full of a cold. Head pounding x")]), _vm._v(" "), _c('p', [_vm._v("10:01 P.M. Sarah: Oh, that’s awful. Wish I could help – could step in for your food bag x")]), _vm._v(" "), _c('p', [_vm._v("10:01 P.M. Rick: Lol. Eat you? x")]), _vm._v(" "), _c('p', [_vm._v("10:02 P.M. Sarah: Well that would save some bother in the kitchen x")]), _vm._v(" "), _c('p', [_vm._v("10:02 P.M. Rick: Did you sleep on the plane? ✈")]), _vm._v(" "), _c('p', [_vm._v("10:03 P.M. Sarah: Yes, I must have because I’m here and it doesn’t feel like that many hours have passed! You probably want soup and someone to stroke your head. And tucked up in bed. I am a pro at all of the above. Could even tuck in myself somewhere too xxx")]), _vm._v(" "), _c('p', [_vm._v("10:06 P.M. Rick: Looked after too many sick kids!!! xxx")]), _vm._v(" "), _c('p', [_vm._v("10:06 P.M. Sarah: No actually. I’m just nice. Hang around and you’ll see. I’m not a nurse just in case you get the wrong impression xxx")]), _vm._v(" "), _c('p', [_vm._v("10:08 P.M. Rick: Lol. Never crossed my mind lover xxx")]), _vm._v(" "), _c('p', [_vm._v("10:10 P.M. Sarah: Is the cold why you can’t commit to seeing me? Or too many better offers?")]), _vm._v(" "), _c('p', [_vm._v("10:15 P.M. Rick: It’s not just a cold – more like a flu. I’m coughing, nose running, fever xxx")]), _vm._v(" "), _c('p', [_vm._v("10:16 P.M. Sarah: Oh dear – hope you are in bed, medicated? Sleep is the only cure I suspect. I’ll leave you to do that, so good night Cutie. Feel better – I’d never pressure you to see me if you’re not up to it. I’m not going anywhere xxx")]), _vm._v(" "), _c('p', [_vm._v("10:16 P.M. Rick: I’m pretty sick, dosed up and about to sleep. Good night lover xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "thursday-21-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Thursday, 21 June 2018")]), _vm._v(" "), _c('p', [_vm._v("2:05 P.M. Rick: Hello lover. Have you landed yet? Xxx")]), _vm._v(" "), _c('p', [_vm._v("3.30 P.M. Rick: Are you home? xxx")]), _vm._v(" "), _c('p', [_vm._v("5:19 P.M. Sarah: Hello babe. Just landed – plane was ridiculously delayed so I had a total ten hours in the airport. Now I’m home. Showered. Tidied up after my darling son stayed over and made a mess. Washing is on. Clean sheets and no one else here. Delicious xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "friday-22-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Friday, 22 June 2018")]), _vm._v(" "), _c('p', [_vm._v("9:15 A.M. Sarah: Good morning – I’ve got used to our messaging. Hope you are feeling better? You know I’m very keen to see you so if you are well enough, let me know and we can make a plan 💋")]), _vm._v(" "), _c('p', [_vm._v("9:56 A.M. Rick: Good morning lover. Sorry for being under the radar, not been in the office for the last two days. Damn flu is raging and having to fly again on Sunday isn’t going to help. Glad to have you back xxx")]), _vm._v(" "), _c('p', [_vm._v("9:58 A.M. Sarah: I thought that might be the case. We’ll have to wait until next weekend then, but I can cheer you up in the meantime. Glad to be back, and do let me know if I can help – I mean that seriously xxx")]), _vm._v(" "), _c('p', [_vm._v("10:13 A.M. Rick: It’s all good thanks, darling. I am fielding business calls and emails between taking lots of tablets and honey, lemon and ginger xxx")]), _vm._v(" "), _c('p', [_vm._v("11:00 A.M. Sarah: Ok well just tell me if you need help sweetheart xxx")]), _vm._v(" "), _c('p', [_vm._v("11:41 A.M. Rick: Thank you darling 💋💋")]), _vm._v(" "), _c('p', [_vm._v("3:55 P.M. Rick: Hello babe. Have you had a couple of naps today? Had your coffee? 💋")]), _vm._v(" "), _c('p', [_vm._v("3:58 P.M. Sarah: Hello Cutie. Yes I got up for coffee with some friends, then saw my son for some food later in the morning and am having a drink with a woman friend at 5. I’ll be back at work next week. I could do with a snuggle right now but will have to hold out x")]), _vm._v(" "), _c('p', [_vm._v("4:02 P.M. Rick: I can assure you it’s not worth the dreaded lurgy. Throat rasping along with the nostril discharge and shakes is not a turn on!!!")]), _vm._v(" "), _c('p', [_vm._v("4:03 P.M. Sarah: No, I don’t want that, thanks, but you make it sound so sexy I’m almost tempted x")]), _vm._v(" "), _c('p', [_vm._v("4:03 P.M. Rick: God woman!!! You like to tempt fate xxx")]), _vm._v(" "), _c('p', [_vm._v("4:04 P.M. Sarah: You’d better get well while you’re away! x")]), _vm._v(" "), _c('p', [_vm._v("4:05 P.M. Rick: Mmm. Sounds intriguing 💋")]), _vm._v(" "), _c('p', [_vm._v("4:06 P.M. Sarah: You’re too cute 💋")]), _vm._v(" "), _c('p', [_vm._v("4:07 P.M. Rick: Thanks, Sweet Cheeks. Glad to be home? xxx")]), _vm._v(" "), _c('p', [_vm._v("4:09 P.M. Sarah: Yes actually. It was a great trip for many reasons, but I need to sort my life out now. Settle finances with ex, find an occupation, be ravished by you etc xxx")]), _vm._v(" "), _c('p', [_vm._v("4:12 P.M. Rick: You now have sorted out any issues with your daughter now time to focus on Sarah. And it will be more than ravish lover 💋")]), _vm._v(" "), _c('p', [_vm._v("4:12 P.M. Sarah: Oh really…")]), _vm._v(" "), _c('p', [_vm._v("4:13 P.M. Rick: Mmm. You’ve tempted me you seductress x")]), _vm._v(" "), _c('p', [_vm._v("4:14 P.M. Sarah: Hard to resist")]), _vm._v(" "), _c('p', [_vm._v("4:15 P.M. Rick: Me or you?")]), _vm._v(" "), _c('p', [_vm._v("4:15 P.M. Sarah: Lol me")]), _vm._v(" "), _c('p', [_vm._v("4:15 P.M. Rick: I am hard lol")]), _vm._v(" "), _c('p', [_vm._v("4:16 P.M. Sarah: I knew that already xxx")]), _vm._v(" "), _c('p', [_vm._v("4:17 P.M. Rick: You temptress")]), _vm._v(" "), _c('p', [_vm._v("4:17 P.M. Sarah: You make me sound like a predator!")]), _vm._v(" "), _c('p', [_vm._v("4:18 P.M. Rick: You know you will devour me")]), _vm._v(" "), _c('p', [_vm._v("4:18 P.M. Sarah: A snake?")]), _vm._v(" "), _c('p', [_vm._v("4:19 P.M. Rick: Forked tongue")]), _vm._v(" "), _c('p', [_vm._v("4:19 P.M. Sarah: You can fork me any time babe. We are both obviously delirious – you with illness me with exhaustion x")]), _vm._v(" "), _c('p', [_vm._v("4:27 P.M. Rick: What a combo x")]), _vm._v(" "), _c('p', [_vm._v("4:31 P.M. Sarah: Are you getting better, or no change?")]), _vm._v(" "), _c('p', [_vm._v("5:00 P.M. Rick: The green slime seems to dry up during the day and surface in the evenings. My ribs hurt from coughing and wheezing. Other than that, all good x")]), _vm._v(" "), _c('p', [_vm._v("5:02 P.M. Sarah: Like I say. Sexy xxx")]), _vm._v(" "), _c('p', [_vm._v("8:52 P.M. Sarah: I’m failing at keeping awake! Goodnight sweetheart 💋")]), _vm._v(" "), _c('p', [_vm._v("10:11 P.M. Rick: Sweet dreams Sweet Cheeks 💋💋")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "saturday-23-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Saturday, 23 June 2018")]), _vm._v(" "), _c('p', [_vm._v("9:06 A.M. Sarah: Good morning babe – how are you today? xxx")]), _vm._v(" "), _c('p', [_vm._v("9:15 A.M. Rick: Good morning Sweet Cheeks. My lungs are on the floor by the bed 😮😮😮😮")]), _vm._v(" "), _c('p', [_vm._v("9:16 A.M. Sarah: Oh dear! Can you cancel your trip? That will really not help x")]), _vm._v(" "), _c('p', [_vm._v("9:19 A.M. Rick: Unfortunately, not. I will have to drug myself before the flight xxx")]), _vm._v(" "), _c('p', [_vm._v("9:20 A.M. Sarah: Ahhh a disaster then. Do you need a doctor? Antibiotics?")]), _vm._v(" "), _c('p', [_vm._v("9:21 A.M. Rick: No, just rest will do it. It’s the evil in me coming out x")]), _vm._v(" "), _c('p', [_vm._v("9:22 A.M. Sarah: So, no evil left by the time I see you? Is that good? xxx")]), _vm._v(" "), _c('p', [_vm._v("9:32 A.M. Rick: Evil is my good side lol x")]), _vm._v(" "), _c('p', [_vm._v("9:36 A.M. Sarah: I had a terrible sleep after all that. My brain wouldn’t turn off thinking about all the choices and uncertainty ahead. Quite overwhelming x")]), _vm._v(" "), _c('p', [_vm._v("10:11 A.M. Rick: Baby steps lover xxx")]), _vm._v(" "), _c('p', [_vm._v("10:12 A.M. Sarah: I’ve given myself a break from it while I was away but it comes home when I do. Since everything in my life, including my job, revolved around my ex, I will need to start some new work arrangement. The best decision I made was to not work for a while at least – it really does help sort the brain and body out. I’ve been surprised at how fucked up I have been – and am – in a work sense.")]), _vm._v(" "), _c('p', [_vm._v("10:24 A.M. Rick: It’s a fresh start for both brain and body. You have absolutely nothing to prove to anyone babe xxx")]), _vm._v(" "), _c('p', [_vm._v("10:24 A.M. Sarah: Thanks. You are good at this xxx")]), _vm._v(" "), _c('p', [_vm._v("10:54 A.M. Rick: I’m good at many things xxx")]), _vm._v(" "), _c('p', [_vm._v("10:54 A.M. Sarah: I noticed. I’m pretty good at a few things too x")]), _vm._v(" "), _c('p', [_vm._v("11:01 A.M. Rick: Oh, I noticed and felt x")]), _vm._v(" "), _c('p', [_vm._v("11:02 A.M. Sarah: Such a shame you’re sick x")]), _vm._v(" "), _c('p', [_vm._v("11:03 A.M. Rick: I won’t always be, so beware lol xxx")]), _vm._v(" "), _c('p', [_vm._v("11:04 A.M. Sarah: I know. I’m terrified. Not x")]), _vm._v(" "), _c('p', [_vm._v("1:22 P.M. Rick: Have you caught up with all your mates and lovers? xxx")]), _vm._v(" "), _c('p', [_vm._v("1:34 P.M. Sarah: You are terrible! Out for an hour x")]), _vm._v(" "), _c('p', [_vm._v("1:47 P.M. Rick: One hour!!! The bench mark is three hours 😮😮")]), _vm._v(" "), _c('p', [_vm._v("2:09 P.M. Sarah: Omg man. And no, I haven’t. I could do more than three hours if you can. Also, just to clarify the rules, does the timer start when clothes are removed?")]), _vm._v(" "), _c('p', [_vm._v("2:17 P.M. Rick: Would that be passive or active? Lol")]), _vm._v(" "), _c('p', [_vm._v("2:18 P.M. Sarah: Oh, so just lying around naked doesn’t count?")]), _vm._v(" "), _c('p', [_vm._v("2:19 P.M. Rick: Not really")]), _vm._v(" "), _c('p', [_vm._v("2:19 P.M. Sarah: Not that we did a lot of that")]), _vm._v(" "), _c('p', [_vm._v("2:20 P.M. Sarah: That was a long “date” x")]), _vm._v(" "), _c('p', [_vm._v("2:21 P.M. Rick: It was long and hard babe x")]), _vm._v(" "), _c('p', [_vm._v("2:21 P.M. Sarah: Oh, poor you")]), _vm._v(" "), _c('p', [_vm._v("2:22 P.M. Rick: And the date was also long")]), _vm._v(" "), _c('p', [_vm._v("2:23 P.M. Sarah: Haha yes to both x")]), _vm._v(" "), _c('p', [_vm._v("2:24 P.M. Sarah: Remind me to set a timer next time chicky – go for a record. You must be feeling better.")]), _vm._v(" "), _c('p', [_vm._v("2:27 P.M. Rick: The coughing stops until around four and then remembers itself and comes back with a passion xxx")]), _vm._v(" "), _c('p', [_vm._v("2:27 P.M. Sarah: Nice. You like passion x")]), _vm._v(" "), _c('p', [_vm._v("2:28 P.M. Rick: Heat and passion x")]), _vm._v(" "), _c('p', [_vm._v("2:28 P.M. Sarah: Ooo yes very nice x")]), _vm._v(" "), _c('p', [_vm._v("2:29 P.M. Sarah: I keep forgetting we’re in the same country. You won’t be looking forward to your flight tomorrow… Lucky person sitting next to you!")]), _vm._v(" "), _c('p', [_vm._v("2:33 P.M. Rick: Exactly. I have changed my seat so that the seat next to me is empty.")]), _vm._v(" "), _c('p', [_vm._v("2:34 P.M. Sarah: Good plan. My parents want me to escort them to Sydney in July for a few days, to see a show.")]), _vm._v(" "), _c('p', [_vm._v("2:41 P.M. Rick: Escort! Parent police x")]), _vm._v(" "), _c('p', [_vm._v("2:41 P.M. Sarah: I’d be a great escort! I may be a little over qualified.")]), _vm._v(" "), _c('p', [_vm._v("2:46 P.M. Rick: Handcuffs? mmm")]), _vm._v(" "), _c('p', [_vm._v("2:47 P.M. Sarah: I’d have other ways to control the detainee")]), _vm._v(" "), _c('p', [_vm._v("2:48 P.M. Rick: Elaborate and reveal")]), _vm._v(" "), _c('p', [_vm._v("2:48 P.M. Sarah: No. I can also be mean in more subtle ways.")]), _vm._v(" "), _c('p', [_vm._v("2:54 P.M. Rick: And I have ways and means of getting it out of you")]), _vm._v(" "), _c('p', [_vm._v("2:54 P.M. Sarah: Do you now! You do have powers of persuasion, already noticed that. I will have forgotten what you look like, or feel like, by the time I see you again. I’ll need a refresher x")]), _vm._v(" "), _c('p', [_vm._v("3:11 P.M. Rick: You feeling horny babe? x")]), _vm._v(" "), _c('p', [_vm._v("3:12 P.M. Sarah: Always, and I always need close body time, if that doesn’t sound terrible!")]), _vm._v(" "), _c('p', [_vm._v("3:14 P.M. Rick: It sounds superb")]), _vm._v(" "), _c('p', [_vm._v("3:15 P.M. Sarah: Lol no it doesn’t! But yes, I could use you xxx")]), _vm._v(" "), _c('p', [_vm._v("3:19 P.M. Rick: That’s a turn on babe xxx")]), _vm._v(" "), _c('p', [_vm._v("3:20 P.M. Sarah: Every man likes an enthusiastic woman x")]), _vm._v(" "), _c('p', [_vm._v("3:23 P.M. Rick: That you are. You enjoy being sexually aggressive.")]), _vm._v(" "), _c('p', [_vm._v("3:23 P.M. Sarah: I’d never say I was aggressive!")]), _vm._v(" "), _c('p', [_vm._v("3:23 P.M. Rick: You like to be, want to be")]), _vm._v(" "), _c('p', [_vm._v("3:24 P.M. Sarah: I no longer know myself! That’s part of this process – to work out what I need sexually. My evolution. You are so challenging – I don’t know the words to describe myself, but experience will fix that. Is it aggressive to like sex?")]), _vm._v(" "), _c('p', [_vm._v("3:35 P.M. Rick: Depends on the type of sex babe")]), _vm._v(" "), _c('p', [_vm._v("3:36 P.M. Sarah: There you go again …")]), _vm._v(" "), _c('p', [_vm._v("3:36 P.M. Rick: You enjoy the banter")]), _vm._v(" "), _c('p', [_vm._v("3:36 P.M. Sarah: I do. You’re an education.")]), _vm._v(" "), _c('p', [_vm._v("3:37 P.M. Rick: An enlightening x")]), _vm._v(" "), _c('p', [_vm._v("3:37 P.M. Sarah: Hope you are happy taking part x")]), _vm._v(" "), _c('p', [_vm._v("3:38 P.M. Rick: More than x")]), _vm._v(" "), _c('p', [_vm._v("3:40 P.M. Sarah: I’m ridiculously open with you")]), _vm._v(" "), _c('p', [_vm._v("3:42 P.M. Rick: Not to mention your legs mmm")]), _vm._v(" "), _c('p', [_vm._v("3:43 P.M. Sarah: Oh yes, they also open for you")]), _vm._v(" "), _c('p', [_vm._v("3:45 P.M. Rick: You enjoyed how I held them open by your ankles")]), _vm._v(" "), _c('p', [_vm._v("3:45 P.M. Sarah: I did")]), _vm._v(" "), _c('p', [_vm._v("3:45 P.M. Rick: On display for me")]), _vm._v(" "), _c('p', [_vm._v("3:46 P.M. Sarah: I enjoyed being positioned")]), _vm._v(" "), _c('p', [_vm._v("3:48 P.M. Rick: Did you notice how my cock just entered you as I held your legs wide?")]), _vm._v(" "), _c('p', [_vm._v("3:49 P.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("3:50 P.M. Rick: How your hips arched")]), _vm._v(" "), _c('p', [_vm._v("3:50 P.M. Sarah: Yes. Just what are you trying to do to me man!!! x")]), _vm._v(" "), _c('p', [_vm._v("3:52 P.M. Rick: Are they moving now babe? x")]), _vm._v(" "), _c('p', [_vm._v("3:52 P.M. Sarah: You know they are!")]), _vm._v(" "), _c('p', [_vm._v("3:54 P.M. Rick: 💋 your hand cupping your mound?")]), _vm._v(" "), _c('p', [_vm._v("3:54 P.M. Sarah: No! You are evil")]), _vm._v(" "), _c('p', [_vm._v("3:55 P.M. Rick: Do it babe. Move against your hand for me.")]), _vm._v(" "), _c('p', [_vm._v("3:59 P.M. Sarah: You are definitely improving the flexibility in my lower back")]), _vm._v(" "), _c('p', [_vm._v("4:00 P.M. Rick: Now tell me how you enjoy being liberated and ache for me to fill you x")]), _vm._v(" "), _c('p', [_vm._v("4:00 P.M. Sarah: I do ache for that x")]), _vm._v(" "), _c('p', [_vm._v("4:11 P.M. Rick: Just that? Not my fingers? Tongue?")]), _vm._v(" "), _c('p', [_vm._v("4:12 P.M. Sarah: Of course. The full package. Hope I get to collect all these kisses some time – they are really building up x")]), _vm._v(" "), _c('p', [_vm._v("4:21 P.M. Rick: Oh, you will babe. Have your other lovers been chasing you? x")]), _vm._v(" "), _c('p', [_vm._v("4:22 P.M. Sarah: I’m inundated with offers but not feeling like it")]), _vm._v(" "), _c('p', [_vm._v("4:22 P.M. Rick: How many do you have in the wings? You do know it’s of no consequence to me don’t you, lover? x")]), _vm._v(" "), _c('p', [_vm._v("4:25 P.M. Sarah: You know how I feel about this – I like to focus on one. I only use Tinder if I’m unhappy or need a major change. It doesn’t mean I’m not in demand, I’m just not keen. And yes, I do know that.")]), _vm._v(" "), _c('p', [_vm._v("4:25 P.M. Rick: That’s just part of my kink")]), _vm._v(" "), _c('p', [_vm._v("4:26 P.M. Sarah: What is? You want your lovers to be with other men?")]), _vm._v(" "), _c('p', [_vm._v("4:26 P.M. Rick: If that’s a need for them I have no problem with it. Some women need to have more than one lover.")]), _vm._v(" "), _c('p', [_vm._v("4:27 P.M. Sarah: And you have how many on the go at the moment?")]), _vm._v(" "), _c('p', [_vm._v("4:28 P.M. Rick: Each one provides different qualities")]), _vm._v(" "), _c('p', [_vm._v("4:28 P.M. Sarah: Answer")]), _vm._v(" "), _c('p', [_vm._v("4:28 P.M. Rick: Lol. I knew you would be all over that")]), _vm._v(" "), _c('p', [_vm._v("4:29 P.M. Sarah: I know I have no hold over you but it’s nice to know. So?")]), _vm._v(" "), _c('p', [_vm._v("4:30 P.M. Rick: When you say on the go, clarity is needed")]), _vm._v(" "), _c('p', [_vm._v("4:30 P.M. Sarah: How many people are you having sex with. A difficult question? Am I going to get an STI?")]), _vm._v(" "), _c('p', [_vm._v("4:34 P.M. Rick: Not at all babe. Am I? 😮")]), _vm._v(" "), _c('p', [_vm._v("4:34 P.M. Sarah: Definitely not")]), _vm._v(" "), _c('p', [_vm._v("4:45 P.M. Rick: I am not having sex at the moment")]), _vm._v(" "), _c('p', [_vm._v("4:46 P.M. Sarah: You did say that right at the start but I wondered if the status had changed. I hope you can see how the multiple partner issue is difficult for me? I do try to have an open mind on it, believe it or not xxx")]), _vm._v(" "), _c('p', [_vm._v("5:03 P.M. Rick: Multiple partners for you? xxx")]), _vm._v(" "), _c('p', [_vm._v("5:04 P.M. Sarah: Both. It’s complicated – something I’m training myself to do is NOT get too close and then attached to a man. The only way to stop that is to confuse my brain with another man, but I hate myself for doing it. So basically, I’m still learning to be single x")]), _vm._v(" "), _c('p', [_vm._v("6:02 P.M. Sarah: Also, sweet pea I really do enjoy everything about this conversation – looking forward to having it in person. I’m so tired – I’ll be off to sleep early tonight xxx")]), _vm._v(" "), _c('p', [_vm._v("10:58 P.M. Rick: I could make you cum for me and that will send you to sleep")]), _vm._v(" "), _c('p', [_vm._v("10:59 P.M. Sarah: You are as reliable as a geyser. Love it ❤")]), _vm._v(" "), _c('p', [_vm._v("11:01 P.M. Rick: Can you do that babe? x")]), _vm._v(" "), _c('p', [_vm._v("11:01 P.M. Sarah: Yes, I can. I resorted to that when I was still awake at 3 A.M. Desperate times…")]), _vm._v(" "), _c('p', [_vm._v("11:03 P.M. Rick: Oh, you naughty girl and you didn’t tell me! x")]), _vm._v(" "), _c('p', [_vm._v("11:04 P.M. Sarah: Funny man you were asleep! A means to an end xxx")]), _vm._v(" "), _c('p', [_vm._v("11:05 P.M. Rick: Fingers?")]), _vm._v(" "), _c('p', [_vm._v("11:05 P.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("11:06 P.M. Rick: Let’s look for an object to use. You can tell me what you find")]), _vm._v(" "), _c('p', [_vm._v("11:08 P.M. Sarah: I’m too tired tonight but another day, ok? x")]), _vm._v(" "), _c('p', [_vm._v("11:09 P.M. Rick: Ok babe")]), _vm._v(" "), _c('p', [_vm._v("11:09 P.M. Sarah: Why are you still awake? Coughing?")]), _vm._v(" "), _c('p', [_vm._v("11:10 P.M. Rick: Coughing, and I had a nap this afternoon")]), _vm._v(" "), _c('p', [_vm._v("11:10 P.M. Sarah: Oh, that’s good. Would have come over for a cuddle if I’d known. I had a nap too.")]), _vm._v(" "), _c('p', [_vm._v("11:11 P.M. Rick: We wouldn’t have slept babe x")]), _vm._v(" "), _c('p', [_vm._v("11:13 P.M. Sarah: Some body time is always good x")]), _vm._v(" "), _c('p', [_vm._v("11:14 P.M. Rick: Would you have stopped me sliding my hand in your knickers? x")]), _vm._v(" "), _c('p', [_vm._v("11:15 P.M. Sarah: I doubt I would have been wearing any if I was in bed so that would be a no babe. Who am I kidding – I would have been all over you xxx")]), _vm._v(" "), _c('p', [_vm._v("11:16 P.M. Rick: Are you going to use one of your lovers next week?")]), _vm._v(" "), _c('p', [_vm._v("11:17 P.M. Sarah: If I want to yes, I’m not sure")]), _vm._v(" "), _c('p', [_vm._v("11:17 P.M. Rick: Do it babe.")]), _vm._v(" "), _c('p', [_vm._v("11:18 P.M. Sarah: You are a tonic for me. Giving me permission even if I don’t want it x")]), _vm._v(" "), _c('p', [_vm._v("11:20 P.M. Rick: You know me quite well already!")]), _vm._v(" "), _c('p', [_vm._v("11:20 P.M. Sarah: I think I do x")]), _vm._v(" "), _c('p', [_vm._v("11:20 P.M. Rick: Then you know I give you permission x")]), _vm._v(" "), _c('p', [_vm._v("11:21 P.M. Sarah: I do know that Cutie Pie xxx")]), _vm._v(" "), _c('p', [_vm._v("11:21 P.M. Rick: Does that turn you on babe? x")]), _vm._v(" "), _c('p', [_vm._v("11:21 P.M. Sarah: I assimilate everything you say like a puzzle. I appreciate it, but am also confused by it x")]), _vm._v(" "), _c('p', [_vm._v("11:23 P.M. Rick: Trust me, I will be turned on if you meet your other lovers. Are your legs open now babe? x")]), _vm._v(" "), _c('p', [_vm._v("11:23 P.M. Sarah: Yes. I like it that way whatever is going on between them.")]), _vm._v(" "), _c('p', [_vm._v("11:23 P.M. Rick: Wide or knees bent?")]), _vm._v(" "), _c('p', [_vm._v("11:23 P.M. Sarah: Bent")]), _vm._v(" "), _c('p', [_vm._v("11:24 P.M. Rick: Put your ankles together and open your knees")]), _vm._v(" "), _c('p', [_vm._v("11:24 P.M. Sarah: I am. That’s how I like it. Feet together.")]), _vm._v(" "), _c('p', [_vm._v("11:25 P.M. Rick: Good girl. Moving your hips?")]), _vm._v(" "), _c('p', [_vm._v("11:26 P.M. Sarah: Of course, xxx")]), _vm._v(" "), _c('p', [_vm._v("11:26 P.M. Rick: Eventually I will watch you pleasure another man for me x")]), _vm._v(" "), _c('p', [_vm._v("11:27 P.M. Sarah: That will be a long time coming babe. Let me focus on you xxx")]), _vm._v(" "), _c('p', [_vm._v("11:28 P.M. Rick: So which lover are you going to pick?")]), _vm._v(" "), _c('p', [_vm._v("11:29 P.M. Sarah: Another time you can tell me how you came to be like this. And you’ll be the first to know if I do decide to see one of the others, and if I do it will probably be the loving one. I could do with that sort of attention. We’ve had an interesting chat just lately – our roles have completely reversed. When we first met, I was anxious and somewhat needy, he was unavailable. Now he’s needy and I have options. It’s sort of funny.")]), _vm._v(" "), _c('p', [_vm._v("11:32 P.M. Rick: You will tell me babe?")]), _vm._v(" "), _c('p', [_vm._v("11:32 P.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("11:33 P.M. Rick: In detail?")]), _vm._v(" "), _c('p', [_vm._v("11:33 P.M. Sarah: I’ll see. That’s a new one for me, but willing to give it a go. And you won’t be disappointed if I don’t do it?")]), _vm._v(" "), _c('p', [_vm._v("11:33 P.M. Rick: Of course not. Will he be eager to have you babe? x")]), _vm._v(" "), _c('p', [_vm._v("11:34 P.M. Sarah: Of course! It doesn’t mean I’m eager x")]), _vm._v(" "), _c('p', [_vm._v("11:35 P.M. Rick: Did you meet him since you have been back?")]), _vm._v(" "), _c('p', [_vm._v("11:35 P.M. Sarah: No. I’m reluctant because he loves me and I don’t want to lead him on.")]), _vm._v(" "), _c('p', [_vm._v("11:36 P.M. Rick: Are you rubbing your clit babe?")]), _vm._v(" "), _c('p', [_vm._v("11:36 P.M. Sarah: No, I’m typing!")]), _vm._v(" "), _c('p', [_vm._v("11:37 P.M. Rick: Can’t you multi task?")]), _vm._v(" "), _c('p', [_vm._v("11:37 P.M. Sarah: Lol no – my phone screen will get messy, silly")]), _vm._v(" "), _c('p', [_vm._v("11:39 P.M. Rick: Is he the one that is the better of the two?")]), _vm._v(" "), _c('p', [_vm._v("11:39 P.M. Sarah: He’s keen to please me and enjoys everything about me so it’s more satisfying. The other one can make me feel inadequate – I’m sure it’s just in my head but that’s where I’m at!")]), _vm._v(" "), _c('p', [_vm._v("11:43 P.M. Rick: Did the loving one have anal with you?")]), _vm._v(" "), _c('p', [_vm._v("11:43 P.M. Sarah: No")]), _vm._v(" "), _c('p', [_vm._v("11:43 P.M. Rick: The other one?")]), _vm._v(" "), _c('p', [_vm._v("11:43 P.M. Sarah: No! Inquisitive man")]), _vm._v(" "), _c('p', [_vm._v("11:45 P.M. Rick: Kinky man. Does that turn you on babe? x")]), _vm._v(" "), _c('p', [_vm._v("11:45 P.M. Sarah: You’re so strange to innocent little me, but I’m intrigued xxx")]), _vm._v(" "), _c('p', [_vm._v("11:46 P.M. Rick: It will be a turn on to know you are being fucked in your bed for me xxx")]), _vm._v(" "), _c('p', [_vm._v("11:47 P.M. Sarah: Why would I fuck for you? What if it’s for me?")]), _vm._v(" "), _c('p', [_vm._v("11:47 P.M. Rick: That’s the kinky Rick side x")]), _vm._v(" "), _c('p', [_vm._v("11:48 P.M. Sarah: Is he always there?")]), _vm._v(" "), _c('p', [_vm._v("11:49 P.M. Rick: You know he is babe")]), _vm._v(" "), _c('p', [_vm._v("11:49 P.M. Sarah: But you hide it occasionally")]), _vm._v(" "), _c('p', [_vm._v("11:49 P.M. Rick: Not a lot of people know x")]), _vm._v(" "), _c('p', [_vm._v("11:50 P.M. Sarah: Ah I see. Honoured to be in the inner circle. Now let me go – talk tomorrow xxx")]), _vm._v(" "), _c('p', [_vm._v("11:51 P.M. Rick: Yes babe. Sweet dreams xxx")]), _vm._v(" "), _c('p', [_vm._v("11:51 P.M. Sarah: Goodnight sweetheart xxx")]), _vm._v(" "), _c('p', [_vm._v("11:51 P.M. Rick: Sleep well xxx")]), _vm._v(" "), _c('p', [_vm._v("11:52 P.M. Rick: One last question before I let you go. Do you let him cum in you? xxx")]), _vm._v(" "), _c('p', [_vm._v("11:53 P.M. Sarah: Yes, I do. Is that good or bad, in the book of Rick?")]), _vm._v(" "), _c('p', [_vm._v("11:54 P.M. Rick: How do you feel about it babe?")]), _vm._v(" "), _c('p', [_vm._v("11:55 P.M. Sarah: Fine, but that’s part of the not liking to mix it up. I feel disloyal.")]), _vm._v(" "), _c('p', [_vm._v("11:55 P.M. Rick: Don’t. You have needs.")]), _vm._v(" "), _c('p', [_vm._v("11:56 P.M. Sarah: Ok, thanks babe. Goodnight now xxx")]), _vm._v(" "), _c('p', [_vm._v("11:56 P.M. Rick: Is he a big cummer?")]), _vm._v(" "), _c('p', [_vm._v("11:56 P.M. Sarah: Stop! Not as big as you. You made a huge mess.")]), _vm._v(" "), _c('p', [_vm._v("11:57 P.M. Rick: Is that a problem babe?")]), _vm._v(" "), _c('p', [_vm._v("11:57 P.M. Sarah: Not at all. I like it.")]), _vm._v(" "), _c('p', [_vm._v("11:58 P.M. Rick: Have you let him cum in your mouth?")]), _vm._v(" "), _c('p', [_vm._v("11:58 P.M. Sarah: No. I’ve never done that with anyone. Dream of me xxx")]), _vm._v(" "), _c('p', [_vm._v("11:59 P.M. Rick: Mmm. A challenge.")]), _vm._v(" "), _c('p', [_vm._v("11:59 P.M. Sarah: There’s plenty of those with this girl. Go away xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "sunday-24-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Sunday, 24 June 2018")]), _vm._v(" "), _c('p', [_vm._v("7:17 A.M. Sarah: Good morning babe – how did your night go? Better? I had a solid seven hours sleep – that’s fantastic for me xxx")]), _vm._v(" "), _c('p', [_vm._v("12:14 P.M. Rick: Good morning darling. Obviously, your body needed to catch up. My night was restless but that’s to be expected xxx")]), _vm._v(" "), _c('p', [_vm._v("12:26 P.M. Sarah: I finally feel normal today xxx")]), _vm._v(" "), _c('p', [_vm._v("12:29 P.M. Rick: The question is what is normal lol 😮😮😮")]), _vm._v(" "), _c('p', [_vm._v("12:34 P.M. Sarah: Tell me about it – I’ve fought normality, despite an apparently normal life, so watch this space. I doubt my brain will ever conform, and I doubt you ever have! 😮")]), _vm._v(" "), _c('p', [_vm._v("12:49 P.M. Rick: Conform to whose standards? I do try to perform lol xxx")]), _vm._v(" "), _c('p', [_vm._v("12:53 P.M. Sarah: You perform to a high standard babe, but you’ve spent years on your skills. My advantage is I’m fresh x")]), _vm._v(" "), _c('p', [_vm._v("1:00 P.M. Rick: Virginal and pliant xxx")]), _vm._v(" "), _c('p', [_vm._v("1:00 P.M. Sarah: Is that what you think? I do too. Finally, out of prison after a long sentence. Murder.")]), _vm._v(" "), _c('p', [_vm._v("1:03 P.M. Rick: Murder of your free spirit")]), _vm._v(" "), _c('p', [_vm._v("1:04 P.M. Sarah: So true. I can’t even explain to myself how I let that happen. Hope free spirits grow back.")]), _vm._v(" "), _c('p', [_vm._v("1:05 P.M. Rick: They need to be nurtured")]), _vm._v(" "), _c('p', [_vm._v("1:05 P.M. Sarah: It’s sprouting")]), _vm._v(" "), _c('p', [_vm._v("1:07 P.M. Rick: Embrace it lover")]), _vm._v(" "), _c('p', [_vm._v("1:07 P.M. Sarah: You know I am")]), _vm._v(" "), _c('p', [_vm._v("1:09 P.M. Rick: Yes, I do... 💋💋")]), _vm._v(" "), _c('p', [_vm._v("1:10 P.M. Sarah: Lol thanks 💋")]), _vm._v(" "), _c('p', [_vm._v("1:38 P.M. Sarah: You know you terrify me, slightly don’t you?")]), _vm._v(" "), _c('p', [_vm._v("1:38 P.M. Rick: That’s the attraction xxx")]), _vm._v(" "), _c('p', [_vm._v("1:39 P.M. Sarah: I also like you – kind, intuitive, funny")]), _vm._v(" "), _c('p', [_vm._v("1:41 P.M. Rick: Who!!! Me!!!")]), _vm._v(" "), _c('p', [_vm._v("1:42 P.M. Sarah: I know. You’re thinking I must have had some terrible experiences if I think you’re kind, but you have been x")]), _vm._v(" "), _c('p', [_vm._v("1:44 P.M. Rick: Kind of cute 💋")]), _vm._v(" "), _c('p', [_vm._v("1:45 P.M. Sarah: Who?")]), _vm._v(" "), _c('p', [_vm._v("1:47 P.M. Rick: Me lol")]), _vm._v(" "), _c('p', [_vm._v("1:47 P.M. Rick: You, lover")]), _vm._v(" "), _c('p', [_vm._v("1:48 P.M. Sarah: Then what do you mean “kind of”?")]), _vm._v(" "), _c('p', [_vm._v("1:48 P.M. Rick: Cute and fuckable, Sweet Cheeks x")]), _vm._v(" "), _c('p', [_vm._v("1:49 P.M. Sarah: Haha you are a bad man x")]), _vm._v(" "), _c('p', [_vm._v("1:54 P.M. Rick: To the bone x")]), _vm._v(" "), _c('p', [_vm._v("1:56 P.M. Sarah: Which bone was that?")]), _vm._v(" "), _c('p', [_vm._v("1:57 P.M. Rick: Now who is being bad!!! So prim and proper, then I came along x")]), _vm._v(" "), _c('p', [_vm._v("2:05 P.M. Sarah: You did x")]), _vm._v(" "), _c('p', [_vm._v("2:20 P.M. Rick: Regrets?")]), _vm._v(" "), _c('p', [_vm._v("2:21 P.M. Sarah: None x")]), _vm._v(" "), _c('p', [_vm._v("2:21 P.M. Rick: Excellent x")]), _vm._v(" "), _c('p', [_vm._v("2:31 P.M. Rick: Did the conversation last night excite you? Repulse you? Make you question yourself? Challenge you?")]), _vm._v(" "), _c('p', [_vm._v("3:05 P.M. Sarah: I’d say challenge. Not repulsed.")]), _vm._v(" "), _c('p', [_vm._v("3:06 P.M. Rick: Did you give the idea of having your other lover any further consideration?")]), _vm._v(" "), _c('p', [_vm._v("3:08 P.M. Sarah: I’m having a very tricky conversation with him – I think he can’t deal with me having another guy, even though he’s not in a position to incorporate me into his life.")]), _vm._v(" "), _c('p', [_vm._v("3:08 P.M. Rick: Have you told him?")]), _vm._v(" "), _c('p', [_vm._v("3:09 P.M. Sarah: I’ve told him I’m seeing others")]), _vm._v(" "), _c('p', [_vm._v("3:10 P.M. Rick: And that you will also have sex with him?")]), _vm._v(" "), _c('p', [_vm._v("3:10 P.M. Sarah: I don’t want to have secrets like that especially when strong emotions are involved")]), _vm._v(" "), _c('p', [_vm._v("3:11 P.M. Rick: Was it him that wants to have the 3sum?")]), _vm._v(" "), _c('p', [_vm._v("3:11 P.M. Sarah: That was the challenging one")]), _vm._v(" "), _c('p', [_vm._v("3:12 P.M. Rick: Pity lol")]), _vm._v(" "), _c('p', [_vm._v("3:14 P.M. Sarah: Way too soon for me babe x")]), _vm._v(" "), _c('p', [_vm._v("3:16 P.M. Rick: You know my philosophy, never say never x")]), _vm._v(" "), _c('p', [_vm._v("3:17 P.M. Sarah: I know that, and I agree but I’ve said before if I go too fast it will set me back. Like a virgin.")]), _vm._v(" "), _c('p', [_vm._v("3:18 P.M. Rick: You know he is the safer option. He doesn’t want to share?")]), _vm._v(" "), _c('p', [_vm._v("3:19 P.M. Sarah: Oh, much safer, but I don’t really want safe. And no, he doesn’t want to share at all so he’s turning a blind eye.")]), _vm._v(" "), _c('p', [_vm._v("3:20 P.M. Rick: Then you need to invite him over and seduce him")]), _vm._v(" "), _c('p', [_vm._v("3:20 P.M. Sarah: I feel I’m fucking with his brain.")]), _vm._v(" "), _c('p', [_vm._v("3:21 P.M. Rick: You do have an alternative, lover – find another xxx")]), _vm._v(" "), _c('p', [_vm._v("3:24 P.M. Sarah: I guess it is an option")]), _vm._v(" "), _c('p', [_vm._v("3:24 P.M. Rick: Yes babe")]), _vm._v(" "), _c('p', [_vm._v("3:27 P.M. Sarah: I just had a call from my teacher friend who relieved me of my extra virginity")]), _vm._v(" "), _c('p', [_vm._v("3:28 P.M. Rick: Does he want you again?")]), _vm._v(" "), _c('p', [_vm._v("3:29 P.M. Sarah: No, but he has similarities to you – challenged me sexually and now challenges me in other ways. Provocative but in a teaching way.")]), _vm._v(" "), _c('p', [_vm._v("3:29 P.M. Rick: Tell him you need him sexually")]), _vm._v(" "), _c('p', [_vm._v("3:30 P.M. Sarah: No! I can’t go back there.")]), _vm._v(" "), _c('p', [_vm._v("3:30 P.M. Rick: You loved how he had you")]), _vm._v(" "), _c('p', [_vm._v("3:30 P.M. Sarah: I did, and I loved that he showed me some of what I’d been missing. I don’t want to reopen the sex thing with the teacher – if I need another man, I’d have no trouble finding one.")]), _vm._v(" "), _c('p', [_vm._v("3:30 P.M. Rick: Oh, I know this x")]), _vm._v(" "), _c('p', [_vm._v("3:31 P.M. Sarah: But absolutely no on that man. He was fun and stimulating, but I know now I was a challenge to him – he wanted to be my first, to take my extra virginity. Maybe I was just a challenge and nothing more.")]), _vm._v(" "), _c('p', [_vm._v("3:32 P.M. Rick: I doubt that babe. You gave yourself willingly?")]), _vm._v(" "), _c('p', [_vm._v("3:32 P.M. Sarah: Completely, yes, but there was so much I didn’t understand back then – not even a year ago – that I would view very differently now with the wisdom of my recent experiences. I made the mistake of thinking we had more than just the removal of the extra virginity.")]), _vm._v(" "), _c('p', [_vm._v("3:32 P.M. Rick: More than sex?")]), _vm._v(" "), _c('p', [_vm._v("3:32 P.M. Sarah: Yes. We have everything except sex now.")]), _vm._v(" "), _c('p', [_vm._v("3:33 P.M. Rick: That’s because you have not made yourself available")]), _vm._v(" "), _c('p', [_vm._v("3:34 P.M. Sarah: I treat him like he’s my brother and we don’t fuck our brothers do we!")]), _vm._v(" "), _c('p', [_vm._v("3:34 P.M. Rick: Well I don’t have any brothers lol")]), _vm._v(" "), _c('p', [_vm._v("3:35 P.M. Sarah: We have an agreement, simply that we are better as friends because we can do that forever")]), _vm._v(" "), _c('p', [_vm._v("3:36 P.M. Rick: Was the sex good?")]), _vm._v(" "), _c('p', [_vm._v("3:36 P.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("3:36 P.M. Rick: In your bed?")]), _vm._v(" "), _c('p', [_vm._v("3:36 P.M. Sarah: No. In his.")]), _vm._v(" "), _c('p', [_vm._v("3:37 P.M. Rick: How often?")]), _vm._v(" "), _c('p', [_vm._v("3:37 P.M. Sarah: It went on for six weeks, I guess. All broad daylight – it was pretty funny, and fun.")]), _vm._v(" "), _c('p', [_vm._v("3:40 P.M. Rick: Do you enjoy sex in the daytime?")]), _vm._v(" "), _c('p', [_vm._v("3:40 P.M. Sarah: It feels naughty, so who wouldn’t?")]), _vm._v(" "), _c('p', [_vm._v("3:40 P.M. Rick: Was it him that wanted the 3sum?")]), _vm._v(" "), _c('p', [_vm._v("3:40 P.M. Sarah: Definitely not")]), _vm._v(" "), _c('p', [_vm._v("3:41 P.M. Rick: Lol. Must have been the other one!")]), _vm._v(" "), _c('p', [_vm._v("3:41 P.M. Sarah: Yes, I told you – it was the challenging one")]), _vm._v(" "), _c('p', [_vm._v("3:42 P.M. Rick: Did he also have your arse?")]), _vm._v(" "), _c('p', [_vm._v("3:43 P.M. Sarah: No!")]), _vm._v(" "), _c('p', [_vm._v("3:43 P.M. Sarah: Confused?")]), _vm._v(" "), _c('p', [_vm._v("3:54 P.M. Rick: Lol yes, completely confused!")]), _vm._v(" "), _c('p', [_vm._v("3:55 P.M. Rick: It’s good I’m not flying till tomorrow now – my chest got tight again")]), _vm._v(" "), _c('p', [_vm._v("3:55 P.M. Sarah: How are the discharges? You do know you don’t have to be sexy all the time? Normally the thought of me nursing anyone is enough to make them well x")]), _vm._v(" "), _c('p', [_vm._v("4:46 P.M. Rick: I remember my mother having us do Vicks inhalations xxx")]), _vm._v(" "), _c('p', [_vm._v("4:47 P.M. Sarah: Try it – an oldie but a goodie")]), _vm._v(" "), _c('p', [_vm._v("4:47 P.M. Rick: Like me!")]), _vm._v(" "), _c('p', [_vm._v("4:47 P.M. Sarah: I’d say and me but I’m not old yet")]), _vm._v(" "), _c('p', [_vm._v("4:48 P.M. Rick: Old as you feel and I felt most of you x")]), _vm._v(" "), _c('p', [_vm._v("4:48 P.M. Sarah: And how old am I then?")]), _vm._v(" "), _c('p', [_vm._v("4:49 P.M. Rick: 56")]), _vm._v(" "), _c('p', [_vm._v("4:50 P.M. Sarah: Fuck you. And yes, please x")]), _vm._v(" "), _c('p', [_vm._v("4:54 P.M. Rick: Well how old are you? And bend over xxx")]), _vm._v(" "), _c('p', [_vm._v("4:55 P.M. Sarah: I am 56, but you’re meant to be slightly complimentary! And no xxx")]), _vm._v(" "), _c('p', [_vm._v("4:57 P.M. Rick: You know resistance is futile xxx")]), _vm._v(" "), _c('p', [_vm._v("4:59 P.M. Sarah: You can check my age any time – I like a good feel xxx")]), _vm._v(" "), _c('p', [_vm._v("8:10 P.M. Rick: External and internal xxx")]), _vm._v(" "), _c('p', [_vm._v("10:41 P.M. Sarah: Yum xxx")]), _vm._v(" "), _c('p', [_vm._v("10:50 P.M. Rick: I thought you would like that x")]), _vm._v(" "), _c('p', [_vm._v("10:51 P.M. Sarah: Well I would when you can squeeze me in x")]), _vm._v(" "), _c('p', [_vm._v("10:52 P.M. Rick: I would love to squeeze in you x")]), _vm._v(" "), _c('p', [_vm._v("10:53 P.M. Sarah: I have great pelvic floor muscles for squeezing x")]), _vm._v(" "), _c('p', [_vm._v("10:55 P.M. Rick: I know you do naughty girl")]), _vm._v(" "), _c('p', [_vm._v("10:55 P.M. Sarah: I’m glad you noticed")]), _vm._v(" "), _c('p', [_vm._v("11:03 P.M. Rick: So, did your other lover find peace with the situation?")]), _vm._v(" "), _c('p', [_vm._v("11:05 P.M. Sarah: Not really, or at least not yet")]), _vm._v(" "), _c('p', [_vm._v("11:05 P.M. Rick: How long have you known him?")]), _vm._v(" "), _c('p', [_vm._v("11:06 P.M. Sarah: Since January")]), _vm._v(" "), _c('p', [_vm._v("11:06 P.M. Rick: Ok. So, it’s a while. He has been a regular in your bed?")]), _vm._v(" "), _c('p', [_vm._v("11:06 P.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("11:07 P.M. Rick: Did he know about the other one?")]), _vm._v(" "), _c('p', [_vm._v("11:08 P.M. Sarah: That’s complicated")]), _vm._v(" "), _c('p', [_vm._v("11:09 P.M. Rick: In what way?")]), _vm._v(" "), _c('p', [_vm._v("11:09 P.M. Sarah: I met both of them in January but wasn’t going between them. I met the loving one first, and decided after a couple of meetings not to carry on with him because of his complicated life and consequent unavailability. I then met the other one and saw him for a few weeks, got irritated receiving advice all the time, so that petered out; and then the loving one got back in touch … so not both at once.")]), _vm._v(" "), _c('p', [_vm._v("11:12 P.M. Rick: Alternating them. Did you fuck both of them in the same week?")]), _vm._v(" "), _c('p', [_vm._v("11:12 P.M. Sarah: That did happen, once. Right at the beginning")]), _vm._v(" "), _c('p', [_vm._v("11:13 P.M. Rick: And did you feel wanton?")]), _vm._v(" "), _c('p', [_vm._v("11:13 P.M. Sarah: Yes!")]), _vm._v(" "), _c('p', [_vm._v("11:13 P.M. Rick: The same day?")]), _vm._v(" "), _c('p', [_vm._v("11:13 P.M. Sarah: No!!! What do you take me for man!")]), _vm._v(" "), _c('p', [_vm._v("11:14 P.M. Rick: There is nothing wrong if you did – we’re not in the dark ages")]), _vm._v(" "), _c('p', [_vm._v("11:15 P.M. Sarah: Putting aside the moral issue, I’m not sure I could physically do an extended session twice in one day. Having said that you are far and away the longest I’ve had.")]), _vm._v(" "), _c('p', [_vm._v("11:16 P.M. Rick: Did you tell your other lover you had a three-hour session?")]), _vm._v(" "), _c('p', [_vm._v("11:16 P.M. Sarah: Good god no")]), _vm._v(" "), _c('p', [_vm._v("11:17 P.M. Rick: He doesn’t have stamina?")]), _vm._v(" "), _c('p', [_vm._v("11:17 P.M. Sarah: I wouldn’t say that at all. He doesn’t have time.")]), _vm._v(" "), _c('p', [_vm._v("11:18 P.M. Rick: Why not? Are you sure he’s not married?")]), _vm._v(" "), _c('p', [_vm._v("11:18 P.M. Sarah: He has commitments at home – kids he cares for, and no not married")]), _vm._v(" "), _c('p', [_vm._v("11:19 P.M. Rick: Ok, but you do enjoy his cock")]), _vm._v(" "), _c('p', [_vm._v("11:20 P.M. Sarah: Obviously")]), _vm._v(" "), _c('p', [_vm._v("11:21 P.M. Rick: You wanton hussy. I like that x")]), _vm._v(" "), _c('p', [_vm._v("11:21 P.M. Sarah: Thanks. You’re weird x")]), _vm._v(" "), _c('p', [_vm._v("11:21 P.M. Rick: Did you tell him I have no problem sharing you?")]), _vm._v(" "), _c('p', [_vm._v("11:22 P.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("11:22 P.M. Rick: What did he say to that?")]), _vm._v(" "), _c('p', [_vm._v("11:24 P.M. Sarah: I only told him in the interests of openness, but I can see he’s just going to be messed up by it. When you feel very strongly about a person most people don’t want to share x")]), _vm._v(" "), _c('p', [_vm._v("11:27 P.M. Rick: Do you have a problem with it babe? xxx")]), _vm._v(" "), _c('p', [_vm._v("11:27 P.M. Sarah: No of course not. Each to their own. Back to the motto – open mind, open heart, and now open legs xxx")]), _vm._v(" "), _c('p', [_vm._v("11:28 P.M. Rick: Mmm. I like your outlook. It’s not like I am sending you to him full of cum x")]), _vm._v(" "), _c('p', [_vm._v("11:29 P.M. Sarah: No and in fact this chat with you is clarifying how I feel about it – it’s made me less inclined to continue with him for much longer.")]), _vm._v(" "), _c('p', [_vm._v("11:29 P.M. Rick: His closed mind?")]), _vm._v(" "), _c('p', [_vm._v("11:30 P.M. Sarah: That is frustrating, but more his general unavailability. We haven’t had a single sleepover in the six months we’ve known each other!")]), _vm._v(" "), _c('p', [_vm._v("11:30 P.M. Rick: You want cock on demand!")]), _vm._v(" "), _c('p', [_vm._v("11:30 P.M. Sarah: It does sound like that, but I think I just need to be higher on the priority list.")]), _vm._v(" "), _c('p', [_vm._v("11:31 P.M. Rick: You are aching aren’t you babe?")]), _vm._v(" "), _c('p', [_vm._v("11:31 P.M. Sarah: Yes, and I want everything! I’m very friendly, affectionate, house trained, almost virginal …")]), _vm._v(" "), _c('p', [_vm._v("11:31 P.M. Rick: You couldn’t handle everything")]), _vm._v(" "), _c('p', [_vm._v("11:32 P.M. Sarah: Ok then not everything lol")]), _vm._v(" "), _c('p', [_vm._v("11:32 P.M. Rick: Lol. Thought that would change your mind!")]), _vm._v(" "), _c('p', [_vm._v("11:33 P.M. Sarah: Good call. I am not only interested in sex either. I like man company – you may have observed?")]), _vm._v(" "), _c('p', [_vm._v("11:35 P.M. Rick: Oh, I have, and if it turns physical that’s also ok. Welcome to the real world. Give and take.")]), _vm._v(" "), _c('p', [_vm._v("11:36 P.M. Sarah: Yes, I see that")]), _vm._v(" "), _c('p', [_vm._v("11:37 P.M. Rick: Have you heard from the other lover?")]), _vm._v(" "), _c('p', [_vm._v("11:37 P.M. Sarah: The advisor? No but I’m sure I will. He loves sex with me. We made peace and catch up occasionally.")]), _vm._v(" "), _c('p', [_vm._v("11:38 P.M. Rick: Call him and tell him you need his type of attention")]), _vm._v(" "), _c('p', [_vm._v("11:38 P.M. Sarah: So much power...but I find him such challenging company! And I want you to have me.")]), _vm._v(" "), _c('p', [_vm._v("11:40 P.M. Rick: You know you can handle it. It’s a turn on for you. And you know I will have you x")]), _vm._v(" "), _c('p', [_vm._v("11:40 P.M. Sarah: Very flattering I’m sure!")]), _vm._v(" "), _c('p', [_vm._v("11:40 P.M. Rick: I will have you any way I want babe")]), _vm._v(" "), _c('p', [_vm._v("11:41 P.M. Sarah: A tiger by the tail")]), _vm._v(" "), _c('p', [_vm._v("11:42 P.M. Rick: I do like your tail")]), _vm._v(" "), _c('p', [_vm._v("11:42 P.M. Rick: Is the challenging one demanding sexually? Treats you like a sex toy?")]), _vm._v(" "), _c('p', [_vm._v("11:44 P.M. Sarah: He can be, but I do like spending time with him – we go out, get a bit drunk – he’s fun")]), _vm._v(" "), _c('p', [_vm._v("11:45 P.M. Rick: Are you surprised with yourself that you keep opening your legs for him? x")]), _vm._v(" "), _c('p', [_vm._v("11:49 P.M. Sarah: Not really, he’s also a bit naughty – I like that")]), _vm._v(" "), _c('p', [_vm._v("11:49 P.M. Rick: You have needs")]), _vm._v(" "), _c('p', [_vm._v("11:50 P.M. Sarah: Absolutely, and it goes both ways")]), _vm._v(" "), _c('p', [_vm._v("11:50 P.M. Rick: Just maybe you enjoy the way he treats you")]), _vm._v(" "), _c('p', [_vm._v("11:50 P.M. Sarah: Don’t even suggest it, but there is some aspect of it that is familiar to me")]), _vm._v(" "), _c('p', [_vm._v("11:51 P.M. Rick: That is the attraction, but what about during sex?")]), _vm._v(" "), _c('p', [_vm._v("11:52 P.M. Sarah: I initially felt he was pushy, but I do wonder if it was just too soon for me to be actually open minded. I suspect he just wants it to be good for both of us, and that’s probably why I keep seeing him, to find out.")]), _vm._v(" "), _c('p', [_vm._v("11:53 P.M. Rick: I push you don’t I babe, with my probing questions? x")]), _vm._v(" "), _c('p', [_vm._v("11:54 P.M. Sarah: Yes of course")]), _vm._v(" "), _c('p', [_vm._v("11:54 P.M. Rick: You can tell me to stop")]), _vm._v(" "), _c('p', [_vm._v("11:55 P.M. Sarah: I don’t want you to stop. Part of the problem is I think I’m already reasonably compliant, so don’t think I need to be criticised. Correct?")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "monday-25-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Monday, 25 June 2018")]), _vm._v(" "), _c('p', [_vm._v("12:00 A.M. Rick: So very true. Why change a good formula?")]), _vm._v(" "), _c('p', [_vm._v("12:01 A.M. Sarah: I see it’s now Monday – do you need to sleep?")]), _vm._v(" "), _c('p', [_vm._v("12:01 A.M. Rick: I do. Chat tomorrow babe xxx")]), _vm._v(" "), _c('p', [_vm._v("12:02 A.M. Sarah: Ok goodnight Cutie 💋")]), _vm._v(" "), _c('p', [_vm._v("12:04 A.M. Rick: Good night Sweet Cheeks 💋")]), _vm._v(" "), _c('p', [_vm._v("8:35 A.M. Rick: Good morning Sweet Cheeks 💋")]), _vm._v(" "), _c('p', [_vm._v("8:38 A.M. Sarah: Good morning Cutie Pie. Feeling better? x")]), _vm._v(" "), _c('p', [_vm._v("9:30 A.M. Rick: Still got the irritating niggle that brings on the coughing fit, otherwise all good xxx")]), _vm._v(" "), _c('p', [_vm._v("9:30 A.M. Sarah: Well that’s an improvement. Happy to hear it ahead of your trip x")]), _vm._v(" "), _c('p', [_vm._v("9:31 A.M. Rick: I enjoyed our chat yesterday babe x")]), _vm._v(" "), _c('p', [_vm._v("9:31 A.M. Sarah: Which part? I always enjoy our chat x")]), _vm._v(" "), _c('p', [_vm._v("9:33 A.M. Rick: All of it, we cover a multitude of topics x")]), _vm._v(" "), _c('p', [_vm._v("9:34 A.M. Sarah: Good, me too. Do you enjoy having an innocent to educate? x")]), _vm._v(" "), _c('p', [_vm._v("9:35 A.M. Rick: Absolutely. Do you enjoy the education?")]), _vm._v(" "), _c('p', [_vm._v("9:35 A.M. Sarah: Of course! xxx")]), _vm._v(" "), _c('p', [_vm._v("9:43 A.M. Rick: Do you want to stay virginal? x")]), _vm._v(" "), _c('p', [_vm._v("9:43 A.M. Sarah: Not at all – and I don’t consider myself that any more but the more I know, the more innocent and ignorant I feel! I don’t know what I don’t know.")]), _vm._v(" "), _c('p', [_vm._v("9:44 A.M. Sarah: It was so cold and wet this morning – I froze on my walk x")]), _vm._v(" "), _c('p', [_vm._v("9:46 A.M. Rick: Did you get back into bed again?")]), _vm._v(" "), _c('p', [_vm._v("9:47 A.M. Sarah: No, I had a long shower to warm up")]), _vm._v(" "), _c('p', [_vm._v("9:48 A.M. Rick: I will take you in the shower babe. Pushed up against the glass and the water cascading down on us x")]), _vm._v(" "), _c('p', [_vm._v("9:49 A.M. Sarah: Lots of plans for me then? It’ll be more than a month since I saw you last by the time you get back xxx")]), _vm._v(" "), _c('p', [_vm._v("9:51 A.M. Rick: And you can still remember and feel everything we did, can’t you babe? x")]), _vm._v(" "), _c('p', [_vm._v("9:51 A.M. Sarah: I absolutely can, and am very keen to have another bout x")]), _vm._v(" "), _c('p', [_vm._v("9:53 A.M. Rick: Bout!!! Interesting choice of words x")]), _vm._v(" "), _c('p', [_vm._v("9:53 A.M. Sarah: I thought that but it was too late! In the office being busy and important? x")]), _vm._v(" "), _c('p', [_vm._v("10:01 A.M. Rick: Lol. I’m just trying to catch up after a few days off sick")]), _vm._v(" "), _c('p', [_vm._v("10:01 A.M. Sarah: Have you forgotten how?")]), _vm._v(" "), _c('p', [_vm._v("10:02 A.M. Rick: It’s in my DNA")]), _vm._v(" "), _c('p', [_vm._v("10:02 A.M. Sarah: How did I know that. Master of all.")]), _vm._v(" "), _c('p', [_vm._v("10:14 A.M. Rick: All seeing, all knowing")]), _vm._v(" "), _c('p', [_vm._v("10:15 A.M. Sarah: Omnipotent x")]), _vm._v(" "), _c('p', [_vm._v("10:16 A.M. Rick: Lol. Are you on birth control???😮")]), _vm._v(" "), _c('p', [_vm._v("10:16 A.M. Sarah: You think you could get me pregnant? If so, you are definitely a god!")]), _vm._v(" "), _c('p', [_vm._v("10:17 A.M. Rick: It is the ultimate power to impregnate")]), _vm._v(" "), _c('p', [_vm._v("10:17 A.M. Sarah: Might be a bit late for that with me babe!")]), _vm._v(" "), _c('p', [_vm._v("10:18 A.M. Rick: Never say never")]), _vm._v(" "), _c('p', [_vm._v("10:18 A.M. Sarah: EEK. Imagine having a baby at this stage of life. I just can’t.")]), _vm._v(" "), _c('p', [_vm._v("10:20 A.M. Rick: It would get a few tongues wagging")]), _vm._v(" "), _c('p', [_vm._v("10:20 A.M. Sarah: My body would be in ruins! My poor finely tuned pelvic floor!")]), _vm._v(" "), _c('p', [_vm._v("10:22 A.M. Rick: Oh, I felt that x")]), _vm._v(" "), _c('p', [_vm._v("10:23 A.M. Sarah: You certainly did")]), _vm._v(" "), _c('p', [_vm._v("10:24 A.M. Rick: If it was painful you should have stopped me x")]), _vm._v(" "), _c('p', [_vm._v("10:25 A.M. Sarah: You became friends with my cervix x")]), _vm._v(" "), _c('p', [_vm._v("10:41 A.M. Rick: And you positioned yourself to get maximum feeling. Don’t think I didn’t notice!!! xxx")]), _vm._v(" "), _c('p', [_vm._v("10:44 A.M. Sarah: You might be a bit longer than I’m used to, or you just know how to get deeper, but you get as deep as I am x")]), _vm._v(" "), _c('p', [_vm._v("10:58 A.M. Rick: Fuck woman – now I am hard and rampant x")]), _vm._v(" "), _c('p', [_vm._v("10:58 A.M. Sarah: Your natural state xxx")]), _vm._v(" "), _c('p', [_vm._v("10:59 A.M. Rick: Mostly. As you are also in a constant state of arousal x")]), _vm._v(" "), _c('p', [_vm._v("11:00 A.M. Sarah: It’s easier to hide for me though")]), _vm._v(" "), _c('p', [_vm._v("11:01 A.M. Rick: When I walked through the front door, I could smell your sex x")]), _vm._v(" "), _c('p', [_vm._v("11:01 A.M. Sarah: I cannot believe I’m that obvious! xxx")]), _vm._v(" "), _c('p', [_vm._v("11:04 A.M. Rick: Babe. It was so obvious xxx")]), _vm._v(" "), _c('p', [_vm._v("11:04 A.M. Sarah: Well that’s good then isn’t it? I’m very direct as you have observed x")]), _vm._v(" "), _c('p', [_vm._v("11:05 A.M. Rick: I’m not complaining mmm")]), _vm._v(" "), _c('p', [_vm._v("11:05 A.M. Sarah: I didn’t think so. I didn’t complain either x")]), _vm._v(" "), _c('p', [_vm._v("11:06 A.M. Rick: Hips moving?")]), _vm._v(" "), _c('p', [_vm._v("11:07 A.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("11:07 A.M. Rick: Where are you?")]), _vm._v(" "), _c('p', [_vm._v("11:08 A.M. Sarah: Just at home working on my laptop")]), _vm._v(" "), _c('p', [_vm._v("11:08 A.M. Rick: Skirt? Dress?")]), _vm._v(" "), _c('p', [_vm._v("11:08 A.M. Sarah: No, jeans. It’s cold.")]), _vm._v(" "), _c('p', [_vm._v("11:08 A.M. Rick: Knickers on or off")]), _vm._v(" "), _c('p', [_vm._v("11:09 A.M. Sarah: Always on when I’m in jeans")]), _vm._v(" "), _c('p', [_vm._v("11:09 A.M. Rick: Don’t you like the feel of the seam rubbing on your clit?")]), _vm._v(" "), _c('p', [_vm._v("11:10 A.M. Sarah: I’m a busy girl, so it hurts after a while. Plus, wetness makes a mess x")]), _vm._v(" "), _c('p', [_vm._v("11:11 A.M. Rick: Mmm I would have to try and stem the flow with my tongue")]), _vm._v(" "), _c('p', [_vm._v("11:11 A.M. Sarah: That would work but jeans may have to be removed first")]), _vm._v(" "), _c('p', [_vm._v("11:15 A.M. Rick: Not necessarily. I would put you on all fours and tongue fuck you from behind babe. Have you push back onto my face. Am I being cruel!!! xxx")]), _vm._v(" "), _c('p', [_vm._v("11:16 A.M. Sarah: You are very cruel. And leaving the country x")]), _vm._v(" "), _c('p', [_vm._v("11:16 A.M. Rick: Your hips are moving a lot quicker now? Higher? xxx")]), _vm._v(" "), _c('p', [_vm._v("11:17 A.M. Sarah: You know I’m feeling it")]), _vm._v(" "), _c('p', [_vm._v("11:18 A.M. Sarah: Were your parents’ sadists too? Or you were raised by wolves?")]), _vm._v(" "), _c('p', [_vm._v("11:20 A.M. Rick: Oh yes. Wolves. Wait until I bite you.")]), _vm._v(" "), _c('p', [_vm._v("11:21 A.M. Sarah: You can’t be serious! Eat me maybe.")]), _vm._v(" "), _c('p', [_vm._v("11:21 A.M. Rick: Are you wanting my face between your legs?")]), _vm._v(" "), _c('p', [_vm._v("11:22 A.M. Sarah: Of course – such a bad man! x")]), _vm._v(" "), _c('p', [_vm._v("11:35 A.M. Rick: We know this")]), _vm._v(" "), _c('p', [_vm._v("11:36 A.M. Sarah: Sure do")]), _vm._v(" "), _c('p', [_vm._v("11:54 A.M. Rick: Does my language sometimes offend you? x")]), _vm._v(" "), _c('p', [_vm._v("11:54 A.M. Sarah: No, never. Well at least not yet! What in particular made you say that?")]), _vm._v(" "), _c('p', [_vm._v("11:56 A.M. Rick: Nothing in particular")]), _vm._v(" "), _c('p', [_vm._v("11:58 A.M. Rick: Have you tried another woman?")]), _vm._v(" "), _c('p', [_vm._v("11:58 A.M. Sarah: You definitely sometimes shock me, but I’m not offended easily. You are very provocative, and I’ve never had so much sex chat. And no, never. People make choices all the time, so that would be just another choice. I think about that constantly.")]), _vm._v(" "), _c('p', [_vm._v("12:34 P.M. Rick: Making choices?")]), _vm._v(" "), _c('p', [_vm._v("12:34 P.M. Sarah: Yes. It’s when you don’t make active choices but passively let life lead you that things go wrong. Well that’s what happened to me.")]), _vm._v(" "), _c('p', [_vm._v("12:43 P.M. Rick: Deep. Very deep.")]), _vm._v(" "), _c('p', [_vm._v("12:44 P.M. Sarah: You mean that?")]), _vm._v(" "), _c('p', [_vm._v("12:44 P.M. Rick: I mean it Sweet Cheeks x")]), _vm._v(" "), _c('p', [_vm._v("12:46 P.M. Sarah: I’ve looked back through my sexual history and not been happy about the choices I made, for many reasons.")]), _vm._v(" "), _c('p', [_vm._v("2:09 P.M. Sarah: Are you at the airport? All ready for tomorrow? Of course, you are.")]), _vm._v(" "), _c('p', [_vm._v("2:11 P.M. Rick: How did you know...yes, I’m in the lounge x")]), _vm._v(" "), _c('p', [_vm._v("2:12 P.M. Sarah: I imagine you are a hyper organised type")]), _vm._v(" "), _c('p', [_vm._v("2:12 P.M. Rick: Some would say OCD")]), _vm._v(" "), _c('p', [_vm._v("2:13 P.M. Sarah: Interesting – I’m a bit OCD too. Just ask my son. I gave him a serious message when I got back from my trip about not messing up my space – didn’t go down very well. I think he’s territorial, exerting some sort of weird ownership over the house.")]), _vm._v(" "), _c('p', [_vm._v("2:15 P.M. Rick: So he is the next one to sort out. Hope he’s not urinating on everything 😱")]), _vm._v(" "), _c('p', [_vm._v("2:16 P.M. Sarah: We are pretty good usually, but he likes to flex his muscles over me. A bit like his father. And no, minor things but REALLY annoying to me, and he knows it then puts on a show to make me look unreasonable.")]), _vm._v(" "), _c('p', [_vm._v("2:16 P.M. Rick: He knows your pain points")]), _vm._v(" "), _c('p', [_vm._v("2:17 P.M. Sarah: Most definitely. I’m not easily upset, so he has to try quite hard to get a real rise out of me!")]), _vm._v(" "), _c('p', [_vm._v("2:17 P.M. Rick: And you react. Always a big mistake.")]), _vm._v(" "), _c('p', [_vm._v("2:18 P.M. Sarah: Very true, but I couldn’t help myself on that occasion. He’d expressly been asked politely not to camp at my place, but he did, for his convenience, and stayed four nights. Making a fuss was a rookie mistake, but after such a long trip it was more than I could handle.")]), _vm._v(" "), _c('p', [_vm._v("2:24 P.M. Sarah: Such a nice photo of you in your pic – you look like someone to snuggle")]), _vm._v(" "), _c('p', [_vm._v("2:27 P.M. Rick: Snuggle!!! That’s up there with cute!")]), _vm._v(" "), _c('p', [_vm._v("2:27 P.M. Sarah: I know – deceptive. But you are a lovely snuggle. You don’t want to be?")]), _vm._v(" "), _c('p', [_vm._v("2:28 P.M. Rick: I do like to spoon")]), _vm._v(" "), _c('p', [_vm._v("2:28 P.M. Sarah: I do too. I like to lie on top of you, or curl in tight. Maximum skin coverage.")]), _vm._v(" "), _c('p', [_vm._v("2:29 P.M. Rick: You know what happens if you do that")]), _vm._v(" "), _c('p', [_vm._v("2:29 P.M. Sarah: No what?")]), _vm._v(" "), _c('p', [_vm._v("2:30 P.M. Rick: I have to put my cock in you babe")]), _vm._v(" "), _c('p', [_vm._v("2:30 P.M. Sarah: That’s fine – I can lie there connected to you by it. Just more skin")]), _vm._v(" "), _c('p', [_vm._v("2:31 P.M. Rick: Lol 💋")]), _vm._v(" "), _c('p', [_vm._v("2:36 P.M. Sarah: Are you getting lots of work done, amidst the sex chat? x")]), _vm._v(" "), _c('p', [_vm._v("2:36 P.M. Rick: You do like to be a naughty girl")]), _vm._v(" "), _c('p', [_vm._v("2:37 P.M. Sarah: I fear I’m not naughty enough for you. Am I?")]), _vm._v(" "), _c('p', [_vm._v("2:37 P.M. Rick: I can train you")]), _vm._v(" "), _c('p', [_vm._v("2:37 P.M. Sarah: Ouch")]), _vm._v(" "), _c('p', [_vm._v("2:37 P.M. Rick: Lol 💋")]), _vm._v(" "), _c('p', [_vm._v("2:37 P.M. Sarah: Mean!")]), _vm._v(" "), _c('p', [_vm._v("2:38 P.M. Rick: Heard from the challenging lover?")]), _vm._v(" "), _c('p', [_vm._v("2:39 P.M. Sarah: No, not for a while. The loving one is upset about my suggestion that we lighten the relationship, to open it up a bit, and needs to be put in the freezer for a while.")]), _vm._v(" "), _c('p', [_vm._v("2:42 P.M. Rick: Lol. Or warmed up in the oven.")]), _vm._v(" "), _c('p', [_vm._v("2:42 P.M. Sarah: The freezer is best for this situation. If I keep communicating, he’ll say something he regrets, so it’s best to leave him to have a bit of a think. Consider his options.")]), _vm._v(" "), _c('p', [_vm._v("2:44 P.M. Rick: Lol. So you still have need for his cock?")]), _vm._v(" "), _c('p', [_vm._v("2:44 P.M. Sarah: Well he’s kind to me, and he’s such a nice man, but you know I’m in a good position. It has made me ambivalent.")]), _vm._v(" "), _c('p', [_vm._v("2:56 P.M. Rick: So many cocks on offer! Spoilt for choice x")]), _vm._v(" "), _c('p', [_vm._v("2:56 P.M. Sarah: It’s true. I’m lucky to be in a position to choose.")]), _vm._v(" "), _c('p', [_vm._v("2:58 P.M. Rick: How many potentials?")]), _vm._v(" "), _c('p', [_vm._v("2:58 P.M. Sarah: I’m not marketing myself, so none")]), _vm._v(" "), _c('p', [_vm._v("2:59 P.M. Rick: I could market you 😈")]), _vm._v(" "), _c('p', [_vm._v("2:59 P.M. Sarah: But why would you?")]), _vm._v(" "), _c('p', [_vm._v("3:01 P.M. Rick: I am your Master. Not to mention evil.")]), _vm._v(" "), _c('p', [_vm._v("3:01 P.M. Sarah: Is that so … And you’re not evil, you’re cute. And I still don’t know why you would?")]), _vm._v(" "), _c('p', [_vm._v("3:03 P.M. Rick: It is a turn on. Would you go through with it to please your Master?")]), _vm._v(" "), _c('p', [_vm._v("3:06 P.M. Sarah: Slow that one down babe!")]), _vm._v(" "), _c('p', [_vm._v("3:07 P.M. Rick: Easy tiger?")]), _vm._v(" "), _c('p', [_vm._v("3:07 P.M. Sarah: That’s the one")]), _vm._v(" "), _c('p', [_vm._v("3:08 P.M. Rick: Does it scare you and excite you at the same time?")]), _vm._v(" "), _c('p', [_vm._v("3:09 P.M. Sarah: I actually just don’t understand, so yes to all. I feel everything.")]), _vm._v(" "), _c('p', [_vm._v("3:10 P.M. Rick: At one with yourself")]), _vm._v(" "), _c('p', [_vm._v("3:10 P.M. Sarah: I hope so")]), _vm._v(" "), _c('p', [_vm._v("3:11 P.M. Rick: Ok lover, doors closed so have to say bye xxx")]), _vm._v(" "), _c('p', [_vm._v("3:11 P.M. Sarah: Ok Cutie Pie, fly well xxx")]), _vm._v(" "), _c('p', [_vm._v("9:30 P.M. Rick: Hello again x")]), _vm._v(" "), _c('p', [_vm._v("9:31 P.M. Sarah: Hello. Can’t get enough! x")]), _vm._v(" "), _c('p', [_vm._v("9:32 P.M. Rick: Enough is never enough")]), _vm._v(" "), _c('p', [_vm._v("9:33 P.M. Sarah: True. We talk all day and all night!")]), _vm._v(" "), _c('p', [_vm._v("9:55 P.M. Rick: What you up to?")]), _vm._v(" "), _c('p', [_vm._v("9:55 P.M. Sarah: I’m tired so am reading in bed. Boring. It’s been a very dull day apart from you. Nice hotel? Room for two? I could read my book next to you...")]), _vm._v(" "), _c('p', [_vm._v("10:13 P.M. Rick: You know we would end up playing games")]), _vm._v(" "), _c('p', [_vm._v("10:14 P.M. Sarah: Would I be any good at it?")]), _vm._v(" "), _c('p', [_vm._v("10:15 P.M. Rick: A star performance lover xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "tuesday-26-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Tuesday, 26 June 2018")]), _vm._v(" "), _c('p', [_vm._v("9:00 A.M. Sarah: Good morning sweetheart. Fell asleep last night sorry xxx")]), _vm._v(" "), _c('p', [_vm._v("9:01 A.M. Rick: Good morning Sweet Cheeks xxx")]), _vm._v(" "), _c('p', [_vm._v("9:05 A.M. Sarah: Feel better today?")]), _vm._v(" "), _c('p', [_vm._v("9:07 A.M. Rick: Nose all clogged up but the coughing seems to have abated to a random tickle. How are you babe? xxx")]), _vm._v(" "), _c('p', [_vm._v("9:09 A.M. Sarah: The cough is the worst part so I guess that’s good. I’m fine. Behaving myself. Just home from making lunches xxx")]), _vm._v(" "), _c('p', [_vm._v("9:10 A.M. Rick: Lol. Behaving yourself? Have you had offers to misbehave? 😮")]), _vm._v(" "), _c('p', [_vm._v("9:10 A.M. Sarah: Only from you x")]), _vm._v(" "), _c('p', [_vm._v("9:11 A.M. Rick: You scared the rest away!")]), _vm._v(" "), _c('p', [_vm._v("9:11 A.M. Sarah: Me? Scary? Never!")]), _vm._v(" "), _c('p', [_vm._v("9:12 A.M. Rick: Oh, I know babe x")]), _vm._v(" "), _c('p', [_vm._v("7:08 P.M. Sarah: Been out for a drink with my book club – we’ve been going more than 15 years so are intimately involved in each other’s lives. I love it.")]), _vm._v(" "), _c('p', [_vm._v("7:22 P.M. Rick: Hello Sweet Cheeks. What do you discuss at this book club!!! Past and present conquests over many barrels of wine? 😈💋")]), _vm._v(" "), _c('p', [_vm._v("7:24 P.M. Sarah: LOTS to discuss. No books tonight, just life. I’m the single now amongst happy marrieds, makes me somewhat interesting xxx")]), _vm._v(" "), _c('p', [_vm._v("7:26 P.M. Rick: I’m sure you are, did you make them all green with envy? x")]), _vm._v(" "), _c('p', [_vm._v("7:26 P.M. Sarah: Well green with curiosity! Everything is relative xx")]), _vm._v(" "), _c('p', [_vm._v("7:29 P.M. Rick: Very profound")]), _vm._v(" "), _c('p', [_vm._v("7:30 P.M. Sarah: Yes, that’s me. We did have a very interesting discussion about bodies and nakedness tonight – as you know I don’t have any problem whipping my clothes off, but it is definitely a barrier to both of them. In fact, it would be one of the more terrifying things they could think of, even though they are both attractive women in their mid-50s. I thought that was interesting.")]), _vm._v(" "), _c('p', [_vm._v("7:32 P.M. Rick: Are you serious that women feel that way?")]), _vm._v(" "), _c('p', [_vm._v("7:33 P.M. Sarah: Yes absolutely! Crazy isn’t it – I said to them that men are just happy to have anything naked in their beds. Plus seeking a partner online, you pretty much know what you’re getting before you meet the person, so long as you’re honest in your profile and photos are recent. I always think that minimises the pressure.")]), _vm._v(" "), _c('p', [_vm._v("7:33 P.M. Rick: Totally. And these women are married?")]), _vm._v(" "), _c('p', [_vm._v("7:33 P.M. Sarah: Yes, very married, both happy")]), _vm._v(" "), _c('p', [_vm._v("7:34 P.M. Rick: Are they getting fucked by their hubbies?")]), _vm._v(" "), _c('p', [_vm._v("7:34 P.M. Sarah: I’m sure they are, from conversations we have had over the years when I was in the same situation")]), _vm._v(" "), _c('p', [_vm._v("7:35 P.M. Rick: You should ask")]), _vm._v(" "), _c('p', [_vm._v("7:35 P.M. Sarah: They find my tales of wantonness FASCINATING")]), _vm._v(" "), _c('p', [_vm._v("7:35 P.M. Rick: Why not invite them over to watch?")]), _vm._v(" "), _c('p', [_vm._v("7:36 P.M. Sarah: OMG man! Stop that")]), _vm._v(" "), _c('p', [_vm._v("7:36 P.M. Rick: Lol try it lover xxx")]), _vm._v(" "), _c('p', [_vm._v("7:36 P.M. Sarah: No! xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "wednesday-27-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Wednesday, 27 June 2018")]), _vm._v(" "), _c('p', [_vm._v("6:10 A.M. Sarah: Good morning to you Cutie. I would love to be backed into you when you wake up this morning 💋")]), _vm._v(" "), _c('p', [_vm._v("7:57 A.M. Rick: Good morning babe. Now that is a delicious thought.")]), _vm._v(" "), _c('p', [_vm._v("8:15 A.M. Rick: Heard back from your other lover? xxx")]), _vm._v(" "), _c('p', [_vm._v("8:17 A.M. Sarah: Of course!")]), _vm._v(" "), _c('p', [_vm._v("8:18 A.M. Rick: And? Have you had a good fuck? xxx")]), _vm._v(" "), _c('p', [_vm._v("8:20 A.M. Sarah: Haha too funny xxx")]), _vm._v(" "), _c('p', [_vm._v("8:20 A.M. Rick: So that’s a yes xxx")]), _vm._v(" "), _c('p', [_vm._v("8:23 A.M. Sarah: You’re a terrier x")]), _vm._v(" "), _c('p', [_vm._v("8:25 A.M. Rick: Yesterday? Did it turn you on more when you opened your legs for him? xxx")]), _vm._v(" "), _c('p', [_vm._v("8:30 A.M. Sarah: You got me x")]), _vm._v(" "), _c('p', [_vm._v("8:31 A.M. Rick: That’s why you fell asleep babe? xxx")]), _vm._v(" "), _c('p', [_vm._v("8:32 A.M. Sarah: Not at all. My sleep pattern is all over the place. Tips?")]), _vm._v(" "), _c('p', [_vm._v("8:33 A.M. Rick: More sex! Did he ask about me as he fucked you? xxx")]), _vm._v(" "), _c('p', [_vm._v("8:37 A.M. Sarah: He didn’t ask, doesn’t want to know. You know he’s in love and jealous.")]), _vm._v(" "), _c('p', [_vm._v("8:37 A.M. Rick: Aww. Cute xxx")]), _vm._v(" "), _c('p', [_vm._v("8:38 A.M. Sarah: So cute. I don’t want to hurt him, but I don’t want to let him get on with his life without me either!")]), _vm._v(" "), _c('p', [_vm._v("8:38 A.M. Rick: Did you tell him he is just a cock!!!")]), _vm._v(" "), _c('p', [_vm._v("8:39 A.M. Sarah: HAHA")]), _vm._v(" "), _c('p', [_vm._v("8:42 A.M. Rick: That’s a no!!!")]), _vm._v(" "), _c('p', [_vm._v("8:43 A.M. Sarah: A very definite no. I’m not cruel.")]), _vm._v(" "), _c('p', [_vm._v("8:43 A.M. Rick: And you do enjoy his cock")]), _vm._v(" "), _c('p', [_vm._v("8:44 A.M. Sarah: Of course, I do")]), _vm._v(" "), _c('p', [_vm._v("8:46 A.M. Rick: There is nothing wrong with that xxx")]), _vm._v(" "), _c('p', [_vm._v("9:08 A.M. Sarah: This is kind of nice, but weird for me xxx")]), _vm._v(" "), _c('p', [_vm._v("9:17 A.M. Rick: Did you feel wicked? 😮")]), _vm._v(" "), _c('p', [_vm._v("9:18 A.M. Sarah: Yes! Absolutely x")]), _vm._v(" "), _c('p', [_vm._v("9:24 A.M. Rick: How many times did you think of me as he fucked you darling? xxx")]), _vm._v(" "), _c('p', [_vm._v("9:24 A.M. Sarah: It’s impossible to avoid thinking of you since we spend so much time talking, even though I’m generally very much “in the moment”. He provides something I don’t believe I’ve ever had before – actual lovemaking.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "thursday-28-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Thursday, 28 June 2018")]), _vm._v(" "), _c('p', [_vm._v("8:36 A.M. Rick: Good morning Sweet Cheeks. Trust you slept well and had delicious dreams xxx")]), _vm._v(" "), _c('p', [_vm._v("8:37 A.M. Sarah: Good morning to you too, Cutie. Yes, to both xxx")]), _vm._v(" "), _c('p', [_vm._v("8:39 A.M. Rick: What are your plans for today, babe? Spreading your legs for your other lover later? 😮")]), _vm._v(" "), _c('p', [_vm._v("8:43 A.M. Sarah: No plans for that. You’re next. I’m making bookings for my trip to Sydney with my parents.")]), _vm._v(" "), _c('p', [_vm._v("8:44 A.M. Rick: Is he not an everyday sex type? xxx")]), _vm._v(" "), _c('p', [_vm._v("8:46 A.M. Sarah: I’ve said before, he’s just not available because of family commitments. That’s been the problem for me with him all along. The challenging one made contact yesterday. Told you he would.")]), _vm._v(" "), _c('p', [_vm._v("8:56 A.M. Rick: You are so desirable babe xxx")]), _vm._v(" "), _c('p', [_vm._v("8:56 A.M. Sarah: Aww thanks xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "friday-29-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Friday, 29 June 2018")]), _vm._v(" "), _c('p', [_vm._v("9:52 A.M. Sarah: Good morning Rick. Hope you are now in relax mode, ready to fly home later? Quick question – can we see each other tonight? xxx")]), _vm._v(" "), _c('p', [_vm._v("10:57 A.M. Rick: Good morning, lover. Relaxed day and easy travel with no pressure. I won’t be seeing you tonight – I arrive too late xxx")]), _vm._v(" "), _c('p', [_vm._v("11:52 A.M. Sarah: I need to see you soon babe x")]), _vm._v(" "), _c('p', [_vm._v("11:53 A.M. Rick: Tell me more xxx")]), _vm._v(" "), _c('p', [_vm._v("11:53 A.M. Sarah: It’s been so long I’ve forgotten who you are, what you feel like x")]), _vm._v(" "), _c('p', [_vm._v("11:54 A.M. Rick: Plus, we have never seen each other in the cold light of day x")]), _vm._v(" "), _c('p', [_vm._v("11:55 A.M. Sarah: No – that’s true. You’ve seen plenty of photos of me in the daytime! xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "saturday-30-june-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Saturday, 30 June 2018")]), _vm._v(" "), _c('p', [_vm._v("3:06 P.M. Rick: Hello babe. Back home but back at square one with my health. Obviously, the change of climates and flights didn’t help xxx")]), _vm._v(" "), _c('p', [_vm._v("3:08 P.M. Sarah: Sorry to hear that – take care of yourself sweetheart. Keep me posted x")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "sunday-1-july-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Sunday, 1 July 2018")]), _vm._v(" "), _c('p', [_vm._v("9:28 A.M. Sarah: Morning babe – how are you feeling today? x")]), _vm._v(" "), _c('p', [_vm._v("9:40 A.M. Rick: Morning lover. My lungs are on the pillow next to me, my chest aches from the coughing otherwise all good. How are you? x")]), _vm._v(" "), _c('p', [_vm._v("9:41 A.M. Sarah: That’s terrible! Hope it improves quickly. And I’m good. Caught up with the challenging one last night. He knows how to party and always gets me so messed up I can hardly see straight the next day. So that’s me today – back in bed watching Netflix xxx")]), _vm._v(" "), _c('p', [_vm._v("9:50 A.M. Rick: Hard fucking was had by all mmm")]), _vm._v(" "), _c('p', [_vm._v("9:51 A.M. Sarah: Only fucking was this morning – too messed up last night! Was in the mood to see you but knew you wouldn’t mind xxx")]), _vm._v(" "), _c('p', [_vm._v("1:37 P.M. Rick: When you say too messed up...you mean you drank too much!!!")]), _vm._v(" "), _c('p', [_vm._v("1:38 P.M. Sarah: I do. You should have said earlier you were still unwell – I’m sorry I didn’t even ask, just assumed you were fine!")]), _vm._v(" "), _c('p', [_vm._v("2:01 P.M. Rick: I don’t need to impart every ailment 😮")]), _vm._v(" "), _c('p', [_vm._v("2:02 P.M. Sarah: Tough guy huh xxx")]), _vm._v(" "), _c('p', [_vm._v("2:07 P.M. Rick: So, submissive or aggressive? With the challenging one.")]), _vm._v(" "), _c('p', [_vm._v("2:09 P.M. Sarah: Are you asking if I’m submissive or aggressive sexually with the challenging one? If so, I don’t think it’s like that with him. You are the only chap I have come across who has a clear direction. I’m sure if you asked him, he would say he’s the aggressive one, but I’m not sure.")]), _vm._v(" "), _c('p', [_vm._v("2:18 P.M. Rick: Did you present yourself to him on all fours?")]), _vm._v(" "), _c('p', [_vm._v("2:19 P.M. Sarah: No, should I have?")]), _vm._v(" "), _c('p', [_vm._v("2:21 P.M. Rick: Yes. You should have told him to help himself.")]), _vm._v(" "), _c('p', [_vm._v("2:23 P.M. Sarah: It was fairly relaxed sex, all horizontal, mainly from behind starting with spooning. I know he has fantasies about me but is actually pretty happy with just having the chance to get into bed with me. He’s nice to cuddle with overnight, loves to spoon.")]), _vm._v(" "), _c('p', [_vm._v("2:24 P.M. Rick: Lol. What kind of fantasies?")]), _vm._v(" "), _c('p', [_vm._v("2:26 P.M. Sarah: You’re insatiable! Well, he wants me in certain clothing; a 3sum; that sort of thing.")]), _vm._v(" "), _c('p', [_vm._v("2:28 P.M. Rick: Wants to watch you fuck another cock?")]), _vm._v(" "), _c('p', [_vm._v("2:28 P.M. Sarah: No, I don’t think that’s it, but we haven’t covered that one!")]), _vm._v(" "), _c('p', [_vm._v("2:29 P.M. Rick: Well that’s what will happen in a 3sum")]), _vm._v(" "), _c('p', [_vm._v("2:29 P.M. Sarah: I think he would prefer two women")]), _vm._v(" "), _c('p', [_vm._v("2:30 P.M. Rick: Did you tell him you spread your legs earlier in the week?")]), _vm._v(" "), _c('p', [_vm._v("2:30 P.M. Sarah: Not specifically, but he is fully aware he’s not alone, and doesn’t care so long as I’m taking care of my sexual health, which I am of course. A bit of a reminder though to be more vigilant.")]), _vm._v(" "), _c('p', [_vm._v("2:31 P.M. Rick: Did he fuck your arse?")]), _vm._v(" "), _c('p', [_vm._v("2:31 P.M. Sarah: Cute. No.")]), _vm._v(" "), _c('p', [_vm._v("2:32 P.M. Rick: Did he want it?")]), _vm._v(" "), _c('p', [_vm._v("2:32 P.M. Sarah: I don’t think so – it didn’t really come up")]), _vm._v(" "), _c('p', [_vm._v("2:33 P.M. Rick: Do you feel wanton having fucked two cocks in the same week?")]), _vm._v(" "), _c('p', [_vm._v("2:33 P.M. Sarah: A little. Why do men all want me on top!!!")]), _vm._v(" "), _c('p', [_vm._v("2:33 P.M. Rick: You know you do! And it gives them such a great view of your body and their cocks inside you, lover.")]), _vm._v(" "), _c('p', [_vm._v("2:34 P.M. Sarah: Of course, I do – just teasing. Does it make you hard?")]), _vm._v(" "), _c('p', [_vm._v("2:36 P.M. Rick: Actually yes. Such a filthy and debauched mind, knowing that you spread your legs so willingly x")]), _vm._v(" "), _c('p', [_vm._v("2:38 P.M. Sarah: Now I feel like a slut!")]), _vm._v(" "), _c('p', [_vm._v("2:39 P.M. Rick: Mmm. A major turn on that you possibly even slightly did as I ordered and fucked them for me. I know you will deny it x")]), _vm._v(" "), _c('p', [_vm._v("2:42 P.M. Sarah: I fucked the others for you? I’m not going to deny it – I actually like that you gave me “permission”, even though I know I don’t need it. I wanted sex so... Actually, I wanted more than sex. I wanted man company.")]), _vm._v(" "), _c('p', [_vm._v("2:42 P.M. Rick: Are your hips moving lover?")]), _vm._v(" "), _c('p', [_vm._v("2:43 P.M. Sarah: Yes. I’m still in bed – been here all day binging on Netflix and sleeping.")]), _vm._v(" "), _c('p', [_vm._v("2:45 P.M. Rick: Naked?")]), _vm._v(" "), _c('p', [_vm._v("2:45 P.M. Sarah: Fully clothed on this rare occasion")]), _vm._v(" "), _c('p', [_vm._v("2:46 P.M. Rick: In bed?")]), _vm._v(" "), _c('p', [_vm._v("2:46 P.M. Sarah: Yes – I got up, dropped the man home, came back to bed in my clothes. I needed to be very warm and since you weren’t miraculously here to keep me warm had to improvise.")]), _vm._v(" "), _c('p', [_vm._v("2:47 P.M. Rick: What does he want you to wear?")]), _vm._v(" "), _c('p', [_vm._v("2:47 P.M. Sarah: Sexy, short red dress and red heels, nails, bleached blond, slick look")]), _vm._v(" "), _c('p', [_vm._v("2:48 P.M. Rick: And go out?")]), _vm._v(" "), _c('p', [_vm._v("2:48 P.M. Sarah: I’ve no idea what he wants me to do while dressed like that but I’m assuming not standing round the house! The heels would make me significantly taller than him – he has a thing for tall women.")]), _vm._v(" "), _c('p', [_vm._v("2:49 P.M. Rick: Lol. Underwear?")]), _vm._v(" "), _c('p', [_vm._v("2:49 P.M. Sarah: He didn’t mention it but I assume that would be optional. He doesn’t seem particularly turned on by that. UNLIKE YOU.")]), _vm._v(" "), _c('p', [_vm._v("2:50 P.M. Rick: So I take it you have to be on top and ride him")]), _vm._v(" "), _c('p', [_vm._v("2:51 P.M. Sarah: No, I don’t have to be, but it usually ends up that way. I’m out for dinner this evening with couple friends – I’m not sure I’m up to another night out!")]), _vm._v(" "), _c('p', [_vm._v("2:51 P.M. Rick: What will you wear tonight?")]), _vm._v(" "), _c('p', [_vm._v("2:52 P.M. Sarah: We’re just going somewhere relaxed so maybe jeans, boots...")]), _vm._v(" "), _c('p', [_vm._v("2:53 P.M. Rick: I would like you in a skirt. No knickers.")]), _vm._v(" "), _c('p', [_vm._v("2:54 P.M. Sarah: I know you would – I don’t have many skirts for this season. I can’t find anything I like. The short black dress I wore when you came to dinner is a goodie but doesn’t get to go out much, and obviously not right for a casual dinner with friends. I hope you have spent the day in bed recovering?")]), _vm._v(" "), _c('p', [_vm._v("3:11 P.M. Rick: It is most definitely a goodie. You looked beautiful that night babe, so sexy. And I have, thanks for asking. Plenty of liquids.")]), _vm._v(" "), _c('p', [_vm._v("3:19 P.M. Sarah: Pleased to hear it. I’ve just had a hot shower – delicious. Could you please pop over and rub some moisturiser on to my back? It’s a constant problem to me. I’d be happy to oblige with the sex which would be the consequence.")]), _vm._v(" "), _c('p', [_vm._v("3:28 P.M. Rick: Oh, I know you would, and the further consequence would be not making your dinner date x")]), _vm._v(" "), _c('p', [_vm._v("3:28 P.M. Sarah: Lucky for them you’re sick x")]), _vm._v(" "), _c('p', [_vm._v("3:29 P.M. Rick: Did you not have a hangover this morning?")]), _vm._v(" "), _c('p', [_vm._v("3:30 P.M. Sarah: Now I’m typing naked getting ready for heading out later! Yes, I did – nothing a sleep and plenty of water didn’t fix. I feel perfect now. Want to check?")]), _vm._v(" "), _c('p', [_vm._v("3:31 P.M. Rick: Mmm yes! External and internal. Who initiated the sex?")]), _vm._v(" "), _c('p', [_vm._v("3:32 P.M. Sarah: I woke up with him behind me so did a little wiggle. Not sure who “started” that.")]), _vm._v(" "), _c('p', [_vm._v("3:38 P.M. Rick: Lol. A spoon fuck")]), _vm._v(" "), _c('p', [_vm._v("3:39 P.M. Sarah: Technically turns into a spork fuck")]), _vm._v(" "), _c('p', [_vm._v("3:40 P.M. Sarah: Twice actually this morning – one spork, one he initiated")]), _vm._v(" "), _c('p', [_vm._v("3:44 P.M. Rick: Did you have to use your mouth? x")]), _vm._v(" "), _c('p', [_vm._v("3:44 P.M. Sarah: I didn’t have to, but I did do that. Need practice.")]), _vm._v(" "), _c('p', [_vm._v("3:45 P.M. Rick: Lol. On your knees or between his legs?")]), _vm._v(" "), _c('p', [_vm._v("3:46 P.M. Sarah: Between his legs. I never want to be on my knees doing that. It feels demeaning. I don’t have a problem with generally being on my knees (as in hands and..).")]), _vm._v(" "), _c('p', [_vm._v("3:48 P.M. Rick: I will have you on your knees with my fingers in your hair")]), _vm._v(" "), _c('p', [_vm._v("3:50 P.M. Sarah: I’m getting over a lot of sexual insecurities so maybe one day. I need to see more of you before that happens xxx")]), _vm._v(" "), _c('p', [_vm._v("3:51 P.M. Rick: Is that what ex had you do?")]), _vm._v(" "), _c('p', [_vm._v("3:51 P.M. Sarah: He wasn’t demanding in that way but was demanding of sex in general regardless of my inclination. Anyway, it just feels demeaning, humiliating somehow.")]), _vm._v(" "), _c('p', [_vm._v("3:52 P.M. Rick: Tell me why – would he fuck your throat hard?")]), _vm._v(" "), _c('p', [_vm._v("3:54 P.M. Sarah: No, no, really nothing like that. It wouldn’t have occurred to him to “fuck my throat” at all. It was just feeling used and powerless.")]), _vm._v(" "), _c('p', [_vm._v("3:55 P.M. Rick: Did he pull out and cum over your face?")]), _vm._v(" "), _c('p', [_vm._v("3:55 P.M. Sarah: No, that would never have occurred to him either. If I was giving oral I would always stop and finish by hand at the last moment.")]), _vm._v(" "), _c('p', [_vm._v("3:55 P.M. Rick: Make you show him before telling you to swallow?")]), _vm._v(" "), _c('p', [_vm._v("3:56 P.M. Sarah: Stop that")]), _vm._v(" "), _c('p', [_vm._v("3:56 P.M. Rick: I will have you do that lover")]), _vm._v(" "), _c('p', [_vm._v("4:03 P.M. Rick: Did I scare you away lover?")]), _vm._v(" "), _c('p', [_vm._v("4:03 P.M. Sarah: You did")]), _vm._v(" "), _c('p', [_vm._v("4:04 P.M. Rick: Tell me why")]), _vm._v(" "), _c('p', [_vm._v("4:06 P.M. Sarah: I think maybe the thought that you want to control me in that way scares me")]), _vm._v(" "), _c('p', [_vm._v("4:08 P.M. Rick: The same way your ex controlled you?")]), _vm._v(" "), _c('p', [_vm._v("4:09 P.M. Sarah: Partly your desire to control, yes, but it’s very different to how ex controlled me")]), _vm._v(" "), _c('p', [_vm._v("4:10 P.M. Rick: And?")]), _vm._v(" "), _c('p', [_vm._v("4:10 P.M. Sarah: It’s taken me a while to get to where I am, believe it or not. I don’t really understand how I feel, and I don’t want to disappoint. Maybe I already am?")]), _vm._v(" "), _c('p', [_vm._v("4:16 P.M. Rick: How would you disappoint? It’s all about knowing yourself.")]), _vm._v(" "), _c('p', [_vm._v("4:16 P.M. Sarah: Well if I just can’t do what you want, you’ll be disappointed!")]), _vm._v(" "), _c('p', [_vm._v("4:17 P.M. Rick: You please me in other ways")]), _vm._v(" "), _c('p', [_vm._v("4:18 P.M. Sarah: Do I?")]), _vm._v(" "), _c('p', [_vm._v("4:18 P.M. Rick: Yes lover")]), _vm._v(" "), _c('p', [_vm._v("4:19 P.M. Sarah: Thank you. Pleased to hear it. I’m being very honest with you x")]), _vm._v(" "), _c('p', [_vm._v("4:21 P.M. Rick: That’s good lover. How wet are you? x")]), _vm._v(" "), _c('p', [_vm._v("4:22 P.M. Sarah: Always ready babe. Despite the challenges you pose, I really love talking to you x")]), _vm._v(" "), _c('p', [_vm._v("4:23 P.M. Rick: Did he cum inside you lover? x")]), _vm._v(" "), _c('p', [_vm._v("4:23 P.M. Sarah: Yes, both times")]), _vm._v(" "), _c('p', [_vm._v("4:24 P.M. Rick: Did you enjoy that?")]), _vm._v(" "), _c('p', [_vm._v("4:24 P.M. Sarah: I do enjoy that")]), _vm._v(" "), _c('p', [_vm._v("4:25 P.M. Rick: Did you clean his cock with your mouth?")]), _vm._v(" "), _c('p', [_vm._v("4:26 P.M. Sarah: I did, yes")]), _vm._v(" "), _c('p', [_vm._v("4:26 P.M. Rick: To taste his and your juices")]), _vm._v(" "), _c('p', [_vm._v("4:27 P.M. Sarah: I hadn’t thought about it like that, but yes")]), _vm._v(" "), _c('p', [_vm._v("4:28 P.M. Rick: Did he tongue fuck you babe?")]), _vm._v(" "), _c('p', [_vm._v("4:28 P.M. Sarah: No. I wish he had!")]), _vm._v(" "), _c('p', [_vm._v("4:29 P.M. Rick: You should have sat on his face")]), _vm._v(" "), _c('p', [_vm._v("4:29 P.M. Sarah: He would have loved that, but it was a bit of a low-key sexual event")]), _vm._v(" "), _c('p', [_vm._v("4:30 P.M. Sarah: Do all men want to have their faces sat on? Seems that way. You’re probably not the right gender to ask!")]), _vm._v(" "), _c('p', [_vm._v("4:30 P.M. Rick: I do enjoy 69")]), _vm._v(" "), _c('p', [_vm._v("4:30 P.M. Sarah: You on top?")]), _vm._v(" "), _c('p', [_vm._v("4:31 P.M. Rick: Any position. If I am on top in 69 it means I deep throat fuck because that puts me in control.")]), _vm._v(" "), _c('p', [_vm._v("4:32 P.M. Sarah: You’re always in control")]), _vm._v(" "), _c('p', [_vm._v("4:32 P.M. Rick: That’s true")]), _vm._v(" "), _c('p', [_vm._v("4:33 P.M. Sarah: Not cute at all I suspect xxx")]), _vm._v(" "), _c('p', [_vm._v("4:35 P.M. Rick: You know that’s the turn on for you x")]), _vm._v(" "), _c('p', [_vm._v("4:35 P.M. Sarah: The unpredictability? Maybe so xxx")]), _vm._v(" "), _c('p', [_vm._v("4:36 P.M. Rick: Did you enjoy our fucking lover? x")]), _vm._v(" "), _c('p', [_vm._v("4:37 P.M. Sarah: Loved it. You know that x")]), _vm._v(" "), _c('p', [_vm._v("4:38 P.M. Rick: How do I? x")]), _vm._v(" "), _c('p', [_vm._v("4:38 P.M. Sarah: I’ve said it before xxx")]), _vm._v(" "), _c('p', [_vm._v("4:39 P.M. Rick: You wanted and needed it")]), _vm._v(" "), _c('p', [_vm._v("4:40 P.M. Sarah: Yes, I did – I’m not planning on having sex with anyone ever again if I don’t want it! I hope you enjoyed it as much as me xxx")]), _vm._v(" "), _c('p', [_vm._v("4:45 P.M. Rick: You know I did x")]), _vm._v(" "), _c('p', [_vm._v("4:47 P.M. Sarah: So we’re potentially on to a winner. I can’t tell you how much I don’t want to go out tonight! I haven’t eaten a single meal from my own kitchen this weekend, other than a piece of toast this morning.")]), _vm._v(" "), _c('p', [_vm._v("5:27 P.M. Sarah: I’m out in a moment, so hope I’ve made you feel better today Cutie Pie xxx")]), _vm._v(" "), _c('p', [_vm._v("5:38 P.M. Rick: Very hot lover xxx")]), _vm._v(" "), _c('p', [_vm._v("9:54 P.M. Rick: Are you being a naughty girl again?")]), _vm._v(" "), _c('p', [_vm._v("10:41 P.M. Rick: Yes, I think you are x")]), _vm._v(" "), _c('p', [_vm._v("10:50 P.M. Rick: Another Tinder meet?")]), _vm._v(" "), _c('p', [_vm._v("11:27 P.M. Rick: You can tell me all about it later x")]), _vm._v(" "), _c('p', [_vm._v("11:29 P.M. Sarah: Not at all! I told you dinner with couple friends. I’m in bed alone now. Thought you might have heard enough from me today! xxx")]), _vm._v(" "), _c('p', [_vm._v("11:31 P.M. Rick: Are you thinking about this morning’s activities?")]), _vm._v(" "), _c('p', [_vm._v("11:35 P.M. Sarah: I’m a little bit sore from being pushed into when I wasn’t quite ready actually")]), _vm._v(" "), _c('p', [_vm._v("11:35 P.M. Rick: Does he have a big cock?")]), _vm._v(" "), _c('p', [_vm._v("11:36 P.M. Sarah: Not especially. You’re bigger, longer.")]), _vm._v(" "), _c('p', [_vm._v("11:36 P.M. Rick: You are kind")]), _vm._v(" "), _c('p', [_vm._v("11:36 P.M. Sarah: Only if size matters!")]), _vm._v(" "), _c('p', [_vm._v("11:37 P.M. Rick: He has more girth?")]), _vm._v(" "), _c('p', [_vm._v("11:38 P.M. Sarah: I need to be reminded first before I comment on that")]), _vm._v(" "), _c('p', [_vm._v("11:39 P.M. Rick: Have you ever fucked a small cock?")]), _vm._v(" "), _c('p', [_vm._v("11:30 P.M. Sarah: No, never")]), _vm._v(" "), _c('p', [_vm._v("11:30 P.M. Rick: What would you have done if I had had a 3\" cock?")]), _vm._v(" "), _c('p', [_vm._v("11:30 P.M. Sarah: I guess I would have just seen what you could do with it!")]), _vm._v(" "), _c('p', [_vm._v("11:31 P.M. Rick: Yeah right … I’ve said before I think you’re a woman who needs to feel full")]), _vm._v(" "), _c('p', [_vm._v("11:31 P.M. Sarah: I like that, but I also like to think I’m moderately openminded!")]), _vm._v(" "), _c('p', [_vm._v("11:33 P.M. Rick: How long did it take you to get wet?")]), _vm._v(" "), _c('p', [_vm._v("11:41 P.M. Sarah: Well twice in a relatively short time frame wasn’t expected so the second time I needed a moment. Not long. My default is wet.")]), _vm._v(" "), _c('p', [_vm._v("11:42 P.M. Rick: That’s what I thought. So why are you sore?")]), _vm._v(" "), _c('p', [_vm._v("11:42 P.M. Sarah: Because he pushed without me being open. Once it’s been shoved too hard against the perineum the damage is done however wet you get!")]), _vm._v(" "), _c('p', [_vm._v("11:43 P.M. Rick: He needed to be deep in you then. Did you struggle or submit, lover? x")]), _vm._v(" "), _c('p', [_vm._v("11:43 P.M. Sarah: Submit, I guided him into me eventually, of course! I’m polite like that.")]), _vm._v(" "), _c('p', [_vm._v("11:44 P.M. Rick: Then you moved on his cock")]), _vm._v(" "), _c('p', [_vm._v("11:44 P.M. Sarah: Of course")]), _vm._v(" "), _c('p', [_vm._v("11:45 P.M. Rick: Does he talk when he fucks you?")]), _vm._v(" "), _c('p', [_vm._v("11:46 P.M. Sarah: Not a lot")]), _vm._v(" "), _c('p', [_vm._v("11:46 P.M. Rick: What does he say?")]), _vm._v(" "), _c('p', [_vm._v("11:46 P.M. Sarah: “Fuck me” and says I’m a “bad girl”. That’s about it.")]), _vm._v(" "), _c('p', [_vm._v("11:47 P.M. Rick: What do you say?")]), _vm._v(" "), _c('p', [_vm._v("11:48 P.M. Sarah: I’m quiet generally. You know that, I think.")]), _vm._v(" "), _c('p', [_vm._v("11:49 P.M. Rick: I think we should fuck you together so you can compare")]), _vm._v(" "), _c('p', [_vm._v("11:50 P.M. Sarah: You can’t be serious! We’ve had this chat, haven’t we?")]), _vm._v(" "), _c('p', [_vm._v("11:51 P.M. Rick: Yes, I am very serious. Are your legs open lover?")]), _vm._v(" "), _c('p', [_vm._v("11:52 P.M. Sarah: Slightly")]), _vm._v(" "), _c('p', [_vm._v("11:53 P.M. Rick: Open them wide as though you are offering yourself to be fucked. You can use your fingers deep x")]), _vm._v(" "), _c('p', [_vm._v("11:55 P.M. Sarah: Not tonight. I’m in recovery.")]), _vm._v(" "), _c('p', [_vm._v("11:55 P.M. Rick: He must have fucked you hard")]), _vm._v(" "), _c('p', [_vm._v("11:56 P.M. Sarah: It’ll only take a day")]), _vm._v(" "), _c('p', [_vm._v("11:57 P.M. Rick: Did he use his fingers in you?")]), _vm._v(" "), _c('p', [_vm._v("11:57 P.M. Sarah: Not really. If he had I would have been ready and avoided this unnecessary waste!")]), _vm._v(" "), _c('p', [_vm._v("11:58 P.M. Rick: Did he have his hand in you?")]), _vm._v(" "), _c('p', [_vm._v("11:58 P.M. Sarah: No. How hard are you?")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "monday-2-july-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Monday, 2 July 2018")]), _vm._v(" "), _c('p', [_vm._v("12:01 A.M. Rick: You know I am fucking hard")]), _vm._v(" "), _c('p', [_vm._v("12:01 A.M. Sarah: I do. I like asking. Makes me feel like a temptress.")]), _vm._v(" "), _c('p', [_vm._v("12:02 A.M. Rick: Thinking about how hard you have me?")]), _vm._v(" "), _c('p', [_vm._v("12:02 A.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("12:02 A.M. Rick: Throbbing and hard babe")]), _vm._v(" "), _c('p', [_vm._v("12:03 A.M. Sarah: Just the way you like it")]), _vm._v(" "), _c('p', [_vm._v("12:03 A.M. Rick: And the way you need it fucking you")]), _vm._v(" "), _c('p', [_vm._v("12:04 A.M. Sarah: I’m looking forward to it")]), _vm._v(" "), _c('p', [_vm._v("12:04 A.M. Rick: I will have you ask me to fuck you – you will as you spread your legs")]), _vm._v(" "), _c('p', [_vm._v("12:06 A.M. Sarah: Delish")]), _vm._v(" "), _c('p', [_vm._v("12:09 A.M. Rick: Who is the better lover between the two?")]), _vm._v(" "), _c('p', [_vm._v("12:10 A.M. Sarah: The unavailable loving one")]), _vm._v(" "), _c('p', [_vm._v("12:10 A.M. Rick: In what way?")]), _vm._v(" "), _c('p', [_vm._v("12:11 A.M. Sarah: He pays attention to me, he goes at my pace, and its nice slow sex")]), _vm._v(" "), _c('p', [_vm._v("12:12 A.M. Rick: You need more than that lover")]), _vm._v(" "), _c('p', [_vm._v("12:12 A.M. Sarah: He makes love 🖤")]), _vm._v(" "), _c('p', [_vm._v("12:13 A.M. Rick: I am right, admit it lover. Did you contact the challenging one?")]), _vm._v(" "), _c('p', [_vm._v("12:14 A.M. Sarah: I do need more, but I had never been made love to before so it is also nice. And no, the challenging one asked me out and when I realised, I wasn’t seeing you Saturday I told him I was free.")]), _vm._v(" "), _c('p', [_vm._v("12:15 A.M. Rick: You wanted him to fuck you?")]), _vm._v(" "), _c('p', [_vm._v("12:16 A.M. Sarah: I wanted you to fuck me, but I’m not just after sex. I wanted to hang out too. I’d explained to him the other night what I didn’t like about him.")]), _vm._v(" "), _c('p', [_vm._v("12:17 A.M. Rick: Did he change?")]), _vm._v(" "), _c('p', [_vm._v("12:17 A.M. Sarah: I think he was shocked and felt bad, so yes, he was nice. He picked me up, paid. I couldn’t fault him in all honesty.")]), _vm._v(" "), _c('p', [_vm._v("12:19 A.M. Rick: Did you play with his cock during the meal?")]), _vm._v(" "), _c('p', [_vm._v("12:20 A.M. Sarah: He finds my friendliness a little overwhelming so no I didn’t even try")]), _vm._v(" "), _c('p', [_vm._v("12:21 A.M. Rick: Lol. I didn’t find that")]), _vm._v(" "), _c('p', [_vm._v("12:21 A.M. Sarah: He’s not used to it, and I suspect he finds me a little too “tactile” – I do crave physical closeness and don’t mind a PDA! And that’s good – I don’t like feeling predatory!")]), _vm._v(" "), _c('p', [_vm._v("12:22 A.M. Rick: Did you strip when you got home?")]), _vm._v(" "), _c('p', [_vm._v("12:22 A.M. Sarah: We had a whiskey in the garden first")]), _vm._v(" "), _c('p', [_vm._v("12:23 A.M. Rick: Naked?")]), _vm._v(" "), _c('p', [_vm._v("12:23 A.M. Sarah: Last thing I needed, and no too cold!")]), _vm._v(" "), _c('p', [_vm._v("12:24 A.M. Rick: Did he strip you?")]), _vm._v(" "), _c('p', [_vm._v("12:24 A.M. Sarah: Yes. I like that.")]), _vm._v(" "), _c('p', [_vm._v("12:25 A.M. Rick: In the lounge?")]), _vm._v(" "), _c('p', [_vm._v("12:25 A.M. Sarah: Bedroom")]), _vm._v(" "), _c('p', [_vm._v("12:25 A.M. Rick: This was in the evening?")]), _vm._v(" "), _c('p', [_vm._v("12:25 A.M. Sarah: Yes, probably around 1 A.M.")]), _vm._v(" "), _c('p', [_vm._v("12:26 A.M. Rick: Did you strip him?")]), _vm._v(" "), _c('p', [_vm._v("12:26 A.M. Sarah: Yes, but not a lot happened after that. We were both too messed up so we had a kiss and cuddle and went to sleep spooning.")]), _vm._v(" "), _c('p', [_vm._v("12:26 A.M. Rick: Suck his cock?")]), _vm._v(" "), _c('p', [_vm._v("12:26 A.M. Sarah: Not then, no")]), _vm._v(" "), _c('p', [_vm._v("12:27 A.M. Rick: Did you want to be fucked?")]), _vm._v(" "), _c('p', [_vm._v("12:28 A.M. Sarah: Not really")]), _vm._v(" "), _c('p', [_vm._v("12:28 A.M. Rick: Or did you pass out?")]), _vm._v(" "), _c('p', [_vm._v("12:28 A.M. Sarah: No! Was just happy to have a body to be near.")]), _vm._v(" "), _c('p', [_vm._v("12:30 A.M. Rick: How did you fuck the second time?")]), _vm._v(" "), _c('p', [_vm._v("12:32 A.M. Sarah: That’s when I wasn’t ready, and he was on top")]), _vm._v(" "), _c('p', [_vm._v("12:33 A.M. Rick: How can you have been not ready? He had fucked you from behind x")]), _vm._v(" "), _c('p', [_vm._v("12:34 A.M. Sarah: I just wasn’t ready! It was a couple of hours later and I’d been asleep, cum had dried from the first fuck and that always feels sort of dry.")]), _vm._v(" "), _c('p', [_vm._v("12:35 A.M. Rick: Did he put a lot of cum in you?")]), _vm._v(" "), _c('p', [_vm._v("12:35 A.M. Sarah: He’s not hugely prolific")]), _vm._v(" "), _c('p', [_vm._v("12:36 A.M. Rick: Is the loving one a big cummer?")]), _vm._v(" "), _c('p', [_vm._v("12:37 A.M. Sarah: Bigger")]), _vm._v(" "), _c('p', [_vm._v("12:37 A.M. Rick: You like that feeling. Running out of you.")]), _vm._v(" "), _c('p', [_vm._v("12:37 A.M. Sarah: I do. I like it a lot. I never wipe up after sex now.")]), _vm._v(" "), _c('p', [_vm._v("12:39 A.M. Rick: Imagine if we both stood over you and covered you")]), _vm._v(" "), _c('p', [_vm._v("12:39 A.M. Sarah: I want it inside")]), _vm._v(" "), _c('p', [_vm._v("12:39 A.M. Rick: Both filled you")]), _vm._v(" "), _c('p', [_vm._v("12:41 A.M. Sarah: You know I’d be so intimidated by two men")]), _vm._v(" "), _c('p', [_vm._v("12:41 A.M. Rick: What about one load in your pussy and the other in your arse?")]), _vm._v(" "), _c('p', [_vm._v("12:41 A.M. Sarah: I’d run away and leave you to entertain yourselves. Now you’re just messing with me. Where’s the cute one? I want happy dreams not nightmares.")]), _vm._v(" "), _c('p', [_vm._v("12:43 A.M. Rick: Have you heard from the challenging one?")]), _vm._v(" "), _c('p', [_vm._v("12:44 A.M. Sarah: After this morning? I texted him thanks, so a brief chat. He will have spent the day in bed.")]), _vm._v(" "), _c('p', [_vm._v("12:45 A.M. Rick: Does he want you again?")]), _vm._v(" "), _c('p', [_vm._v("12:45 A.M. Sarah: I’m sure. He’s very attracted to me, and I do like hanging out with him.")]), _vm._v(" "), _c('p', [_vm._v("12:45 A.M. Rick: Will you be fucking them both this week?")]), _vm._v(" "), _c('p', [_vm._v("12:46 A.M. Sarah: I don’t plan in advance. Would like a turn with you.")]), _vm._v(" "), _c('p', [_vm._v("12:47 A.M. Rick: We should all fuck you this week. Would you like that?")]), _vm._v(" "), _c('p', [_vm._v("12:47 A.M. Sarah: I don’t have a target! I’m an opportunist.")]), _vm._v(" "), _c('p', [_vm._v("12:48 A.M. Rick: You want me between your legs")]), _vm._v(" "), _c('p', [_vm._v("12:48 A.M. Sarah: I definitely do")]), _vm._v(" "), _c('p', [_vm._v("12:49 A.M. Rick: You know it will be hard and demanding babe. Do you want that?")]), _vm._v(" "), _c('p', [_vm._v("12:50 A.M. Sarah: Will it be like last time?")]), _vm._v(" "), _c('p', [_vm._v("12:50 A.M. Rick: Yes, it will, and harder")]), _vm._v(" "), _c('p', [_vm._v("12:50 A.M. Sarah: Then bring it on. Say something nice – we should sleep xxx")]), _vm._v(" "), _c('p', [_vm._v("12:51 A.M. Rick: You will cum on my mouth and cock")]), _vm._v(" "), _c('p', [_vm._v("12:51 A.M. Sarah: Not what I expected but I hope so")]), _vm._v(" "), _c('p', [_vm._v("12:52 A.M. Rick: Did you cum today?")]), _vm._v(" "), _c('p', [_vm._v("12:52 A.M. Sarah: No")]), _vm._v(" "), _c('p', [_vm._v("12:52 A.M. Rick: With the good guy?")]), _vm._v(" "), _c('p', [_vm._v("12:52 A.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("12:52 A.M. Rick: On his cock?")]), _vm._v(" "), _c('p', [_vm._v("12:53 A.M. Sarah: No. Fingers.")]), _vm._v(" "), _c('p', [_vm._v("12:53 A.M. Rick: Deep?")]), _vm._v(" "), _c('p', [_vm._v("12:53 A.M. Sarah: Both. Inside and outside.")]), _vm._v(" "), _c('p', [_vm._v("12:54 A.M. Rick: How deep?")]), _vm._v(" "), _c('p', [_vm._v("12:54 A.M. Sarah: I need to sleep babe. Say something to send me there x")]), _vm._v(" "), _c('p', [_vm._v("12:55 A.M. Rick: You will play all you want on my cock, lover xxx")]), _vm._v(" "), _c('p', [_vm._v("12:56 A.M. Sarah: Good night sweetheart 💋")]), _vm._v(" "), _c('p', [_vm._v("12:57 A.M. Rick: Sweet dreams xxx")]), _vm._v(" "), _c('p', [_vm._v("10:07 A.M. Sarah: Good morning Rick. How’s the cough? Still keeping you up all night, or is that just me? xxx")]), _vm._v(" "), _c('p', [_vm._v("10:53 A.M. Rick: Good morning Sweet Cheeks. It’s so annoying, clear and then a coughing fit that makes you light headed. How did you zzz? xxx")]), _vm._v(" "), _c('p', [_vm._v("10:55 A.M. Sarah: Very frustrating I’m sure. Are you sure you don’t need a doctor? I slept ok, got up early for a walk/talk with the London office xxx")]), _vm._v(" "), _c('p', [_vm._v("10:55 A.M. Rick: Body heal thyself!!! The London office being the child? x")]), _vm._v(" "), _c('p', [_vm._v("10:56 A.M. Sarah: I know you say that, but you’ve been unwell quite a while? Just asking out of self-interest. And yes, the child. She starts a new job tomorrow so is excited/terrified about that.")]), _vm._v(" "), _c('p', [_vm._v("11:39 A.M. Rick: How do you feel about it?")]), _vm._v(" "), _c('p', [_vm._v("11:40 A.M. Sarah: I have faith in both my kids in the workplace. She’s amazing – great work ethic, personable, charming, super smart.")]), _vm._v(" "), _c('p', [_vm._v("11:49 A.M. Rick: She does seem grounded")]), _vm._v(" "), _c('p', [_vm._v("11:50 A.M. Sarah: Her major problem is she tries too hard which causes her anxiety. She’ll learn she has the power as she gets older. I’m such a great cheerleader for her – I never had that myself growing up!")]), _vm._v(" "), _c('p', [_vm._v("12:02 P.M. Rick: You have the power now lover")]), _vm._v(" "), _c('p', [_vm._v("12:02 P.M. Sarah: And what power do I have? Not feeling particularly powerful just now.")]), _vm._v(" "), _c('p', [_vm._v("2:24 P.M. Rick: The power of sex")]), _vm._v(" "), _c('p', [_vm._v("2:24 P.M. Sarah: That’s not real power")]), _vm._v(" "), _c('p', [_vm._v("2:24 P.M. Rick: Oh really! I would have to disagree babe")]), _vm._v(" "), _c('p', [_vm._v("9:41 P.M. Sarah: Hello again sweetheart xxx")]), _vm._v(" "), _c('p', [_vm._v("10:50 P.M. Rick: Hello lover. Two webinars tonight xxx")]), _vm._v(" "), _c('p', [_vm._v("11:03 P.M. Sarah: Oh boring. Hope the webinars are not on honing your interrogation techniques xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "tuesday-3-july-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Tuesday, 3 July 2018")]), _vm._v(" "), _c('p', [_vm._v("7:32 A.M. Rick: Good morning babe. Do you feel they need to be honed??? xxx")]), _vm._v(" "), _c('p', [_vm._v("7:56 A.M. Sarah: Good morning to you too sweetheart. And that’s a definite NO!!! xxx")]), _vm._v(" "), _c('p', [_vm._v("8:58 A.M. Rick: I can always fuck the answers out of you xxx")]), _vm._v(" "), _c('p', [_vm._v("8:59 A.M. Sarah: You can certainly try that method see how it works xxx")]), _vm._v(" "), _c('p', [_vm._v("9:38 A.M. Rick: Between the moans x")]), _vm._v(" "), _c('p', [_vm._v("9:54 A.M. Sarah: The child’s first day went spectacularly so everyone’s happy")]), _vm._v(" "), _c('p', [_vm._v("10:07 A.M. Rick: That’s excellent, now you can stop worrying")]), _vm._v(" "), _c('p', [_vm._v("10:07 A.M. Sarah: I wasn’t worrying")]), _vm._v(" "), _c('p', [_vm._v("10:08 A.M. Rick: Yeah right")]), _vm._v(" "), _c('p', [_vm._v("10:08 A.M. Sarah: Haha I have faith. I told you that yesterday")]), _vm._v(" "), _c('p', [_vm._v("10:15 A.M. Sarah: And, how are you?")]), _vm._v(" "), _c('p', [_vm._v("10:16 A.M. Rick: Wheezing but getting stronger by the minute")]), _vm._v(" "), _c('p', [_vm._v("10:16 A.M. Sarah: Good man x")]), _vm._v(" "), _c('p', [_vm._v("10:17 A.M. Rick: Meeting the loving one today? x")]), _vm._v(" "), _c('p', [_vm._v("10:17 A.M. Sarah: No plans to see anyone")]), _vm._v(" "), _c('p', [_vm._v("10:18 A.M. Rick: And how is the Tinder action?")]), _vm._v(" "), _c('p', [_vm._v("10:19 A.M. Sarah: I turned myself off again before I went away. So, none.")]), _vm._v(" "), _c('p', [_vm._v("10:19 A.M. Sarah: And for you?")]), _vm._v(" "), _c('p', [_vm._v("10:20 A.M. Rick: Not really invested in it. I could have had a great time in Melbourne!")]), _vm._v(" "), _c('p', [_vm._v("10:20 A.M. Sarah: Hmm is that so – how do you know?")]), _vm._v(" "), _c('p', [_vm._v("10:21 A.M. Rick: All the interest 😮")]), _vm._v(" "), _c('p', [_vm._v("10:21 A.M. Sarah: On Tinder, or just women you knew already in Melbourne? I’m not at all invested in it. It’s useful on occasion, but that’s all.")]), _vm._v(" "), _c('p', [_vm._v("10:21 A.M. Rick: Yes, Tinder")]), _vm._v(" "), _c('p', [_vm._v("10:23 A.M. Sarah: You get a lot of interest usually? Do you turn your profile off ever? Or always on the prowl?")]), _vm._v(" "), _c('p', [_vm._v("10:29 A.M. Rick: You know I am a lone wolf")]), _vm._v(" "), _c('p', [_vm._v("10:31 A.M. Sarah: I only ask because I can’t work out the strategy. I don’t like to think of men looking at my profile if I’m not looking for them. Probably a flawed plan.")]), _vm._v(" "), _c('p', [_vm._v("10:57 A.M. Rick: You know how it works woman! One has to like the other before a match is generated.")]), _vm._v(" "), _c('p', [_vm._v("10:58 A.M. Sarah: I got that far. Just when my dance card is full, I turn my profile off. Good/bad strategy? Who knows?")]), _vm._v(" "), _c('p', [_vm._v("10:59 A.M. Rick: Never do that!!!")]), _vm._v(" "), _c('p', [_vm._v("10:59 A.M. Sarah: Why? Don’t I have to be actively engaged with the app for anything to work? I actually want to know. I’m a comparative novice and can hardly ask the kids.")]), _vm._v(" "), _c('p', [_vm._v("11:35 A.M. Rick: Well not your son!")]), _vm._v(" "), _c('p', [_vm._v("11:36 A.M. Sarah: I just want to know why I shouldn’t turn myself off. And better my son than my daughter I suspect.")]), _vm._v(" "), _c('p', [_vm._v("11:37 A.M. Rick: You don’t have to. If you don’t like anyone it’s not going to match you.")]), _vm._v(" "), _c('p', [_vm._v("11:38 A.M. Sarah: I know, but all those men will be liking me and I’m not responding! but ok I’ll turn it on. I still don’t see what the point is xxx")]), _vm._v(" "), _c('p', [_vm._v("11:48 A.M. Rick: It’s always good to see who is out there")]), _vm._v(" "), _c('p', [_vm._v("11:48 A.M. Sarah: Yes, I agree, but when I go on, I get sucked into the vortex. Look what happened last time!")]), _vm._v(" "), _c('p', [_vm._v("11:49 A.M. Rick: What happened!!!")]), _vm._v(" "), _c('p', [_vm._v("11:49 A.M. Sarah: You did")]), _vm._v(" "), _c('p', [_vm._v("11:50 A.M. Rick: You say that like a bad thing!")]), _vm._v(" "), _c('p', [_vm._v("11:50 A.M. Sarah: It’s a great thing")]), _vm._v(" "), _c('p', [_vm._v("1:58 P.M. Rick: Do you like to dress like a loose woman?")]), _vm._v(" "), _c('p', [_vm._v("1:59 P.M. Sarah: My style is a little edgy, not a loose woman, just not a tight one! And in this season, my standard is well fitting jeans or pants like I wore the first time I met you. Will have to rethink.")]), _vm._v(" "), _c('p', [_vm._v("2:05 P.M. Rick: When did you start being so sexual?")]), _vm._v(" "), _c('p', [_vm._v("2:08 P.M. Sarah: Well that’s an essay … I’ve always felt a gap between desire and reality, but I’d say probably 2 years ago I started to understand I wasn’t getting anywhere near what I needed. Looking into the future with ex it was clear nothing was going to change, and any attraction to him had died long before.")]), _vm._v(" "), _c('p', [_vm._v("I started very critically analysing what I was getting – not just sexually, but in every way. So, sex/intimacy failings were an important factor in my decision to exit that relationship. To clarify, I say sex/intimacy because I don’t see myself only as a sex toy – I hope you don’t only see me that way either.")]), _vm._v(" "), _c('p', [_vm._v("2:13 P.M. Rick: Mmm. Well. Lol 😱")]), _vm._v(" "), _c('p', [_vm._v("2:14 P.M. Sarah: Wow – seriously? I don’t believe it. I have no expectations of you but after all this talking it’s really not possible for you to think of me as just a sex toy.")]), _vm._v(" "), _c('p', [_vm._v("3:53 P.M. Rick: I will say I want to ravish you again x")]), _vm._v(" "), _c('p', [_vm._v("3:54 P.M. Sarah: Marginally better. I want that too xxx")]), _vm._v(" "), _c('p', [_vm._v("3:59 P.M. Rick: Even as a sex toy? 😮")]), _vm._v(" "), _c('p', [_vm._v("4:00 P.M. Sarah: I can do sex toy, but I like talking to you too")]), _vm._v(" "), _c('p', [_vm._v("4:01 P.M. Rick: We do have a good conversational relationship")]), _vm._v(" "), _c('p', [_vm._v("4:02 P.M. Sarah: There’s not many people I have shared so much with on sensitive matters. Must be slightly more than a sex toy. A chat toy.")]), _vm._v(" "), _c('p', [_vm._v("4:10 P.M. Rick: A chat sex bot x")]), _vm._v(" "), _c('p', [_vm._v("4:11 P.M. Sarah: Hilarious. That’s what I was aiming for. Batteries to be inserted.")]), _vm._v(" "), _c('p', [_vm._v("4:18 P.M. Rick: Lol. Well I don’t know about batteries x")]), _vm._v(" "), _c('p', [_vm._v("4:46 P.M. Sarah: Are you fully recovered?")]), _vm._v(" "), _c('p', [_vm._v("4:48 P.M. Rick: Feeling a lot better")]), _vm._v(" "), _c('p', [_vm._v("4:50 P.M. Sarah: Fantastic. Been a long time! Hopefully this will be the end of it then and you can get back to fucking your way through Tinder.")]), _vm._v(" "), _c('p', [_vm._v("5:01 P.M. Rick: You know I am not that type")]), _vm._v(" "), _c('p', [_vm._v("5:02 P.M. Sarah: I do babe. My apologies x")]), _vm._v(" "), _c('p', [_vm._v("5:11 P.M. Rick: On the other hand, you can xxx")]), _vm._v(" "), _c('p', [_vm._v("5:12 P.M. Sarah: Fuck my way through Tinder? Not my style either xxx")]), _vm._v(" "), _c('p', [_vm._v("5:14 P.M. Rick: You have your three lovers!")]), _vm._v(" "), _c('p', [_vm._v("5:16 P.M. Sarah: I know. It’s weird. Tinder is a tool to assist in my education x")]), _vm._v(" "), _c('p', [_vm._v("5:19 P.M. Rick: It does turn you on")]), _vm._v(" "), _c('p', [_vm._v("5:19 P.M. Sarah: Are you referring to my loose morals?")]), _vm._v(" "), _c('p', [_vm._v("5:20 P.M. Rick: Yes lover")]), _vm._v(" "), _c('p', [_vm._v("5:20 P.M. Sarah: It’s novel and a bit exciting. I doubt I can sustain it for long so enjoy while it lasts!")]), _vm._v(" "), _c('p', [_vm._v("5:24 P.M. Rick: The new you")]), _vm._v(" "), _c('p', [_vm._v("5:25 P.M. Sarah: Lol talk later x")]), _vm._v(" "), _c('p', [_vm._v("9:35 P.M. Sarah: Chat sex bot ready to continue when you are. Home from dinner with an old friend xxx")]), _vm._v(" "), _c('p', [_vm._v("9:38 P.M. Rick: Did you have a good time with your mate? xxx")]), _vm._v(" "), _c('p', [_vm._v("9:39 P.M. Sarah: Yes. She’s lovely. Just exiting a relationship, herself.")]), _vm._v(" "), _c('p', [_vm._v("9:40 P.M. Rick: Does she want to join us? Did you tell her how sexually liberated you have become?")]), _vm._v(" "), _c('p', [_vm._v("9:40 P.M. Sarah: No, she doesn’t, and yes, I told her all the horrors! She’s been in my position before so it’s helpful to talk to her. It makes me feel better about it!")]), _vm._v(" "), _c('p', [_vm._v("9:42 P.M. Rick: Multiple lovers?")]), _vm._v(" "), _c('p', [_vm._v("9:42 P.M. Sarah: I’m not sure about multiples, but quite a few sexual partners along the way.")]), _vm._v(" "), _c('p', [_vm._v("9:43 P.M. Sarah: Do you know my worst fear?")]), _vm._v(" "), _c('p', [_vm._v("9:44 P.M. Rick: Tell me lover")]), _vm._v(" "), _c('p', [_vm._v("9:46 P.M. Sarah: Falling into another relationship where I’m not actively choosing. All my life I’ve gone with whoever stepped up next, so I need this time to clear the head. I know I’ve said this before, but this is my first time single since I was basically a child.")]), _vm._v(" "), _c('p', [_vm._v("9:47 P.M. Rick: I can understand that lover. You have to remember you are in control, and this education will be teaching you that xxx")]), _vm._v(" "), _c('p', [_vm._v("9:48 P.M. Sarah: That’s also not familiar. But I’m trying, and that’s at the root of my comment earlier. I want sex but also humanity, which I’m now getting xxx")]), _vm._v(" "), _c('p', [_vm._v("9:52 P.M. Rick: Have you heard from the others?")]), _vm._v(" "), _c('p', [_vm._v("9:53 P.M. Sarah: I have an ongoing chat with the loving one and wouldn’t expect to hear from the challenging one for a week or so. No plans to see either. Do you want to see me? I’m busy tomorrow night but free otherwise x")]), _vm._v(" "), _c('p', [_vm._v("9:56 P.M. Rick: We should meet for coffee and a chat lover xxx")]), _vm._v(" "), _c('p', [_vm._v("9:57 P.M. Sarah: I would like that. When?")]), _vm._v(" "), _c('p', [_vm._v("10:05 P.M. Rick: Let me look at my dairy. Do you want to ride me babe?")]), _vm._v(" "), _c('p', [_vm._v("10:06 P.M. Sarah: Of course. But coffee is also good.")]), _vm._v(" "), _c('p', [_vm._v("10:07 P.M. Rick: I would like to feel you move under me")]), _vm._v(" "), _c('p', [_vm._v("10:08 P.M. Sarah: I’d like that too")]), _vm._v(" "), _c('p', [_vm._v("10:08 P.M. Rick: You know it will be hard and demanding. Is that what you need lover?")]), _vm._v(" "), _c('p', [_vm._v("10:11 P.M. Sarah: If it’s like last time I’m up for it. You know that.")]), _vm._v(" "), _c('p', [_vm._v("10:12 P.M. Rick: Oh of course I do lover. It will be like that and more.")]), _vm._v(" "), _c('p', [_vm._v("10:13 P.M. Sarah: I’m keen x")]), _vm._v(" "), _c('p', [_vm._v("10:14 P.M. Rick: You must be horny xxx")]), _vm._v(" "), _c('p', [_vm._v("10:15 P.M. Sarah: Why? You’re planning good things for me I’m sure x")]), _vm._v(" "), _c('p', [_vm._v("10:16 P.M. Rick: What would you like babe?")]), _vm._v(" "), _c('p', [_vm._v("10:17 P.M. Sarah: Haha I have no idea what I would like. I’m still developing my own preferences. But I enjoyed last time. A lot.")]), _vm._v(" "), _c('p', [_vm._v("10:18 P.M. Rick: As did I. So, every way possible then. Nothing is off the table xxx")]), _vm._v(" "), _c('p', [_vm._v("10:20 P.M. Sarah: Back to my table then! x")]), _vm._v(" "), _c('p', [_vm._v("10:20 P.M. Rick: Funny girl! Did you tell the loving one you fucked the challenging one?")]), _vm._v(" "), _c('p', [_vm._v("10:22 P.M. Sarah: No. A few months ago the nice one cooled off and I didn’t see him for quite a while. I now know he was trying to sort out his head and thought not seeing me would help him. I had unfortunately attached to him by then, as is my normal pattern, so to extract myself I realised I needed to see other men. He knows he’s not alone in my bed because his own behaviour created distance. He claims not to care now, but I don’t believe him. I need it to be this way or I can’t carry on with him. I’m not ready for a relationship with anyone.")]), _vm._v(" "), _c('p', [_vm._v("10:23 P.M. Rick: Did you tell the challenging one about me?")]), _vm._v(" "), _c('p', [_vm._v("10:23 P.M. Sarah: Not specifically but he also knows he’s not alone. Not particularly relevant with him – he’s definitely headed to the friend zone. You’re the only person I’ve met who wants details of the others. I’d tell if they asked.")]), _vm._v(" "), _c('p', [_vm._v("10:25 P.M. Rick: Oh, I know you would, it also turns you on doesn’t it, lover?")]), _vm._v(" "), _c('p', [_vm._v("10:26 P.M. Sarah: I admit that. But I never want to hurt anyone so will be honest but not go into detail until I’m asked.")]), _vm._v(" "), _c('p', [_vm._v("10:27 P.M. Rick: I was initially worried that you thought it too kinky")]), _vm._v(" "), _c('p', [_vm._v("10:27 P.M. Sarah: I did. It’s definitely new to me but I’m oddly ok with it. You’re like having a best friend I can tell things to, but also a sex buddy.")]), _vm._v(" "), _c('p', [_vm._v("10:30 P.M. Rick: You know I will ask you questions as I move in you")]), _vm._v(" "), _c('p', [_vm._v("10:31 P.M. Sarah: I have no doubt. Those webinars.")]), _vm._v(" "), _c('p', [_vm._v("10:32 P.M. Rick: Lol. Do you think you will be able to answer as I pound in you?")]), _vm._v(" "), _c('p', [_vm._v("10:33 P.M. Sarah: Try me")]), _vm._v(" "), _c('p', [_vm._v("10:33 P.M. Rick: Oh, I will babe")]), _vm._v(" "), _c('p', [_vm._v("10:34 P.M. Rick: Have you cum thinking of our sex?")]), _vm._v(" "), _c('p', [_vm._v("10:34 P.M. Sarah: Yes, several times. Have you?")]), _vm._v(" "), _c('p', [_vm._v("10:35 P.M. Rick: Yes babe. Does that turn you on?")]), _vm._v(" "), _c('p', [_vm._v("10:35 P.M. Sarah: Yes of course")]), _vm._v(" "), _c('p', [_vm._v("10:36 P.M. Rick: Are you still only using your fingers")]), _vm._v(" "), _c('p', [_vm._v("10:36 P.M. Sarah: I have a little vibe, but fingers are good too")]), _vm._v(" "), _c('p', [_vm._v("10:37 P.M. Rick: Good girl! Deep?")]), _vm._v(" "), _c('p', [_vm._v("10:37 P.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("10:37 P.M. Rick: All the way in?")]), _vm._v(" "), _c('p', [_vm._v("10:38 P.M. Sarah: As far as I can reach")]), _vm._v(" "), _c('p', [_vm._v("10:38 P.M. Rick: Two fingers?")]), _vm._v(" "), _c('p', [_vm._v("10:38 P.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("10:39 P.M. Rick: Do you fuck your hips against them?")]), _vm._v(" "), _c('p', [_vm._v("10:39 P.M. Sarah: I do")]), _vm._v(" "), _c('p', [_vm._v("10:40 P.M. Rick: I will introduce you to fucking other objects")]), _vm._v(" "), _c('p', [_vm._v("10:41 P.M. Sarah: One day you might")]), _vm._v(" "), _c('p', [_vm._v("10:41 P.M. Rick: Sooner than you think")]), _vm._v(" "), _c('p', [_vm._v("10:41 P.M. Sarah: Oh?")]), _vm._v(" "), _c('p', [_vm._v("10:42 P.M. Rick: Tell me what you think about as you use your fingers deep")]), _vm._v(" "), _c('p', [_vm._v("10:43 P.M. Sarah: Your cock")]), _vm._v(" "), _c('p', [_vm._v("10:48 P.M. Rick: Did you think of me as you fucked the others?")]), _vm._v(" "), _c('p', [_vm._v("10:48 P.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("10:49 P.M. Rick: Tell me about what you thought.")]), _vm._v(" "), _c('p', [_vm._v("10:51 P.M. Sarah: When I’m in the moment, I’m in the moment, but there were a lot of things we did I really liked – before, during and after. I’ve never been with someone quite like you.")]), _vm._v(" "), _c('p', [_vm._v("10:51 P.M. Rick: Did you want me there to watch you?")]), _vm._v(" "), _c('p', [_vm._v("10:52 P.M. Sarah: I didn’t think that, but I was happy to talk to you about it afterwards. I might get to that in future, but not yet.")]), _vm._v(" "), _c('p', [_vm._v("10:53 P.M. Rick: What things did you like?")]), _vm._v(" "), _c('p', [_vm._v("10:55 P.M. Sarah: I like my body being pulled around and positioned. I love your kiss, and you getting so deep inside me. Lying afterwards, being close. All sorts of things. What did you like?")]), _vm._v(" "), _c('p', [_vm._v("10:57 P.M. Rick: Exactly the things you described. Having you in any and every way. Watching the effect my cock has on you, watching your face as I move hard and deep.")]), _vm._v(" "), _c('p', [_vm._v("10:58 P.M. Sarah: Good feedback I hope!!!")]), _vm._v(" "), _c('p', [_vm._v("10:59 P.M. Rick: Oh yes. Very good. Watching you gasp as I moved.")]), _vm._v(" "), _c('p', [_vm._v("10:59 P.M. Sarah: It hurt, but in a good way. Very intense.")]), _vm._v(" "), _c('p', [_vm._v("11:00 P.M. Rick: You can tell me to stop any time")]), _vm._v(" "), _c('p', [_vm._v("11:00 P.M. Sarah: I will if I want to, but thanks")]), _vm._v(" "), _c('p', [_vm._v("11:01 P.M. Rick: I know you won’t mmm")]), _vm._v(" "), _c('p', [_vm._v("11:02 P.M. Sarah: Probably not. New sensations x")]), _vm._v(" "), _c('p', [_vm._v("11:02 P.M. Rick: Do you have KY?")]), _vm._v(" "), _c('p', [_vm._v("11:02 P.M. Sarah: No")]), _vm._v(" "), _c('p', [_vm._v("11:04 P.M. Rick: You do know why I asked?")]), _vm._v(" "), _c('p', [_vm._v("11:04 P.M. Sarah: No")]), _vm._v(" "), _c('p', [_vm._v("11:05 P.M. Rick: To use as I fuck your arse")]), _vm._v(" "), _c('p', [_vm._v("11:06 P.M. Sarah: Not sure how I feel about that")]), _vm._v(" "), _c('p', [_vm._v("11:07 P.M. Rick: It won’t be your first time will it?")]), _vm._v(" "), _c('p', [_vm._v("11:07 P.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("11:08 P.M. Rick: Really? I thought you mentioned you had previously.")]), _vm._v(" "), _c('p', [_vm._v("11:08 P.M. Sarah: Dabbled")]), _vm._v(" "), _c('p', [_vm._v("11:08 P.M. Rick: How?")]), _vm._v(" "), _c('p', [_vm._v("11:08 P.M. Sarah: Not all the way, but no philosophical objection")]), _vm._v(" "), _c('p', [_vm._v("11:09 P.M. Rick: So not balls deep. Are your legs open babe?")]), _vm._v(" "), _c('p', [_vm._v("11:10 P.M. Sarah: They will be when I get to bed")]), _vm._v(" "), _c('p', [_vm._v("11:10 P.M. Rick: You know I will take your arse")]), _vm._v(" "), _c('p', [_vm._v("11:12 P.M. Sarah: Slightly scared of that, but yes")]), _vm._v(" "), _c('p', [_vm._v("11:13 P.M. Rick: What did your friend say about your promiscuity?")]), _vm._v(" "), _c('p', [_vm._v("11:13 P.M. Sarah: She laughed and said go for it!")]), _vm._v(" "), _c('p', [_vm._v("11:14 P.M. Rick: Did you tell her how many?")]), _vm._v(" "), _c('p', [_vm._v("11:14 P.M. Sarah: Yes, I did, we had quite a discussion about it")]), _vm._v(" "), _c('p', [_vm._v("11:14 P.M. Rick: Good for you")]), _vm._v(" "), _c('p', [_vm._v("11:14 P.M. Sarah: She’s an old friend")]), _vm._v(" "), _c('p', [_vm._v("11:16 P.M. Rick: Did you know she also had plenty of cock on call?")]), _vm._v(" "), _c('p', [_vm._v("11:17 P.M. Sarah: That was many years ago, and yes, I knew she’d had a few after her last husband. Not more than one lover at a time though.")]), _vm._v(" "), _c('p', [_vm._v("11:18 P.M. Rick: Ask her if she had a 3sum")]), _vm._v(" "), _c('p', [_vm._v("11:18 P.M. Sarah: Pretty sure she hadn’t")]), _vm._v(" "), _c('p', [_vm._v("11:20 P.M. Rick: You are going to experience the sensation")]), _vm._v(" "), _c('p', [_vm._v("11:20 P.M. Sarah: Not for a while yet. I concede it’s possible but in my own time babe.")]), _vm._v(" "), _c('p', [_vm._v("11:22 P.M. Rick: Are your hips moving?")]), _vm._v(" "), _c('p', [_vm._v("11:22 P.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("11:23 P.M. Rick: How wet are you?")]), _vm._v(" "), _c('p', [_vm._v("11:23 P.M. Sarah: I’d like a second opinion")]), _vm._v(" "), _c('p', [_vm._v("11:24 P.M. Rick: It will be more than two fingers that you use to fuck yourself for me lover")]), _vm._v(" "), _c('p', [_vm._v("11:25 P.M. Sarah: I just want a man now")]), _vm._v(" "), _c('p', [_vm._v("11:25 P.M. Rick: You mean a cock?")]), _vm._v(" "), _c('p', [_vm._v("11:25 P.M. Sarah: No, I don’t. I mean a whole man.")]), _vm._v(" "), _c('p', [_vm._v("11:26 P.M. Rick: Any man. You need a new cock experience.")]), _vm._v(" "), _c('p', [_vm._v("11:28 P.M. Sarah: Another one?")]), _vm._v(" "), _c('p', [_vm._v("11:28 P.M. Rick: Yes lover")]), _vm._v(" "), _c('p', [_vm._v("11:28 P.M. Sarah: Why do you say that?")]), _vm._v(" "), _c('p', [_vm._v("11:28 P.M. Rick: Let me pimp you babe")]), _vm._v(" "), _c('p', [_vm._v("11:29 P.M. Sarah: Too far")]), _vm._v(" "), _c('p', [_vm._v("11:30 P.M. Rick: Lol. I am playing with you")]), _vm._v(" "), _c('p', [_vm._v("11:30 P.M. Sarah: No, you’re not")]), _vm._v(" "), _c('p', [_vm._v("11:30 P.M. Rick: Did that shock you?")]), _vm._v(" "), _c('p', [_vm._v("11:30 P.M. Sarah: YES")]), _vm._v(" "), _c('p', [_vm._v("11:30 P.M. Rick: Did you clench?")]), _vm._v(" "), _c('p', [_vm._v("11:31 P.M. Sarah: NO. This is going to cost you.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "wednesday-4-july-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Wednesday, 4 July 2018")]), _vm._v(" "), _c('p', [_vm._v("7:18 A.M. Rick: I need to ravish you first")]), _vm._v(" "), _c('p', [_vm._v("7:18 A.M. Sarah: You do. In my frock.")]), _vm._v(" "), _c('p', [_vm._v("7:20 A.M. Rick: Bend you over the table and lift the frock over your shoulders")]), _vm._v(" "), _c('p', [_vm._v("7:20 A.M. Sarah: Now there’s an image")]), _vm._v(" "), _c('p', [_vm._v("7:22 A.M. Rick: Your legs splayed as my fingers work you. Would I find you wet and willing lover?")]), _vm._v(" "), _c('p', [_vm._v("7:29 A.M. Sarah: You would babe")]), _vm._v(" "), _c('p', [_vm._v("7:39 A.M. Rick: My fingers would play along your lips, feeling your clit get hard x")]), _vm._v(" "), _c('p', [_vm._v("7:40 A.M. Sarah: Bit like you at the moment x")]), _vm._v(" "), _c('p', [_vm._v("7:41 A.M. Rick: You know it lover xxx")]), _vm._v(" "), _c('p', [_vm._v("9:32 A.M. Sarah: I missed my early morning walk today – will have to go out later. Need to keep fit xxx")]), _vm._v(" "), _c('p', [_vm._v("9:49 A.M. Rick: Specially to wrap your legs around my waist and pull me in deeper xxx")]), _vm._v(" "), _c('p', [_vm._v("9:50 A.M. Sarah: They do need to be strong to do that x")]), _vm._v(" "), _c('p', [_vm._v("9:59 A.M. Rick: Or fucking horny xxx")]), _vm._v(" "), _c('p', [_vm._v("10:00 A.M. Sarah: Both works best – I did it last time, didn’t I?")]), _vm._v(" "), _c('p', [_vm._v("10:03 A.M. Rick: You most certainly did lover, held me in deep, feeling me throbbing")]), _vm._v(" "), _c('p', [_vm._v("10:04 A.M. Sarah: I like that babe")]), _vm._v(" "), _c('p', [_vm._v("11:37 A.M. Rick: What don’t you like! xxx")]), _vm._v(" "), _c('p', [_vm._v("11:37 A.M. Sarah: I don’t know yet. I’ll tell you when it happens. Oh yes. Sushi.")]), _vm._v(" "), _c('p', [_vm._v("11:52 A.M. Rick: You don’t like Sushi!!! 😱")]), _vm._v(" "), _c('p', [_vm._v("12:01 P.M. Sarah: You already know about bananas")]), _vm._v(" "), _c('p', [_vm._v("12:06 P.M. Rick: I don’t want you to eat a banana, just fuck it for me. Or a cucumber xxx")]), _vm._v(" "), _c('p', [_vm._v("12:08 P.M. Sarah: You’re incorrigible")]), _vm._v(" "), _c('p', [_vm._v("2:41 P.M. Rick: I would bring one to you xxx")]), _vm._v(" "), _c('p', [_vm._v("2:41 P.M. Sarah: No thanks")]), _vm._v(" "), _c('p', [_vm._v("2:42 P.M. Rick: Lol. Scaredy-cat")]), _vm._v(" "), _c('p', [_vm._v("2:43 P.M. Sarah: You got me! Definitely scaredy-cat. Are you sure you’re a wolf? I’m thinking I’ve got a tiger by the tail.")]), _vm._v(" "), _c('p', [_vm._v("2:51 P.M. Rick: Have you orgasmed today?")]), _vm._v(" "), _c('p', [_vm._v("2:51 P.M. Sarah: No actually")]), _vm._v(" "), _c('p', [_vm._v("2:52 P.M. Rick: When is the next cock arranged?")]), _vm._v(" "), _c('p', [_vm._v("2:52 P.M. Sarah: I don’t have any plans. I would like it to be you – but I don’t have a date!")]), _vm._v(" "), _c('p', [_vm._v("3:09 P.M. Rick: Will sort out my schedule")]), _vm._v(" "), _c('p', [_vm._v("3:10 P.M. Sarah: Good idea")]), _vm._v(" "), _c('p', [_vm._v("3:11 P.M. Rick: Do you need me inside you?")]), _vm._v(" "), _c('p', [_vm._v("3:11 P.M. Sarah: Let’s just say we need to see each other x")]), _vm._v(" "), _c('p', [_vm._v("3:24 P.M. Rick: So that we can explore x")]), _vm._v(" "), _c('p', [_vm._v("3:26 P.M. Sarah: I need to be reminded x")]), _vm._v(" "), _c('p', [_vm._v("3:26 P.M. Rick: Over and over babe – you know when I start there is no stopping")]), _vm._v(" "), _c('p', [_vm._v("3:27 P.M. Sarah: I seem to recall something like that. Are you suggesting I might not want to see you? x")]), _vm._v(" "), _c('p', [_vm._v("3:47 P.M. Rick: Oh, I know you do babe xxx")]), _vm._v(" "), _c('p', [_vm._v("4:33 P.M. Sarah: x")]), _vm._v(" "), _c('p', [_vm._v("4:41 P.M. Rick: Do I keep you entertained, lover? xxx")]), _vm._v(" "), _c('p', [_vm._v("4:42 P.M. Sarah: You do actually. Do I keep you entertained?")]), _vm._v(" "), _c('p', [_vm._v("4:43 P.M. Rick: Very much so xxx")]), _vm._v(" "), _c('p', [_vm._v("4:43 P.M. Sarah: Can’t take sex toys to work, but I seem to come to work with you anyway x")]), _vm._v(" "), _c('p', [_vm._v("4:45 P.M. Rick: You do have me hard at work")]), _vm._v(" "), _c('p', [_vm._v("4:46 P.M. Sarah: Haha – your pocket assistant x")]), _vm._v(" "), _c('p', [_vm._v("4:49 P.M. Rick: Pocket rocket x")]), _vm._v(" "), _c('p', [_vm._v("4:53 P.M. Sarah: Out to book club in a moment xxx")]), _vm._v(" "), _c('p', [_vm._v("4:54 P.M. Rick: Lots of wine")]), _vm._v(" "), _c('p', [_vm._v("4:55 P.M. Sarah: Not too much. I’m a good girl. I’ve reformed after the weekend.")]), _vm._v(" "), _c('p', [_vm._v("4:57 P.M. Rick: It didn’t stop you fucking")]), _vm._v(" "), _c('p', [_vm._v("4:58 P.M. Sarah: It did on Saturday night!")]), _vm._v(" "), _c('p', [_vm._v("4:58 P.M. Rick: I would have still fucked you babe xxx")]), _vm._v(" "), _c('p', [_vm._v("4:59 P.M. Sarah: It’s not especially fun having sex with a terrible headache but I soldiered on...")]), _vm._v(" "), _c('p', [_vm._v("4:59 P.M. Rick: A trooper")]), _vm._v(" "), _c('p', [_vm._v("4:59 P.M. Sarah: I am! I’m rarely not up for it. Such an obliging girl.")]), _vm._v(" "), _c('p', [_vm._v("5:02 P.M. Rick: Mmm. I remember how obliging.")]), _vm._v(" "), _c('p', [_vm._v("5:03 P.M. Sarah: That’s helpful to know. So funny the people you meet, and such random chance – it’s amazing you stumbled over me.")]), _vm._v(" "), _c('p', [_vm._v("5:04 P.M. Rick: I did a number of things over you")]), _vm._v(" "), _c('p', [_vm._v("5:04 P.M. Sarah: Yes, you did")]), _vm._v(" "), _c('p', [_vm._v("5:06 P.M. Rick: I didn’t slap your arse enough")]), _vm._v(" "), _c('p', [_vm._v("5:06 P.M. Sarah: Lol. Ok actually going now 💋")]), _vm._v(" "), _c('p', [_vm._v("5:07 P.M. Rick: 💋💋")]), _vm._v(" "), _c('p', [_vm._v("10:24 P.M. Rick: Have you passed out babe xxx")]), _vm._v(" "), _c('p', [_vm._v("11:29 A.M. Sarah: No just out. Had fun. Home now xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "thursday-5-july-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Thursday, 5 July 2018")]), _vm._v(" "), _c('p', [_vm._v("8:08 A.M. Rick: Good morning Sarah x")]), _vm._v(" "), _c('p', [_vm._v("8:13 A.M. Sarah: Good morning Rick x")]), _vm._v(" "), _c('p', [_vm._v("8:17 A.M. Rick: Did you get naughty last night?")]), _vm._v(" "), _c('p', [_vm._v("8:34 A.M. Sarah: I’m an opportunist as you know")]), _vm._v(" "), _c('p', [_vm._v("8:36 A.M. Rick: Lol. Who was it babe?")]), _vm._v(" "), _c('p', [_vm._v("8:37 A.M. Sarah: New one")]), _vm._v(" "), _c('p', [_vm._v("8:37 A.M. Rick: Tinder?")]), _vm._v(" "), _c('p', [_vm._v("8:38 A.M. Sarah: Correct. It’s your fault telling me to leave it on!")]), _vm._v(" "), _c('p', [_vm._v("8:40 A.M. Rick: Wine, dine and?")]), _vm._v(" "), _c('p', [_vm._v("8:41 A.M. Sarah: Correct again. He’s a bit young, I think. 44. We didn’t dine, just wine after my book club. Didn’t intend the “and”! My book club ladies thought it was hilarious I was heading out on a date after our meeting.")]), _vm._v(" "), _c('p', [_vm._v("8:44 A.M. Rick: So you spread your legs mmm")]), _vm._v(" "), _c('p', [_vm._v("8:44 A.M. Sarah: So your diary? Saturday?")]), _vm._v(" "), _c('p', [_vm._v("8:45 A.M. Rick: We can meet for coffee babe. Did you fuck in your bed?")]), _vm._v(" "), _c('p', [_vm._v("8:49 A.M. Sarah: Not telling until you give me a time and date")]), _vm._v(" "), _c('p', [_vm._v("8:50 A.M. Rick: Saturday 9:30")]), _vm._v(" "), _c('p', [_vm._v("8:51 A.M. Sarah: Good. No. His.")]), _vm._v(" "), _c('p', [_vm._v("8:51 A.M. Rick: Pity. I would have fucked you on the same sheets")]), _vm._v(" "), _c('p', [_vm._v("8:52 A.M. Sarah: But we’re having coffee. Not fucking. If it’s fucking, I’ll only have an hour with you. Shall we make it Sunday? I’m free all day.")]), _vm._v(" "), _c('p', [_vm._v("8:57 A.M. Rick: No. I just gave you a date and time. Sat. 9:30. Now about last night. So, no book club?")]), _vm._v(" "), _c('p', [_vm._v("9:11 A.M. Sarah: I did have book club first 5-7, then Uber to a bar to meet him, then back to his place, and you know when I got home")]), _vm._v(" "), _c('p', [_vm._v("9:12 A.M. Rick: When did you start chatting?")]), _vm._v(" "), _c('p', [_vm._v("9:13 A.M. Sarah: The night before. We had a very long phone call shortly after we matched.")]), _vm._v(" "), _c('p', [_vm._v("9:14 A.M. Rick: You are a dirty girl. I like that.")]), _vm._v(" "), _c('p', [_vm._v("9:14 A.M. Sarah: From you that’s a huge compliment")]), _vm._v(" "), _c('p', [_vm._v("9:15 A.M. Rick: It is. A long sexual phone call?")]), _vm._v(" "), _c('p', [_vm._v("9:15 A.M. Sarah: Not at all, just getting to know each other and a bit of personal history. Usual thing.")]), _vm._v(" "), _c('p', [_vm._v("9:15 A.M. Rick: I reward initiative. Did he tell you what to wear?")]), _vm._v(" "), _c('p', [_vm._v("9:16 A.M. Sarah: No way. He loved what I wore and how I looked.")]), _vm._v(" "), _c('p', [_vm._v("9:17 A.M. Rick: What did you wear lover?")]), _vm._v(" "), _c('p', [_vm._v("9:18 A.M. Sarah: Dark jeans sexy boots, complicated top")]), _vm._v(" "), _c('p', [_vm._v("9:18 A.M. Rick: Knickers?")]), _vm._v(" "), _c('p', [_vm._v("9:19 A.M. Sarah: Always with jeans for me")]), _vm._v(" "), _c('p', [_vm._v("9:19 A.M. Rick: Lol. Wet spot")]), _vm._v(" "), _c('p', [_vm._v("9:19 A.M. Sarah: Yep")]), _vm._v(" "), _c('p', [_vm._v("9:20 A.M. Rick: When did you decide to fuck him?")]), _vm._v(" "), _c('p', [_vm._v("9:21 A.M. Sarah: I was planning on exercising self-control like I did with you, but things got a bit hot on the couch so I thought fuck it. He has a very, very good body, a nice kiss, hands all over me, and he definitely didn’t suggest we go further. I did.")]), _vm._v(" "), _c('p', [_vm._v("9:24 A.M. Rick: Did you have his cock out?")]), _vm._v(" "), _c('p', [_vm._v("9:24 A.M. Sarah: No. Want to know something about me?")]), _vm._v(" "), _c('p', [_vm._v("9:26 A.M. Rick: Yes lover")]), _vm._v(" "), _c('p', [_vm._v("9:26 A.M. Sarah: I’m more open to full sex than a blow job. Somehow it seems less personal.")]), _vm._v(" "), _c('p', [_vm._v("9:28 A.M. Rick: That’s weird. Did you blow him on the couch, to get some practice? Use your new talents?")]), _vm._v(" "), _c('p', [_vm._v("9:28 A.M. Sarah: No, didn’t do that at all. It didn’t come up, but we had very busy sex. And I don’t lack talent! x")]), _vm._v(" "), _c('p', [_vm._v("9:30 A.M. Rick: I can vouch for your talent’s babe. Tell me more.")]), _vm._v(" "), _c('p', [_vm._v("9:31 A.M. Sarah: Let’s say I’m no longer a virgin")]), _vm._v(" "), _c('p', [_vm._v("9:34 A.M. Rick: He fucked your arse?")]), _vm._v(" "), _c('p', [_vm._v("9:34 A.M. Sarah: You have such a nice way with words, but yes")]), _vm._v(" "), _c('p', [_vm._v("9:35 A.M. Rick: Balls deep?")]), _vm._v(" "), _c('p', [_vm._v("9:35 A.M. Sarah: Yes. There was no discussion, he just launched himself. I definitely thought of you then!")]), _vm._v(" "), _c('p', [_vm._v("9:35 A.M. Rick: You enjoy my bluntness")]), _vm._v(" "), _c('p', [_vm._v("9:36 A.M. Sarah: Lol nothing wrong with being frank")]), _vm._v(" "), _c('p', [_vm._v("9:36 A.M. Rick: Was he gentle or did he pound you?")]), _vm._v(" "), _c('p', [_vm._v("9:37 A.M. Sarah: I had to tell him to stop after a while. I’m very tight.")]), _vm._v(" "), _c('p', [_vm._v("9:38 A.M. Rick: He fucked your arse first?")]), _vm._v(" "), _c('p', [_vm._v("9:39 A.M. Sarah: No. Swapped round.")]), _vm._v(" "), _c('p', [_vm._v("9:42 A.M. Rick: A hard session then")]), _vm._v(" "), _c('p', [_vm._v("9:45 A.M. Sarah: It was actually")]), _vm._v(" "), _c('p', [_vm._v("9:50 A.M. Rick: Big cock?")]), _vm._v(" "), _c('p', [_vm._v("9:52 A.M. Sarah: Very nice cock. Māori chap. And yes, I’d say big or at least long. He’s very fit, and as I said, young.")]), _vm._v(" "), _c('p', [_vm._v("10:00 A.M. Rick: Big cummer?")]), _vm._v(" "), _c('p', [_vm._v("10:00 A.M. Sarah: I don’t know – he used condoms. The youths seem to be more careful with their health, plus they think anyone can get pregnant.")]), _vm._v(" "), _c('p', [_vm._v("10:03 A.M. Rick: It’s because they fuck around!")]), _vm._v(" "), _c('p', [_vm._v("10:04 A.M. Sarah: You think? I don’t think this guy does. I think it’s more they have been brought up differently.")]), _vm._v(" "), _c('p', [_vm._v("10:05 A.M. Sarah: Can you clarify the Saturday arrangement babe? Does coffee = fuck or coffee?")]), _vm._v(" "), _c('p', [_vm._v("10:06 A.M. Rick: Silly girl...fuck")]), _vm._v(" "), _c('p', [_vm._v("10:06 A.M. Sarah: So I only have an hour before I need to be getting ready for a social thing. How’s that going to work???")]), _vm._v(" "), _c('p', [_vm._v("10:07 A.M. Rick: It will be intense. You’ll arrive smelling of sex. Have you been clenching as we chatted? Still feeling the pounding from last night?")]), _vm._v(" "), _c('p', [_vm._v("10:13 A.M. Sarah: I’m wearing my sensible undies if that’s a clue")]), _vm._v(" "), _c('p', [_vm._v("10:13 A.M. Rick: So, are you wet recounting last night’s activities? And did he lube your arse first?")]), _vm._v(" "), _c('p', [_vm._v("10:14 A.M. Sarah: Yes, and yes")]), _vm._v(" "), _c('p', [_vm._v("10:15 A.M. Rick: Babe. Please. Organise a Friday fuck if you need it. You know you want to fuck another cock and you have no intention of dumping the challenging one. Am I right babe? You love the thrill of the chase.")]), _vm._v(" "), _c('p', [_vm._v("10:19 A.M. Sarah: That’s an interesting thought. I am very on/off with the challenging one – my sex coach calls him the light switch, and I don’t see him often, but increasingly when I do it feels more and more friend-like.")]), _vm._v(" "), _c('p', [_vm._v("10:19 A.M. Rick: You love the power between your legs")]), _vm._v(" "), _c('p', [_vm._v("10:19 A.M. Sarah: It is proving relatively easy to wield")]), _vm._v(" "), _c('p', [_vm._v("10:19 A.M. Rick: Except for me. I hold the power.")]), _vm._v(" "), _c('p', [_vm._v("10:21 A.M. Sarah: You know I’m more than a little intimidated by you?")]), _vm._v(" "), _c('p', [_vm._v("10:23 A.M. Rick: You should be lover. Do you inspect yourself after you have been fucked?")]), _vm._v(" "), _c('p', [_vm._v("10:23 A.M. Sarah: No, I don’t – inspect for what?")]), _vm._v(" "), _c('p', [_vm._v("10:25 A.M. Rick: Just take a pic on your phone and look at your cunt after it’s been well fucked. We shall try it xxx")]), _vm._v(" "), _c('p', [_vm._v("10:27 A.M. Sarah: Stop that!")]), _vm._v(" "), _c('p', [_vm._v("10:27 A.M. Rick: Wait until I have fucked you and taken a pic to show how your cunt is spread for more")]), _vm._v(" "), _c('p', [_vm._v("11:55 A.M. Sarah: Still laughing to myself about you not responding to my mentioning my sex coach. So funny xxx")]), _vm._v(" "), _c('p', [_vm._v("2:06 P.M. Rick: I noted the reference, obviously that’s me xxx")]), _vm._v(" "), _c('p', [_vm._v("3:04 P.M. Sarah: I wasn’t referring to you. I know I’ve told you before about a former lover who was a teacher at the kids’ school. He vets my experiences and last year coached me sexually. He’s currently appalled and impressed in equal measure. I’m changing the title now – he offers a much wider range of advice than just sex, and I don’t talk to him about sex so much these days. You are officially now my sex coach and he can revert to occupation – teacher.")]), _vm._v(" "), _c('p', [_vm._v("3:07 P.M. Rick: I am your Master. Does he want to try you again? xxx")]), _vm._v(" "), _c('p', [_vm._v("3:07 P.M. Sarah: Maybe, but he’s not going to. I’ve said before that revisiting the fuck days would potentially ruin our friendship. Plus, I think we both enjoy the sexual tension. A question Rick – do you prefer to hear about me with others than have me yourself?")]), _vm._v(" "), _c('p', [_vm._v("3:13 P.M. Rick: Both lover. Did the Māori tongue fuck you?")]), _vm._v(" "), _c('p', [_vm._v("3:18 P.M. Sarah: Language Richard! And yes.")]), _vm._v(" "), _c('p', [_vm._v("3:18 P.M. Rick: Did you cum?")]), _vm._v(" "), _c('p', [_vm._v("3:18 P.M. Sarah: No")]), _vm._v(" "), _c('p', [_vm._v("3:20 P.M. Rick: Did he have you ride him?")]), _vm._v(" "), _c('p', [_vm._v("3:21 P.M. Sarah: No, he was very happy being in charge")]), _vm._v(" "), _c('p', [_vm._v("3:21 P.M. Rick: On your back?")]), _vm._v(" "), _c('p', [_vm._v("3:22 P.M. Sarah: Yes, and hands and knees")]), _vm._v(" "), _c('p', [_vm._v("3:22 P.M. Rick: Mmm")]), _vm._v(" "), _c('p', [_vm._v("3:22 P.M. Sarah: And he did the ankle thing")]), _vm._v(" "), _c('p', [_vm._v("3:22 P.M. Rick: Holding them as he spread you?")]), _vm._v(" "), _c('p', [_vm._v("3:22 P.M. Sarah: Yes. Are you hard again?")]), _vm._v(" "), _c('p', [_vm._v("3:23 P.M. Rick: Fucking hard")]), _vm._v(" "), _c('p', [_vm._v("3:23 P.M. Sarah: Good. He had a few of your moves.")]), _vm._v(" "), _c('p', [_vm._v("3:24 P.M. Rick: Are you wet?")]), _vm._v(" "), _c('p', [_vm._v("3:24 P.M. Sarah: Absolutely. Not touching it though.")]), _vm._v(" "), _c('p', [_vm._v("3:28 P.M. Rick: Was he in your anal passage first? Does that sound better???")]), _vm._v(" "), _c('p', [_vm._v("3:29 P.M. Sarah: Vagina then anal passage then return to vagina")]), _vm._v(" "), _c('p', [_vm._v("3:30 P.M. Rick: I hope he didn’t use the same condom")]), _vm._v(" "), _c('p', [_vm._v("3:30 P.M. Sarah: No, he changed")]), _vm._v(" "), _c('p', [_vm._v("3:31 P.M. Rick: Between your arse and pussy?")]), _vm._v(" "), _c('p', [_vm._v("3:31 P.M. Sarah: Of course. Must have attended the same sex school as you.")]), _vm._v(" "), _c('p', [_vm._v("3:31 P.M. Rick: Good. You don’t need a UTI.")]), _vm._v(" "), _c('p', [_vm._v("3:32 P.M. Sarah: No, I do not")]), _vm._v(" "), _c('p', [_vm._v("3:32 P.M. Rick: Put you out of action. That would not be good.")]), _vm._v(" "), _c('p', [_vm._v("3:32 P.M. Sarah: Couldn’t have that could you???")]), _vm._v(" "), _c('p', [_vm._v("3:33 P.M. Rick: Exactly! You’re learning.")]), _vm._v(" "), _c('p', [_vm._v("3:33 P.M. Sarah: Where would you get your kicks? Tragedy x")]), _vm._v(" "), _c('p', [_vm._v("3:34 P.M. Rick: It turns you on just as much as me lover x")]), _vm._v(" "), _c('p', [_vm._v("3:35 P.M. Sarah: I’m surprised I’m happy sharing. I’m finding it quite useful to revisit the events and to pay attention to what happened. I have never consciously done that before.")]), _vm._v(" "), _c('p', [_vm._v("3:37 P.M. Rick: Especially to a third party")]), _vm._v(" "), _c('p', [_vm._v("3:38 P.M. Sarah: Yes, that’s quite new. I do have the teacher friend for some sharing of course, and definitely shared sexual experiences from my relationship with the ex with him.")]), _vm._v(" "), _c('p', [_vm._v("3:38 P.M. Rick: Explicit detail?")]), _vm._v(" "), _c('p', [_vm._v("3:39 P.M. Sarah: I did, but now I only share if I’m concerned or curious about something which I know he will have experience with, but I don’t generally because of our history. He’s had a lot of sex experiences. Like you.")]), _vm._v(" "), _c('p', [_vm._v("3:41 P.M. Rick: I may give you a camera to put in your bedroom. That will allow me to watch remotely. It would be erotic.")]), _vm._v(" "), _c('p', [_vm._v("3:42 P.M. Sarah: Might be just a mile too far for me for a while yet – you have to remember the conservative life I led locked away for so long.")]), _vm._v(" "), _c('p', [_vm._v("3:44 P.M. Rick: My jail bird. Prison of your mind")]), _vm._v(" "), _c('p', [_vm._v("3:47 P.M. Sarah: Circumstances certainly made it prison, just no walls or locks.")]), _vm._v(" "), _c('p', [_vm._v("3:54 P.M. Rick: And now cocks")]), _vm._v(" "), _c('p', [_vm._v("3:55 P.M. Sarah: I do have plenty of those. I’m educating myself – it’s like going to school – I’ll graduate one day.")]), _vm._v(" "), _c('p', [_vm._v("3:57 P.M. Rick: Have you heard from him today?")]), _vm._v(" "), _c('p', [_vm._v("3:57 P.M. Sarah: The Māori? Yes of course. He apparently had a GREAT night with me.")]), _vm._v(" "), _c('p', [_vm._v("4:03 P.M. Sarah: I figured something out last night at book club")]), _vm._v(" "), _c('p', [_vm._v("4:04 P.M. Rick: Hit me")]), _vm._v(" "), _c('p', [_vm._v("4:05 P.M. Sarah: My ex couldn’t be touched in a normal friendly way. Any touching with me meant sex. I was told that’s an actual condition.")]), _vm._v(" "), _c('p', [_vm._v("4:07 P.M. Rick: That’s right. I have met people like that. That explains the lack of intimacy and affection in your relationship babe. Are you aching for the Māori’s cock again?")]), _vm._v(" "), _c('p', [_vm._v("4:08 P.M. Sarah: Absolutely it does. I thought there was something wrong with me! And a little, I’m meant to be having a brief drink with him tonight to collect my earrings, left behind on the coffee table, but there’s zero chance I’d have sex in my sensible undies!")]), _vm._v(" "), _c('p', [_vm._v("4:11 P.M. Rick: Lol. He wouldn’t mind. Does he talk when he fucks?")]), _vm._v(" "), _c('p', [_vm._v("4:14 P.M. Sarah: Yes. Don’t ask. I can’t type those words.")]), _vm._v(" "), _c('p', [_vm._v("4:16 P.M. Rick: How he likes fucking your hot cunt?")]), _vm._v(" "), _c('p', [_vm._v("4:16 P.M. Sarah: That sort of thing yes")]), _vm._v(" "), _c('p', [_vm._v("4:17 P.M. Rick: How good your tight arse feels on his cock?")]), _vm._v(" "), _c('p', [_vm._v("4:18 P.M. Sarah: Yes exactly")]), _vm._v(" "), _c('p', [_vm._v("4:19 P.M. Rick: How good your cunt tastes on his tongue")]), _vm._v(" "), _c('p', [_vm._v("4:19 P.M. Sarah: You ARE this guy!")]), _vm._v(" "), _c('p', [_vm._v("4:20 P.M. Rick: There is only one of me babe. What else?")]), _vm._v(" "), _c('p', [_vm._v("4:21 P.M. Sarah: No, I can’t type the words but you were obviously present anyway")]), _vm._v(" "), _c('p', [_vm._v("4:22 P.M. Rick: Yes, you can")]), _vm._v(" "), _c('p', [_vm._v("4:22 P.M. Sarah: You’ve said it anyway now")]), _vm._v(" "), _c('p', [_vm._v("4:23 P.M. Rick: There is more")]), _vm._v(" "), _c('p', [_vm._v("4:23 P.M. Sarah: I do find it intoxicating but also confusing how these men find me so attractive. I’ve honestly never seen it. Can they all be flatterers?")]), _vm._v(" "), _c('p', [_vm._v("4:23 P.M. Rick: You are very attractive darling")]), _vm._v(" "), _c('p', [_vm._v("4:24 P.M. Sarah: I’m sceptical")]), _vm._v(" "), _c('p', [_vm._v("4:24 P.M. Rick: You don’t like compliments?")]), _vm._v(" "), _c('p', [_vm._v("4:25 P.M. Sarah: I really do like compliments; I just find it hard to believe")]), _vm._v(" "), _c('p', [_vm._v("4:25 P.M. Rick: Enjoy it babe x")]), _vm._v(" "), _c('p', [_vm._v("4:26 P.M. Sarah: I am! x")]), _vm._v(" "), _c('p', [_vm._v("4:26 P.M. Rick: Now what else?")]), _vm._v(" "), _c('p', [_vm._v("4:27 P.M. Sarah: Would you like to see the morning after text?")]), _vm._v(" "), _c('p', [_vm._v("4:27 P.M. Rick: Yes")]), _vm._v(" "), _c('p', [_vm._v("4:27 P.M. Sarah: “Morning gorgeous! I never expected to have a great night like that – wow. Hope you enjoyed it too and having me lick and stretch your pussy and ass...yum!”")]), _vm._v(" "), _c('p', [_vm._v("4:28 P.M. Rick: Not too crude")]), _vm._v(" "), _c('p', [_vm._v("4:28 P.M. Sarah: Not at all. Still hard?")]), _vm._v(" "), _c('p', [_vm._v("4:28 P.M. Rick: You know I am")]), _vm._v(" "), _c('p', [_vm._v("4:29 P.M. Rick: He obviously used cruder during the fucking")]), _vm._v(" "), _c('p', [_vm._v("4:29 P.M. Sarah: Well yes of course")]), _vm._v(" "), _c('p', [_vm._v("4:33 P.M. Rick: Ok, so you’ve now had brown – would you like to try black?")]), _vm._v(" "), _c('p', [_vm._v("4:35 P.M. Sarah: Hmm")]), _vm._v(" "), _c('p', [_vm._v("4:35 P.M. Rick: Black? Would you?")]), _vm._v(" "), _c('p', [_vm._v("4:36 P.M. Sarah: I have no view on black really but there were so many gorgeous black men roaming the streets in south London, I did wonder. Opportunity is very limited here.")]), _vm._v(" "), _c('p', [_vm._v("4:36 P.M. Rick: True")]), _vm._v(" "), _c('p', [_vm._v("4:36 P.M. Sarah: Great bodies")]), _vm._v(" "), _c('p', [_vm._v("4:37 P.M. Rick: Have you thought any more of the before and after cunt pics? x")]), _vm._v(" "), _c('p', [_vm._v("4:38 P.M. Sarah: I’m not overly interested, but I don’t really mind if you want to do that")]), _vm._v(" "), _c('p', [_vm._v("4:40 P.M. Rick: Start tonight")]), _vm._v(" "), _c('p', [_vm._v("4:40 P.M. Sarah: What after I’ve fucked a cucumber?")]), _vm._v(" "), _c('p', [_vm._v("4:41 P.M. Rick: Mmm. Is this one kinky?")]), _vm._v(" "), _c('p', [_vm._v("4:45 P.M. Sarah: Too early to tell but I think probably not. Very energetic and enthusiastic.")]), _vm._v(" "), _c('p', [_vm._v("4:50 P.M. Rick: Do you have a cucumber?")]), _vm._v(" "), _c('p', [_vm._v("4:50 P.M. Sarah: You know the answer to that! I’m heading out soon to have that drink with him.")]), _vm._v(" "), _c('p', [_vm._v("4:54 P.M. Rick: Go in the bathroom and message me before you fuck him")]), _vm._v(" "), _c('p', [_vm._v("4:54 P.M. Sarah: I’m not fucking him tonight!")]), _vm._v(" "), _c('p', [_vm._v("4:55 P.M. Rick: Of course, not... I will wait for the message")]), _vm._v(" "), _c('p', [_vm._v("4:55 P.M. Sarah: You’ll be waiting a while Cutie Pie. I have willpower xxx")]), _vm._v(" "), _c('p', [_vm._v("4:59 P.M. Rick: Until the kisses start")]), _vm._v(" "), _c('p', [_vm._v("5:00 P.M. Sarah: Now that would generally get me")]), _vm._v(" "), _c('p', [_vm._v("5:00 P.M. Rick: Alternatively send me a pic of you spread naked on his bed")]), _vm._v(" "), _c('p', [_vm._v("5:00 P.M. Sarah: Now that ain’t happening")]), _vm._v(" "), _c('p', [_vm._v("5:03 P.M. Rick: So now you have the extremes. You choose.")]), _vm._v(" "), _c('p', [_vm._v("5:03 P.M. Sarah: So I do have the power!")]), _vm._v(" "), _c('p', [_vm._v("5:05 P.M. Rick: Until I get my hands on you")]), _vm._v(" "), _c('p', [_vm._v("5:05 P.M. Sarah: Mmm")]), _vm._v(" "), _c('p', [_vm._v("5:14 P.M. Rick: Don’t disappoint me lover 💋")]), _vm._v(" "), _c('p', [_vm._v("5:14 P.M. Sarah: You are a pimp!")]), _vm._v(" "), _c('p', [_vm._v("5:17 P.M. Rick: Never. Are you still wet? Dripping?")]), _vm._v(" "), _c('p', [_vm._v("5:22 P.M. Sarah: Go away! xxx")]), _vm._v(" "), _c('p', [_vm._v("5:23 P.M. Rick: All of the above? x")]), _vm._v(" "), _c('p', [_vm._v("5:23 P.M. Sarah: Bad man x")]), _vm._v(" "), _c('p', [_vm._v("5:24 P.M. Rick: Bad woman. Now go and get yourself fucked again x")]), _vm._v(" "), _c('p', [_vm._v("5:25 P.M. Sarah: You can’t get enough of me x")]), _vm._v(" "), _c('p', [_vm._v("5:25 P.M. Rick: Or you me x")]), _vm._v(" "), _c('p', [_vm._v("5:25 P.M. Sarah: Bye x")]), _vm._v(" "), _c('p', [_vm._v("5:26 P.M. Rick: Message me. Especially during mmm")]), _vm._v(" "), _c('p', [_vm._v("7:38 P.M. Sarah: I win")]), _vm._v(" "), _c('p', [_vm._v("8:13 P.M. Rick: You didn’t open your legs?")]), _vm._v(" "), _c('p', [_vm._v("8:14 P.M. Sarah: Not even close. Hug and kiss. Chat and wine. Sorry to disappoint.")]), _vm._v(" "), _c('p', [_vm._v("8:48 P.M. Rick: You never disappoint. Didn’t he want you again?")]), _vm._v(" "), _c('p', [_vm._v("8:49 P.M. Sarah: He’s definitely keen, but we are both tired after last night")]), _vm._v(" "), _c('p', [_vm._v("9:23 P.M. Rick: Are you sure you’re not in his bed? Who is fucking you lover? x")]), _vm._v(" "), _c('p', [_vm._v("9:49 P.M. Sarah: No one! I’m behaving myself.")]), _vm._v(" "), _c('p', [_vm._v("9:50 P.M. Rick: Seriously?")]), _vm._v(" "), _c('p', [_vm._v("9:50 P.M. Sarah: You’re a bad influence x")]), _vm._v(" "), _c('p', [_vm._v("9:51 P.M. Rick: Did he ask you to go to his?")]), _vm._v(" "), _c('p', [_vm._v("9:52 P.M. Sarah: No, we were only meeting because of my earrings, and he had them with him. I’ll be seeing him again, don’t you worry. Such a nice body!")]), _vm._v(" "), _c('p', [_vm._v("9:54 P.M. Rick: Sorry I can’t give you that. I have an old body.")]), _vm._v(" "), _c('p', [_vm._v("9:55 P.M. Sarah: I like your body. I also have an old body.")]), _vm._v(" "), _c('p', [_vm._v("9:56 P.M. Rick: No, you don’t")]), _vm._v(" "), _c('p', [_vm._v("9:56 P.M. Sarah: It’s as old as the rest of me, and nearly as old as you!")]), _vm._v(" "), _c('p', [_vm._v("9:57 P.M. Rick: It’s fuckable babe")]), _vm._v(" "), _c('p', [_vm._v("9:58 P.M. Sarah: You fucked it, ergo yours is also fuckable. I don’t care about bodies all that much, and by the time you get to our age most are flawed.")]), _vm._v(" "), _c('p', [_vm._v("9:59 P.M. Rick: Good answer")]), _vm._v(" "), _c('p', [_vm._v("9:59 P.M. Sarah: I’d be fucking lonely if I did care")]), _vm._v(" "), _c('p', [_vm._v("9:59 P.M. Rick: Who are you chatting to on Tinder?")]), _vm._v(" "), _c('p', [_vm._v("10:00 P.M. Sarah: Seriously I’m having an alone night. No chats. No sex. It’s glorious occasionally.")]), _vm._v(" "), _c('p', [_vm._v("10:02 P.M. Rick: How does your arse feel?")]), _vm._v(" "), _c('p', [_vm._v("10:03 P.M. Sarah: Hmm it’s ok. Been better but a day or two will fix it. Thanks for your concern x")]), _vm._v(" "), _c('p', [_vm._v("10:04 P.M. Rick: I will stretch it again. On your back with your legs back. Have you rub my cock in your cunt and position it against your arse.")]), _vm._v(" "), _c('p', [_vm._v("10:07 P.M. Sarah: You expect me to walk after that? I’m not a gymnast!")]), _vm._v(" "), _c('p', [_vm._v("10:07 P.M. Rick: Lol. How would you want it babe? xxx")]), _vm._v(" "), _c('p', [_vm._v("10:09 P.M. Sarah: I have no idea of the options available. It’s a beautiful world I live in. Wide eyed with wonder.")]), _vm._v(" "), _c('p', [_vm._v("10:09 P.M. Rick: And wonderful wide legs")]), _vm._v(" "), _c('p', [_vm._v("10:10 P.M. Sarah: I can arrange that. My hips are tight from last night being pulled in two. I should be better than that!")]), _vm._v(" "), _c('p', [_vm._v("10:19 P.M. Rick: Tell me the positions he put you in")]), _vm._v(" "), _c('p', [_vm._v("10:21 P.M. Sarah: I don’t know how to but the wide at the ankles thing is a test! I like how it feels but it leaves me tight the next day.")]), _vm._v(" "), _c('p', [_vm._v("10:32 P.M. Rick: And others?")]), _vm._v(" "), _c('p', [_vm._v("10:34 P.M. Sarah: Nothing I hadn’t done with you")]), _vm._v(" "), _c('p', [_vm._v("10:35 P.M. Rick: Describe the evening")]), _vm._v(" "), _c('p', [_vm._v("10:37 P.M. Sarah: Very relaxed and comfortable. We met with a lip kiss and a nice hug. I found out in the phone call he loves to hug, tight, long and intimate. Chat in the bar over a single drink and some chips felt easy and friendly. Legs touching in a relaxed way. We went back to his house for another drink because he was driving. Once inside I found myself in a long hug in the kitchen and a proper kiss, followed by a bottle of red on the couch, and more talk, and then he can’t stop kissing me, hands searching. The rest you know.")]), _vm._v(" "), _c('p', [_vm._v("10:53 P.M. Rick: No. Tell me.")]), _vm._v(" "), _c('p', [_vm._v("10:55 P.M. Sarah: He has that look that so clearly says I want to fuck you but we only just met")]), _vm._v(" "), _c('p', [_vm._v("10:55 P.M. Rick: What clothes came off on the couch?")]), _vm._v(" "), _c('p', [_vm._v("10:55 P.M. Sarah: Just my earrings lol. I suggested we should move to the bedroom.")]), _vm._v(" "), _c('p', [_vm._v("10:57 P.M. Rick: And?")]), _vm._v(" "), _c('p', [_vm._v("10:57 P.M. Sarah: I had to remove my own clothes. Another youth problem, but I think he enjoyed watching.")]), _vm._v(" "), _c('p', [_vm._v("10:58 P.M. Rick: Did you parade?")]), _vm._v(" "), _c('p', [_vm._v("10:58 P.M. Sarah: No, I’m not good at performance, and there wasn’t room anyway. His bedroom was tiny, with clothes and stuff stacked up against all the walls.")]), _vm._v(" "), _c('p', [_vm._v("10:59 P.M. Rick: Did you strip him?")]), _vm._v(" "), _c('p', [_vm._v("11:00 P.M. Sarah: He’d already done that way before I was out of my clothes. Mine were complicated because I hadn’t planned on removing them at all.")]), _vm._v(" "), _c('p', [_vm._v("11:00 P.M. Rick: Did you feel slutty?")]), _vm._v(" "), _c('p', [_vm._v("11:00 P.M. Sarah: Of course")]), _vm._v(" "), _c('p', [_vm._v("11:01 P.M. Rick: You like the feeling, don’t you?")]), _vm._v(" "), _c('p', [_vm._v("11:01 P.M. Sarah: Yes, I think I do")]), _vm._v(" "), _c('p', [_vm._v("11:02 P.M. Rick: What happened when you had stripped?")]), _vm._v(" "), _c('p', [_vm._v("11:02 P.M. Sarah: I jumped on the bed, over him, and…he LOVES my body, even though I’m a dinosaur next to him")]), _vm._v(" "), _c('p', [_vm._v("11:04 P.M. Rick: You are a sexual woman, who wouldn’t love your body? So you jumped on the bed and…")]), _vm._v(" "), _c('p', [_vm._v("11:05 P.M. Sarah: Well, he flipped me under him, kissing obviously, hands, mouth everywhere")]), _vm._v(" "), _c('p', [_vm._v("11:07 P.M. Rick: Did you have your hand on his cock?")]), _vm._v(" "), _c('p', [_vm._v("11:07 P.M. Sarah: Yes, and all over him")]), _vm._v(" "), _c('p', [_vm._v("11:08 P.M. Rick: Did he tongue fuck you at that point?")]), _vm._v(" "), _c('p', [_vm._v("11:08 P.M. Sarah: Yes, on his knees lifting my hips high")]), _vm._v(" "), _c('p', [_vm._v("11:09 P.M. Rick: His tongue in your cunt and arse")]), _vm._v(" "), _c('p', [_vm._v("11:09 P.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("11:09 P.M. Rick: Which did you prefer?")]), _vm._v(" "), _c('p', [_vm._v("11:10 P.M. Sarah: Both feel nice but I’m less comfortable with the arse")]), _vm._v(" "), _c('p', [_vm._v("11:11 P.M. Rick: What happened then?")]), _vm._v(" "), _c('p', [_vm._v("11:11 P.M. Sarah: He put a condom on and hammered me as previously described")]), _vm._v(" "), _c('p', [_vm._v("11:12 P.M. Rick: On your back")]), _vm._v(" "), _c('p', [_vm._v("11:12 P.M. Sarah: To start, yes, legs spread and held open at the ankles, me holding on to the headboard to push back against. Then flipped over to hands and knees, then back to on my back.")]), _vm._v(" "), _c('p', [_vm._v("11:13 P.M. Rick: Banging hard?")]), _vm._v(" "), _c('p', [_vm._v("11:14 P.M. Sarah: Variable, but generally yes. Some very deep thrusts.")]), _vm._v(" "), _c('p', [_vm._v("11:14 P.M. Rick: So, no finesse. Did he have his finger in your arse?")]), _vm._v(" "), _c('p', [_vm._v("11:15 P.M. Sarah: Yes, at the start, when I was on hands and knees with him in my vagina.")]), _vm._v(" "), _c('p', [_vm._v("11:17 P.M. Rick: Cunt babe. Did you tell him to fuck you?")]), _vm._v(" "), _c('p', [_vm._v("11:18 P.M. Sarah: No")]), _vm._v(" "), _c('p', [_vm._v("11:19 P.M. Rick: No talking from you at all?")]), _vm._v(" "), _c('p', [_vm._v("11:19 P.M. Sarah: Not really")]), _vm._v(" "), _c('p', [_vm._v("11:20 P.M. Rick: Did he cum at this stage?")]), _vm._v(" "), _c('p', [_vm._v("11:22 P.M. Sarah: Did he cum in my arse? No. I asked him to stop because it hurt and he swapped to a fresh condom.")]), _vm._v(" "), _c('p', [_vm._v("11:23 P.M. Rick: Next time have him empty the condom over you")]), _vm._v(" "), _c('p', [_vm._v("11:24 P.M. Sarah: Ewww yuck why?")]), _vm._v(" "), _c('p', [_vm._v("11:24 P.M. Rick: Do as you are told lover. When did he start to fuck your arse?")]), _vm._v(" "), _c('p', [_vm._v("11:26 P.M. Sarah: After he’d been in the front door for a while, he decided to try round the back")]), _vm._v(" "), _c('p', [_vm._v("11:27 P.M. Rick: Did he use your cunt from behind before your arse?")]), _vm._v(" "), _c('p', [_vm._v("11:27 P.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("11:27 P.M. Rick: Did he ask for your arse?")]), _vm._v(" "), _c('p', [_vm._v("11:28 P.M. Sarah: I already told you, no he didn’t. I was surprised by that.")]), _vm._v(" "), _c('p', [_vm._v("11:29 P.M. Rick: Slow or just rammed it in?")]), _vm._v(" "), _c('p', [_vm._v("11:30 P.M. Sarah: Slow")]), _vm._v(" "), _c('p', [_vm._v("11:30 P.M. Rick: Well that’s a blessing. Then he fucked faster?")]), _vm._v(" "), _c('p', [_vm._v("11:31 P.M. Sarah: Yes. Everything about my body is small and tight so that’s also tight.")]), _vm._v(" "), _c('p', [_vm._v("11:31 P.M. Rick: Did he tell you to finger your cunt and clit as he fucked your arse?")]), _vm._v(" "), _c('p', [_vm._v("11:31 P.M. Sarah: No")]), _vm._v(" "), _c('p', [_vm._v("11:32 P.M. Rick: Did he have you moaning?")]), _vm._v(" "), _c('p', [_vm._v("11:32 P.M. Sarah: I guess, but I’m not really a moaner, plus it was quite painful")]), _vm._v(" "), _c('p', [_vm._v("11:33 P.M. Rick: You don’t remember?")]), _vm._v(" "), _c('p', [_vm._v("11:33 P.M. Sarah: Too many questions!")]), _vm._v(" "), _c('p', [_vm._v("11:34 P.M. Rick: I will let you go to sleep")]), _vm._v(" "), _c('p', [_vm._v("11:34 P.M. Sarah: That’s sweet of you")]), _vm._v(" "), _c('p', [_vm._v("11:35 P.M. Rick: That’s cute of me")]), _vm._v(" "), _c('p', [_vm._v("11:35 P.M. Sarah: Yes, very cute")]), _vm._v(" "), _c('p', [_vm._v("11:36 P.M. Rick: Are you going to fuck fresh cock tomorrow")]), _vm._v(" "), _c('p', [_vm._v("11:36 P.M. Sarah: I’m not a complete slut!")]), _vm._v(" "), _c('p', [_vm._v("11:36 P.M. Rick: You know you have the taste")]), _vm._v(" "), _c('p', [_vm._v("11:38 P.M. Sarah: Will try to see the love bird but it might not work out. It often doesn’t.")]), _vm._v(" "), _c('p', [_vm._v("11:38 P.M. Rick: In the evening?")]), _vm._v(" "), _c('p', [_vm._v("11:38 P.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("11:38 P.M. Rick: He doesn’t stay over?")]), _vm._v(" "), _c('p', [_vm._v("11:38 P.M. Sarah: Never. He’s not available for that.")]), _vm._v(" "), _c('p', [_vm._v("11:40 P.M. Rick: Has he fucked your arse yet?")]), _vm._v(" "), _c('p', [_vm._v("11:40 P.M. Sarah: No. You know that!")]), _vm._v(" "), _c('p', [_vm._v("11:41 P.M. Rick: I like to tease you")]), _vm._v(" "), _c('p', [_vm._v("11:41 P.M. Sarah: You like to check my story you mean")]), _vm._v(" "), _c('p', [_vm._v("11:41 P.M. Rick: Will he cum in you tomorrow?")]), _vm._v(" "), _c('p', [_vm._v("11:41 P.M. Sarah: Yes – you’d like him to?")]), _vm._v(" "), _c('p', [_vm._v("11:41 P.M. Rick: Yes darling. Have you been fucked with another man’s cum in you?")]), _vm._v(" "), _c('p', [_vm._v("11:44 P.M. Sarah: No, never")]), _vm._v(" "), _c('p', [_vm._v("11:44 P.M. Rick: You will")]), _vm._v(" "), _c('p', [_vm._v("11:45 P.M. Sarah: You are corrupting me!")]), _vm._v(" "), _c('p', [_vm._v("11:45 P.M. Rick: Should I stop lover?")]), _vm._v(" "), _c('p', [_vm._v("11:46 P.M. Sarah: No, but just take it easy! My head will implode.")]), _vm._v(" "), _c('p', [_vm._v("11:47 P.M. Rick: You are loving the freedom")]), _vm._v(" "), _c('p', [_vm._v("11:47 P.M. Sarah: Yes, I am but it’s a full-time job")]), _vm._v(" "), _c('p', [_vm._v("11:48 P.M. Rick: Did you think a few weeks ago you would be fucking so much?")]), _vm._v(" "), _c('p', [_vm._v("11:48 P.M. Sarah: No way. Absolutely not.")]), _vm._v(" "), _c('p', [_vm._v("11:49 P.M. Rick: You need it, am I right?")]), _vm._v(" "), _c('p', [_vm._v("11:50 P.M. Sarah: Maybe, yes. High intensity training, but I honestly see it as educational.")]), _vm._v(" "), _c('p', [_vm._v("11:51 P.M. Rick: Have you been rubbing between your legs as we chat?")]), _vm._v(" "), _c('p', [_vm._v("11:51 P.M. Sarah: No")]), _vm._v(" "), _c('p', [_vm._v("11:52 P.M. Rick: Not turned on enough?")]), _vm._v(" "), _c('p', [_vm._v("11:52 P.M. Sarah: No, not that at all. I’m not touching it because it needs recovery, but I am straightening and tightening my legs. It has the same effect.")]), _vm._v(" "), _c('p', [_vm._v("11:54 P.M. Rick: Good girl")]), _vm._v(" "), _c('p', [_vm._v("11:54 P.M. Sarah: You’re so not cute!")]), _vm._v(" "), _c('p', [_vm._v("11:55 P.M. Rick: And I know you won’t be telling me I’m cute as my cock fucks you")]), _vm._v(" "), _c('p', [_vm._v("11:56 P.M. Sarah: Must be nice to have a cock. Convenient.")]), _vm._v(" "), _c('p', [_vm._v("11:57 P.M. Rick: You will have its use on Saturday")]), _vm._v(" "), _c('p', [_vm._v("11:58 P.M. Sarah: Ok it’s almost Friday now. I’m going to sleep Cutie Pie xxx")]), _vm._v(" "), _c('p', [_vm._v("11:58 P.M. Rick: Sweet dreams Sweet Cheeks x")]), _vm._v(" "), _c('p', [_vm._v("11:58 P.M. Sarah: Thanks for over-entertaining me, good night xxx")]), _vm._v(" "), _c('p', [_vm._v("11:59 P.M. Rick: Lol any time lover xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "friday-6-july-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Friday, 6 July 2018")]), _vm._v(" "), _c('p', [_vm._v("9:41 A.M. Rick: Hello lover. Enjoy your walk?")]), _vm._v(" "), _c('p', [_vm._v("9:48 A.M. Sarah: Are you spying on me? Such a beautiful morning today x")]), _vm._v(" "), _c('p', [_vm._v("9:49 A.M. Rick: I am waiting in your bed, come fuck me x")]), _vm._v(" "), _c('p', [_vm._v("9:50 A.M. Sarah: I wish, but I just made the bed didn’t see you there? Wrong house?")]), _vm._v(" "), _c('p', [_vm._v("9:52 A.M. Rick: Lol. Caught me")]), _vm._v(" "), _c('p', [_vm._v("9:52 A.M. Sarah: I hope there’s a desperate housewife wherever you are x")]), _vm._v(" "), _c('p', [_vm._v("10:05 A.M. Rick: Lol. Are you? x")]), _vm._v(" "), _c('p', [_vm._v("10:12 A.M. Sarah: I’ll never be desperate x")]), _vm._v(" "), _c('p', [_vm._v("10:14 A.M. Rick: That’s true. Cock on tap.")]), _vm._v(" "), _c('p', [_vm._v("10:15 A.M. Sarah: Well more than I can manage anyway")]), _vm._v(" "), _c('p', [_vm._v("10:42 A.M. Rick: That’s not true!")]), _vm._v(" "), _c('p', [_vm._v("10:42 A.M. Sarah: I love these names. Loving, challenging, Māori, cute/sex coach.")]), _vm._v(" "), _c('p', [_vm._v("10:43 A.M. Rick: Master babe")]), _vm._v(" "), _c('p', [_vm._v("10:43 A.M. Sarah: Cute. If I stop thinking of you as cute, I’ll get scared x")]), _vm._v(" "), _c('p', [_vm._v("6:26 P.M. Sarah: Over and out for tonight babe. See you tomorrow x")]), _vm._v(" "), _c('p', [_vm._v("8:22 P.M. Rick: Are you going to be full of cum? x")]), _vm._v(" "), _c('p', [_vm._v("10:22 P.M. Sarah: Will be if you get here earlier than 9.30!")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "saturday-7-july-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Saturday, 7 July 2018")]), _vm._v(" "), _c('p', [_vm._v("9:34 A.M. Rick: I won’t be able to make the timeframe, what time will you be home from the event?")]), _vm._v(" "), _c('p', [_vm._v("9:36 A.M. Sarah: Ok that’s cool. I’ll be home by 3.30 x")]), _vm._v(" "), _c('p', [_vm._v("9:42 A.M. Rick: Who was the one last night. The nice one?")]), _vm._v(" "), _c('p', [_vm._v("9:43 A.M. Sarah: Yes, the loving one")]), _vm._v(" "), _c('p', [_vm._v("9:45 A.M. Rick: Did you use him hard, thinking about all the cock you have fucked recently?")]), _vm._v(" "), _c('p', [_vm._v("9:45 A.M. Sarah: No, not hard. He’s rarely that.")]), _vm._v(" "), _c('p', [_vm._v("9:49 A.M. Completely forgot a tiny insignificant detail – the Māori had his hand on my throat. Often, quite tight. Your views on that?")]), _vm._v(" "), _c('p', [_vm._v("9:49 A.M. Rick: As he pounded you?")]), _vm._v(" "), _c('p', [_vm._v("9:49 A.M. Sarah: Yes. Firmly on the throat.")]), _vm._v(" "), _c('p', [_vm._v("9:50 A.M. Rick: You liked the feeling? Enjoyed it?")]), _vm._v(" "), _c('p', [_vm._v("9:51 A.M. Sarah: I have slight speed wobbles. I’m seeing the danger in these men I don’t know. He could have done anything, and no one knew where I was – even me!")]), _vm._v(" "), _c('p', [_vm._v("9:54 A.M. Rick: Well, lover. You spread your legs and let him fuck your arse...you are up for it.")]), _vm._v(" "), _c('p', [_vm._v("9:55 A.M. Sarah: I obviously need to work on my “no”")]), _vm._v(" "), _c('p', [_vm._v("9:56 A.M. Rick: You know that’s not going to happen!")]), _vm._v(" "), _c('p', [_vm._v("9:56 A.M. Sarah: I need to slow down though")]), _vm._v(" "), _c('p', [_vm._v("9:57 A.M. Rick: You know that’s not going to happen either. You have opened Pandora’s legs, and you give off that aura.")]), _vm._v(" "), _c('p', [_vm._v("9:59 A.M. Sarah: I’ll have a break next week in Sydney. Aura of fuckability, willingness, you mean?")]), _vm._v(" "), _c('p', [_vm._v("10:02 A.M. Rick: Exactly. Does that turn you on babe? xxx")]), _vm._v(" "), _c('p', [_vm._v("10:03 A.M. Sarah: It’s certainly a new feeling, but one that’s been coming for a couple of years as previously detailed, and yes it does")]), _vm._v(" "), _c('p', [_vm._v("10:04 A.M. Rick: Does the Māori want to use you again?")]), _vm._v(" "), _c('p', [_vm._v("10:04 A.M. Sarah: Yes. I didn’t reply to his text while I was busy last night and he second guessed that I wasn’t interested. He reminds me a lot of the challenging one in the way he’s attracted to me.")]), _vm._v(" "), _c('p', [_vm._v("10:05 A.M. Rick: Did the loving one cum deep in you?")]), _vm._v(" "), _c('p', [_vm._v("10:05 A.M. Sarah: Yes, he doesn’t get to the pain point though")]), _vm._v(" "), _c('p', [_vm._v("10:06 A.M. Rick: Did you shower afterwards?")]), _vm._v(" "), _c('p', [_vm._v("10:06 A.M. Sarah: Yes, I showered this morning. Everyone except you can’t believe their luck. I find that weird.")]), _vm._v(" "), _c('p', [_vm._v("10:06 A.M. Rick: Do you enjoy falling asleep full of cum?")]), _vm._v(" "), _c('p', [_vm._v("10:07 A.M. Sarah: Yes, I do. I never thought I’d be saying that. I always efficiently cleaned up in my previous life, no dribbling on the sheets.")]), _vm._v(" "), _c('p', [_vm._v("10:09 A.M. Sarah: Do you also hear confessions?")]), _vm._v(" "), _c('p', [_vm._v("10:10 A.M. Rick: Yes lover")]), _vm._v(" "), _c('p', [_vm._v("10:10 A.M. Sarah: I feel a bit apprehensive about seeing you. Should I?")]), _vm._v(" "), _c('p', [_vm._v("10:11 A.M. Rick: Why would you?")]), _vm._v(" "), _c('p', [_vm._v("10:11 A.M. Sarah: You are a serious challenge, no matter how much I like you. I haven’t seen you for so long, yet you know me inside out.")]), _vm._v(" "), _c('p', [_vm._v("10:12 A.M. Rick: And I will fuck you inside out. Did I mention you are my fuck toy? 😮")]), _vm._v(" "), _c('p', [_vm._v("10:13 A.M. Sarah: You may have mentioned it xxx")]), _vm._v(" "), _c('p', [_vm._v("10:14 A.M. Rick: Good. I thought it might have slipped your mind.")]), _vm._v(" "), _c('p', [_vm._v("10:14 A.M. Sarah: Fuck you x")]), _vm._v(" "), _c('p', [_vm._v("10:15 A.M. Rick: That you need x")]), _vm._v(" "), _c('p', [_vm._v("10:16 A.M. Sarah: You’d better make it this afternoon x")]), _vm._v(" "), _c('p', [_vm._v("10:29 A.M. Rick: When do you go to Sydney?")]), _vm._v(" "), _c('p', [_vm._v("10:29 A.M. Sarah: Monday about lunchtime")]), _vm._v(" "), _c('p', [_vm._v("10:30 A.M. Rick: Plenty of opportunity to fuck the Māori again")]), _vm._v(" "), _c('p', [_vm._v("10:31 A.M. Sarah: He’s going away today so he will get in touch when I return")]), _vm._v(" "), _c('p', [_vm._v("10:34 A.M. Rick: Otherwise you would have fucked him again?")]), _vm._v(" "), _c('p', [_vm._v("10:35 A.M. Sarah: OMG no! I’ve had Saturday, Wednesday and Friday already this week with you today! Too much badness.")]), _vm._v(" "), _c('p', [_vm._v("10:35 A.M. Rick: You have become a cock addict!")]), _vm._v(" "), _c('p', [_vm._v("10:36 A.M. Sarah: I hope not, just slightly addicted to flattery")]), _vm._v(" "), _c('p', [_vm._v("3:05 P.M. Sarah: Home by 3.30. Leaving now babe x")]), _vm._v(" "), _c('p', [_vm._v("3:12 P.M. Sarah: Hello?")]), _vm._v(" "), _c('p', [_vm._v("4:35 P.M. Sarah: Come on man what could be more important? xxx")]), _vm._v(" "), _c('p', [_vm._v("6:40 P.M. Sarah: What’s the game? I’m happy to spend time alone but we had an arrangement!")]), _vm._v(" "), _c('p', [_vm._v("10:17 P.M. Rick: It’s no game lover")]), _vm._v(" "), _c('p', [_vm._v("10:24 P.M. Rick: Are you out on the tiles lover?")]), _vm._v(" "), _c('p', [_vm._v("11:58 P.M. Rick: Did you find a fuck?")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "sunday-8-july-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Sunday, 8 July 2018")]), _vm._v(" "), _c('p', [_vm._v("12:57 P.M. Rick: Given up on me!!!")]), _vm._v(" "), _c('p', [_vm._v("12:59 P.M. Sarah: Kind of. I don’t like being treated like that. It’s disrespectful.")]), _vm._v(" "), _c('p', [_vm._v("1:04 P.M. Rick: I can understand that")]), _vm._v(" "), _c('p', [_vm._v("1:04 P.M. Sarah: So why do it?")]), _vm._v(" "), _c('p', [_vm._v("1:08 P.M. Rick: I got caught up")]), _vm._v(" "), _c('p', [_vm._v("1:08 P.M. Sarah: I’m not a fool Rick. Don’t treat me like one.")]), _vm._v(" "), _c('p', [_vm._v("1:12 P.M. Rick: I know that Sarah")]), _vm._v(" "), _c('p', [_vm._v("1:13 P.M. Sarah: So, no apology? No explanation?")]), _vm._v(" "), _c('p', [_vm._v("1:15 P.M. Rick: I explained. I got caught up. I should have told you, and I am sorry.")]), _vm._v(" "), _c('p', [_vm._v("1:17 P.M. Sarah: That’s not an explanation – the lack of respect hurts Rick")]), _vm._v(" "), _c('p', [_vm._v("1:30 P.M. Rick: A good spanking would hurt more x")]), _vm._v(" "), _c('p', [_vm._v("1:32 P.M. Sarah: No doubt. Do you only want to be a voyeur in my life and don’t intend to see me? I want a sensible conversation about it so I understand. You know I like you, and our chats, so just help me here. I’d be very reluctant to let it go.")]), _vm._v(" "), _c('p', [_vm._v("1:50 P.M. Sarah: Are you now ignoring me?")]), _vm._v(" "), _c('p', [_vm._v("1:58 P.M. Rick: Of course, not lover")]), _vm._v(" "), _c('p', [_vm._v("2:00 P.M. Sarah: So where to from here NotSoCuteRick? Do you have a master plan for me?")]), _vm._v(" "), _c('p', [_vm._v("2:02 P.M. Rick: Not so cute!!! We enjoy each other babe and I do need to have you sexually.")]), _vm._v(" "), _c('p', [_vm._v("2:02 P.M. Sarah: I also know you have work to do to regain your cuteness")]), _vm._v(" "), _c('p', [_vm._v("2:03 P.M. Rick: I will be myself")]), _vm._v(" "), _c('p', [_vm._v("2:03 P.M. Sarah: And who might that be?")]), _vm._v(" "), _c('p', [_vm._v("2:04 P.M. Rick: That’s the burning question")]), _vm._v(" "), _c('p', [_vm._v("2:06 P.M. Sarah: I will also be myself. I’ll continue to be completely honest with you and express my feelings, even my annoyance. Like today x")]), _vm._v(" "), _c('p', [_vm._v("2:10 P.M. Rick: That’s the only way it should be Sarah. Never suppress your feelings or emotions.")]), _vm._v(" "), _c('p', [_vm._v("2:13 P.M. Sarah: What are you up to today?")]), _vm._v(" "), _c('p', [_vm._v("2:17 P.M. Rick: Cleaning my boat out")]), _vm._v(" "), _c('p', [_vm._v("2:21 P.M. Sarah: Nice. I get seasick")]), _vm._v(" "), _c('p', [_vm._v("2:24 P.M. Rick: Now you just gag on cock")]), _vm._v(" "), _c('p', [_vm._v("2:25 P.M. Sarah: Or not as I choose")]), _vm._v(" "), _c('p', [_vm._v("2:25 P.M. Rick: Depends if your head is being held and your mouth used")]), _vm._v(" "), _c('p', [_vm._v("2:26 P.M. Sarah: Too far in my current mood chicky")]), _vm._v(" "), _c('p', [_vm._v("2:26 P.M. Rick: You mean cocky! You will for me.")]), _vm._v(" "), _c('p', [_vm._v("11:07 P.M. Sarah: You make me nervous")]), _vm._v(" "), _c('p', [_vm._v("11:07 P.M. Rick: Why?")]), _vm._v(" "), _c('p', [_vm._v("11:08 P.M. Sarah: I like going with what feels right at the time, depending on the mood. I’ve never had choreographed sex before.")]), _vm._v(" "), _c('p', [_vm._v("11:08 P.M. Rick: You will do as instructed")]), _vm._v(" "), _c('p', [_vm._v("11:09 P.M. Sarah: Stop right there. I’m not your puppet babe.")]), _vm._v(" "), _c('p', [_vm._v("11:10 P.M. Rick: I know how to push your buttons!")]), _vm._v(" "), _c('p', [_vm._v("11:11 P.M. Sarah: Hmmm. Was it hard to be nice last time?")]), _vm._v(" "), _c('p', [_vm._v("11:12 P.M. Rick: Do you have your legs spread babe?")]), _vm._v(" "), _c('p', [_vm._v("11:13 P.M. Sarah: I’m lying diagonally taking up as much bed as I can, so yes")]), _vm._v(" "), _c('p', [_vm._v("11:14 P.M. Rick: In a sexual way, to have access?")]), _vm._v(" "), _c('p', [_vm._v("11:14 P.M. Sarah: I have access of course")]), _vm._v(" "), _c('p', [_vm._v("11:18 P.M. Rick: Did you not entertain the challenging one today?")]), _vm._v(" "), _c('p', [_vm._v("11:18 P.M. Sarah: No babe. No one. Not been in the mood, and he’s not a frequent visitor anyway, even though he does do a good spoon.")]), _vm._v(" "), _c('p', [_vm._v("11:20 P.M. Rick: With his cock in you?")]), _vm._v(" "), _c('p', [_vm._v("11:21 P.M. Sarah: Both.")]), _vm._v(" "), _c('p', [_vm._v("11:27 P.M. Rick: What time are you leaving in the morning?")]), _vm._v(" "), _c('p', [_vm._v("11:28 P.M. Sarah: Around 9 A.M.")]), _vm._v(" "), _c('p', [_vm._v("11:29 P.M. Rick: So my morning fuck is out")]), _vm._v(" "), _c('p', [_vm._v("11:29 P.M. Sarah: Like it was ever going to happen. I need someone to tell me it’s ok to be me. I have speed wobbles.")]), _vm._v(" "), _c('p', [_vm._v("11:32 P.M. Rick: You know you are a well-grounded woman babe. You are just finding your sexuality.")]), _vm._v(" "), _c('p', [_vm._v("11:34 P.M. Sarah: I feel like I’m on a roller coaster")]), _vm._v(" "), _c('p', [_vm._v("11:35 P.M. Rick: You are in charge")]), _vm._v(" "), _c('p', [_vm._v("11:35 P.M. Sarah: Thanks")]), _vm._v(" "), _c('p', [_vm._v("11:38 P.M. Rick: Any new ones on Tinder?")]), _vm._v(" "), _c('p', [_vm._v("11:38 P.M. Sarah: I haven’t been on, so no. I need to progress at my own pace.")]), _vm._v(" "), _c('p', [_vm._v("11:40 P.M. Rick: You have the bug babe. Do you want the Māori in your arse again? xxx")]), _vm._v(" "), _c('p', [_vm._v("11:45 P.M. Rick: Tell me, lover")]), _vm._v(" "), _c('p', [_vm._v("11:46 P.M. Sarah: Rick. Too far. I do want to see him again.")]), _vm._v(" "), _c('p', [_vm._v("11:47 P.M. Rick: Did you enjoy his tongue in your arse?")]), _vm._v(" "), _c('p', [_vm._v("11:47 P.M. Sarah: I think I’ll start calling you Richard when you’re too naughty. And yes, I kind of do. I’ll tell you when I don’t like something. Not when I do!")]), _vm._v(" "), _c('p', [_vm._v("11:49 P.M. Rick: Lol. He must have held your cheeks apart to tongue it deep")]), _vm._v(" "), _c('p', [_vm._v("11:50 P.M. Sarah: I was on my back. Hips high.")]), _vm._v(" "), _c('p', [_vm._v("11:53 P.M. Rick: Did he have you on your back when he first used your arse?")]), _vm._v(" "), _c('p', [_vm._v("11:53 P.M. Sarah: No. You’re so technical!")]), _vm._v(" "), _c('p', [_vm._v("11:55 P.M. Rick: I am going to restrain you, to use you how and when I want")]), _vm._v(" "), _c('p', [_vm._v("11:57 P.M. Sarah: I really can’t cope with you! Why not keep me under the stairs while you’re at it")]), _vm._v(" "), _c('p', [_vm._v("11:59 P.M. Rick: You just can’t open your mind can you 😮")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "monday-9-july-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Monday, 9 July 2018")]), _vm._v(" "), _c('p', [_vm._v("12:02 A.M. Sarah: It’s not fair to say that. I’m going as fast as I can! I’ve just said I have speed wobbles so you suggest something else you know will be a further challenge?")]), _vm._v(" "), _c('p', [_vm._v("12:03 A.M. Rick: I am not criticising babe x")]), _vm._v(" "), _c('p', [_vm._v("12:05 A.M. Sarah: I’m fighting my past, retraining my brain. Has this evening’s neuroticism bored you?")]), _vm._v(" "), _c('p', [_vm._v("12:09 A.M. Rick: Not at all babe. I will help you work through it.")]), _vm._v(" "), _c('p', [_vm._v("12:10 A.M. Sarah: If that’s kindly meant I’m grateful xxx")]), _vm._v(" "), _c('p', [_vm._v("12:11 A.M. Rick: Of course, it is xxx")]), _vm._v(" "), _c('p', [_vm._v("12:11 A.M. Rick: Sleep time xxx")]), _vm._v(" "), _c('p', [_vm._v("12:11 A.M. Sarah: Ok Cutie Pie")]), _vm._v(" "), _c('p', [_vm._v("12:12 A.M. Rick: Good night Sweet Cheeks. Sweet dreams xxx")]), _vm._v(" "), _c('p', [_vm._v("7:53 A.M. Rick: Morning lover. Did you sleep well? x")]), _vm._v(" "), _c('p', [_vm._v("8:11 A.M. Sarah: Not specially xxx")]), _vm._v(" "), _c('p', [_vm._v("8:13 A.M. Rick: Why is that lover? x")]), _vm._v(" "), _c('p', [_vm._v("8:13 A.M. Sarah: Was just having a moment, wondering about my life, more of the same from yesterday x")]), _vm._v(" "), _c('p', [_vm._v("8:15 A.M. Rick: The speed wobble???")]), _vm._v(" "), _c('p', [_vm._v("8:16 A.M. Sarah: Yes. I’ll come right.")]), _vm._v(" "), _c('p', [_vm._v("8:16 A.M. Rick: There is no pressure babe. Enjoy the attention x")]), _vm._v(" "), _c('p', [_vm._v("8:20 A.M. Sarah: Thanks. It’s just a moment xxx")]), _vm._v(" "), _c('p', [_vm._v("8:22 A.M. Rick: Don’t get too vested in the relationship. Enjoy the moment x")]), _vm._v(" "), _c('p', [_vm._v("8:25 A.M. Sarah: I’m not vested in anything. And I’ll get back to enjoying the other moment any day now xxx")]), _vm._v(" "), _c('p', [_vm._v("8:27 A.M. Rick: That’s good to hear babe x")]), _vm._v(" "), _c('p', [_vm._v("8:35 A.M. Rick: Are you going to wear jeans on the flight? x")]), _vm._v(" "), _c('p', [_vm._v("8:36 A.M. Sarah: Yes. Sexy jeans x")]), _vm._v(" "), _c('p', [_vm._v("8:47 A.M. Rick: You make them look sexy babe xxx")]), _vm._v(" "), _c('p', [_vm._v("8:48 A.M. Sarah: Aww thanks x")]), _vm._v(" "), _c('p', [_vm._v("8:49 A.M. Rick: I did think of turning up for a quick session with you this morning x")]), _vm._v(" "), _c('p', [_vm._v("8:50 A.M. Sarah: After this long I doubt a quick session would cut it. I’m off now cutie x")]), _vm._v(" "), _c('p', [_vm._v("8:52 A.M. Rick: Message me anytime babe xxx")]), _vm._v(" "), _c('p', [_vm._v("11:03 A.M. Sarah: Thanks xxx")]), _vm._v(" "), _c('p', [_vm._v("11:05 A.M. Rick: At the airport?")]), _vm._v(" "), _c('p', [_vm._v("11:05 A.M. Sarah: Got them airside so a success so far! My parents are surprisingly anxious travellers, having done such a lot of travel in their lives. While they are both fit and active, they are in their mid80s and need a lot of help with the technical stuff, organising activities or transport. I’m a reasonably calm traveller so it will be good for them to have the drama removed, if they can relinquish control to me! I’m on full management mode – yesterday afternoon I suddenly thought it might be a good idea to make an itinerary. Only partly in jest, and I’m very pleased I did – they are looking to me right now for an agenda!")]), _vm._v(" "), _c('p', [_vm._v("11:46 A.M. Rick: Have you given them emergency locator beacons yet?")]), _vm._v(" "), _c('p', [_vm._v("11:48 A.M. Sarah: I’m going to get leashes and a flag. You’d appreciate that.")]), _vm._v(" "), _c('p', [_vm._v("11:48 A.M. Rick: I’ll collar you babe")]), _vm._v(" "), _c('p', [_vm._v("12:26 P.M. Sarah: Oh really… Cutie Pie Rick x")]), _vm._v(" "), _c('p', [_vm._v("1:05 P.M. Rick: I will need to see proof of your knickers on a daily basis xxx")]), _vm._v(" "), _c('p', [_vm._v("1:05 P.M. Sarah: Lol xxx")]), _vm._v(" "), _c('p', [_vm._v("1:08 P.M. Rick: Safe flight xxx")]), _vm._v(" "), _c('p', [_vm._v("3:58 P.M. Rick: Are you there yet???")]), _vm._v(" "), _c('p', [_vm._v("4:47 P.M. Sarah: Just landed x")]), _vm._v(" "), _c('p', [_vm._v("10:37 P.M. Sarah: Here’s evidence. My first day’s knickers xxx")]), _vm._v(" "), _c('p', [_vm._v("11:53 P.M. Rick: Now that is you being a good girl. Goodnight Sweet Cheeks xxx")]), _vm._v(" "), _c('p', [_vm._v("11:55 P.M. Sarah: Goodnight Cutie Pie xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "tuesday-10-july-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Tuesday, 10 July 2018")]), _vm._v(" "), _c('p', [_vm._v("6:28 A.M. Sarah: Good morning sweetheart x")]), _vm._v(" "), _c('p', [_vm._v("7:11 A.M. Rick: Good morning lover xxx")]), _vm._v(" "), _c('p', [_vm._v("7:11 A.M. Sarah: I’m awake so early! Heading out for a walk soon.")]), _vm._v(" "), _c('p', [_vm._v("7:13 A.M. Rick: I can see that babe x")]), _vm._v(" "), _c('p', [_vm._v("7:14 A.M. Sarah: Usual for me these days. Could use some company. When I said I wanted a room to myself I didn’t mean with no one else in it! xxx")]), _vm._v(" "), _c('p', [_vm._v("7:16 A.M. Rick: Have you been thinking naughty thoughts? That choke hold…")]), _vm._v(" "), _c('p', [_vm._v("7:17 A.M. Sarah: I do think about that and am not sure how I feel. I think I liked it. But more the kiss. Yours.")]), _vm._v(" "), _c('p', [_vm._v("7:19 A.M. Rick: Kisses")]), _vm._v(" "), _c('p', [_vm._v("7:19 A.M. Sarah: Yes. I want to feel that.")]), _vm._v(" "), _c('p', [_vm._v("7:22 A.M. Rick: As the Māori fucks you")]), _vm._v(" "), _c('p', [_vm._v("7:23 A.M. Sarah: Well that just ruined it! A private moment kissing you.")]), _vm._v(" "), _c('p', [_vm._v("7:24 A.M. Rick: Lol mmm. Trust me to ruin it.")]), _vm._v(" "), _c('p', [_vm._v("7:26 A.M. Sarah: I’m sure you can rectify the situation")]), _vm._v(" "), _c('p', [_vm._v("7:27 A.M. Rick: Are you naked?")]), _vm._v(" "), _c('p', [_vm._v("7:27 A.M. Sarah: Yes")]), _vm._v(" "), _c('p', [_vm._v("7:27 A.M. Rick: Exploring?")]), _vm._v(" "), _c('p', [_vm._v("7:28 A.M. Sarah: A little stretch for now. Are you up yet?")]), _vm._v(" "), _c('p', [_vm._v("7:35 A.M. Rick: I am always “up” talking to you – and I am in the office already!")]), _vm._v(" "), _c('p', [_vm._v("7:36 A.M. Sarah: Oh, that’s boring. I’ll have to stay in your pocket – you don’t want a naked woman in your office xxx")]), _vm._v(" "), _c('p', [_vm._v("7:38 A.M. Rick: Mmm yes, I do")]), _vm._v(" "), _c('p', [_vm._v("7:38 A.M. Sarah: Under your desk I assume")]), _vm._v(" "), _c('p', [_vm._v("8:10 A.M. Rick: Or on it")]), _vm._v(" "), _c('p', [_vm._v("8:11 A.M. Sarah: That sounds good. I’m bony. Is it a padded desk?")]), _vm._v(" "), _c('p', [_vm._v("8:11 A.M. Rick: You want comfort!!!")]), _vm._v(" "), _c('p', [_vm._v("8:11 A.M. Sarah: Executive desk for executive fucks")]), _vm._v(" "), _c('p', [_vm._v("8:13 A.M. Rick: I will make you into a dirty girl...fuck you on the bonnet of the car")]), _vm._v(" "), _c('p', [_vm._v("8:14 A.M. Sarah: Owww that will hurt!")]), _vm._v(" "), _c('p', [_vm._v("8:16 A.M. Rick: Back seat then")]), _vm._v(" "), _c('p', [_vm._v("8:16 A.M. Sarah: I’ve been behaving like a teenager so no reason why not!")]), _vm._v(" "), _c('p', [_vm._v("8:17 A.M. Rick: When was your last fuck in the back of a car?")]), _vm._v(" "), _c('p', [_vm._v("8:18 A.M. Sarah: 17")]), _vm._v(" "), _c('p', [_vm._v("8:19 A.M. Rick: Then we need to bring back memories")]), _vm._v(" "), _c('p', [_vm._v("8:19 A.M. Sarah: Yes, sounds fun!")]), _vm._v(" "), _c('p', [_vm._v("8:20 A.M. Rick: I have a different take")]), _vm._v(" "), _c('p', [_vm._v("8:23 A.M. Sarah: Oh?")]), _vm._v(" "), _c('p', [_vm._v("8:25 A.M. Rick: Your legs will be spread and your ankles trapped between the headrest and seat")]), _vm._v(" "), _c('p', [_vm._v("8:26 A.M. Sarah: You want to hurt me?")]), _vm._v(" "), _c('p', [_vm._v("8:28 A.M. Rick: It wouldn’t hurt. I will drive around with you in that position.")]), _vm._v(" "), _c('p', [_vm._v("8:29 A.M. Sarah: Funny man")]), _vm._v(" "), _c('p', [_vm._v("8:30 A.M. Rick: I’m serious. You know this.")]), _vm._v(" "), _c('p', [_vm._v("8:31 A.M. Sarah: No, I don’t")]), _vm._v(" "), _c('p', [_vm._v("8:32 A.M. Rick: Are your legs spread lover?")]), _vm._v(" "), _c('p', [_vm._v("8:37 A.M. Sarah: I’m out for an early walk now, so no!")]), _vm._v(" "), _c('p', [_vm._v("8:39 A.M. Rick: Remember my instruction. The knickers. Although it was erotic to see them on the floor by your ankles, I would prefer to see them on and the wetness on display.")]), _vm._v(" "), _c('p', [_vm._v("8:43 A.M. Sarah: Very detailed!")]), _vm._v(" "), _c('p', [_vm._v("8:44 A.M. Rick: Follow my instructions. Have you contacted the Māori?")]), _vm._v(" "), _c('p', [_vm._v("8:46 A.M. Sarah: No. I will when I get home.")]), _vm._v(" "), _c('p', [_vm._v("8:46 A.M. Rick: You need his cock")]), _vm._v(" "), _c('p', [_vm._v("8:47 A.M. Sarah: We don’t always get what we want 😮")]), _vm._v(" "), _c('p', [_vm._v("8:48 A.M. Rick: Touché lover. You know I will fuck you again xxx")]), _vm._v(" "), _c('p', [_vm._v("8:50 A.M. Sarah: I don’t believe you anymore, but I’ll wear my best frock if it happens")]), _vm._v(" "), _c('p', [_vm._v("8:57 A.M. Rick: Do you want to be fucked in it or out of it?")]), _vm._v(" "), _c('p', [_vm._v("9:01 A.M. Sarah: Out. Skin please.")]), _vm._v(" "), _c('p', [_vm._v("9:06 A.M. Rick: We will do both")]), _vm._v(" "), _c('p', [_vm._v("9:14 A.M. Sarah: I’m back at the hotel, in my room peeling lycra off now. Very tight.")]), _vm._v(" "), _c('p', [_vm._v("9:15 A.M. Rick: Mmm. Like you. You have a very nice tight pussy. I don’t know about your arse.")]), _vm._v(" "), _c('p', [_vm._v("9:16 A.M. Sarah: It’s tighter")]), _vm._v(" "), _c('p', [_vm._v("9:19 A.M. Rick: Will you offer it to him again?")]), _vm._v(" "), _c('p', [_vm._v("9:19 A.M. Sarah: I didn’t offer it last time!")]), _vm._v(" "), _c('p', [_vm._v("9:20 A.M. Rick: Lol. This time you will. If you meet him it’s a given.")]), _vm._v(" "), _c('p', [_vm._v("9:22 A.M. Sarah: Hmm well unless we discuss it.")]), _vm._v(" "), _c('p', [_vm._v("9:22 A.M. Rick: Lol. Yeah right")]), _vm._v(" "), _c('p', [_vm._v("9:22 A.M. Sarah: Do you think all men like anal?")]), _vm._v(" "), _c('p', [_vm._v("9:22 A.M. Rick: Yes. It’s a power play.")]), _vm._v(" "), _c('p', [_vm._v("9:28 A.M. Sarah: But not all women want it")]), _vm._v(" "), _c('p', [_vm._v("9:28 A.M. Rick: True. When are you back?")]), _vm._v(" "), _c('p', [_vm._v("9:29 A.M. Sarah: Thursday 9 P.M.")]), _vm._v(" "), _c('p', [_vm._v("9:29 A.M. Rick: Do you have a deodorant can with you?")]), _vm._v(" "), _c('p', [_vm._v("9:30 A.M. Sarah: No.")]), _vm._v(" "), _c('p', [_vm._v("9:32 A.M. Rick: When you are out today look for a suitable object to fuck yourself with")]), _vm._v(" "), _c('p', [_vm._v("9:32 A.M. Sarah: Stop that!")]), _vm._v(" "), _c('p', [_vm._v("9:35 A.M. Rick: Do as I have instructed babe")]), _vm._v(" "), _c('p', [_vm._v("9:36 A.M. Sarah: Have you worked out that I don’t take particularly well to being told what to do?")]), _vm._v(" "), _c('p', [_vm._v("9:36 A.M. Rick: Funny girl, I’ll teach you. Show me later what you have purchased. Are you naked on the bed again?")]), _vm._v(" "), _c('p', [_vm._v("9:37 A.M. Sarah: Just out of the shower. Still wet.")]), _vm._v(" "), _c('p', [_vm._v("9:48 A.M. Rick: Wet and wild")]), _vm._v(" "), _c('p', [_vm._v("9:51 A.M. Sarah: It’s so interesting observing my parents outside their normal lives – they seem perfectly fine at home, but Dad must have almost lost his passport half a dozen times on the way here, and they are very slow and tire easily.")]), _vm._v(" "), _c('p', [_vm._v("10:04 A.M. Rick: That’s by your standards babe. Have patience. They are trying to not be a burden to you x")]), _vm._v(" "), _c('p', [_vm._v("10:07 A.M. Sarah: I know. I’m very good with them...can you even imagine me not being nice or patient?")]), _vm._v(" "), _c('p', [_vm._v("10:18 A.M. Rick: That’s good. And yes.")]), _vm._v(" "), _c('p', [_vm._v("10:18 A.M. Sarah: Good")]), _vm._v(" "), _c('p', [_vm._v("10:19 A.M. Rick: You are like that with me when you are demanding my cock")]), _vm._v(" "), _c('p', [_vm._v("10:20 A.M. Sarah: I’m not nice!!!")]), _vm._v(" "), _c('p', [_vm._v("10:28 A.M. Rick: Especially if you can’t get it")]), _vm._v(" "), _c('p', [_vm._v("10:30 A.M. Sarah: That makes me cute")]), _vm._v(" "), _c('p', [_vm._v("10:31 A.M. Rick: Oh, so cute. Take a banana back to your room. Make sure it’s firm and curved.")]), _vm._v(" "), _c('p', [_vm._v("10:48 A.M. Sarah: You do know I’m not taking you seriously on this matter, don’t you?")]), _vm._v(" "), _c('p', [_vm._v("10:49 A.M. Rick: I am very serious babe. Let’s explore your sexuality. What have you had used in your cunt besides cock? xxx")]), _vm._v(" "), _c('p', [_vm._v("10:53 A.M. Sarah: Let’s not!")]), _vm._v(" "), _c('p', [_vm._v("10:53 A.M. Rick: What are you afraid of?")]), _vm._v(" "), _c('p', [_vm._v("10:54 A.M. Sarah: You. You’re so demanding!")]), _vm._v(" "), _c('p', [_vm._v("11:00 A.M. Rick: You have your task lover. The banana, or other object. Don’t disappoint me x")]), _vm._v(" "), _c('p', [_vm._v("11:03 A.M. Rick: I have not ordered you to switch on Tinder yet 😮😮😮")]), _vm._v(" "), _c('p', [_vm._v("11:03 A.M. Sarah: I’m not good with being controlled. You know why, so be kind.")]), _vm._v(" "), _c('p', [_vm._v("11:04 A.M. Rick: You have an option. Banana or another object. Or Tinder.")]), _vm._v(" "), _c('p', [_vm._v("11:05 A.M. Sarah: Lol go away xxx")]), _vm._v(" "), _c('p', [_vm._v("11:06 A.M. Rick: Which do you prefer? Xxx")]), _vm._v(" "), _c('p', [_vm._v("11:06 A.M. Sarah: You, but I gtg sweetie xxx")]), _vm._v(" "), _c('p', [_vm._v("11:07 A.M. Rick: Enjoy the day xxx")]), _vm._v(" "), _c('p', [_vm._v("2:31 P.M. Rick: Don’t forget your instruction. You have already forgotten to show me the knickers you are wearing xxx")]), _vm._v(" "), _c('p', [_vm._v("2:34 P.M. Sarah: You only get one photo a day. And I’m babysitting! We are about to have lunch. I have somewhat exhausted my charges with all this walking, so will be back to the hotel soon for a bit of a lie down.")]), _vm._v(" "), _c('p', [_vm._v("2:41 P.M. Rick: You are a good daughter. I have not had a pic today!!!")]), _vm._v(" "), _c('p', [_vm._v("2:42 P.M. Sarah: Pics come at night xxx")]), _vm._v(" "), _c('p', [_vm._v("4:54 P.M. Rick: Did you buy anything today?")]), _vm._v(" "), _c('p', [_vm._v("4:54 P.M. Sarah: No shopping")]), _vm._v(" "), _c('p', [_vm._v("4:56 P.M. Sarah: What do you do for insubordination?")]), _vm._v(" "), _c('p', [_vm._v("4:58 P.M. Rick: Do you want to find out?")]), _vm._v(" "), _c('p', [_vm._v("4:58 P.M. Sarah: Not really! Lucky I’m in Sydney.")]), _vm._v(" "), _c('p', [_vm._v("5:01 P.M. Rick: You have to come home eventually")]), _vm._v(" "), _c('p', [_vm._v("5:01 P.M. Sarah: I do but I have avoided you so far so all good. Sexy black corset back dress tonight. What a waste!")]), _vm._v(" "), _c('p', [_vm._v("5:06 P.M. Rick: You can show me")]), _vm._v(" "), _c('p', [_vm._v("5:18 P.M. Sarah: That would put me over the photo quota")]), _vm._v(" "), _c('p', [_vm._v("5:20 P.M. Rick: Just do it!")]), _vm._v(" "), _c('p', [_vm._v("5:20 P.M. Sarah: Are you enjoying this?")]), _vm._v(" "), _c('p', [_vm._v("5:32 P.M. Rick: Of course. Are you?")]), _vm._v(" "), _c('p', [_vm._v("5:33 P.M. Sarah: I am. Do you want tonight’s pic now or later?")]), _vm._v(" "), _c('p', [_vm._v("6:22 P.M. Rick: Surprise me lover xxx")]), _vm._v(" "), _c('p', [_vm._v("8:40 P.M. Sarah: You know you’ll never get the pic you want from me, don’t you?")]), _vm._v(" "), _c('p', [_vm._v("9:57 P.M. Rick: That is a great pic. Nice tight arse, very sexy x")]), _vm._v(" "), _c('p', [_vm._v("11:36 P.M. Sarah: x")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "wednesday-11-july-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Wednesday, 11 July 2018")]), _vm._v(" "), _c('p', [_vm._v("7:21 A.M. Sarah: Good morning Cutie Pie xxx")]), _vm._v(" "), _c('p', [_vm._v("7:31 A.M. Rick: Good morning Sweet Cheeks. You are awake early again. Are you after the worm!!! xxx")]), _vm._v(" "), _c('p', [_vm._v("7:32 A.M. Sarah: MAYBE. And most days I’m awake a couple of hours before it’s completely necessary x")]), _vm._v(" "), _c('p', [_vm._v("7:32 A.M. Sarah: Glad you liked my little arse last night")]), _vm._v(" "), _c('p', [_vm._v("7:45 A.M. Rick: I’m looking forward to stretching your arse. Bareback so I can put a load deep in you.")]), _vm._v(" "), _c('p', [_vm._v("7:47 A.M. Sarah: I know you’re not going to do that")]), _vm._v(" "), _c('p', [_vm._v("7:47 A.M. Rick: Oh, but I am")]), _vm._v(" "), _c('p', [_vm._v("7:49 A.M. Sarah: Do you have these conversations with many others? Don’t tell me. You don’t have a job, you just send sexual messages to lonely ladies")]), _vm._v(" "), _c('p', [_vm._v("7:54 A.M. Rick: Agony Rick!")]), _vm._v(" "), _c('p', [_vm._v("7:55 A.M. Sarah: Causing the agony Rick")]), _vm._v(" "), _c('p', [_vm._v("8:38 A.M. Rick: Why do you say that?")]), _vm._v(" "), _c('p', [_vm._v("8:38 A.M. Sarah: The good sort of agony x")]), _vm._v(" "), _c('p', [_vm._v("8:39 A.M. Rick: Cervical agony mmm")]), _vm._v(" "), _c('p', [_vm._v("8:40 A.M. Sarah: Here’s where I am right now – beautiful sunrise isn’t it?")]), _vm._v(" "), _c('p', [_vm._v("8:40 A.M. Rick: That doesn’t count!!!")]), _vm._v(" "), _c('p', [_vm._v("8:40 A.M. Sarah: I know! Don’t panic. You got four pics yesterday, three tourist and one knickers")]), _vm._v(" "), _c('p', [_vm._v("8:41 A.M. Rick: Lol. Who’s counting? x")]), _vm._v(" "), _c('p', [_vm._v("8:42 A.M. Sarah: You x")]), _vm._v(" "), _c('p', [_vm._v("8:42 A.M. Rick: Look for a banana today")]), _vm._v(" "), _c('p', [_vm._v("8:43 A.M. Sarah: Incorrigible Rick xxx")]), _vm._v(" "), _c('p', [_vm._v("8:43 A.M. Rick: Show me how adventurous you can be. That’s a challenge for you babe xxx")]), _vm._v(" "), _c('p', [_vm._v("8:47 A.M. Sarah: You know that’s true xxx")]), _vm._v(" "), _c('p', [_vm._v("8:49 A.M. Rick: Your challenge for today. Banana or deodorant can x")]), _vm._v(" "), _c('p', [_vm._v("8:50 A.M. Sarah: Hush man. I don’t need homework x")]), _vm._v(" "), _c('p', [_vm._v("8:51 A.M. Rick: Yes, you do babe")]), _vm._v(" "), _c('p', [_vm._v("8:52 A.M. Sarah: I need to know you better before I start doing homework. That means in person. Not trying to force anything, it’s just a feeling xxx")]), _vm._v(" "), _c('p', [_vm._v("8:52 A.M. Rick: Why would that be? xxx")]), _vm._v(" "), _c('p', [_vm._v("8:54 A.M. Sarah: I think it’s about trust. I know you as two different people and need to know the real one first. I’m told patience is a virtue xxx")]), _vm._v(" "), _c('p', [_vm._v("8:58 A.M. Rick: When you get back to the room, I want you to fuck yourself x")]), _vm._v(" "), _c('p', [_vm._v("8:59 A.M. Sarah: I know you do. May just happen, I woke up feeling keen x")]), _vm._v(" "), _c('p', [_vm._v("9:00 A.M. Rick: From your dreams or thinking about all the cock?")]), _vm._v(" "), _c('p', [_vm._v("9:01 A.M. Sarah: I don’t recall either! x")]), _vm._v(" "), _c('p', [_vm._v("9:02 A.M. Rick: Lol. Yeah right")]), _vm._v(" "), _c('p', [_vm._v("9:06 A.M. Sarah: It’s true! I need to pay more attention to my thoughts, but then that’s wrong too – I know I overthink but how do you stop that?")]), _vm._v(" "), _c('p', [_vm._v("9:24 A.M. Rick: You do overthink babe. Just do it!")]), _vm._v(" "), _c('p', [_vm._v("9:26 A.M. Sarah: Easy for you. I’m aware I create my own roadblocks. That’s part of what I’m working on. Takes time is all, I’m sure x")]), _vm._v(" "), _c('p', [_vm._v("9:37 A.M. Rick: Of course, lover, Rome wasn’t built in a day x")]), _vm._v(" "), _c('p', [_vm._v("9:38 A.M. Sarah: Sometimes you say just the right thing xxx")]), _vm._v(" "), _c('p', [_vm._v("9:46 A.M. Rick: And I kiss well xxx")]), _vm._v(" "), _c('p', [_vm._v("9:47 A.M. Sarah: Yes, you do. And you’re cute.")]), _vm._v(" "), _c('p', [_vm._v("9:47 A.M. Rick: Plus, not a bad fuck! xxx")]), _vm._v(" "), _c('p', [_vm._v("9:47 A.M. Sarah: And so modest. True though. Not sure what you’re getting from me?")]), _vm._v(" "), _c('p', [_vm._v("9:48 A.M. Rick: Total lust xxx")]), _vm._v(" "), _c('p', [_vm._v("9:49 A.M. Sarah: Not sure how to answer that! I do love feeling so desired xxx")]), _vm._v(" "), _c('p', [_vm._v("9:52 A.M. Rick: Desired and fucked babe. You need sex don’t you Sweet Cheeks? xxx")]), _vm._v(" "), _c('p', [_vm._v("9:57 A.M. Sarah: If that’s an offer, yes please!")]), _vm._v(" "), _c('p', [_vm._v("9:59 A.M. Rick: That’s why you will spread your legs and arse cheeks for the Māori")]), _vm._v(" "), _c('p', [_vm._v("10:01 A.M. Sarah: I’m going to get caught. My poor parents would die if they read this! xxx")]), _vm._v(" "), _c('p', [_vm._v("10:03 A.M. Rick: You loved being a bad girl with him. You just needed his cock. You can’t hide from me babe. Am I right? x")]), _vm._v(" "), _c('p', [_vm._v("10:10 A.M. Sarah: Well he’s also a nice guy, which is important to me…")]), _vm._v(" "), _c('p', [_vm._v("10:12 A.M. Rick: Rubbish. You are caught up in the moment. All the attention and lust.")]), _vm._v(" "), _c('p', [_vm._v("10:15 A.M. Sarah: I know. A step back being here is good.")]), _vm._v(" "), _c('p', [_vm._v("10:16 A.M. Rick: Lol. You will be right back into it when you are back")]), _vm._v(" "), _c('p', [_vm._v("10:17 A.M. Sarah: MAYBE")]), _vm._v(" "), _c('p', [_vm._v("10:18 A.M. Rick: Babe. We both know. How wet are you?")]), _vm._v(" "), _c('p', [_vm._v("10:21 A.M. Sarah: Very. But having breakfast with the parents again. No rest for the wicked. It’s hard pretending to always be a good girl.")]), _vm._v(" "), _c('p', [_vm._v("10:33 A.M. Rick: You are sometimes a good girl xxx")]), _vm._v(" "), _c('p', [_vm._v("10:35 A.M. Sarah: I’m a confusing mix. Well I’m confused.")]), _vm._v(" "), _c('p', [_vm._v("10:36 A.M. Rick: Good at being bad, lover xxx")]), _vm._v(" "), _c('p', [_vm._v("10:36 A.M. Sarah: I wasn’t “good” when I was young. I scared myself good, and now overreacting to a life of not being myself. I had an unfortunate experience which set me on the wrong path – maybe not a story for messaging just yet.")]), _vm._v(" "), _c('p', [_vm._v("10:39 A.M. Rick: Molested?")]), _vm._v(" "), _c('p', [_vm._v("10:40 A.M. Sarah: No, just how I lost my virginity. Statutory rape.")]), _vm._v(" "), _c('p', [_vm._v("10:50 A.M. Rick: So, it was forced?")]), _vm._v(" "), _c('p', [_vm._v("10:51 A.M. Sarah: The circumstances were fucked up.")]), _vm._v(" "), _c('p', [_vm._v("10:51 A.M. Rick: I see.")]), _vm._v(" "), _c('p', [_vm._v("10:51 A.M. Sarah: I really don’t want to go into it right now. Almost no-one knows.")]), _vm._v(" "), _c('p', [_vm._v("10:51 A.M. Rick: I understand. Age?")]), _vm._v(" "), _c('p', [_vm._v("10:52 A.M. Sarah: 15")]), _vm._v(" "), _c('p', [_vm._v("10:52 A.M. Rick: That prompted you to go rouge?")]), _vm._v(" "), _c('p', [_vm._v("10:53 A.M. Sarah: Well yes. Just made me pick the wrong boys/men. Behaving out of character, then I married one when I was 20, realised what a stupid thing I’d done.")]), _vm._v(" "), _c('p', [_vm._v("10:53 A.M. Rick: It happens x")]), _vm._v(" "), _c('p', [_vm._v("10:53 A.M. Sarah: Unmarried by the time I was 22, then got entangled with the ex, almost immediately")]), _vm._v(" "), _c('p', [_vm._v("10:54 A.M. Rick: Now it’s Sarah’s time, and you are finally back home in your own body")]), _vm._v(" "), _c('p', [_vm._v("10:57 A.M. Sarah: I think it’s worth spending the time to sort this shit out now before launching into some new relationship")]), _vm._v(" "), _c('p', [_vm._v("10:58 A.M. Rick: You mean fuck it out of your system!")]), _vm._v(" "), _c('p', [_vm._v("10:59 A.M. Sarah: It’s more about becoming able to resist falling into a relationship. It seems I’ve mastered meeting new men.")]), _vm._v(" "), _c('p', [_vm._v("11:00 A.M. Rick: You’ve certainly done that babe. And mastered fucking them mmm.")]), _vm._v(" "), _c('p', [_vm._v("11:01 A.M. Sarah: Lol it’s hilarious that you say I’m good at it")]), _vm._v(" "), _c('p', [_vm._v("11:02 A.M. Rick: Meeting or fucking?")]), _vm._v(" "), _c('p', [_vm._v("11:03 A.M. Sarah: Fucking")]), _vm._v(" "), _c('p', [_vm._v("11:03 A.M. Rick: You don’t think you are?")]), _vm._v(" "), _c('p', [_vm._v("11:04 A.M. Sarah: I’ve never been given reason to, but I hear it a lot now, so yeah, it’s funny. I rediscovered passion since separating.")]), _vm._v(" "), _c('p', [_vm._v("11:05 A.M. Rick: Excellent and I will test it again")]), _vm._v(" "), _c('p', [_vm._v("11:09 A.M. Sarah: Talk in a bit Cutie Pie xxx")]), _vm._v(" "), _c('p', [_vm._v("11:13 A.M. Rick: Later babe xxx")]), _vm._v(" "), _c('p', [_vm._v("4:31 P.M. Sarah: We’ve had a great day. Mum and dad have loved having me along to be the tour leader.")]), _vm._v(" "), _c('p', [_vm._v("4:51 P.M. Rick: They don’t travel these days?")]), _vm._v(" "), _c('p', [_vm._v("4:51 P.M. Sarah: Not so much. The last big trip was probably about three years ago. Heading to dinner soon – Spanish tonight.")]), _vm._v(" "), _c('p', [_vm._v("9:22 P.M. Sarah: Was yummy")]), _vm._v(" "), _c('p', [_vm._v("9:23 P.M. Rick: Spices?")]), _vm._v(" "), _c('p', [_vm._v("9:24 P.M. Sarah: Only me")]), _vm._v(" "), _c('p', [_vm._v("9:25 P.M. Rick: I would have to taste you")]), _vm._v(" "), _c('p', [_vm._v("9:26 P.M. Rick: After I have fucked you")]), _vm._v(" "), _c('p', [_vm._v("9:26 P.M. Sarah: That can be arranged. It’s delish – see? That’s two photos today.")]), _vm._v(" "), _c('p', [_vm._v("9:30 P.M. Rick: Lol. Actually not!!!")]), _vm._v(" "), _c('p', [_vm._v("9:40 P.M. Sarah: Not what?")]), _vm._v(" "), _c('p', [_vm._v("9:42 P.M. Rick: The pics only start with flesh")]), _vm._v(" "), _c('p', [_vm._v("9:42 P.M. Sarah: One flesh pic a day")]), _vm._v(" "), _c('p', [_vm._v("9:58 P.M. Rick: Did you get a banana?")]), _vm._v(" "), _c('p', [_vm._v("10:01 P.M. Sarah: No babe")]), _vm._v(" "), _c('p', [_vm._v("10:02 P.M. Rick: Are you scared that you may enjoy it too much?")]), _vm._v(" "), _c('p', [_vm._v("10:02 P.M. Sarah: No")]), _vm._v(" "), _c('p', [_vm._v("10:03 P.M. Rick: Let me see your spread pussy")]), _vm._v(" "), _c('p', [_vm._v("10:04 P.M. Sarah: No, this is as much as you get tonight. Real life for the full spread.")]), _vm._v(" "), _c('p', [_vm._v("10:06 P.M. Rick: Ok. Very cute x")]), _vm._v(" "), _c('p', [_vm._v("10:58 P.M. Sarah: Was the photo to your high and exacting standards?")]), _vm._v(" "), _c('p', [_vm._v("10:59 P.M. Rick: Banana less, but otherwise yes!")]), _vm._v(" "), _c('p', [_vm._v("11:01 P.M. Sarah: Taskmaster")]), _vm._v(" "), _c('p', [_vm._v("11:02 P.M. Rick: I am your Master")]), _vm._v(" "), _c('p', [_vm._v("11:02 P.M. Sarah: See above Cutie Pie xxx")]), _vm._v(" "), _c('p', [_vm._v("11:09 P.M. Sarah: So, it’s 9 pm and I’m naked in bed. At least it’s 11 for you!")]), _vm._v(" "), _c('p', [_vm._v("11:09 P.M. Rick: Prove it")]), _vm._v(" "), _c('p', [_vm._v("11:10 P.M. Sarah: You had your pic")]), _vm._v(" "), _c('p', [_vm._v("11:10 P.M. Rick: Lol. Good night lover xxx")]), _vm._v(" "), _c('p', [_vm._v("11:10 P.M. Sarah: Fuck you x")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "thursday-12-july-2018"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Garamond",
      "text-align": "left"
    }
  }, [_vm._v("Thursday, 12 July 2018")]), _vm._v(" "), _c('p', [_vm._v("7:54 A.M. Sarah: Good moaning xxx")]), _vm._v(" "), _c('p', [_vm._v("8:17 A.M. Rick: Lol. You are not a moaner. I have fucked women where I needed earplugs xxx")]), _vm._v(" "), _c('p', [_vm._v("8:21 A.M. Sarah: Oh, that’s nice. Good to know. Am I in a category then?")]), _vm._v(" "), _c('p', [_vm._v("8:32 A.M. Rick: You are not a moaner babe xxx")]), _vm._v(" "), _c('p', [_vm._v("8:42 A.M. Sarah: Two categories then. Moaners. Not moaners. And I know I’m not xxx")]), _vm._v(" "), _c('p', [_vm._v("8:44 A.M. Rick: Do you find it hard to let yourself go babe? xxx")]), _vm._v(" "), _c('p', [_vm._v("8:44 A.M. Sarah: I do. Surprisingly hard. So, question time, what was your first impression of me?")]), _vm._v(" "), _c('p', [_vm._v("9:00 A.M. Rick: Shy. Reserved. Sexual.")]), _vm._v(" "), _c('p', [_vm._v("9:04 A.M. Sarah: Interesting. And I do hold back, but I always want to touch too early. I didn’t realise I was so tactile until this recent unveiling.")]), _vm._v(" "), _c('p', [_vm._v("9:23 A.M. Rick: You didn’t really touch me")]), _vm._v(" "), _c('p', [_vm._v("9:24 A.M. Sarah: I wanted to, but you didn’t sit very close so I thought you wouldn’t want me to, and I’d already been quite forward in suggesting we go out the day we matched!")]), _vm._v(" "), _c('p', [_vm._v("9:25 A.M. Rick: What kind of touching?")]), _vm._v(" "), _c('p', [_vm._v("9:27 A.M. Sarah: When I meet someone, I might sit close, maybe touch a hand or rest a leg. Touching.")]), _vm._v(" "), _c('p', [_vm._v("9:27 A.M. Rick: Did you molest the Māori?")]), _vm._v(" "), _c('p', [_vm._v("9:28 A.M. Sarah: I touched him, but I wouldn’t call it molesting! We had discussed the merits of a great hug in our earlier exchanges. That’s a good place to start. I was on a stool in the bar when I met him, and I did rest my leg against his. I find it quite normal. I asked if it was ok.")]), _vm._v(" "), _c('p', [_vm._v("9:28 A.M. Rick: I wouldn’t mind watching him fuck you babe")]), _vm._v(" "), _c('p', [_vm._v("9:29 A.M. Sarah: Why him?")]), _vm._v(" "), _c('p', [_vm._v("9:38 A.M. Rick: It sounds like an interesting fuck you had. And you may as well have just put your legs around his neck in the bar!")]), _vm._v(" "), _c('p', [_vm._v("9:39 A.M. Sarah: In a bar!!!")]), _vm._v(" "), _c('p', [_vm._v("9:44 A.M. Rick: Bit too forward maybe")]), _vm._v(" "), _c('p', [_vm._v("9:45 A.M. Sarah: Yes, it’s hard to judge. That’s the problem – I want to touch but not come across as too forward.")]), _vm._v(" "), _c('p', [_vm._v("9:45 A.M. Rick: Well if you opened his pants that would be forward")]), _vm._v(" "), _c('p', [_vm._v("9:46 A.M. Sarah: I’m unlikely to do that in a bar either. My other problem is that I like everyone. I like people, I have no discernment. Oops, that includes you lol.")]), _vm._v(" "), _c('p', [_vm._v("9:48 A.M. Rick: Doesn’t faze me lol")]), _vm._v(" "), _c('p', [_vm._v("9:49 A.M. Sarah: Nothing fazes you! The wide-eyed wonder. I trust everyone to treat me well. I’ll suspect I’ll never change.")]), _vm._v(" "), _c('p', [_vm._v("9:55 A.M. Rick: You are like a kid let loose in a candy store")]), _vm._v(" "), _c('p', [_vm._v("9:56 A.M. Sarah: I actually meant generally Rick. But yes. A little bit.")]), _vm._v(" "), _c('p', [_vm._v("11:00 A.M. Rick: What time is your flight?")]), _vm._v(" "), _c('p', [_vm._v("11:01 A.M. Sarah: 4 P.M., so the anxious travellers will get us leaving at 12 no doubt")]), _vm._v(" "), _c('p', [_vm._v("11:08 A.M. Rick: Do you only fuck unattached guys?")]), _vm._v(" "), _c('p', [_vm._v("11:08 A.M. Sarah: I’ve never been confronted with an unattached one, so yes. Why?")]), _vm._v(" "), _c('p', [_vm._v("12:22 P.M. Rick: You haven’t worked it out yet?")]), _vm._v(" "), _c('p', [_vm._v("12:23 P.M. Sarah: You are not unattached?")]), _vm._v(" "), _c('p', [_vm._v("12:25 P.M. Rick: You win anything of the top shelf")]), _vm._v(" "), _c('p', [_vm._v("1:30 P.M. Sarah: Fuck you Rick. I specifically asked – more than once – and was told you had no-one else. More than that, you said you weren’t having sex at the moment! How do you think that makes me feel? There have been hundreds of opportunities for you to correct that little misapprehension. Just fuck you.")]), _vm._v(" "), _c('p', [_vm._v("3:31 P.M. Rick: It is what it is babe.")]), _vm._v(" "), _c('p', [_vm._v("3:40 P.M. Sarah: That’s it? I said only yesterday I didn’t trust you enough to do something – I’ve felt something wasn’t right since you’ve made yourself so physically unavailable. I did wonder if it was some kinky thing where you only wanted virtual sex, but no. Why did you say you were unattached? Or at least had no one?")]), _vm._v(" "), _c('p', [_vm._v("3:51 P.M. Rick: Because you wouldn’t have fucked me 😮")]), _vm._v(" "), _c('p', [_vm._v("3:51 P.M. Sarah: You live with her? How long?")]), _vm._v(" "), _c('p', [_vm._v("3:53 P.M. Rick: Yes, three years")]), _vm._v(" "), _c('p', [_vm._v("3:53 P.M. Sarah: I kind of hate you")]), _vm._v(" "), _c('p', [_vm._v("3:53 P.M. Rick: Enough to fuck me raw?")]), _vm._v(" "), _c('p', [_vm._v("3:54 P.M. Sarah: Enough not to")]), _vm._v(" "), _c('p', [_vm._v("3:54 P.M. Rick: You got too invested in me. I should have warned you.")]), _vm._v(" "), _c('p', [_vm._v("3:57 P.M. Sarah: I’m not invested in you, and you should have been straight with me. You knew what I was about, how honesty is critical to me, so it was simply unkind, disrespectful.")]), _vm._v(" "), _c('p', [_vm._v("4:03 P.M. Rick: I now realise that you are looking for love")]), _vm._v(" "), _c('p', [_vm._v("4:07 P.M. Sarah: I’m actively not looking for love! I connect strongly, and honesty and respect are everything, and it needs to go both ways. It’s part of what you like about me. I’m educating myself and learning to be alone. You know all this better than anyone.")]), _vm._v(" "), _c('p', [_vm._v("4:28 P.M. Rick: I apologise for not being totally honest with you babe. I don’t fuck around and you are the only one.")]), _vm._v(" "), _c('p', [_vm._v("4:33 P.M. Sarah: I’ll revise my Pollyanna views. There’s no upside to this, so thanks for fucking it up.")]), _vm._v(" "), _c('p', [_vm._v("4:33 P.M. Rick: You can have me again, or we stay pen pals, your sex coach?")]), _vm._v(" "), _c('p', [_vm._v("4:34 P.M. Sarah: I need to think about it. I feel embarrassed at sharing so much, and foolish for misjudging you.")]), _vm._v(" "), _c('p', [_vm._v("4:37 P.M. Rick: Why feel embarrassed or foolish? It’s only between us babe.")]), _vm._v(" "), _c('p', [_vm._v("4:38 P.M. Sarah: Silly Sarah. Lesson learned")]), _vm._v(" "), _c('p', [_vm._v("4:35 P.M. Rick: I really am sorry babe. Have a good flight. Think about what you want. I won’t contact you until I hear from you.")])])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781398433403',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(94)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(96);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 96 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.790c0621691bc2055e1d.js